
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("6qBzG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3409d202bfcc1da0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $grj9i = parcelRequire("grj9i");

var $l8ruj = parcelRequire("l8ruj");

var $baoQa = parcelRequire("baoQa");
function $3409d202bfcc1da0$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "queues-issue-view-spa"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $grj9i.default), {
        pageId: "queues-issue-view"
    }, ({ match: match, pageContext: pageContext, push: push })=>pageContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $baoQa.default), {
            pageContext: pageContext,
            // @ts-expect-error - TS2322 - Type 'QueuesPush' is not assignable to type '(url: string) => void'.
            push: push,
            match: match
        })));
}

});
parcelRegister("grj9i", function(module, exports) {

$parcel$export(module.exports, "default", () => $412a33f5222e913d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9sGI6 = parcelRequire("9sGI6");

var $cf7yQ = parcelRequire("cf7yQ");

var $53AcJ = parcelRequire("53AcJ");

var $kbi2o = parcelRequire("kbi2o");

var $jF62O = parcelRequire("jF62O");

var $e33py = parcelRequire("e33py");

var $gq0sA = parcelRequire("gq0sA");

var $cz40O = parcelRequire("cz40O");

var $kb4zh = parcelRequire("kb4zh");

var $8XAvX = parcelRequire("8XAvX");

var $1ilU2 = parcelRequire("1ilU2");

var $g5X3G = parcelRequire("g5X3G");

var $4dRjY = parcelRequire("4dRjY");

var $doZTA = parcelRequire("doZTA");

var $4R6GH = parcelRequire("4R6GH");

var $hoJVU = parcelRequire("hoJVU");

var $k30xR = parcelRequire("k30xR");

var $6OeKD = parcelRequire("6OeKD");
const $412a33f5222e913d$var$QueuesAppBase = (props)=>{
    const { QueuesPushProvider: QueuesPushProvider, pageId: pageId } = props;
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const [{ data: pageContextData, error: error }] = (0, $gq0sA.usePageContext)();
    const { tenantContext: tenantContext, projectContext: projectContext, serviceDeskContext: serviceDeskContext } = pageContextData || {};
    const { baseUrl: baseUrl = '' } = tenantContext || {};
    const { projectName: projectName } = projectContext || {};
    const pageContextProps = (0, $5uXOq.useMemo)(()=>({
            ...tenantContext,
            ...projectContext,
            ...serviceDeskContext
        }), [
        projectContext,
        serviceDeskContext,
        tenantContext
    ]);
    const projectKey = (0, $g5X3G.toProjectKey)(match.params.projectKey || '');
    const practice = (0, $1ilU2.toItsmPractice)(match.params.practiceType);
    const [categorizedQueues, categorizedQueuesLoading, categorizedError, methods] = (0, $jF62O.useCategorizedQueues)(baseUrl, projectKey, practice);
    let selectedQueueName;
    if (categorizedQueues && match.params.queueId) {
        const selectedQueue = categorizedQueues.find((queue)=>queue.id === Number(match.params.queueId));
        selectedQueueName = selectedQueue ? selectedQueue.name : undefined;
    }
    (0, $k30xR.useOnFavoritesChanged)(projectKey, practice, categorizedQueues, methods.editItemFavorite);
    const { shouldUseStylingPatch: shouldShowContainer } = (0, $hoJVU.useStylingPatch)();
    const isLoading = !pageContextData && !error || categorizedQueuesLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cz40O.SpaPageWrapper), {
        pageId: pageId,
        baseUrl: baseUrl,
        currentUrl: match.url,
        // @ts-expect-error - TS2322 - Type '{ projectId: number; projectKey: string; projectName: string; projectType: ProjectType; isAdmin: boolean; isProjectSimplified: boolean; } | undefined' is not assignable to type 'ProjectContext | null | undefined'.
        projectContext: projectContext,
        isLoading: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? !shouldShowContainer && isLoading : isLoading,
        error: error
    }, isLoading && shouldShowContainer && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hoJVU.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(QueuesPushProvider, {
        projectKey: projectKey
    }, ({ push: push, replace: providerReplace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e33py.ServiceDeskDocumentTitle), {
            // @ts-expect-error - TS2322 - Type '{ projectName: string | undefined; section: string; }' is not assignable to type 'IntrinsicAttributes & Diff<(Diff<RefAttributes<any> | (RefAttributes<any> & { children?: ReactNode; }), Partial<RefAttributes<...> | (RefAttributes<...> & { ...; })>> & RefAttributes<...>) | (Diff<...> & ... 1 more ... & { ...; }), InjectIntlVoidProps> & { ...; }'.
            projectName: projectName,
            section: "queues",
            subsection: selectedQueueName
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children({
            push: push,
            match: match,
            replace: providerReplace,
            queuesData: {
                data: (0, $6OeKD.pageToQueues)(categorizedQueues || []),
                error: categorizedError ? categorizedError.message : undefined,
                loading: categorizedQueuesLoading
            },
            category: practice,
            // @ts-expect-error - TS2322 - Type '{ portalId?: number | undefined; canSeeNewIssueView?: boolean | undefined; userRole?: string | undefined; serviceDeskId?: number | undefined; projectId?: number | undefined; projectKey?: string | undefined; ... 11 more ...; isSiteAdmin?: boolean | undefined; }' is not assignable to type 'PageProps'.
            pageContext: pageContextProps
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cf7yQ.JsdGettingStartedPanelShouldRender), null));
};
var $412a33f5222e913d$export$2e2bcd8739ae039 = (0, $9sGI6.default)($412a33f5222e913d$var$QueuesAppBase, {
    QueueProvider: (0, $kbi2o.default),
    QueuesApiDataProvider: (0, $53AcJ.default),
    QueuesPushProvider: (0, $8XAvX.default)
});

});
parcelRegister("cf7yQ", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $8aa55ef5824c4e4d$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $8aa55ef5824c4e4d$export$c7732c55900cf0b9);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("sXYgA")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("2OvSt")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("f6mEW")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("1oRHz")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
$8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
$8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
$8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("sXYgA", function(module, exports) {

let $057122a3b41c04fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $057122a3b41c04fd$var$load("eNmuD"),
    $057122a3b41c04fd$var$load("chQyv")
]).then(()=>parcelRequire('hZyYK'));

});

parcelRegister("2OvSt", function(module, exports) {

let $20c8fa806ea6db90$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $20c8fa806ea6db90$var$load("eNmuD"),
    $20c8fa806ea6db90$var$load("cM9em"),
    $20c8fa806ea6db90$var$load("fr9NE"),
    $20c8fa806ea6db90$var$load("3Xgpx")
]).then(()=>parcelRequire('2NciN'));

});

parcelRegister("f6mEW", function(module, exports) {

let $afe8fe3c672ff16f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $afe8fe3c672ff16f$var$load("eNmuD"),
    $afe8fe3c672ff16f$var$load("cM9em"),
    $afe8fe3c672ff16f$var$load("fr9NE"),
    $afe8fe3c672ff16f$var$load("hlGg7")
]).then(()=>parcelRequire('4F6ZA'));

});

parcelRegister("1oRHz", function(module, exports) {

let $1051b0675adbeaab$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1051b0675adbeaab$var$load("eNmuD"),
    $1051b0675adbeaab$var$load("cM9em"),
    $1051b0675adbeaab$var$load("fr9NE"),
    $1051b0675adbeaab$var$load("eXDqW")
]).then(()=>parcelRequire('6Wput'));

});


parcelRegister("53AcJ", function(module, exports) {

$parcel$export(module.exports, "AvailableQueuesConsumer", () => $f81f7587879fbe9d$export$dfebed0fc9519fcc);
$parcel$export(module.exports, "default", () => $f81f7587879fbe9d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8Rkzz = parcelRequire("8Rkzz");

var $dd29Z = parcelRequire("dd29Z");

var $3HGy4 = parcelRequire("3HGy4");

var $5j0B5 = parcelRequire("5j0B5");

var $gm93k = parcelRequire("gm93k");

var $8nV9C = parcelRequire("8nV9C");
const $f81f7587879fbe9d$var$LAST_VISITED_QUEUE_KEY_PREFIX = 'last_visited_queue';
// @ts-expect-error - TS2322 - Type 'Context<{ setFavorite: (...args: any[]) => void; deleteNavItem: (...args: any[]) => void; updateIssueCount: (...args: any[]) => void; markNavItemsAsStale: (...args: any[]) => void; getQueueCount: (...args: any[]) => void; setLastVisitedQueueId: (...args: any[]) => void; getLastVisitedQueueId: (...args: any[]) => voi...' is not assignable to type 'Context<QueuesContextType>'.
const $f81f7587879fbe9d$var$AvailableQueuesContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    setFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    deleteNavItem: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    updateIssueCount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    markNavItemsAsStale: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    getQueueCount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    setLastVisitedQueueId: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    getLastVisitedQueueId: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});
const { Provider: $f81f7587879fbe9d$var$Provider, Consumer: $f81f7587879fbe9d$export$dfebed0fc9519fcc } = $f81f7587879fbe9d$var$AvailableQueuesContext;
class $f81f7587879fbe9d$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            FavoriteSubscriber: (0, $gm93k.default),
            queuesPrefetchData: [],
            push: undefined,
            onDeleteNavItem: undefined
        };
    }
    constructor(props){
        const { onNavUpdated: onNavUpdated, onIssueCountUpdated: onIssueCountUpdated, queuesPrefetchData: queuesPrefetchData, push: push } = props;
        super(props), this.getQueueCount = ()=>{
            const { data: data } = this.state;
            return data ? Object.keys(data).filter((queueId)=>!this.deletedQueueIds.has((0, $3HGy4.toQueueIdString)(queueId))).length : 0;
        }, this.getLastVisitedQueueId = (projectKey)=>{
            const { category: category } = this.props;
            if (!projectKey) return null;
            try {
                if (category) return (0, $5j0B5.getFromLocalStorage)(`${$f81f7587879fbe9d$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`);
                return (0, $5j0B5.getFromLocalStorage)(`${$f81f7587879fbe9d$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                return null;
            }
        }, this.setFavorite = (queueId, newValue)=>{
            const { FavoriteSubscriber: FavoriteSubscriber } = this.props;
            FavoriteSubscriber.setFavorite(queueId, newValue);
        }, this.setLastVisitedQueueId = (queueId, projectKey)=>{
            const lastVisitedQueueId = this.getLastVisitedQueueId(projectKey);
            const { category: category } = this.props;
            // @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'string | null | undefined' and 'number' have no overlap.
            if (projectKey && lastVisitedQueueId !== queueId) try {
                if (category) (0, $5j0B5.setInLocalStorage)(`${$f81f7587879fbe9d$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`, (0, $3HGy4.fromQueueIdString)(queueId));
                else (0, $5j0B5.setInLocalStorage)(`${$f81f7587879fbe9d$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}`, (0, $3HGy4.fromQueueIdString)(queueId));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
            // Don't care if it fails. Default behavior in QueuesRedirect will take users to first available queue.
            }
        };
        this.queuesContext = {
            deleteNavItem: this.deleteNavItem(push),
            updateIssueCount: onIssueCountUpdated,
            markNavItemsAsStale: ()=>onNavUpdated(false),
            setFavorite: this.setFavorite,
            getQueueCount: this.getQueueCount,
            setLastVisitedQueueId: this.setLastVisitedQueueId,
            getLastVisitedQueueId: this.getLastVisitedQueueId
        };
        this.deletedQueueIds = new Set();
        this.state = {
            loading: false,
            error: undefined,
            data: queuesPrefetchData.length ? (0, $8nV9C.pageToQueues)(queuesPrefetchData) : undefined
        };
    }
    static getDerivedStateFromProps(props, state) {
        const { queuesPrefetchData: queuesPrefetchData } = props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))((0, $8nV9C.pageToQueues)(queuesPrefetchData), state.data) && queuesPrefetchData.length) return {
            data: (0, $8nV9C.pageToQueues)(queuesPrefetchData)
        };
        return null;
    }
    componentWillUnmount() {
        const { fetchSubscription: fetchSubscription, deleteItemSubscription: deleteItemSubscription } = this;
        fetchSubscription && fetchSubscription.unsubscribe();
        deleteItemSubscription && deleteItemSubscription.unsubscribe();
    }
    deleteNavItem(push) {
        return (queueId)=>{
            const { onDeleteNavItem: onDeleteNavItem } = this.props;
            onDeleteNavItem && onDeleteNavItem((0, $3HGy4.fromQueueIdString)(queueId));
            // update queue counts to reflect the deletion
            // note that deleteQueueFromSidebar is called after the delete endpoint returns success
            const updatedQueues = {
                ...this.state.data
            };
            delete updatedQueues[(0, $3HGy4.fromQueueIdString)(queueId)];
            const deletedLastQueue = Object.keys(updatedQueues).length === 0;
            if (deletedLastQueue) push && push(`${(0, $dd29Z.getQueueFragment)()}/custom/new`);
            else push && push((0, $dd29Z.getQueueFragment)());
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f81f7587879fbe9d$var$Provider, {
            value: this.queuesContext
        }, this.props.children(this.state));
    }
}

});
parcelRegister("dd29Z", function(module, exports) {

$parcel$export(module.exports, "QUEUE_ROUTES", () => $10cfdb56a53da9cf$export$410a6306dae101ca);
$parcel$export(module.exports, "navigate", () => $10cfdb56a53da9cf$export$ff7962acd6052c28);
$parcel$export(module.exports, "getQueueFragment", () => $10cfdb56a53da9cf$export$954f428fa284c7);
$parcel$export(module.exports, "getEditQueueFragment", () => $10cfdb56a53da9cf$export$86f6a6d69e87f843);
$parcel$export(module.exports, "getCloneQueueFragment", () => $10cfdb56a53da9cf$export$7a487d215c9c3f76);
$parcel$export(module.exports, "getQueueIssueFragment", () => $10cfdb56a53da9cf$export$773cefb51b60b161);
$parcel$export(module.exports, "getIssueFragment", () => $10cfdb56a53da9cf$export$a796bfaff67c9fae);
$parcel$export(module.exports, "getQueueUrl", () => $10cfdb56a53da9cf$export$a29b42a005fecf0);
$parcel$export(module.exports, "getEditQueueUrlFromManageQueue", () => $10cfdb56a53da9cf$export$91152835d12ca65f);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("9o0uh");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $5viSR = parcelRequire("5viSR");

var $oCMSG = parcelRequire("oCMSG");

var $hzd6p = parcelRequire("hzd6p");
const $10cfdb56a53da9cf$var$LOCATION = 'servicedesk.common.navigation.queues';
let $10cfdb56a53da9cf$var$navigatorPromise;
const $10cfdb56a53da9cf$var$getPushStateNavigator = ()=>{
    if (!$10cfdb56a53da9cf$var$navigatorPromise) $10cfdb56a53da9cf$var$navigatorPromise = (0, $hzd6p.createPushStateNavigator)();
    return $10cfdb56a53da9cf$var$navigatorPromise;
};
const $10cfdb56a53da9cf$export$410a6306dae101ca = {
    [(0, $oCMSG.INCIDENTS)]: 'section/incidents',
    [(0, $oCMSG.CHANGES)]: 'section/changes',
    [(0, $oCMSG.SERVICE_REQUEST)]: 'section/service-requests',
    [(0, $oCMSG.PROBLEMS)]: 'section/problems',
    [(0, $oCMSG.POST_INCIDENT_REVIEWS)]: 'section/post-incident-reviews',
    [(0, $oCMSG.NO_CATEGORY)]: 'queues'
};
const $10cfdb56a53da9cf$var$fromCategory = (category)=>$10cfdb56a53da9cf$export$410a6306dae101ca[category || (0, $oCMSG.NO_CATEGORY)];
const $10cfdb56a53da9cf$export$ff7962acd6052c28 = (projectKey, fragment)=>{
    (0, $5viSR.emitSignal)($10cfdb56a53da9cf$var$LOCATION, {
        projectKey: projectKey,
        fragment: fragment
    });
    return (0, $kVLXA.Observable).fromPromise($10cfdb56a53da9cf$var$getPushStateNavigator()).mergeMap((pushStateNavigator)=>{
        pushStateNavigator.navigateToFragment(fragment);
        return (0, $kVLXA.Observable).empty();
    }).catch(()=>(0, $kVLXA.Observable).empty());
};
const $10cfdb56a53da9cf$export$954f428fa284c7 = (queueId, category)=>{
    const categoryString = $10cfdb56a53da9cf$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/${queueId}` : `${categoryString}`;
};
const $10cfdb56a53da9cf$export$86f6a6d69e87f843 = (queueId, category)=>`${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}/edit`;
const $10cfdb56a53da9cf$export$7a487d215c9c3f76 = (queueId, category)=>{
    const categoryString = $10cfdb56a53da9cf$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/new?parentId=${queueId}` : `${categoryString}/custom/new`;
};
const $10cfdb56a53da9cf$export$773cefb51b60b161 = (queueId, issueKey, category)=>`${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}/${issueKey}`;
const $10cfdb56a53da9cf$export$a796bfaff67c9fae = (issueKey)=>`${$10cfdb56a53da9cf$export$954f428fa284c7()}/issue/${issueKey}`;
const $10cfdb56a53da9cf$export$a29b42a005fecf0 = ({ projectKey: projectKey, category: category, queueId: queueId, queryParams: queryParams })=>{
    const urlSearchParams = new URLSearchParams();
    if (queryParams) Object.entries(queryParams).forEach(([key, value])=>{
        urlSearchParams.set(key, value);
    });
    const formattedQueryParams = urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : '';
    return `/jira/servicedesk/projects/${projectKey}/${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}${formattedQueryParams}`;
};
const $10cfdb56a53da9cf$export$91152835d12ca65f = (queueId, projectKey, category)=>`/jira/servicedesk/projects/${projectKey}/${$10cfdb56a53da9cf$export$86f6a6d69e87f843(queueId, category)}`;

});
parcelRegister("5viSR", function(module, exports) {

$parcel$export(module.exports, "emitSignal", () => $8dc3d00171ca741d$export$a8a72bca1918549c);
/**
 * A signalling mechanism for Cypress tests.
 *
 * This acts as a bridge between the storybook application and cypress for
 * checking behaviours which cannot be asserted on via the DOM or are
 * otherwise not reflected in application state.
 *
 * This is the 'emit' side of the story. It should be used by
 * production-facing code to emit a signal.
 */ const $8dc3d00171ca741d$var$isProduction = ()=>true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8dc3d00171ca741d$var$registerSignal = (signal, meta)=>{
    window.cySignals.allSignals.push(signal);
    const signalsByName = window.cySignals.signalsByName;
    if (signalsByName[signal]) signalsByName[signal].push(meta);
    else signalsByName[signal] = [
        meta
    ];
};
const $8dc3d00171ca741d$var$initCySignals = ()=>{
    window.cySignals = {
        signalsByName: {},
        allSignals: []
    };
};
const $8dc3d00171ca741d$export$a8a72bca1918549c = (signal, meta = {})=>{
    if ($8dc3d00171ca741d$var$isProduction()) return;
    if (!window.cySignals) $8dc3d00171ca741d$var$initCySignals();
    $8dc3d00171ca741d$var$registerSignal(signal, meta);
};

});

parcelRegister("hzd6p", function(module, exports) {

$parcel$export(module.exports, "createPushStateNavigator", () => $ddde70bc55609ded$export$d3bf579f8e5cd838);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
const $ddde70bc55609ded$var$PUSH_STATE_NAVIGATOR_MODULE = 'servicedesk/internal-api/core/util/push-state-navigator/push-state-navigator';
// Try to require push-state-navigator over 500ms, otherwise we'll fallback.
const $ddde70bc55609ded$var$REQUIRE_TIMEOUT = 100;
const $ddde70bc55609ded$var$REQUIRE_RETRIES = 5;
const $ddde70bc55609ded$export$d3bf579f8e5cd838 = ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: $ddde70bc55609ded$var$PUSH_STATE_NAVIGATOR_MODULE,
        timeout: $ddde70bc55609ded$var$REQUIRE_TIMEOUT,
        tentatives: $ddde70bc55609ded$var$REQUIRE_RETRIES
    });

});


parcelRegister("3HGy4", function(module, exports) {

$parcel$export(module.exports, "toQueueId", () => $ad23a38600e1d52f$export$dae52b119ebf2444);
$parcel$export(module.exports, "fromQueueId", () => $ad23a38600e1d52f$export$999de35c9ca8105b);
$parcel$export(module.exports, "toQueueIdString", () => $ad23a38600e1d52f$export$cda0e35414946580);
$parcel$export(module.exports, "fromQueueIdString", () => $ad23a38600e1d52f$export$cde8da12f845d56f);
$parcel$export(module.exports, "LOCAL_STORAGE_SOURCE", () => $ad23a38600e1d52f$export$6e21137db7aec966);
$parcel$export(module.exports, "PREFETCHER_SOURCE", () => $ad23a38600e1d52f$export$ce13a6c409c4db7d);
$parcel$export(module.exports, "REST_SOURCE", () => $ad23a38600e1d52f$export$e85fb1a0846db30f);
$parcel$export(module.exports, "SSR_SOURCE", () => $ad23a38600e1d52f$export$c5c05bf31a872c73);
const $ad23a38600e1d52f$export$dae52b119ebf2444 = (queueId)=>queueId;
const $ad23a38600e1d52f$export$999de35c9ca8105b = (queueId)=>queueId;
const $ad23a38600e1d52f$export$cda0e35414946580 = (queueId)=>$ad23a38600e1d52f$export$dae52b119ebf2444(Number(queueId));
const $ad23a38600e1d52f$export$cde8da12f845d56f = (queueId)=>$ad23a38600e1d52f$export$999de35c9ca8105b(queueId).toString();
const $ad23a38600e1d52f$export$6e21137db7aec966 = 'LOCAL_STORAGE';
const $ad23a38600e1d52f$export$ce13a6c409c4db7d = 'PREFETCHER';
const $ad23a38600e1d52f$export$e85fb1a0846db30f = 'REST';
const $ad23a38600e1d52f$export$c5c05bf31a872c73 = 'SSR';

});

parcelRegister("5j0B5", function(module, exports) {

$parcel$export(module.exports, "getFromLocalStorage", () => $a6505ee1b0c5b1ab$export$602bc7b349337fec);
$parcel$export(module.exports, "setInLocalStorage", () => $a6505ee1b0c5b1ab$export$e7b9840f77b6b2a4);

var $bSSG7 = parcelRequire("bSSG7");

var $9vBS6 = parcelRequire("9vBS6");
const $a6505ee1b0c5b1ab$export$f016358f0af18fa0 = (0, $bSSG7.createLocalExpirableStorageProvider)('servicedesk_queues');
const $a6505ee1b0c5b1ab$var$TIME_BEFORE_EXPIRY = 1209600000; // 14 days
const $a6505ee1b0c5b1ab$export$602bc7b349337fec = (key)=>{
    try {
        return $a6505ee1b0c5b1ab$export$f016358f0af18fa0.get(key);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        // .get() can trigger an exception due to a bug in 'storejs', where if
        // LS is not able to be read or written, it will not initialise the store.
        (0, $9vBS6.default).safeWarnWithoutCustomerData('servicedesk.queues.agent-view.services', 'Local storage failure on read');
        return null;
    }
};
const $a6505ee1b0c5b1ab$export$e7b9840f77b6b2a4 = (key, value)=>{
    try {
        const now = Date.now();
        $a6505ee1b0c5b1ab$export$f016358f0af18fa0.set(key, value, now + $a6505ee1b0c5b1ab$var$TIME_BEFORE_EXPIRY);
        $a6505ee1b0c5b1ab$export$f016358f0af18fa0.removeExpiredKeys();
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        (0, $9vBS6.default).safeWarnWithoutCustomerData('servicedesk.queues.agent-view.services', 'Local storage failure');
        return false;
    }
};

});
parcelRegister("9vBS6", function(module, exports) {

$parcel$export(module.exports, "default", () => $35c5e35df79dbfac$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");
const $35c5e35df79dbfac$var$PREFIX = '[Queues]';
/** This function logs privacy safe error.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $35c5e35df79dbfac$var$safeErrorWithoutCustomerData = (location, message, event)=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData(location, `${$35c5e35df79dbfac$var$PREFIX} ${message}`, event);
};
/** This function logs privacy safe warning.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $35c5e35df79dbfac$var$safeWarnWithoutCustomerData = (location, message, event)=>{
    (0, $dJl1T.default).safeWarnWithoutCustomerData(location, `${$35c5e35df79dbfac$var$PREFIX} ${message}`, event);
};
/** This function logs privacy safe info.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $35c5e35df79dbfac$var$safeInfoWithoutCustomerData = (location, message, event)=>{
    (0, $dJl1T.default).safeInfoWithoutCustomerData(location, `${$35c5e35df79dbfac$var$PREFIX} ${message}`, event);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$35c5e35df79dbfac$export$2e2bcd8739ae039 = {
    safeInfoWithoutCustomerData: $35c5e35df79dbfac$var$safeInfoWithoutCustomerData,
    safeWarnWithoutCustomerData: $35c5e35df79dbfac$var$safeWarnWithoutCustomerData,
    safeErrorWithoutCustomerData: $35c5e35df79dbfac$var$safeErrorWithoutCustomerData
};

});


parcelRegister("gm93k", function(module, exports) {

$parcel$export(module.exports, "default", () => $8292a018a8b0a76e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eXQym = parcelRequire("eXQym");

var $3HGy4 = parcelRequire("3HGy4");
class $8292a018a8b0a76e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    static setFavorite() {}
    render() {
        return null;
    }
    constructor(...args){
        super(...args), this.onFavoritesChanged = (items)=>{
            const queueItemsObj = items[0, $eXQym.QUEUES_ITEM_TYPE];
            if (!queueItemsObj) return;
            // Object.values gives Array<mixed> according to Flow, which is wrong.
            // https://github.com/facebook/flow/issues/2221
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const queueItems = Object.values(queueItemsObj);
            // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
            queueItems.forEach((item)=>this.props.onFavoriteItemChanged((0, $3HGy4.toQueueIdString)(item.id), item.value));
        };
    }
}

});

parcelRegister("8nV9C", function(module, exports) {

$parcel$export(module.exports, "pageToQueues", () => $fe4663d2a5f926fb$export$8ada91ce992fa66f);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $3HGy4 = parcelRequire("3HGy4");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe4663d2a5f926fb$export$2e2bcd8739ae039 = (rest, transformFunc)=>rest.mergeMap((payload)=>(0, $kVLXA.Observable).of(transformFunc(payload)));
const $fe4663d2a5f926fb$var$transformColumns = (responseColumns)=>responseColumns.map((responseColumn)=>{
        const column = {
            id: responseColumn.fieldId,
            title: responseColumn.title,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        };
        if (responseColumn.sortOrder) return {
            ...column,
            currentSorting: responseColumn.sortOrder
        };
        return column;
    });
const $fe4663d2a5f926fb$export$8ada91ce992fa66f = (page)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    page.reduce((acc, queue)=>{
        acc[queue.id] = {
            id: (0, $3HGy4.toQueueId)(queue.id),
            name: queue.name,
            jql: queue.jql,
            completeJql: queue.completeJql,
            order: queue.order,
            columns: $fe4663d2a5f926fb$var$transformColumns(queue.columnsDetails),
            // British spelling from legacy Backend code
            isFavorite: queue.favourite,
            category: queue.category,
            canBeHidden: queue.canBeHidden
        };
        return acc;
    }, {});
const $fe4663d2a5f926fb$export$9fd203f323102996 = (prefetchData, queues)=>{
    if (queues === undefined) return [];
    // @ts-expect-error - TS2322 - Type '{ favourite: boolean; columns: string[]; columnsDetails: { title: string; fieldType: string; sortable: boolean; fieldId: string; sortOrder: SortOrder | undefined; }[]; id: number; name: string; ... 8 more ...; shouldSkipIssueCountRefresh?: boolean | undefined; }[]' is not assignable to type 'Page[]'.
    return Object.keys(queues).map((queueId)=>{
        const updatedQueue = queues[queueId];
        const { isFavorite: isFavorite, columns: columns, isTransient: isTransient, ...queuesData } = updatedQueue;
        const cachedPage = prefetchData.find((q)=>String(q.id) === queueId);
        return {
            ...cachedPage,
            ...queuesData,
            favourite: isFavorite,
            columns: columns.map(({ id: id })=>id),
            columnsDetails: columns.map(({ id: id, currentSorting: currentSorting, ...remaining })=>({
                    fieldId: id,
                    sortOrder: currentSorting,
                    ...remaining
                }))
        };
    });
};
const $fe4663d2a5f926fb$export$4906aa3ec3919ad9 = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JSD_QUEUES_PRELOAD_PROMISES && window.JSD_QUEUES_PRELOAD_PROMISES.queues;
const $fe4663d2a5f926fb$export$17bdd949b6a9952 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JSD_QUEUES_PRELOAD_PROMISES) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JSD_QUEUES_PRELOAD_PROMISES.queues = undefined;
};

});


parcelRegister("kbi2o", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd787f787343b6f$export$2e2bcd8739ae039);

var $8RXs9 = parcelRequire("8RXs9");

var $cm25K = parcelRequire("cm25K");
var $fbd787f787343b6f$export$2e2bcd8739ae039 = (0, $8RXs9.default)((0, $cm25K.default));

});
parcelRegister("cm25K", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d6194b196376c0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7uUwQ = parcelRequire("7uUwQ");

var $eae50 = parcelRequire("eae50");

var $79GY5 = parcelRequire("79GY5");

var $hN5eZ = parcelRequire("hN5eZ");

var $PyWGC = parcelRequire("PyWGC");
const $55d6194b196376c0$var$findQueue = (source, id)=>(0, $7uUwQ.getIn)(source, [
        'data',
        id
    ]);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$55d6194b196376c0$export$2e2bcd8739ae039 = ({ queueId: queueId, queuesDataSource: queuesDataSource, baseUrl: baseUrl, projectKey: projectKey, children: children, intl: { formatMessage: formatMessage } })=>{
    const lastUnfoundQueue = (0, $5uXOq.useRef)('');
    if (queuesDataSource.loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79GY5.default), null);
    const queue = $55d6194b196376c0$var$findQueue(queuesDataSource, queueId);
    if (queue) {
        lastUnfoundQueue.current = '';
        (0, $hN5eZ.setLastVisitedQueueIdAndCategory)(queue.id, projectKey, queue.category);
        return children(queue);
    }
    if (lastUnfoundQueue.current === queueId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eae50.default), {
        header: formatMessage((0, $PyWGC.default).notFoundHeader),
        description: formatMessage((0, $PyWGC.default).notFoundDescription),
        onRetry: ()=>{
            // If data source errors out let user retry the current page they are on.
            // Otherwise queue doesn't exist so go back to /queues
            if (queuesDataSource.error) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.reload();
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.assign(`${baseUrl}/jira/servicedesk/projects/${projectKey}/queues`);
        }
    });
    lastUnfoundQueue.current = queueId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79GY5.default), null);
};

});
parcelRegister("eae50", function(module, exports) {

$parcel$export(module.exports, "default", () => $da809c0c454ce05f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $3s0xG = parcelRequire("3s0xG");

var $az4zD = parcelRequire("az4zD");

var $lB1Xg = parcelRequire("lB1Xg");

var $9Le4I = parcelRequire("9Le4I");

var $63TJV = parcelRequire("63TJV");
function $da809c0c454ce05f$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage, headingLevel: headingLevel } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($lB1Xg))) : (0, (/*@__PURE__*/$parcel$interopDefault($9Le4I)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        testId: "common-components-error-state.empty-state",
        size: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: headingLevel
    });
}
$da809c0c454ce05f$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $63TJV.default).retry
};
var $da809c0c454ce05f$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($da809c0c454ce05f$export$edf27be85e5f6da0);

});
parcelRegister("lB1Xg", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("9Le4I", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("63TJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbeb04399739f055$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cbeb04399739f055$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("79GY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bdab3bb4aeae840$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $clxo5 = parcelRequire("clxo5");
// No delay on this spinner; we don't know if the monolith had previously
// provided one. Better to increase risk a very brief display of a spinner
// than have the spinner vanish and return.
const $7bdab3bb4aeae840$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7bdab3bb4aeae840$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        size: "large",
        testId: "servicedesk-common.ui.components.page-spinner.spinner"
    }));
var $7bdab3bb4aeae840$export$2e2bcd8739ae039 = $7bdab3bb4aeae840$var$LoadingSpinner;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7bdab3bb4aeae840$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154i1jfw _1bsb1osq _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hN5eZ", function(module, exports) {

$parcel$export(module.exports, "getLastVisitedQueueIdAndCategory", () => $3f3da0d4b812d0bb$export$b5b4407b2529d2c4);
$parcel$export(module.exports, "setLastVisitedQueueIdAndCategory", () => $3f3da0d4b812d0bb$export$947aff127337ffa5);

var $gccSB = parcelRequire("gccSB");

var $3HGy4 = parcelRequire("3HGy4");

var $5j0B5 = parcelRequire("5j0B5");

var $oCMSG = parcelRequire("oCMSG");

var $1ilU2 = parcelRequire("1ilU2");
const $3f3da0d4b812d0bb$var$LAST_VISITED_QUEUE_KEY_PREFIX = 'last_visited_queue';
const $3f3da0d4b812d0bb$var$LAST_VISITED_CATEGORY_KEY_PREFIX = 'last_visited_category';
const $3f3da0d4b812d0bb$export$b5b4407b2529d2c4 = (projectKey, category = (0, $oCMSG.NO_CATEGORY))=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectKey)) return [
        null,
        null
    ];
    try {
        if (category === (0, $oCMSG.NO_CATEGORY)) {
            // indicates a redirect from /queues endpoint
            const categoryToRedirectTo = (0, $5j0B5.getFromLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_CATEGORY_KEY_PREFIX}_${projectKey}`);
            const queueId = (0, $5j0B5.getFromLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${categoryToRedirectTo}`);
            return [
                queueId,
                ...(0, $1ilU2.isValidItsmPractice)(categoryToRedirectTo) ? [
                    categoryToRedirectTo
                ] : [
                    (0, $oCMSG.NO_CATEGORY)
                ]
            ];
        }
        return [
            (0, $5j0B5.getFromLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`),
            category
        ];
    } catch (error) {
        return [
            null,
            null
        ];
    }
};
const $3f3da0d4b812d0bb$export$947aff127337ffa5 = (queueId, projectKey, category = (0, $oCMSG.NO_CATEGORY))=>{
    let lastVisitedQueueId;
    try {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectKey)) throw new Error('project key is empty');
        lastVisitedQueueId = (0, $5j0B5.getFromLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`);
    } catch (error) {
        lastVisitedQueueId = null;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectKey) && lastVisitedQueueId !== queueId) try {
        (0, $5j0B5.setInLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`, (0, $3HGy4.fromQueueIdString)(queueId));
        (0, $5j0B5.setInLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_CATEGORY_KEY_PREFIX}_${projectKey}`, category);
    } catch (error) {
    // Don't care if it fails. Default behavior in QueuesRedirect will take users to first available queue.
    }
};

});
parcelRegister("1ilU2", function(module, exports) {

$parcel$export(module.exports, "toItsmPractice", () => $27eaa4458d2c6986$export$1b27246f3c7494c);
$parcel$export(module.exports, "isValidItsmPractice", () => $27eaa4458d2c6986$export$357b94e419749e3d);

var $oCMSG = parcelRequire("oCMSG");
const $27eaa4458d2c6986$export$1b27246f3c7494c = (practiceString)=>{
    switch(practiceString){
        case 'incidents':
            return 0, $oCMSG.INCIDENTS;
        case 'changes':
            return 0, $oCMSG.CHANGES;
        case 'service-requests':
            return 0, $oCMSG.SERVICE_REQUEST;
        case 'problems':
            return 0, $oCMSG.PROBLEMS;
        case 'post-incident-reviews':
            return 0, $oCMSG.POST_INCIDENT_REVIEWS;
        default:
            return 0, $oCMSG.NO_CATEGORY;
    }
};
const $27eaa4458d2c6986$export$357b94e419749e3d = (practiceString)=>{
    switch(practiceString){
        case 0, $oCMSG.INCIDENTS:
        case 0, $oCMSG.CHANGES:
        case 0, $oCMSG.SERVICE_REQUEST:
        case 0, $oCMSG.PROBLEMS:
        case 0, $oCMSG.POST_INCIDENT_REVIEWS:
        case 0, $oCMSG.NO_CATEGORY:
            return true;
        default:
            return false;
    }
};

});


parcelRegister("PyWGC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3c71f925aa4f1e4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f3c71f925aa4f1e4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notFoundHeader: {
        "id": "servicedesk-queues-available-queues-api.queue-provider.not-found-header",
        "defaultMessage": "We couldn't find your queue"
    },
    notFoundDescription: {
        "id": "servicedesk-queues-available-queues-api.queue-provider.not-found-description",
        "defaultMessage": "Looks like we\u2019re having trouble connecting, or it may have been removed."
    }
});

});



parcelRegister("jF62O", function(module, exports) {

$parcel$export(module.exports, "useCategorizedNavItems", () => $8f1bc4ac72406fd0$export$fec6561bcaa1c55b);
$parcel$export(module.exports, "useCurrentCategorizedNavItems", () => $8f1bc4ac72406fd0$export$f9b7a4e20c09f3ce);
$parcel$export(module.exports, "useCategorizedQueues", () => $8f1bc4ac72406fd0$export$c4ca47ba8c81dba6);
$parcel$export(module.exports, "useFavouriteNavItems", () => $8f1bc4ac72406fd0$export$e27d61833d43b175);
$parcel$export(module.exports, "usePracticeMetadata", () => $8f1bc4ac72406fd0$export$f857eeb50ae9b1b2);
$parcel$export(module.exports, "usePracticeList", () => $8f1bc4ac72406fd0$export$216a9245ead6e18a);
$parcel$export(module.exports, "CategorizedQueuesStore", () => $8f1bc4ac72406fd0$export$5577ca8a6b2fed3c);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $1WlLE = parcelRequire("1WlLE");

var $oCMSG = parcelRequire("oCMSG");

var $bebaD = parcelRequire("bebaD");

var $fyiDq = parcelRequire("fyiDq");

var $2lO5M = parcelRequire("2lO5M");
const $8f1bc4ac72406fd0$var$useCategorizedData = (category, dataSelector, customContext)=>{
    const { data: allData, loading: loading, error: error, refresh: refresh } = (0, $324W5.useResourceWithCustomRouterContext)((0, $1WlLE.queuesNavigationItems), customContext);
    const memoizedData = (0, $5uXOq.useMemo)(()=>dataSelector(allData, category), [
        allData,
        category,
        dataSelector
    ]);
    return [
        memoizedData,
        loading,
        error,
        refresh
    ];
};
const $8f1bc4ac72406fd0$export$fec6561bcaa1c55b = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error, refresh] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.navDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods,
        refresh
    ];
};
const $8f1bc4ac72406fd0$export$f9b7a4e20c09f3ce = ()=>{
    const projectKey = (0, $bebaD.useProjectKey)();
    const category = (0, $bebaD.useCurrentCategory)();
    const [data, loading, error, methods] = $8f1bc4ac72406fd0$export$c4ca47ba8c81dba6('', projectKey, category);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$1dc9816387d038aa = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY))=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category);
    const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.notFavouriteDataSelector));
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$e27d61833d43b175 = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.favouriteDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$528be43f76fe19f7 = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.notFavouriteAndCanBeHiddenDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$4c168500ca36ad18 = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.cannotBeHiddenAndNotFavouriteDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$c4ca47ba8c81dba6 = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY))=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category);
    const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.queuesDataSelector));
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$f857eeb50ae9b1b2 = (category = (0, $oCMSG.NO_CATEGORY), customContext)=>$8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.practiceMetadataSelector), customContext);
const $8f1bc4ac72406fd0$export$216a9245ead6e18a = (customContext)=>$8f1bc4ac72406fd0$var$useCategorizedData((0, $oCMSG.NO_CATEGORY), (0, $fyiDq.practiceListSelector), customContext);
const $8f1bc4ac72406fd0$export$5577ca8a6b2fed3c = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
    const [data, loading, error, methods] = $8f1bc4ac72406fd0$export$c4ca47ba8c81dba6(baseUrl, projectKey, category);
    return children({
        data: data,
        loading: loading,
        error: error,
        methods: methods
    });
};
const $8f1bc4ac72406fd0$export$aea9dc5735ed30c = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
    const [data, loading, error, methods] = $8f1bc4ac72406fd0$export$fec6561bcaa1c55b(baseUrl, projectKey, category);
    return children({
        data: data,
        loading: loading,
        error: error,
        methods: methods
    });
};
$8f1bc4ac72406fd0$export$5577ca8a6b2fed3c.defaultProps = {
    category: (0, $oCMSG.NO_CATEGORY)
};
$8f1bc4ac72406fd0$export$aea9dc5735ed30c.defaultProps = {
    category: (0, $oCMSG.NO_CATEGORY)
};

});
parcelRegister("bebaD", function(module, exports) {

$parcel$export(module.exports, "getQueuesForCategory", () => $f538431335917e3a$export$fcf9c653a5f7167a);
$parcel$export(module.exports, "setQueuesForCategory", () => $f538431335917e3a$export$7ca50bfd96f22f76);
$parcel$export(module.exports, "queuesToNavItems", () => $f538431335917e3a$export$e6491f132367997c);
$parcel$export(module.exports, "useProjectKey", () => $f538431335917e3a$export$f87be37f8e8be65);
$parcel$export(module.exports, "useCurrentCategory", () => $f538431335917e3a$export$e42116f2f5c27c35);

var $7uUwQ = parcelRequire("7uUwQ");

var $dd29Z = parcelRequire("dd29Z");

var $1ilU2 = parcelRequire("1ilU2");

var $g5X3G = parcelRequire("g5X3G");

var $doZTA = parcelRequire("doZTA");
const $f538431335917e3a$export$fcf9c653a5f7167a = (data, category)=>(0, $7uUwQ.getIn)(data, [
        category,
        'queues'
    ]);
const $f538431335917e3a$export$7ca50bfd96f22f76 = (data, category, newQueues)=>// @ts-expect-error(PARTIAL_RECORD) TS2740 - Type '{}' is missing the following properties from type 'CategorizedQueueData': "change-management", "incident-management", "problem-management", "service-request", and 2 more.
    (0, $7uUwQ.updateIn)(data || {}, [
        category,
        'queues'
    ], (queues)=>{
        // We only want to update queues if they exist in a category already
        if (queues) return newQueues;
        throw new Error(`${category} does not exist in resource`);
    });
const $f538431335917e3a$export$e6491f132367997c = (queues)=>queues.map(({ id: id, name: name, projectKey: projectKey, count: count, category: category, favourite: favourite, canBeHidden: canBeHidden, shouldSkipIssueCountRefresh: shouldSkipIssueCountRefresh, lastRefreshedTime: lastRefreshedTime })=>({
            id: String(id),
            name: name,
            url: `/projects/${projectKey}/${(0, $dd29Z.getQueueFragment)(id, category)}`,
            badgeCount: count,
            starred: favourite,
            canBeHidden: canBeHidden,
            shouldSkipIssueCountRefresh: shouldSkipIssueCountRefresh,
            category: category,
            lastRefreshedTime: lastRefreshedTime
        }));
const $f538431335917e3a$export$f87be37f8e8be65 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    return (0, $g5X3G.toProjectKey)(match.params.projectKey || '');
};
const $f538431335917e3a$export$e42116f2f5c27c35 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    return (0, $1ilU2.toItsmPractice)(match.params.practiceType);
};

});

parcelRegister("fyiDq", function(module, exports) {

$parcel$export(module.exports, "queuesDataSelector", () => $1df222051fb5e2fa$export$fe10e38dc2f0e4c8);
$parcel$export(module.exports, "navDataSelector", () => $1df222051fb5e2fa$export$caf8de9cbdbf9102);
$parcel$export(module.exports, "notFavouriteAndCanBeHiddenDataSelector", () => $1df222051fb5e2fa$export$231e113a2e075013);
$parcel$export(module.exports, "notFavouriteDataSelector", () => $1df222051fb5e2fa$export$46aa703ec1a01e);
$parcel$export(module.exports, "cannotBeHiddenAndNotFavouriteDataSelector", () => $1df222051fb5e2fa$export$f28545acfde3f70e);
$parcel$export(module.exports, "favouriteDataSelector", () => $1df222051fb5e2fa$export$fc3fab89f453b08e);
$parcel$export(module.exports, "practiceMetadataSelector", () => $1df222051fb5e2fa$export$b0af22bb6bff9c49);
$parcel$export(module.exports, "isCountLoadingSelector", () => $1df222051fb5e2fa$export$efbcd30acb5e816f);
$parcel$export(module.exports, "hasRequestedCountSelector", () => $1df222051fb5e2fa$export$54e54a1ac5e7098f);
$parcel$export(module.exports, "practiceListSelector", () => $1df222051fb5e2fa$export$61d9fd7be029b514);

var $7uUwQ = parcelRequire("7uUwQ");

var $bebaD = parcelRequire("bebaD");
const $1df222051fb5e2fa$export$fe10e38dc2f0e4c8 = (data, category)=>(0, $bebaD.getQueuesForCategory)(data, category) || null;
const $1df222051fb5e2fa$export$caf8de9cbdbf9102 = (data, category)=>{
    const queues = (0, $bebaD.getQueuesForCategory)(data, category);
    return queues ? (0, $bebaD.queuesToNavItems)(queues) : null;
};
const $1df222051fb5e2fa$export$231e113a2e075013 = (data, category)=>{
    const queues = (0, $bebaD.getQueuesForCategory)(data, category);
    const otherQueuesData = queues ? queues.filter((q)=>q.canBeHidden && !q.favourite) : null;
    return otherQueuesData ? (0, $bebaD.queuesToNavItems)(otherQueuesData) : null;
};
const $1df222051fb5e2fa$export$46aa703ec1a01e = (data, category)=>{
    const queues = (0, $bebaD.getQueuesForCategory)(data, category);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const otherQueuesData = queues ? queues.filter((q)=>!q.favourite) : null;
    return otherQueuesData ? (0, $bebaD.queuesToNavItems)(otherQueuesData) : null;
};
const $1df222051fb5e2fa$export$f28545acfde3f70e = (data, category)=>{
    const queues = (0, $bebaD.getQueuesForCategory)(data, category);
    const defaultQueuesData = queues ? queues.filter((q)=>!q.canBeHidden && !q.favourite) : null;
    return defaultQueuesData ? (0, $bebaD.queuesToNavItems)(defaultQueuesData) : null;
};
const $1df222051fb5e2fa$export$fc3fab89f453b08e = (data, category)=>{
    const queues = (0, $bebaD.getQueuesForCategory)(data, category);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const starredQueues = queues ? queues.filter((q)=>q.favourite) : null;
    return starredQueues ? (0, $bebaD.queuesToNavItems)(starredQueues) : null;
};
const $1df222051fb5e2fa$export$b0af22bb6bff9c49 = (data, category)=>{
    const practiceData = (0, $7uUwQ.getIn)(data, [
        category
    ]);
    return practiceData ? (0, $7uUwQ.dissoc)(practiceData, 'queues') : null;
};
const $1df222051fb5e2fa$export$efbcd30acb5e816f = (data, category)=>{
    const practiceData = (0, $7uUwQ.getIn)(data, [
        category
    ]);
    return practiceData ? practiceData.isCountLoading : false;
};
const $1df222051fb5e2fa$export$54e54a1ac5e7098f = (data, category)=>{
    const practiceData = (0, $7uUwQ.getIn)(data, [
        category
    ]);
    return practiceData ? practiceData.hasRequestedCount : false;
};
const $1df222051fb5e2fa$export$61d9fd7be029b514 = (data)=>// @ts-expect-error - TS2322 - Type 'string[] | null' is not assignable to type 'Data<ItsmPractice[]>'.
    data ? Object.keys(data) : null;

});

parcelRegister("2lO5M", function(module, exports) {

$parcel$export(module.exports, "useCategorizedActions", () => $ff5cc066d5a13377$export$8632bfeb0b672958);
$parcel$export(module.exports, "default", () => $ff5cc066d5a13377$export$2e2bcd8739ae039);

var $324W5 = parcelRequire("324W5");

var $1WlLE = parcelRequire("1WlLE");

var $a4M45 = parcelRequire("a4M45");
const $ff5cc066d5a13377$export$8632bfeb0b672958 = (baseUrl, projectKey, category, customContext)=>{
    const { update: update } = (0, $324W5.useResourceWithCustomRouterContext)((0, $1WlLE.queuesNavigationItems), customContext);
    const cachedActions = (0, $a4M45.default)(category, update, {
        baseUrl: baseUrl,
        projectKey: projectKey
    });
    return [
        cachedActions
    ];
};
const $ff5cc066d5a13377$var$ActionsProvider = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
    const [actions] = $ff5cc066d5a13377$export$8632bfeb0b672958(baseUrl, projectKey, category);
    return children(actions);
};
var $ff5cc066d5a13377$export$2e2bcd8739ae039 = $ff5cc066d5a13377$var$ActionsProvider;

});
parcelRegister("a4M45", function(module, exports) {

$parcel$export(module.exports, "default", () => $64c8b4db868052f8$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $6vsnF = parcelRequire("6vsnF");
const $64c8b4db868052f8$export$36d128238e6b60f5 = {
    currentCacheKey: '',
    // @ts-expect-error(PARTIAL_RECORD) TS2740 - Type '{}' is missing the following properties from type 'Record<ItsmPractice, ChildrenProps>': "change-management", "incident-management", "problem-management", "service-request", and 2 more.
    actionsByCategory: {}
};
const $64c8b4db868052f8$export$8b3bc28eb06c49b6 = {
    // Actions are lazily created for each category of a project.
    // Project key is used as the cache key. Once the cache key has changed
    // the store will be reset
    getActions: (...args)=>({ getState: getState, setState: setState })=>{
            const [category, , { projectKey: projectKey }] = args;
            const { currentCacheKey: currentCacheKey, actionsByCategory: actionsByCategory } = getState();
            const categoryActions = actionsByCategory[category];
            const hasSameKey = projectKey === currentCacheKey;
            if (hasSameKey && Boolean(categoryActions)) return categoryActions;
            const newCategoryActions = (0, $6vsnF.getActions)(...args);
            setState({
                currentCacheKey: projectKey,
                // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type '{ "change-management"?: Actions | undefined; "incident-management"?: Actions | undefined; "problem-management"?: Actions | undefined; "service-request"?: Actions | undefined; "post-incident-review"?: Actions | undefined; "no-category"?: Actions | undefined; }' is not assignable to type 'Record<ItsmPractice, ChildrenProps>'.
                actionsByCategory: {
                    ...hasSameKey ? actionsByCategory : {},
                    [category]: newCategoryActions
                }
            });
            return newCategoryActions;
        }
};
const $64c8b4db868052f8$var$Store = (0, $iXqE5.createStore)({
    initialState: $64c8b4db868052f8$export$36d128238e6b60f5,
    actions: $64c8b4db868052f8$export$8b3bc28eb06c49b6,
    name: 'jira-servicedesk-categorized-queues-actions-store'
});
const $64c8b4db868052f8$var$useActionsStore = (0, $3sQ5x.createHook)($64c8b4db868052f8$var$Store, {
    selector: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});
const $64c8b4db868052f8$export$193cb0fec61d3692 = (...args)=>{
    const [, { getActions: getActions }] = $64c8b4db868052f8$var$useActionsStore();
    return getActions(...args);
};
var $64c8b4db868052f8$export$2e2bcd8739ae039 = $64c8b4db868052f8$export$193cb0fec61d3692;

});
parcelRegister("6vsnF", function(module, exports) {

$parcel$export(module.exports, "getActions", () => $62968e378f0259c7$export$fe3955935f564b31);

var $7uUwQ = parcelRequire("7uUwQ");

var $34ck9 = parcelRequire("34ck9");


var $6s1PB = parcelRequire("6s1PB");

var $fZneA = parcelRequire("fZneA");

var $2nYuf = parcelRequire("2nYuf");

var $jHq2C = parcelRequire("jHq2C");

var $90q41 = parcelRequire("90q41");

var $bebaD = parcelRequire("bebaD");

var $fyiDq = parcelRequire("fyiDq");

var $czC6V = parcelRequire("czC6V");

var $kTfMz = parcelRequire("kTfMz");
const $62968e378f0259c7$var$getThrottledRefresh = ()=>Number((0, $6s1PB.expVal)('jsm_dynamic_queues_issue_count_refresh_interval', 'value', '120000'));
const $62968e378f0259c7$var$getAnalyticsPayload = (err)=>{
    const wasQueueDeleted = err?.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef);
    const queueConflictOccurred = err?.statusCode === (0, $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f);
    const queueActionNotPermitted = err?.statusCode === (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3);
    return {
        wasQueueDeleted: wasQueueDeleted,
        queueConflictOccurred: queueConflictOccurred,
        queueActionNotPermitted: queueActionNotPermitted,
        isClientFetchError: (0, $fZneA.isClientFetchError)(err)
    };
};
const $62968e378f0259c7$export$fe3955935f564b31 = (category, update, restParams)=>{
    const actions = {
        addItem: (item)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.addItem)(queues, item));
                throw new Error(`Cannot add item because ${category} does not exist in resource`);
            });
        },
        deleteItem: (id)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.deleteItem)(queues, id));
                throw new Error(`Cannot delete item because ${category} does not exist in resource`);
            });
        },
        editItem: (item)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.editItem)(queues, item));
                throw new Error(`Cannot edit item because ${category} does not exist in resource`);
            });
        },
        moveItem: (from, to)=>{
            if (from !== to) update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kTfMz.moveItem)(queues, from, to);
                    (0, $jHq2C.setQueues)(baseUrl, projectKey, (0, $bebaD.queuesToNavItems)(result), category);
                    return (0, $bebaD.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item because ${category} does not exist in resource`);
            });
        },
        moveItemBelow: (queueId, targetQueueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kTfMz.moveItemBelow)(queues, queueId, targetQueueId);
                    (0, $jHq2C.setQueues)(baseUrl, projectKey, (0, $bebaD.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($62968e378f0259c7$var$getAnalyticsPayload(err)));
                    return (0, $bebaD.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item below because ${category} does not exist in resource`);
            });
        },
        moveItemAbove: (queueId, targetQueueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kTfMz.moveItemAbove)(queues, queueId, targetQueueId);
                    (0, $jHq2C.setQueues)(baseUrl, projectKey, (0, $bebaD.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($62968e378f0259c7$var$getAnalyticsPayload(err)));
                    return (0, $bebaD.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item above because ${category} does not exist in resource`);
            });
        },
        moveToTop: (queueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kTfMz.moveToTop)(queues, queueId);
                    (0, $jHq2C.setQueues)(baseUrl, projectKey, (0, $bebaD.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($62968e378f0259c7$var$getAnalyticsPayload(err)));
                    return (0, $bebaD.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item to top because ${category} does not exist in resource`);
            });
        },
        refreshNavItems: (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))((analyticsEvent)=>{
            setTimeout(()=>{
                update((data)=>{
                    const isCountLoading = (0, $fyiDq.isCountLoadingSelector)(data, category);
                    if (isCountLoading) return data;
                    if (restParams.projectKey) (0, $czC6V.refreshIssueCountForVisibleAndStarredQueues)(update, {
                        ...restParams,
                        category: category
                    }, analyticsEvent);
                    const updatedData = data ? (0, $7uUwQ.assocIn)(data, [
                        category,
                        'isCountLoading'
                    ], true) : null;
                    return updatedData;
                });
            // Jitter the call randomly between 1 - 5secs in case of multiple tab requests
            }, Math.floor(Math.random() * 5000) + 1000);
        }, $62968e378f0259c7$var$getThrottledRefresh()),
        initialFetchNavItems: (analyticsEvent)=>{
            update((data)=>{
                const isCountLoading = (0, $fyiDq.isCountLoadingSelector)(data, category);
                const hasRequestedCount = (0, $fyiDq.hasRequestedCountSelector)(data, category);
                if (!isCountLoading && !hasRequestedCount) actions.refreshNavItems(analyticsEvent);
                return data;
            });
        },
        refreshIssueCountForItems: (queueIds, analyticsEvent)=>{
            (0, $czC6V.refreshIssueCountForQueues)(update, {
                ...restParams,
                category: category
            }, queueIds, analyticsEvent);
        },
        editItemIssueCount: (id, count)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.editItem)(queues, {
                    id: Number(id),
                    count: count,
                    lastRefreshedTime: Date.now()
                }));
                // There is no point update the issue-counts for default queue as there is no queues.
                // It might throwing exceptions if we cannot fetch queue categories.
                // Being defensive here for the rollout, if this code throw any errors, it's the same behavior as the below line.
                if (Number(id) === (0, $2nYuf.DEFAULT_QUEUE_ID)) return data;
                throw new Error(`Cannot edit item issue count because ${category} does not exist in resource for queue id ${id}`);
            });
        },
        editItemFavorite: (id, favourite)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.editItem)(queues, {
                    id: Number(id),
                    favourite: favourite
                }));
                throw new Error(`Cannot edit item favorite because ${category} does not exist in resource`);
            });
        },
        editVisibilityOfItems: (updatedItems, draggableId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                if (queues) {
                    (0, $90q41.updateQueuesVisibility)(baseUrl, projectKey, updatedItems).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($62968e378f0259c7$var$getAnalyticsPayload(err)));
                    return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.editItems)(queues, [
                        ...updatedItems
                    ]));
                }
                throw new Error(`Cannot edit item favorite because ${category} does not exist in resource`);
            });
        },
        enableRefreshForQueues: (queueIds)=>{
            (0, $czC6V.enableRefreshForQueues)(update, {
                ...restParams,
                category: category
            }, queueIds);
        },
        enableIssueCountForSelectedQueues: (selectedQueueIds)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.enableSelectedQueuesVisibility)(selectedQueueIds, queues));
                throw new Error(`Cannot enable issue count for selected queues because ${category} does not exist in resource`);
            });
        }
    };
    return actions;
};

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

parcelRegister("2nYuf", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COLUMNS", () => $55f991500b621537$export$50c19f60b9c144f7);
$parcel$export(module.exports, "DEFAULT_QUEUE_ID", () => $55f991500b621537$export$e78379cc32bff512);
$parcel$export(module.exports, "FETCH_BATCH_SIZE", () => $55f991500b621537$export$baa236d86cd0d3f5);
$parcel$export(module.exports, "FETCH_SIZE_IN_INITIAL_LOAD", () => $55f991500b621537$export$4ee65d92b7b81b6b);
const $55f991500b621537$export$50c19f60b9c144f7 = [
    'issuetype',
    'issuekey',
    'summary',
    'reporter',
    'assignee',
    'status',
    'created'
];
const $55f991500b621537$export$e78379cc32bff512 = Number.MIN_VALUE;
const $55f991500b621537$export$baa236d86cd0d3f5 = 100;
const $55f991500b621537$export$4ee65d92b7b81b6b = 30;

});

parcelRegister("jHq2C", function(module, exports) {

$parcel$export(module.exports, "setQueues", () => $7a268253f439fbe8$export$51b06787b88b2bf2);

var $eusud = parcelRequire("eusud");

var $2m5JT = parcelRequire("2m5JT");
const $7a268253f439fbe8$var$getQueuesUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues`;
const $7a268253f439fbe8$export$51b06787b88b2bf2 = (baseUrl, projectKey, queues, category)=>(0, $eusud.performPutRequest)($7a268253f439fbe8$var$getQueuesUrl(baseUrl, projectKey), {
        body: JSON.stringify((0, $2m5JT.transformQueues)(queues, category))
    });

});
parcelRegister("2m5JT", function(module, exports) {

$parcel$export(module.exports, "transformQueues", () => $21e5ad652b3de239$export$66ec85c65393edb4);

var $oCMSG = parcelRequire("oCMSG");
const $21e5ad652b3de239$export$66ec85c65393edb4 = (queues, category)=>({
        order: queues.map((queue)=>queue.id),
        id: 'com.atlassian.servicedesk.project-ui:sd-queues-custom',
        inline: true,
        deleted: [],
        ...category && category !== (0, $oCMSG.NO_CATEGORY) ? {
            category: category
        } : undefined
    });

});


parcelRegister("90q41", function(module, exports) {

$parcel$export(module.exports, "updateQueuesVisibility", () => $8ab251897e60612e$export$c0862f2fb17c23c2);

var $eusud = parcelRequire("eusud");
const $8ab251897e60612e$var$getUpdateQueuesVisibilityUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues/update-visibility`;
const $8ab251897e60612e$export$c0862f2fb17c23c2 = (baseUrl, projectKey, modified)=>(0, $eusud.performPutRequest)($8ab251897e60612e$var$getUpdateQueuesVisibilityUrl(baseUrl, projectKey), {
        body: JSON.stringify({
            modified: modified
        })
    });

});

parcelRegister("czC6V", function(module, exports) {

$parcel$export(module.exports, "refreshIssueCountForVisibleAndStarredQueues", () => $d32f12b3757f33df$export$aaa6aeca5994daee);
$parcel$export(module.exports, "enableRefreshForQueues", () => $d32f12b3757f33df$export$6b0c14cefee3edf5);
$parcel$export(module.exports, "refreshIssueCountForQueues", () => $d32f12b3757f33df$export$b05e3887bfb123a8);

var $7uUwQ = parcelRequire("7uUwQ");

var $4Xk2W = parcelRequire("4Xk2W");

var $8Rkzz = parcelRequire("8Rkzz");

var $7qDUb = parcelRequire("7qDUb");

var $jcw0u = parcelRequire("jcw0u");

var $bebaD = parcelRequire("bebaD");

var $fyiDq = parcelRequire("fyiDq");

var $l6KG9 = parcelRequire("l6KG9");
const $d32f12b3757f33df$export$defcbd4ba0fd3734 = 5;
const $d32f12b3757f33df$var$RETRY_DELAY_IN_MS = 1000;
const $d32f12b3757f33df$var$fireErrorAnalyticsForRetryFailure = (error)=>{
    (0, $jcw0u.default)({
        meta: {
            id: 'retryQueueIssueCountAction',
            packageName: 'jiraServicedeskCategorizedQueuesStore',
            teamName: 'jsd-shield'
        },
        error: error
    });
};
const $d32f12b3757f33df$export$ef7266a9f6c0de43 = ({ baseUrl: baseUrl, projectKey: projectKey, category: category }, skipHiddenQueues, update, retryCount, analyticsEvent)=>async (queueIds)=>{
        if (queueIds && queueIds.length === 0) return;
        if (retryCount >= $d32f12b3757f33df$export$defcbd4ba0fd3734) {
            (0, $l6KG9.fireManualOperationalAnalytics)({
                source: 'refreshQueueIssueCountAction',
                actionSubject: 'retryIssueCount',
                action: 'limitExceeded',
                attributes: {
                    retryCount: retryCount,
                    maxRetryCount: $d32f12b3757f33df$export$defcbd4ba0fd3734
                }
            });
            return;
        }
        setTimeout(()=>{
            try {
                const newRetryCount = retryCount + 1;
                update((data)=>{
                    const queues = (0, $bebaD.getQueuesForCategory)(data, category)?.filter((queue)=>queueIds.includes(queue.id));
                    if (queues && queues.length > 0) {
                        const retryCallback = $d32f12b3757f33df$export$ef7266a9f6c0de43({
                            baseUrl: baseUrl,
                            projectKey: projectKey,
                            category: category
                        }, true, update, newRetryCount, analyticsEvent);
                        (0, $l6KG9.updateIssueCountForQueues)(baseUrl, projectKey, category, queues, skipHiddenQueues, update, retryCallback, analyticsEvent);
                        (0, $l6KG9.fireManualOperationalAnalytics)({
                            source: 'refreshQueueIssueCountAction',
                            actionSubject: 'retryQueueIssueCount',
                            action: 'triggered',
                            attributes: {
                                retryCount: newRetryCount,
                                maxRetryCount: $d32f12b3757f33df$export$defcbd4ba0fd3734,
                                queuesCount: queues.length
                            }
                        });
                        return data ? (0, $7uUwQ.assocIn)(data, [
                            category,
                            'isCountLoading'
                        ], true) : null;
                    }
                    return data;
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                $d32f12b3757f33df$var$fireErrorAnalyticsForRetryFailure(error);
                throw error;
            }
        }, $d32f12b3757f33df$var$RETRY_DELAY_IN_MS);
    };
const $d32f12b3757f33df$export$aaa6aeca5994daee = async (update, { baseUrl: baseUrl, projectKey: projectKey, category: category }, analyticsEvent)=>{
    try {
        update((data)=>{
            const queues = (0, $bebaD.getQueuesForCategory)(data, category);
            const retryCallback = !(0, $fyiDq.hasRequestedCountSelector)(data, category) ? $d32f12b3757f33df$export$ef7266a9f6c0de43({
                baseUrl: baseUrl,
                projectKey: projectKey,
                category: category
            }, true, update, 0, analyticsEvent) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
            if (queues) {
                (0, $l6KG9.updateIssueCountForQueues)(baseUrl, projectKey, category, queues, true, update, retryCallback, analyticsEvent);
                return data ? (0, $7uUwQ.assocIn)(data, [
                    category,
                    'isCountLoading'
                ], true) : null;
            }
            return data;
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $l6KG9.fireErrorAnalyticsForRefreshCountFailure)(error);
        throw error;
    }
};
const $d32f12b3757f33df$export$6b0c14cefee3edf5 = (update, { projectKey: _, category: category }, queueIds)=>{
    update((data)=>{
        const queues = (0, $bebaD.getQueuesForCategory)(data, category);
        const refreshEnabledQueues = queues?.filter((queue)=>queueIds.includes(queue.id.toString())).map((queue)=>queue.shouldSkipIssueCountRefresh ? {
                ...queue,
                shouldSkipIssueCountRefresh: false,
                count: undefined
            } : queue);
        const queuesMap = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(queues, 'id');
        refreshEnabledQueues?.forEach((queue)=>{
            queuesMap[queue.id] = queue;
        });
        return (0, $bebaD.setQueuesForCategory)(data, category, (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(Object.values(queuesMap), 'order'));
    });
};
const $d32f12b3757f33df$export$b05e3887bfb123a8 = async (update, { baseUrl: baseUrl, projectKey: projectKey, category: category }, queueIds, analyticsEvent)=>{
    try {
        update((data)=>{
            const queues = (0, $bebaD.getQueuesForCategory)(data, category)?.filter((queue)=>queueIds.includes(queue.id.toString()));
            if (queues && queues.length > 0) {
                (0, $l6KG9.updateIssueCountForQueues)(baseUrl, projectKey, category, queues, false, update, (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), analyticsEvent);
                return data ? (0, $7uUwQ.assocIn)(data, [
                    category,
                    'isCountLoading'
                ], true) : null;
            }
            return data;
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $l6KG9.fireErrorAnalyticsForRefreshCountFailure)(error);
        throw error;
    }
};

});
parcelRegister("l6KG9", function(module, exports) {

$parcel$export(module.exports, "fireManualOperationalAnalytics", () => $fa1880944e28b500$export$a9301d18019c11f9);
$parcel$export(module.exports, "fireErrorAnalyticsForRefreshCountFailure", () => $fa1880944e28b500$export$b5e2038970f91d6c);
$parcel$export(module.exports, "updateIssueCountForQueues", () => $fa1880944e28b500$export$d436cbef77099410);

var $7uUwQ = parcelRequire("7uUwQ");

var $hUobS = parcelRequire("hUobS");

var $4Xk2W = parcelRequire("4Xk2W");

var $7qDUb = parcelRequire("7qDUb");

var $dMEgP = parcelRequire("dMEgP");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");

var $g9E9n = parcelRequire("g9E9n");

var $7ZmbO = parcelRequire("7ZmbO");

var $bebaD = parcelRequire("bebaD");
const $fa1880944e28b500$var$ERROR_DB_TIMEOUT = 'error.db-timeout';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $fa1880944e28b500$var$ERROR_UNKNOWN = 'error.unknown';
const $fa1880944e28b500$export$cf85cf6a45b00808 = {
    FAILED: 'failed',
    SUCCESS: 'success',
    PENDING: 'pending'
};
const $fa1880944e28b500$var$MAX_ISSUECOUNT_THRESHOLD = 1000;
const $fa1880944e28b500$export$a9301d18019c11f9 = (payload)=>(0, $g9E9n.getAnalyticsWebClient)().getInstance().sendOperationalEvent(payload);
const $fa1880944e28b500$var$filterOutHiddenQueues = (queues)=>queues.filter((q)=>!(q.canBeHidden === undefined ? false : q.canBeHidden) || q.favourite);
const $fa1880944e28b500$var$filterOutBadQueues = (queues)=>queues.filter((q)=>!q.shouldSkipIssueCountRefresh);
const $fa1880944e28b500$var$getIssueCountPerGroup = (issueCounts)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(issueCounts).reduce((curr, queueId)=>{
        const res = curr;
        if (issueCounts[Number(queueId)]) {
            if (issueCounts[Number(queueId)].issueCount || issueCounts[Number(queueId)].issueCount === 0) res[Number(queueId)] = issueCounts[Number(queueId)].issueCount;
        }
        return res;
    }, {});
const $fa1880944e28b500$var$getQueuesPerGroup = (queues, skipHiddenQueues)=>{
    const starredQueues = [];
    const defaultQueues = [];
    let toGroupQueues = queues;
    let hasSkippedQueues = false;
    if (skipHiddenQueues === true) toGroupQueues = $fa1880944e28b500$var$filterOutHiddenQueues(queues);
    toGroupQueues = $fa1880944e28b500$var$filterOutBadQueues(toGroupQueues);
    let queueByGroups = {};
    toGroupQueues.forEach((queue)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hUobS)))(queue.count) && queue.count > $fa1880944e28b500$var$MAX_ISSUECOUNT_THRESHOLD) {
            hasSkippedQueues = true;
            return;
        }
        if (queue.favourite) starredQueues.push(queue);
        else defaultQueues.push(queue);
    });
    queueByGroups = {
        starredQueues: starredQueues,
        defaultQueues: defaultQueues
    };
    if (hasSkippedQueues) $fa1880944e28b500$export$a9301d18019c11f9({
        source: 'refreshQueueIssueCountAction',
        actionSubject: 'queueIssueCountRefresh',
        action: 'skipped'
    });
    return queueByGroups;
};
const $fa1880944e28b500$var$getQueuesSortByLastRefreshedTime = (queuesBeforeSort)=>{
    let queuesSortByLastRefreshedTime = [];
    const queuesSortByGroup = [
        ...queuesBeforeSort.starredQueues,
        ...queuesBeforeSort.defaultQueues
    ];
    queuesSortByLastRefreshedTime = (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(queuesSortByGroup, [
        'lastRefreshedTime'
    ]);
    return queuesSortByLastRefreshedTime;
};
const $fa1880944e28b500$export$b5e2038970f91d6c = (error)=>{
    (0, $jcw0u.default)({
        meta: {
            id: 'refreshQueueIssueCountAction',
            packageName: 'jiraServicedeskCategorizedQueuesStore',
            teamName: 'jsd-shield'
        },
        error: error
    });
};
const $fa1880944e28b500$var$isIssueCountAlreadyFetched = (queue)=>queue.count !== undefined;
const $fa1880944e28b500$var$getSkippedQueues = (issueCounts, queuesMap)=>Object.keys(issueCounts).map((id)=>Number(id)).filter((queueId)=>issueCounts[queueId].result === $fa1880944e28b500$export$cf85cf6a45b00808.PENDING && !$fa1880944e28b500$var$isIssueCountAlreadyFetched(queuesMap[queueId]));
const $fa1880944e28b500$var$fetchIssueCountForQueueGroup = async (projectKey, queueIds)=>(0, $eusud.performPostRequest)(`/rest/servicedesk/1/servicedesk/${projectKey}/queues/issue-counts/refresh`, {
        body: JSON.stringify(queueIds)
    });
const $fa1880944e28b500$var$getQueueGroupData = (queueIds, issueCounts, queuesMap, batchStartProcessingTime)=>{
    const queueRefreshData = {
        minLastRefreshTimeFromCurrentBatch: Number.MAX_VALUE,
        queueCountChanges: 0
    };
    return queueIds.reduce((changes, queueId)=>{
        if (issueCounts[queueId]) {
            if (issueCounts[queueId].issueCount !== undefined || issueCounts[queueId].issueCount === 0) {
                const queue = queuesMap[queueId];
                const currentQueueLastRefreshedTime = queue.lastRefreshedTime !== undefined && queue.lastRefreshedTime !== 0 ? queue.lastRefreshedTime : batchStartProcessingTime;
                const minLastRefreshTimeFromCurrentBatch = Math.min(changes.minLastRefreshTimeFromCurrentBatch, currentQueueLastRefreshedTime);
                const queueCountChanges = queue.count !== issueCounts[queueId].issueCount ? changes.queueCountChanges + 1 : changes.queueCountChanges;
                return {
                    minLastRefreshTimeFromCurrentBatch: minLastRefreshTimeFromCurrentBatch,
                    queueCountChanges: queueCountChanges
                };
            }
        }
        return changes;
    }, queueRefreshData);
};
const $fa1880944e28b500$var$fetchAndUpdateCount = async (baseUrl, projectKey, queueIds, category, analyticsEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
update, batchStartProcessingTime, retryCallback)=>{
    if (queueIds.length === 0) return;
    let maxQueuesPerSd = await (0, $7ZmbO.getLimit)((0, $7ZmbO.MAX_QUEUES_PER_SD));
    if (maxQueuesPerSd === null) maxQueuesPerSd = queueIds.length;
    const queueIdsToFetch = queueIds.slice(0, maxQueuesPerSd);
    const startTime = Date.now();
    await $fa1880944e28b500$var$fetchIssueCountForQueueGroup(projectKey, queueIdsToFetch).then(({ issueCounts: issueCounts })=>{
        update((data)=>{
            const queuesMap = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))((0, $bebaD.getQueuesForCategory)(data, category), 'id');
            const skippedQueues = $fa1880944e28b500$var$getSkippedQueues(issueCounts, queuesMap);
            if (skippedQueues.length > 0) retryCallback(skippedQueues);
            const endTime = Date.now();
            let queueCountChanges = 0;
            let minLastRefreshTimeFromCurrentBatch = 0;
            let numberOfBadQueues = 0;
            const queueRefreshData = $fa1880944e28b500$var$getQueueGroupData(queueIds, issueCounts, queuesMap, batchStartProcessingTime);
            queueCountChanges = queueRefreshData.queueCountChanges;
            minLastRefreshTimeFromCurrentBatch = queueRefreshData.minLastRefreshTimeFromCurrentBatch;
            queueIds.forEach((queueId)=>{
                const queue = queuesMap[queueId];
                if (issueCounts[queueId]) {
                    if (issueCounts[queueId].issueCount !== undefined || issueCounts[queueId].issueCount === 0) queuesMap[queueId] = {
                        ...queue,
                        count: issueCounts[queueId].issueCount,
                        lastRefreshedTime: endTime,
                        shouldSkipIssueCountRefresh: false
                    };
                    else if (issueCounts[queueId].errorCode === $fa1880944e28b500$var$ERROR_DB_TIMEOUT) {
                        numberOfBadQueues += 1;
                        queuesMap[queueId] = {
                            ...queue,
                            shouldSkipIssueCountRefresh: true
                        };
                    }
                }
            });
            if (analyticsEvent) {
                const issueCountPerGroup = $fa1880944e28b500$var$getIssueCountPerGroup(issueCounts);
                const queueIssueCounts = Object.values(issueCountPerGroup).map((queueCount)=>Number(queueCount));
                const jiraShard = (0, $j8DrX.default)('ajs-shard') || '';
                if (queueIssueCounts.length === 0) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'navigationSession poorPerformanceQueuesCountsInfo', {
                    category: category,
                    queuesRequested: queueIdsToFetch.length,
                    maxQueuesPerSd: maxQueuesPerSd,
                    timeToFetchIssueCount: endTime - startTime,
                    timeSinceBatchStart: endTime - batchStartProcessingTime,
                    jiraShard: jiraShard,
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    browserTabVisibilityState: document.visibilityState,
                    numberOfBadQueues: numberOfBadQueues
                });
                else (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'navigationSession queuesCountsInfo', {
                    category: category,
                    queues: queueIssueCounts.length,
                    queuesRequested: queueIdsToFetch.length,
                    maxQueuesPerSd: maxQueuesPerSd,
                    maxIssueCount: Math.max(...queueIssueCounts),
                    timeToFetchIssueCount: endTime - startTime,
                    timeBetweenQueueRefresh: endTime - minLastRefreshTimeFromCurrentBatch,
                    timeSinceBatchStart: endTime - batchStartProcessingTime,
                    noOfQueuesWithUpdatedCount: queueCountChanges,
                    jiraShard: jiraShard,
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    browserTabVisibilityState: document.visibilityState,
                    numberOfBadQueues: numberOfBadQueues
                });
            }
            return (0, $bebaD.setQueuesForCategory)(data, category, // Object.values is typed as Mixed[] and makes flow unhappy
            (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))((0, (/*@__PURE__*/$parcel$interopDefault($dMEgP)))(queuesMap), 'order'));
        });
    }).catch((error)=>{
        $fa1880944e28b500$export$b5e2038970f91d6c(error);
    });
};
const $fa1880944e28b500$var$updateLoadingState = (category, queues, update)=>{
    update((data)=>data ? (0, $7uUwQ.chain)(data).setIn([
            category,
            'hasRequestedCount'
        ], true).setIn([
            category,
            'isCountLoading'
        ], false).value() : null);
};
const $fa1880944e28b500$export$d436cbef77099410 = async (baseUrl, projectKey, category, queues, skipHiddenQueues, update, retryCallback, analyticsEvent)=>{
    const queuesPerGroup = $fa1880944e28b500$var$getQueuesPerGroup(queues, skipHiddenQueues);
    const queuesSortByLastRefreshedTime = $fa1880944e28b500$var$getQueuesSortByLastRefreshedTime(queuesPerGroup);
    const queueIds = queuesSortByLastRefreshedTime.map((x)=>x.id);
    const batchStartProcessingTime = Date.now();
    try {
        // fetching the result in one call
        await $fa1880944e28b500$var$fetchAndUpdateCount(baseUrl, projectKey, queueIds, category, analyticsEvent, update, batchStartProcessingTime, retryCallback);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        $fa1880944e28b500$var$updateLoadingState(category, queues, update);
        $fa1880944e28b500$export$b5e2038970f91d6c(error);
        throw error;
    }
    $fa1880944e28b500$var$updateLoadingState(category, queues, update);
};

});
parcelRegister("hUobS", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $d09a6e5a442af90c$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $d09a6e5a442af90c$var$isNumber(value) {
    return typeof value == 'number' || $fC1Kz(value) && $beQoo(value) == $d09a6e5a442af90c$var$numberTag;
}
module.exports = $d09a6e5a442af90c$var$isNumber;

});

parcelRegister("7ZmbO", function(module, exports) {

$parcel$export(module.exports, "MAX_AUTOMATION_RULES_PER_SD", () => $92269289c1fdd627$export$dca2c2105b681490);
$parcel$export(module.exports, "MAX_AUTOMATION_BRANCHES_PER_RULE", () => $92269289c1fdd627$export$a48ac34d39e0fc22);
$parcel$export(module.exports, "MAX_QUEUES_PER_SD", () => $92269289c1fdd627$export$2e0ba662d5bb7742);
$parcel$export(module.exports, "MAX_SLA_GOALS_PER_SD", () => $92269289c1fdd627$export$eb69982aa3a172b4);
$parcel$export(module.exports, "MAX_CMDB_OBJECTS_PER_FIELD", () => $92269289c1fdd627$export$cb3888a8c43147d2);
$parcel$export(module.exports, "LIMIT_DEFAULTS", () => $92269289c1fdd627$export$5ed1d2ac050e39d);
$parcel$export(module.exports, "getLimit", () => $92269289c1fdd627$export$fb8ce379717a383d);
$parcel$export(module.exports, "LimitData", () => $92269289c1fdd627$export$9989835030ecd317);
$parcel$export(module.exports, "withLimitData", () => $92269289c1fdd627$export$c5d8aa8a650e690f);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $7f4tk = parcelRequire("7f4tk");
const $92269289c1fdd627$export$dca2c2105b681490 = 'max_automation_rules_per_sd';
const $92269289c1fdd627$export$a48ac34d39e0fc22 = 'max_automation_branches_per_rule';
const $92269289c1fdd627$export$2e0ba662d5bb7742 = 'max_queues_per_sd';
const $92269289c1fdd627$export$eb69982aa3a172b4 = 'max_sla_goals_per_sd';
const $92269289c1fdd627$export$cb3888a8c43147d2 = 'max_cmdb_objects_per_field';
const $92269289c1fdd627$export$801a603585fb94d8 = 'max_num_team_priority_queues_per_sd';
const $92269289c1fdd627$export$5ed1d2ac050e39d = {
    [$92269289c1fdd627$export$dca2c2105b681490]: 30,
    [$92269289c1fdd627$export$a48ac34d39e0fc22]: 30,
    [$92269289c1fdd627$export$2e0ba662d5bb7742]: 300,
    [$92269289c1fdd627$export$eb69982aa3a172b4]: 30,
    [$92269289c1fdd627$export$cb3888a8c43147d2]: 20,
    [$92269289c1fdd627$export$801a603585fb94d8]: 50
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $92269289c1fdd627$var$limitCache = {};
const $92269289c1fdd627$export$c419786abd6faaad = (limitProperty)=>{
    delete $92269289c1fdd627$var$limitCache[limitProperty];
};
const $92269289c1fdd627$export$fb8ce379717a383d = (limitProperty)=>{
    if (!$92269289c1fdd627$var$limitCache[limitProperty]) $92269289c1fdd627$var$limitCache[limitProperty] = (0, $7f4tk.default)(`/rest/servicedesk/latest/limit/${limitProperty}?_=${Date.now()}`).then(({ limit: limit })=>limit, (error)=>{
        // Will allow us to try again to fetch limit
        $92269289c1fdd627$export$c419786abd6faaad(limitProperty);
        (0, $dJl1T.default).safeWarnWithoutCustomerData('servicedesk.common.view.components.limit-data', `Failed to fetch limit for ${limitProperty}`);
        throw error;
    });
    return $92269289c1fdd627$var$limitCache[limitProperty];
};
class $92269289c1fdd627$export$9989835030ecd317 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { limitProperty: limitProperty } = this.props;
        const defaultLimit = $92269289c1fdd627$export$5ed1d2ac050e39d[limitProperty];
        $92269289c1fdd627$export$fb8ce379717a383d(limitProperty).then((limit)=>{
            this.updateLimit(limit || defaultLimit);
        }).catch(()=>{
            this.updateLimit(defaultLimit);
        });
    }
    updateLimit(newLimit) {
        this.setState(({ limit: oldLimit })=>oldLimit !== newLimit ? {
                limit: newLimit
            } : undefined);
    }
    render() {
        return this.props.children(this.state.limit);
    }
    constructor(...args){
        super(...args), this.state = {
            // Current consumers of LimitData expect typeof number so this cannot be an empty value.
            // This also voids limit messages showing until we have a reliable limit,
            // instead of showing then changing the value
            limit: Infinity
        };
    }
}
const $92269289c1fdd627$export$c5d8aa8a650e690f = (limitProperty, WrappedComponent)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($92269289c1fdd627$export$9989835030ecd317, {
            limitProperty: limitProperty
        }, (limit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                limit: limit,
                ...props
            }));

});



parcelRegister("kTfMz", function(module, exports) {

$parcel$export(module.exports, "addItem", () => $98056c458719acf6$export$fb9705de59d96855);
$parcel$export(module.exports, "deleteItem", () => $98056c458719acf6$export$8d8542dbbc23fe1a);
$parcel$export(module.exports, "editItem", () => $98056c458719acf6$export$60832f4899fbf6a1);
$parcel$export(module.exports, "editItems", () => $98056c458719acf6$export$8c896bccb18e1db1);
$parcel$export(module.exports, "moveItem", () => $98056c458719acf6$export$ec937e64de6c1257);
$parcel$export(module.exports, "moveItemBelow", () => $98056c458719acf6$export$17c7ebc966cf5476);
$parcel$export(module.exports, "moveItemAbove", () => $98056c458719acf6$export$d54386016cadff45);
$parcel$export(module.exports, "moveToTop", () => $98056c458719acf6$export$f2c5cc4c3f787c3e);
$parcel$export(module.exports, "enableSelectedQueuesVisibility", () => $98056c458719acf6$export$ce58537552972d29);

var $fW7cr = parcelRequire("fW7cr");
const $98056c458719acf6$export$fb9705de59d96855 = (source, item)=>[
        ...source,
        item
    ];
const $98056c458719acf6$export$8d8542dbbc23fe1a = (source, id)=>{
    const result = source.slice();
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
        id: Number(id)
    });
    if (index >= 0) result.splice(index, 1);
    return result;
};
const $98056c458719acf6$export$60832f4899fbf6a1 = (source, updatedItem)=>{
    const result = source.slice();
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
        id: updatedItem.id
    });
    if (index >= 0) result[index] = {
        ...result[index],
        ...updatedItem
    };
    return result;
};
const $98056c458719acf6$export$8c896bccb18e1db1 = (source, updatedItems)=>{
    const result = source.slice();
    updatedItems.forEach((item)=>{
        const index = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
            id: item.id
        });
        if (index >= 0) result[index] = {
            ...result[index],
            ...item
        };
    });
    return result;
};
const $98056c458719acf6$export$ec937e64de6c1257 = (source, from, to)=>{
    const result = source.slice();
    const item = result[from];
    if (from !== to && from >= 0) {
        result.splice(from, 1);
        result.splice(to, 0, item);
    }
    return result.map((page, order)=>({
            ...page,
            order: order
        }));
};
const $98056c458719acf6$export$17c7ebc966cf5476 = (source, sourceId, targetId)=>{
    const result = source.slice();
    if (sourceId !== targetId) {
        const sourceIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
            id: sourceId
        });
        if (sourceIndex >= 0) {
            const sourceQueue = result[sourceIndex];
            result.splice(sourceIndex, 1);
            const targetIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
                id: targetId
            });
            if (targetIndex >= 0) {
                result.splice(targetIndex + 1, 0, sourceQueue);
                return result.map((page, order)=>({
                        ...page,
                        order: order
                    }));
            }
        }
    }
    return source;
};
const $98056c458719acf6$export$d54386016cadff45 = (source, sourceId, targetId)=>{
    const result = source.slice();
    if (sourceId !== targetId) {
        const sourceIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
            id: sourceId
        });
        if (sourceIndex >= 0) {
            const sourceQueue = result[sourceIndex];
            result.splice(sourceIndex, 1);
            const targetIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
                id: targetId
            });
            if (targetIndex >= 0) {
                result.splice(targetIndex, 0, sourceQueue);
                return result.map((page, order)=>({
                        ...page,
                        order: order
                    }));
            }
        }
    }
    return source;
};
const $98056c458719acf6$export$f2c5cc4c3f787c3e = (source, sourceId)=>{
    const result = source.slice();
    if (result.length === 0) return source;
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
        id: sourceId
    });
    if (index > 0) {
        const sourceQueue = result[index];
        result.splice(index, 1);
        result.splice(0, 0, sourceQueue);
        return result.map((page, order)=>({
                ...page,
                order: order
            }));
    }
    return source;
};
const $98056c458719acf6$export$ce58537552972d29 = (selectedQueueIds, queues)=>queues.map((queue)=>{
        if (selectedQueueIds.some((selectedQueueId)=>selectedQueueId === queue.id)) {
            if (!queue.canBeHidden) return queue;
            return {
                ...queue,
                canBeHidden: false
            };
        }
        if (queue.canBeHidden) return queue;
        return {
            ...queue,
            canBeHidden: true
        };
    });

});
parcelRegister("fW7cr", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b9a1db7d7901532f$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $b9a1db7d7901532f$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $kPZpS(fromIndex);
    if (index < 0) index = $b9a1db7d7901532f$var$nativeMax(length + index, 0);
    return $b5dwA(array, $bxDef(predicate, 3), index);
}
module.exports = $b9a1db7d7901532f$var$findIndex;

});






parcelRegister("e33py", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $ae40b537a934bf9c$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $ae40b537a934bf9c$export$c7841d2c1c13065e);

var $5uXOq = parcelRequire("5uXOq");

var $9sGI6 = parcelRequire("9sGI6");

var $id7K0 = parcelRequire("id7K0");

var $koVbs = parcelRequire("koVbs");

var $2BHCj = parcelRequire("2BHCj");
const $ae40b537a934bf9c$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, projectName: projectName, subsection: subsection } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const title = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $2BHCj.default)[section])} - ${subsection} - ${formatMessage((0, $2BHCj.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $2BHCj.default)[section])} - ${formatMessage((0, $2BHCj.default).serviceProject)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DocumentTitle, {
        title: title
    });
};
const $ae40b537a934bf9c$export$c7841d2c1c13065e = (0, $9sGI6.default)($ae40b537a934bf9c$export$155581e8dc02007a, {
    DocumentTitle: (0, $id7K0.DocumentTitle)
});
var $ae40b537a934bf9c$export$2e2bcd8739ae039 = $ae40b537a934bf9c$export$c7841d2c1c13065e;

});
parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("2BHCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d7eb5ce3479323e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7d7eb5ce3479323e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email request"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "External resources"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    projectSummary: {
        "id": "servicedesk-spa-commons.common.utils.document-title.project-summary",
        "defaultMessage": "Summary"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    playbooks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
        "defaultMessage": "Playbooks"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    },
    journeysNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
        "defaultMessage": "Journeys"
    },
    journeyConfigNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
        "defaultMessage": "Journey configuration"
    },
    helpCenterForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-forms",
        "defaultMessage": "Forms"
    },
    helpCenterDetails: {
        "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-details",
        "defaultMessage": "Details"
    },
    virtualAgentAiAnswers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.ai-answers",
        "defaultMessage": "Atlassian Intelligence answers"
    },
    virtualAgentPerformance: {
        "id": "servicedesk-spa-commons.common.utils.document-title.performance",
        "defaultMessage": "Performance"
    },
    customerAccess: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-access",
        "defaultMessage": "Customer access"
    },
    articles: {
        "id": "servicedesk-spa-commons.common.utils.document-title.articles",
        "defaultMessage": "Articles"
    },
    createArticle: {
        "id": "servicedesk-spa-commons.common.utils.document-title.create-article",
        "defaultMessage": "Create articles"
    },
    viewArticle: {
        "id": "servicedesk-spa-commons.common.utils.document-title.view-article",
        "defaultMessage": "View article"
    },
    supportWebsite: {
        "id": "servicedesk-spa-commons.common.utils.document-title.support-website",
        "defaultMessage": "Support website"
    },
    supportWebsiteOverview: {
        "id": "servicedesk-spa-commons.common.utils.document-title.support-website-overview",
        "defaultMessage": "Support website overview"
    },
    supportWebsitePages: {
        "id": "servicedesk-spa-commons.common.utils.document-title.support-website-pages",
        "defaultMessage": "Support website pages"
    },
    viewsSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.view-settings",
        "defaultMessage": "Views Settings"
    },
    customerServiceAgentOverview: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-overview",
        "defaultMessage": "Customer Service Agent"
    },
    customerServiceAgentKnowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-knowledge",
        "defaultMessage": "Customer Service Agent Knowledge"
    },
    customerServiceAgentReview: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-review",
        "defaultMessage": "Customer Service Agent Review"
    },
    customerServiceAgentSimulator: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-simulator",
        "defaultMessage": "Customer Service Agent Test"
    }
});

});


parcelRegister("gq0sA", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $2299d7a4f1092420$export$9c25024bdfe755f7);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");

var $9OXo1 = parcelRequire("9OXo1");

var $dFOAR = parcelRequire("dFOAR");
const $2299d7a4f1092420$var$getProjectContextResource = ()=>(0, $dxCvy.projectContextResourceWithCache);
const $2299d7a4f1092420$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $324W5.useResourceWithCustomRouterContext)($2299d7a4f1092420$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $dFOAR.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $5uXOq.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("dFOAR", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $6c09349e97fba749$export$712ead87353ac687);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $cAofY = parcelRequire("cAofY");
const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, $cAofY.serviceDeskContextResource);
const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $324W5.useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
    (0, $5uXOq.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});


parcelRegister("cz40O", function(module, exports) {

$parcel$export(module.exports, "SpaPageWrapper", () => $2099b56eb86565d0$export$577514961fbf4842);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $dJl1T = parcelRequire("dJl1T");

var $9sGI6 = parcelRequire("9sGI6");

var $9dbF6 = parcelRequire("9dbF6");

var $9NiTW = parcelRequire("9NiTW");

var $aTz47 = parcelRequire("aTz47");

var $cYaqS = parcelRequire("cYaqS");

var $8pMQX = parcelRequire("8pMQX");
const $2099b56eb86565d0$export$91f88695e0d311a5 = (props)=>{
    const { projectContext: projectContext, isLoading: isLoading, error: error, children: children, AccessCheck: AccessCheck, AuthenticationCheck: AuthenticationCheck, ProjectNotFound: ProjectNotFound, ServiceHubNotFound: ServiceHubNotFound, GenericError: GenericError, SubProductUpdater: SubProductUpdater } = props;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    if (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jsdspa-page-wrapper', 'rendering-error-page', error);
        const isHelpCenterSettingsRoute = (0, $aTz47.isHelpCenterSettingsPath)();
        if (isHelpCenterSettingsRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, error.statusCode === 404 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ServiceHubNotFound, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(GenericError, null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, error.statusCode === 404 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProjectNotFound, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(GenericError, null));
    }
    if (projectContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SubProductUpdater, {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AccessCheck, null, children)));
    return null;
};
const $2099b56eb86565d0$export$577514961fbf4842 = (0, $9sGI6.default)($2099b56eb86565d0$export$91f88695e0d311a5, {
    AccessCheck: (0, $cYaqS.default),
    GenericError: (0, $8pMQX.GenericError),
    ProjectNotFound: (0, $8pMQX.ProjectNotFound),
    ServiceHubNotFound: (0, $8pMQX.ServiceHubNotFound),
    AuthenticationCheck: (0, $9NiTW.AuthenticationCheck),
    SubProductUpdater: (0, $9dbF6.SubProductUpdater)
});
var $2099b56eb86565d0$export$2e2bcd8739ae039 = $2099b56eb86565d0$export$577514961fbf4842;

});
parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $dJl1T = parcelRequire("dJl1T");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("cYaqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f72fff5a1e4c8937$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $aTz47 = parcelRequire("aTz47");


var $4UFLs = parcelRequire("4UFLs");

var $g3A84 = parcelRequire("g3A84");
const $f72fff5a1e4c8937$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $6jY6G.useCurrentRoute)().path.includes(`${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const isHelpCenterSettingsRoute = (0, $aTz47.isHelpCenterSettingsPath)();
    const Gate = isSettingsRoute || isHelpCenterSettingsRoute ? (0, $g3A84.default) : (0, $4UFLs.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Gate, null, children);
};
var $f72fff5a1e4c8937$export$2e2bcd8739ae039 = $f72fff5a1e4c8937$var$AccessCheck;

});
const $7c914880cb332728$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';
const $7c914880cb332728$export$16a37d277dff22d6 = '/jira/helpcenter/projects';

parcelRegister("4UFLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9befbeaff9f5385d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $daoB1 = parcelRequire("daoB1");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");

var $iDvG9 = parcelRequire("iDvG9");
const $9befbeaff9f5385d$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $daoB1.useApplicationPermissions)();
    const [projectKey = ''] = (0, $bmKPg.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDvG9.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira"
    });
};
var $9befbeaff9f5385d$export$2e2bcd8739ae039 = $9befbeaff9f5385d$var$ProductAccessCheck;

});
parcelRegister("iDvG9", function(module, exports) {

$parcel$export(module.exports, "default", () => $34dd3dc578b1a167$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");

var $dFOAR = parcelRequire("dFOAR");


var $fhAnU = parcelRequire("fhAnU");
const $34dd3dc578b1a167$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $bmKPg.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $dFOAR.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $fhAnU.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $34dd3dc578b1a167$export$2e2bcd8739ae039 = $34dd3dc578b1a167$var$AgentCheck;

});
parcelRegister("fhAnU", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $1a790f4bb1355504$export$ddaebe4928e793cb);

const $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES = [
    (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
    (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
    (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)
];
const $1a790f4bb1355504$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});



parcelRegister("g3A84", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e7d6646168c089$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aTz47 = parcelRequire("aTz47");

var $8pMQX = parcelRequire("8pMQX");

var $dFOAR = parcelRequire("dFOAR");

var $fhAnU = parcelRequire("fhAnU");
const $60e7d6646168c089$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $dFOAR.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $fhAnU.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) {
        const isHelpCenterSettingsRoute = (0, $aTz47.isHelpCenterSettingsPath)();
        if (isHelpCenterSettingsRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ServiceHubNotFound), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ProjectNotFound), null);
    }
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.GenericError), null);
    return null;
};
var $60e7d6646168c089$export$2e2bcd8739ae039 = $60e7d6646168c089$var$SettingsAccessCheck;

});
parcelRegister("8pMQX", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $951f6bd200bf8b89$export$849d319c342682a2);
$parcel$export(module.exports, "ServiceHubNotFound", () => $951f6bd200bf8b89$export$1fbf518ac538659c);
$parcel$export(module.exports, "GenericError", () => $951f6bd200bf8b89$export$7d465be8efa67280);

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");

var $3s0xG = parcelRequire("3s0xG");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $7xBz2 = parcelRequire("7xBz2");

var $lVQn8 = parcelRequire("lVQn8");

var $id7K0 = parcelRequire("id7K0");

var $bTyOW = parcelRequire("bTyOW");

var $fC09Q = parcelRequire("fC09Q");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $hjSul = parcelRequire("hjSul");

var $4R6GH = parcelRequire("4R6GH");

var $4AdE6 = parcelRequire("4AdE6");
const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).notFoundTitle),
        description: formatMessage((0, $4AdE6.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
            to: projectsPath
        }, formatMessage((0, $4AdE6.default).notFoundAction))
    }));
};
const $951f6bd200bf8b89$export$1fbf518ac538659c = ()=>{
    const projectsPath = '/jira/projects';
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $4AdE6.default).customerHubNotFoundDocumentTitleJsm : (0, $4AdE6.default).serviceHubNotFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $4AdE6.default).customerHubNotFoundTitle : (0, $4AdE6.default).serviceHubNotFoundTitle),
        description: formatMessage((0, $4AdE6.default).serviceHubNotFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
            to: projectsPath
        }, formatMessage((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $4AdE6.default).customerHubNotFoundAction : (0, $4AdE6.default).serviceHubNotFoundAction))
    }));
};
const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
    const interactionId = (0, $5uXOq.useContext)((0, $32M8E.default)).current;
    const labelStack = (0, $5uXOq.useContext)((0, $aatTc.default))?.labelStack;
    const traceId = (0, $5uXOq.useMemo)(()=>{
        const traceContext = (0, $7xBz2.getActiveTrace)();
        return traceContext?.traceId;
    }, []);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let description = formatMessage((0, $4AdE6.default).genericErrorDescription);
    if (traceId) {
        const error = new Error('An error occurred while loading this page');
        description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: $951f6bd200bf8b89$var$styles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lVQn8.ErrorHashAndTraceId), {
            error: error,
            traceId: traceId
        })));
        if ((0, $4R6GH.fg)('add_ufo_error_in_service_desk_genericerror')) {
            const name = 'serviceDeskGenericError';
            if (interactionId) {
                (0, $lAOer.addError)(interactionId, name, labelStack ?? null, error.name, error.message, error.stack);
                // NOTE: to account for awaiting BM3 TTI in UFO code, however we don't need to wait for BM3 TTI when there is an error
                // https://atlassian.slack.com/archives/C01AY8132S3/p1736380314352749?thread_ts=1736377740.484469&cid=C01AY8132S3
                const activeInteraction = (0, $lAOer.getActiveInteraction)();
                activeInteraction?.holdActive.forEach((_, holdId)=>{
                    (0, $lAOer.removeHoldByID)(activeInteraction.id, holdId);
                });
            } else (0, $lAOer.addErrorToAll)(name, labelStack ?? null, error.name, error.message, error.stack);
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $bTyOW.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).genericErrorTitle),
        description: description
    }));
};
const $951f6bd200bf8b89$var$styles = (0, $2s57o.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("lVQn8", function(module, exports) {

$parcel$export(module.exports, "ErrorHashAndTraceId", () => $6bb63dde5e44a95e$export$61354a7dde2c2d3c);

var $5uXOq = parcelRequire("5uXOq");

var $5oFIy = parcelRequire("5oFIy");

var $kobfu = parcelRequire("kobfu");

var $hurrh = parcelRequire("hurrh");
const $6bb63dde5e44a95e$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
    const errorHash = (0, $kobfu.getErrorHash)(error);
    const source = `Hash ${errorHash}\nTrace ${traceId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        action: "rendered",
        actionSubject: "errorHashAndTraceId",
        attributes: {
            errorHash: errorHash,
            traceId: traceId
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "note"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hurrh.CodeBlockWithCopyButton), {
        source: source,
        copyCodeActionSubjectId: "copyErrorHashAndTraceId"
    })));
};

});
parcelRegister("hurrh", function(module, exports) {

$parcel$export(module.exports, "CodeBlockWithCopyButton", () => $e48150d967598599$export$ced1fc74d907d387);

var $5uXOq = parcelRequire("5uXOq");

var $fzUGr = parcelRequire("fzUGr");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $irzxp = parcelRequire("irzxp");
const $e48150d967598599$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $e48150d967598599$var$wrapperStyles,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irzxp.ActionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irzxp.CopyAction), {
        source: source,
        actionSubjectId: copyCodeActionSubjectId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fzUGr.default), {
        text: source,
        showLineNumbers: false,
        shouldWrapLongLines: false
    })));
const $e48150d967598599$var$wrapperStyles = (0, $2s57o.xcss)({
    width: '100%',
    position: 'relative'
});

});
parcelRegister("fzUGr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a96956312d74a20$export$2e2bcd8739ae039);
/* code-block.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $la5nd = parcelRequire("la5nd");

var $jhA2F = parcelRequire("jhA2F");

var $bEVVW = parcelRequire("bEVVW");

var $gCl68 = parcelRequire("gCl68");
const $0a96956312d74a20$var$getCodeBlockStyles = {
    root: "_2rkoglpi _1dqoglyw _1wyb1crf _k48pi7a9 _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhktkvp _syaz1fxt _ect41odn _1ozdn7od _7xinn7od _t7aun7od _1v15u2gc _ilvcu2gc _m29uu2gc _17wyu2gc _pn28u2gc _gz9fu2gc _1hmyegat _vblregat _vbulegat _wozj1yev _1agb1yev _lkm81yev _tv41hkgb _1hmimyb0 _1ra01n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _j1w0ww7y _13cdh2mm _15ba126e _zvy9f705 _qcxof705 _14y71a66 _j0l11wug _1weckb7n _1na21hna _1xx2grf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909m7j4 _scgayz1z _ipl81e17 _jeky1l04 _1gec1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _1552u2gc _12afu2gc _28ddu2gc _1i8zu2gc _12tu1a66 _zu0j1a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgcpf9b _bu7zpf9b _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3moej _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eiht5x2v _t9zb5x2v _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t361fxt _137bh55r _1k7d1fxt _97lipnps _12nh9lu1 _1g0517qg _i2ig10m5 _326z1fxt _113p131l _1n6tpnps _tgu817qg _1k47pnps _g0lx1fxt _ys4e131l _7gp8h55r _1yvq10m5 _1vww10m5 _1rju10m5 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o610m5 _kxov17qg _1np517qg _m2f517qg _1b9tpnps _1tq6pnps _1rd2pnps _1pbkpnps _k3lipnps _13zt131l _2g12fb2s _k86b10m5 _b5iy131l _gti3131l _1f0gpnps _9d3e17qg _qdiapnps _72uvpnps",
    showLineNumbers: "_170714ej _1i3h1txw _1huoidpf _1a9lidpf _20bqidpf _1oggidpf _bympidpf _9nnjidpf",
    dontShowLineNumbers: "_1i3h1ule _1huou2gc _1a9lu2gc _20bqu2gc _1oggu2gc _bympu2gc _9nnju2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
};
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $0a96956312d74a20$var$CodeBlock = /*#__PURE__*/ (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false }) {
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $jhA2F.getLineNumWidth)(numLines) : 0;
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $la5nd.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $5uXOq.useMemo)(()=>(0, $bEVVW.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gCl68.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        text: text,
        className: (0, $bwpsq.default)([
            $0a96956312d74a20$var$getCodeBlockStyles.root,
            shouldWrapLongLines ? $0a96956312d74a20$var$getCodeBlockStyles.shouldWrapLongLines : $0a96956312d74a20$var$getCodeBlockStyles.dontWrapLongLines,
            showLineNumbers ? $0a96956312d74a20$var$getCodeBlockStyles.showLineNumbers : $0a96956312d74a20$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
$0a96956312d74a20$var$CodeBlock.displayName = 'CodeBlock';
var $0a96956312d74a20$export$2e2bcd8739ae039 = $0a96956312d74a20$var$CodeBlock;

});
parcelRegister("la5nd", function(module, exports) {

$parcel$export(module.exports, "useHighlightLines", () => $d16fc758e2d4acef$export$84415a200bdf33ed);

var $5uXOq = parcelRequire("5uXOq");
const $d16fc758e2d4acef$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $d16fc758e2d4acef$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$d16fc758e2d4acef$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $d16fc758e2d4acef$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $d16fc758e2d4acef$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $5uXOq.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $d16fc758e2d4acef$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$d16fc758e2d4acef$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $d16fc758e2d4acef$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("jhA2F", function(module, exports) {

$parcel$export(module.exports, "getLineNumWidth", () => $612757b728dd1aa7$export$cb7aec0206b595d2);
const $612757b728dd1aa7$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};
const $612757b728dd1aa7$export$d5fcf1b7ff23707b = ()=>{
    return {
        display: 'inline',
        padding: '2px 0.5ch',
        backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #091E420F)"})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        borderStyle: 'none',
        boxDecorationBreak: 'clone',
        color: "var(--ds-text, #172B4D)",
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    };
};

});

parcelRegister("bEVVW", function(module, exports) {

$parcel$export(module.exports, "normalizeLanguage", () => $4fed610104ef97c9$export$f38728011c178796);

var $8QpSo = parcelRequire("8QpSo");

var $fTglf = parcelRequire("fTglf");
const $4fed610104ef97c9$export$f38728011c178796 = (0, $8QpSo.default)((language)=>{
    if (!language) return '';
    const match = (0, $fTglf.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("fTglf", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $c6e245aeba898e2e$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $c6e245aeba898e2e$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    }
];

});


parcelRegister("gCl68", function(module, exports) {

$parcel$export(module.exports, "default", () => $868e310e7b464206$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $6HXiV = parcelRequire("6HXiV");
var $868e310e7b464206$export$2e2bcd8739ae039 = (0, $6HXiV.default);

});
parcelRegister("6HXiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $23f9107b8996345e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $25Oq3 = parcelRequire("25Oq3");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $23f9107b8996345e$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $25Oq3.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $2OMIu.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $23f9107b8996345e$var$asyncGenerator = $23f9107b8996345e$var$generator({
    loader: ()=>(parcelRequire("7t3wc")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $23f9107b8996345e$export$2e2bcd8739ae039 = $23f9107b8996345e$var$asyncGenerator;

});
parcelRegister("25Oq3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a3f60eeac7eb983$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jPgP9 = parcelRequire("jPgP9");

var $39BkO = parcelRequire("39BkO");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $3a3f60eeac7eb983$var$Highlight = /*#__PURE__*/ (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $jPgP9.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $39BkO.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $3a3f60eeac7eb983$export$2e2bcd8739ae039 = $3a3f60eeac7eb983$var$Highlight;

});
parcelRegister("jPgP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $83f127a4a907a87e$export$2e2bcd8739ae039);

var $3MiM2 = parcelRequire("3MiM2");

var $1BFv0 = parcelRequire("1BFv0");

var $fQLWH = parcelRequire("fQLWH");

var $gmwnr = parcelRequire("gmwnr");
const $83f127a4a907a87e$var$newLineRegex = /\n/g;
function $83f127a4a907a87e$var$getNewLines(str) {
    return str.match($83f127a4a907a87e$var$newLineRegex);
}
function $83f127a4a907a87e$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $gmwnr.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $3MiM2.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $fQLWH.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $83f127a4a907a87e$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $1BFv0.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $1BFv0.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("3MiM2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c5ea60b42d5d4bb$export$2e2bcd8739ae039);

var $1BFv0 = parcelRequire("1BFv0");

var $54p18 = parcelRequire("54p18");
function $5c5ea60b42d5d4bb$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $1BFv0.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $54p18.default)(lineNumber));
            return children;
        }
    };
}
var $5c5ea60b42d5d4bb$export$2e2bcd8739ae039 = $5c5ea60b42d5d4bb$var$createLineGenerator;

});
parcelRegister("1BFv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $172b8b54beacc18d$export$2e2bcd8739ae039);

var $54p18 = parcelRequire("54p18");
function $172b8b54beacc18d$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && showLineNumbers) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $54p18.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $54p18.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("54p18", function(module, exports) {

$parcel$export(module.exports, "default", () => $3834caf662eda994$export$2e2bcd8739ae039);
function $3834caf662eda994$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("fQLWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c252c59a03fc27$export$2e2bcd8739ae039);

var $1BFv0 = parcelRequire("1BFv0");
function $59c252c59a03fc27$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $1BFv0.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $59c252c59a03fc27$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("gmwnr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0e0821c048da7b0$export$2e2bcd8739ae039);
function $e0e0821c048da7b0$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("39BkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b50830aca1ec5f8b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dMYCB = parcelRequire("dMYCB");
function $b50830aca1ec5f8b$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $dMYCB.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});
parcelRegister("dMYCB", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde6b95e25c7a358$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $UXrz9 = parcelRequire("UXrz9");

var $lmODa = parcelRequire("lmODa");

var $gBK9d = parcelRequire("gBK9d");
function $dde6b95e25c7a358$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $dde6b95e25c7a358$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $lmODa.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $UXrz9.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $gBK9d.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $dde6b95e25c7a358$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("UXrz9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6fb86ced30fc4f0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5KCCi = parcelRequire("5KCCi");

var $eMkc6 = parcelRequire("eMkc6");
function $f6fb86ced30fc4f0$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: label,
        tag: $f6fb86ced30fc4f0$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eMkc6.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: skipChildren ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eMkc6.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: skipChildren ? null : bidiCharacter
    });
}
const $f6fb86ced30fc4f0$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("eMkc6", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $6a3ad388ce84f83d$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBCgC = parcelRequire("cBCgC");
const $6a3ad388ce84f83d$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is06wx40 _1rus1tzq _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rbawx40 _1xqc1rd4"
};
function $6a3ad388ce84f83d$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $6a3ad388ce84f83d$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $bwpsq.default)([
                    $6a3ad388ce84f83d$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $6a3ad388ce84f83d$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("lmODa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dfe4bd40045326b$export$2e2bcd8739ae039);
const $8dfe4bd40045326b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $8dfe4bd40045326b$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($8dfe4bd40045326b$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("gBK9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $b17e0d9de8ef9bb6$export$2e2bcd8739ae039);

var $dMYCB = parcelRequire("dMYCB");
function $b17e0d9de8ef9bb6$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $dMYCB.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("7t3wc", function(module, exports) {

let $56fdf880767119f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56fdf880767119f7$var$load("as9qs").then(()=>parcelRequire('5zvIl'));

});




parcelRegister("irzxp", function(module, exports) {

$parcel$export(module.exports, "CopyAction", () => $64e12044af483692$export$958df07cbf9735fc);
$parcel$export(module.exports, "ActionContainer", () => $64e12044af483692$export$37ab3bdebc286ca);

var $5uXOq = parcelRequire("5uXOq");

var $jHTSg = parcelRequire("jHTSg");

var $86vzA = parcelRequire("86vzA");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $8zOmE = parcelRequire("8zOmE");

var $fEogx = parcelRequire("fEogx");
const $64e12044af483692$export$2ce9877c9c1aa16 = {
    PROMPT: 'Copy',
    SUCCESS: 'Copied!',
    FAILURE: 'Copy to clipboard failed'
};
const $64e12044af483692$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)($64e12044af483692$export$2ce9877c9c1aa16.PROMPT);
    const handleSuccess = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.SUCCESS);
    }, [
        setTooltipMessage
    ]);
    const handleError = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.FAILURE);
    }, [
        setTooltipMessage
    ]);
    const writeToClipboard = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        actionSubjectId && (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(source).then(handleSuccess, handleError);
    }, [
        source,
        handleSuccess,
        handleError,
        actionSubjectId
    ]);
    const resetMessage = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.PROMPT);
    }, [
        setTooltipMessage
    ]);
    function shouldRender() {
        if (typeof document !== 'undefined') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return Boolean(navigator?.clipboard?.writeText);
    }
    return shouldRender() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fEogx.Action), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($86vzA))),
        label: tooltipMessage,
        onClick: writeToClipboard,
        onMouseOver: resetMessage,
        onFocus: resetMessage,
        "aria-live": "assertive",
        "aria-atomic": "true",
        name: "Copy"
    }) : null;
};
const $64e12044af483692$var$stopPropagation = (event)=>event.stopPropagation();
const $64e12044af483692$export$37ab3bdebc286ca = ({ children: children })=>/**
	 * This element uses an `onMouseDown` to block event propagation
	 * to its parent but is not itself interactive.
	 */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $64e12044af483692$var$absolutePositionWrapperStyles,
        onMouseDown: $64e12044af483692$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHTSg.default), {
        label: "actions"
    }, children));
const $64e12044af483692$var$absolutePositionWrapperStyles = (0, $2s57o.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    padding: 'space.050',
    zIndex: 'flag'
});

});
parcelRegister("fEogx", function(module, exports) {

$parcel$export(module.exports, "Action", () => $e6da05ade6347218$export$e19cd5f9376f8cee);

var $5uXOq = parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $5KCCi = parcelRequire("5KCCi");
const $e6da05ade6347218$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
    const updateTooltip = (0, $5uXOq.useRef)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        tooltipLabel,
        label
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipLabel || label;
        },
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        isLoading: isLoading,
        appearance: "subtle",
        icon: icon,
        label: label,
        spacing: "compact",
        ...buttonProps
    }));
};

});




parcelRegister("bTyOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5073396748f92b4e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $5073396748f92b4e$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5I4tL")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("h8kvT")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $dCLgq = parcelRequire("dCLgq");

var $h8kvT = parcelRequire("h8kvT");

var $5I4tL = parcelRequire("5I4tL");
const $5073396748f92b4e$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5I4tL)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($h8kvT))
});
var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
// for advanced use only
const $5073396748f92b4e$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("h8kvT", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("5I4tL", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("fC09Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb376757c4acc5ab$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3pGSh")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3pGSh")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $dCLgq = parcelRequire("dCLgq");

var $3pGSh = parcelRequire("3pGSh");
const $bb376757c4acc5ab$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3pGSh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3pGSh))
});
var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
// for advanced use only
const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("3pGSh", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("4AdE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $135a9e70a6f11b3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    },
    serviceHubNotFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-document-title-jsm",
        "defaultMessage": "Service hub not found - Service project"
    },
    serviceHubNotFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-title",
        "defaultMessage": "This service hub isn't available"
    },
    serviceHubNotFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    serviceHubNotFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-action",
        "defaultMessage": "View a list of all service hubs"
    },
    customerHubNotFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-document-title-jsm",
        "defaultMessage": "Customer hub not found - Service project"
    },
    customerHubNotFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-title",
        "defaultMessage": "This customer hub isn't available"
    },
    customerHubNotFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-action",
        "defaultMessage": "View a list of all customer hubs"
    }
});

});





parcelRegister("8XAvX", function(module, exports) {

$parcel$export(module.exports, "default", () => $95fd3039216adfa3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");

var $dd29Z = parcelRequire("dd29Z");

var $lVJAU = parcelRequire("lVJAU");
/* Intended usage is to replace direct usage of history.push from react-dom-router with a Jira SPA compatible push history */ const $95fd3039216adfa3$var$QueuesPushProvider = (props)=>{
    const { projectKey: projectKey, children: children } = props;
    const { push: push, replace: replace } = (0, $lVJAU.useRouterActions)();
    const pushWithSpaCompatibleUrl = (0, $5uXOq.useCallback)((path)=>{
        const pathWithLeadingSlash = path.charAt(0) === '/' ? `${path}` : `/${path}`;
        let fullPath = pathWithLeadingSlash;
        // Don't update the url if it is already in the right format
        if (pathWithLeadingSlash.indexOf('/jira/servicedesk/projects') !== 0) fullPath = `/jira/servicedesk/projects/${projectKey}${pathWithLeadingSlash}`;
        push(fullPath);
        // Some existing consumers in queues expect this to return an observable
        return (0, $kVLXA.Observable).empty();
    }, [
        projectKey,
        push
    ]);
    const navigateWithProjectKey = (0, $5uXOq.useCallback)((path)=>(0, $dd29Z.navigate)(projectKey, path), [
        projectKey
    ]);
    if (!projectKey) return children({
        push: undefined
    });
    return __SPA__ ? children({
        push: pushWithSpaCompatibleUrl,
        replace: replace
    }) : children({
        push: navigateWithProjectKey
    });
};
var $95fd3039216adfa3$export$2e2bcd8739ae039 = $95fd3039216adfa3$var$QueuesPushProvider;

});

parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("k30xR", function(module, exports) {

$parcel$export(module.exports, "useOnFavoritesChanged", () => $572c407f9743cbb2$export$ddf44c597e03063d);

var $5uXOq = parcelRequire("5uXOq");

var $1sWm7 = parcelRequire("1sWm7");

var $dMEgP = parcelRequire("dMEgP");

var $eXQym = parcelRequire("eXQym");

var $4041n = parcelRequire("4041n");
const $572c407f9743cbb2$export$ddf44c597e03063d = (projectKey, category, queues, callback)=>{
    const { items: items } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const queueItemChanges = items[0, $eXQym.QUEUES_ITEM_TYPE];
    const previousChangesRef = (0, $5uXOq.useRef)({
        projectKey: projectKey,
        category: category,
        changedItems: undefined
    });
    const { current: previousChanges } = previousChangesRef;
    const hasPotentialChanges = previousChanges.projectKey !== projectKey || previousChanges.category !== category || previousChanges.changedItems !== queueItemChanges;
    if (hasPotentialChanges) {
        previousChangesRef.current = {
            projectKey: projectKey,
            category: category,
            changedItems: queueItemChanges
        };
        if (queues) (0, (/*@__PURE__*/$parcel$interopDefault($dMEgP)))(queueItemChanges).forEach(({ id: id, value: value })=>{
            const queue = (0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(queues, {
                id: Number(id)
            });
            if (queue && queue.favourite !== value) callback(id, value);
        });
    }
};

});
parcelRegister("1sWm7", function(module, exports) {

var $bptzf = parcelRequire("bptzf");

var $fW7cr = parcelRequire("fW7cr");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $1115ac3ae60cc7bc$var$find = $bptzf($fW7cr);
module.exports = $1115ac3ae60cc7bc$var$find;

});
parcelRegister("bptzf", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $hTJwX = parcelRequire("hTJwX");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $84e8f705a13e859f$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$hTJwX(collection)) {
            var iteratee = $bxDef(predicate, 3);
            collection = $66FNL(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $84e8f705a13e859f$var$createFind;

});



parcelRegister("6OeKD", function(module, exports) {

$parcel$export(module.exports, "pageToQueues", () => $b8361afc4fd34fcb$export$8ada91ce992fa66f);

var $3HGy4 = parcelRequire("3HGy4");
const $b8361afc4fd34fcb$var$transformColumns = (responseColumns)=>responseColumns.map((responseColumn)=>{
        const column = {
            id: responseColumn.fieldId,
            title: responseColumn.title,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        };
        if (responseColumn.sortOrder) return {
            ...column,
            currentSorting: responseColumn.sortOrder
        };
        return column;
    });
const $b8361afc4fd34fcb$export$8ada91ce992fa66f = (page)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    page.reduce((acc, queue)=>{
        acc[queue.id] = {
            id: (0, $3HGy4.toQueueId)(queue.id),
            name: queue.name,
            jql: queue.jql,
            completeJql: queue.completeJql,
            order: queue.order,
            columns: $b8361afc4fd34fcb$var$transformColumns(queue.columnsDetails),
            // British spelling from legacy Backend code
            isFavorite: queue.favourite,
            category: queue.category,
            canBeHidden: queue.canBeHidden
        };
        return acc;
    }, {});

});


parcelRegister("l8ruj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6056b4460d0127e0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $aatTc = parcelRequire("aatTc");

var $lAOer = parcelRequire("lAOer");

var $5tDD0 = parcelRequire("5tDD0");

var $5i16O = parcelRequire("5i16O");

var $4R6GH = parcelRequire("4R6GH");
/** A portion of the page we apply measurement to */ function $6056b4460d0127e0$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $aatTc.useInteractionContext)();
    const relayProfilerContext = (0, $5uXOq.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $5uXOq.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    if ((0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    this.getInteractionContext().addPreload((0, $lAOer.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    if ((0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    if ((0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $lAOer.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5i16O.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children));
}
function $6056b4460d0127e0$export$2e2bcd8739ae039({ name: segmentName, children: children, mode: mode = 'single' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5tDD0.default), {
        name: segmentName,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6056b4460d0127e0$var$JiraUFOSegmentWrapper, null, children));
}

});

parcelRegister("baoQa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c751acfbbe41f1ec$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1W0cQ = parcelRequire("1W0cQ");

var $l8ruj = parcelRequire("l8ruj");
const $c751acfbbe41f1ec$var$QueuesIssueViewContent = (props)=>{
    const { issueNavigatorData: issueNavigatorData } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "queues-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1W0cQ.default), {
        issueNavigatorData: issueNavigatorData
    }));
};
var $c751acfbbe41f1ec$export$2e2bcd8739ae039 = $c751acfbbe41f1ec$var$QueuesIssueViewContent;

});
parcelRegister("1W0cQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $719e268c3759c45e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");


var $k3PbQ = parcelRequire("k3PbQ");

var $4Eklo = parcelRequire("4Eklo");

var $bYtrC = parcelRequire("bYtrC");

var $9hUca = parcelRequire("9hUca");

var $dd29Z = parcelRequire("dd29Z");

var $l8ruj = parcelRequire("l8ruj");

var $a1E0h = parcelRequire("a1E0h");
let $719e268c3759c45e$var$dispatchExternalAction;
const $719e268c3759c45e$var$getIssueKey = ()=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return (0, $4Eklo.parseIssueKey)(window.location.href);
};
const $719e268c3759c45e$var$getPreviousUrl = ()=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const urlParts = window.location.href.split('/');
    return urlParts.slice(0, urlParts.length - 1).join('/');
};
const $719e268c3759c45e$var$queueRoutesPattern = Object.values((0, $dd29Z.QUEUE_ROUTES)).join('|').replace(/\//g, '\\/');
const $719e268c3759c45e$var$QUEUES_URL_REGEX = new RegExp(`.*\\/projects\\/[^/]+\\/(${$719e268c3759c45e$var$queueRoutesPattern})\\/custom\\/.*`);
const $719e268c3759c45e$var$isComingFromQueue = ()=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.location.pathname.match($719e268c3759c45e$var$QUEUES_URL_REGEX);
};
const $719e268c3759c45e$var$REPORTS_URL_REGEX = /.*\/projects\/[^/]+\/reports\/.*/;
const $719e268c3759c45e$var$isComingFromReport = ()=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.location.pathname.match($719e268c3759c45e$var$REPORTS_URL_REGEX);
};
const $719e268c3759c45e$var$isComingFromQueueOrReport = ()=>$719e268c3759c45e$var$isComingFromQueue() || $719e268c3759c45e$var$isComingFromReport();
const $719e268c3759c45e$var$redirectAfterSuccessfulDelete = ()=>()=>{
        (0, $gKZoD.di)(window);
        const issueKey = $719e268c3759c45e$var$getIssueKey();
        const projectKey = (0, $k3PbQ.extractProjectKey)(issueKey);
        let url;
        if ($719e268c3759c45e$var$isComingFromQueueOrReport()) url = $719e268c3759c45e$var$getPreviousUrl();
        else url = `/projects/${projectKey}`;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(url);
    };
(0, $bYtrC.listenToExternalActionFromLegacy)(()=>({
        dispatchExternalAction: $719e268c3759c45e$var$dispatchExternalAction,
        modifiedIssueIssueKey: $719e268c3759c45e$var$getIssueKey()
    }));
const $719e268c3759c45e$var$onDispatchExternalActionRef = (ref)=>{
    if (ref) $719e268c3759c45e$var$dispatchExternalAction = ref;
};
const $719e268c3759c45e$var$getAnalyticsSourceFromUrl = ()=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    if (pathname.includes('section')) return 0, $fcf97b7a09088940$export$7063ee6d0035a982;
    if (pathname.includes('queues')) return 0, $fcf97b7a09088940$export$7063ee6d0035a982;
    return 0, $fcf97b7a09088940$export$5bd5011b6596a0e7;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$719e268c3759c45e$export$2e2bcd8739ae039 = ({ issueNavigatorData: issueNavigatorData } = {})=>{
    (0, $9hUca.markFragmentReady)();
    const issueKey = $719e268c3759c45e$var$getIssueKey();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "jsm-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a1E0h.default), {
        backButtonUrl: $719e268c3759c45e$var$isComingFromQueueOrReport() ? $719e268c3759c45e$var$getPreviousUrl() : undefined,
        issueNavigatorData: issueNavigatorData,
        analyticsSource: $719e268c3759c45e$var$getAnalyticsSourceFromUrl(),
        issueKey: issueKey,
        onIssueDeleteSuccess: $719e268c3759c45e$var$redirectAfterSuccessfulDelete(),
        onDispatchExternalActionRef: $719e268c3759c45e$var$onDispatchExternalActionRef
    }));
};

});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$2dac1950892123f5 = 'jiraTimeline';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';
const $fcf97b7a09088940$export$5f3c20fe2ff6c0a2 = 'staffing-issue';

parcelRegister("k3PbQ", function(module, exports) {

$parcel$export(module.exports, "extractProjectKey", () => $bfdd97e245e93328$export$f1a2e4721b127828);

var $g5X3G = parcelRequire("g5X3G");
const $bfdd97e245e93328$export$f1a2e4721b127828 = (issueKey)=>(0, $g5X3G.toProjectKey)(issueKey.split('-')[0]);

});

parcelRegister("4Eklo", function(module, exports) {

$parcel$export(module.exports, "parseIssueKey", () => $91413ecb65c044f0$export$775cba7641fc60e9);

var $g5X3G = parcelRequire("g5X3G");
const $91413ecb65c044f0$export$775cba7641fc60e9 = (href)=>{
    const path = href.split('/').pop();
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    return (0, $g5X3G.toIssueKey)(path.split('?')[0].split('#')[0]);
};

});

parcelRegister("bYtrC", function(module, exports) {

$parcel$export(module.exports, "listenToExternalActionFromLegacy", () => $3ad042b87162e1c7$export$60376d8e2c7d8037);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
const $3ad042b87162e1c7$var$isBindableEvents = (Events)=>{
    if (!Events) return false;
    return typeof Events === 'object' && 'bind' in Events && typeof Events.bind === 'function';
};
const $3ad042b87162e1c7$export$60376d8e2c7d8037 = (getDispatcherAndModifiedIssue)=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    }).then((Events)=>{
        if ($3ad042b87162e1c7$var$isBindableEvents(Events)) Events.bind('modify-issue-view-via-external-action', (e, payload)=>{
            const { issueKey: issueKey, externalAction: externalAction } = payload;
            const { dispatchExternalAction: dispatchExternalAction, modifiedIssueIssueKey: modifiedIssueIssueKey } = getDispatcherAndModifiedIssue();
            if (issueKey === modifiedIssueIssueKey && externalAction && dispatchExternalAction) dispatchExternalAction(externalAction);
        });
    });
};

});

parcelRegister("9hUca", function(module, exports) {

$parcel$export(module.exports, "markFragmentReady", () => $09e694cdaae84ff1$export$f35671de67f03a2b);
$parcel$export(module.exports, "initialiseMetrics", () => $09e694cdaae84ff1$export$1ac307e078c767d0);
$parcel$export(module.exports, "markIssueStartRendering", () => $09e694cdaae84ff1$export$c039505b02c87616);
$parcel$export(module.exports, "markIssueRender", () => $09e694cdaae84ff1$export$c16cf8a32075f588);
$parcel$export(module.exports, "markIssueLegacyInteractive", () => $09e694cdaae84ff1$export$4d5d547fdbe28097);
$parcel$export(module.exports, "markSPAReadyEndOfCriticalPath", () => $09e694cdaae84ff1$export$a45a77102d75517f);
$parcel$export(module.exports, "markIssueInteractive", () => $09e694cdaae84ff1$export$e57956c4b76a36f);
$parcel$export(module.exports, "markIssueOnPageLoadEvent", () => $09e694cdaae84ff1$export$c30d9392d27ab5a8);
$parcel$export(module.exports, "markStartIssue", () => $09e694cdaae84ff1$export$71cdf78946f275c);
$parcel$export(module.exports, "markIssuePreviewRendered", () => $09e694cdaae84ff1$export$7f5545008a1e5a18);
$parcel$export(module.exports, "setIsInitialRender", () => $09e694cdaae84ff1$export$eedeaa0a5b3bd3d1);
$parcel$export(module.exports, "isFullIssueView", () => $09e694cdaae84ff1$export$db2ef91f6ace96c7);

var $7Jxgt = parcelRequire("7Jxgt");

var $eyWK5 = parcelRequire("eyWK5");

var $307qF = parcelRequire("307qF");

var $7Ws94 = parcelRequire("7Ws94");

var $lAOer = parcelRequire("lAOer");

var $fDtbf = parcelRequire("fDtbf");

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $dJl1T = parcelRequire("dJl1T");

var $7N30e = parcelRequire("7N30e");


var $1XsIp = parcelRequire("1XsIp");

var $EKr1h = parcelRequire("EKr1h");

var $72N4j = parcelRequire("72N4j");

var $iAWa3 = parcelRequire("iAWa3");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

var $6y2lk = parcelRequire("6y2lk");

var $4R6GH = parcelRequire("4R6GH");

var $eDXka = parcelRequire("eDXka");

var $Rsnea = parcelRequire("Rsnea");

var $1UioC = parcelRequire("1UioC");

var $jf6us = parcelRequire("jf6us");

var $fdHx2 = parcelRequire("fdHx2");
const $09e694cdaae84ff1$var$LOG_LOCATION = 'issue.metrics';
let $09e694cdaae84ff1$var$state;
const $09e694cdaae84ff1$var$getSsrMark = ()=>{
    const ssrMark = (0, $x9xyg.getMark)((0, $fDtbf.SPA_SSR_RENDERED_MARK));
    if (ssrMark != null) return Math.floor(ssrMark.startTime);
    return null;
};
const $09e694cdaae84ff1$var$setMarkWithError = (markName)=>{
    try {
        (0, $x9xyg.setMark)(markName);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData($09e694cdaae84ff1$var$LOG_LOCATION, 'Setting performance mark failed', error);
    }
};
const $09e694cdaae84ff1$export$f35671de67f03a2b = ()=>{
    $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$625e4e4c6eb56930);
};
const $09e694cdaae84ff1$export$1ac307e078c767d0 = (options)=>{
    try {
        const { issueContextActions: issueContextActions, isLoadedWithPage: isLoadedWithPage, isSPA: isSPA, isRecentIssue: isRecentIssue, recentIssuesCount: recentIssuesCount, dataProvider: dataProvider, analyticsSource: analyticsSource, store: store, route: route } = options;
        $09e694cdaae84ff1$var$state = new (0, $jf6us.default)({
            isLoadedWithPage: isLoadedWithPage,
            isSPA: isSPA,
            isRecentIssue: isRecentIssue,
            analyticsSource: analyticsSource,
            recentIssuesCount: recentIssuesCount,
            correlationId: (0, $7Jxgt.v4)(),
            // @ts-expect-error - TS2322 - Type '{ analyticsKey: ApplicationKey | undefined; viewMode: any; issueId: string | undefined; }' is not assignable to type 'MetricsProps'.
            lazyMetricsProps: ()=>(0, $fdHx2.metricsStateSelector)(store.getState()),
            timingDataReporter: ()=>({
                    ...(0, $72N4j.serverTimingSelector)(store.getState()),
                    ...(0, $1XsIp.getFetchIssueNetworkTimes)()
                }),
            issueScaleabilityReporter: (0, $1UioC.issueScaleabilityReporterFactory)(store, issueContextActions),
            dataProvider: dataProvider,
            route: route
        });
        // Marking init of bm3
        (0, $EKr1h.issueViewLoad).mark('metrics_init');
        (0, $EKr1h.issueViewOnPageLoad).mark('metrics_init');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData($09e694cdaae84ff1$var$LOG_LOCATION, 'Failed to initialise issue metrics', error);
    }
};
const $09e694cdaae84ff1$export$c039505b02c87616 = ()=>{
    $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$10082883a7f4ea4d);
    (0, $EKr1h.issueViewLoad).mark($f0ab548eaf57140f$export$10082883a7f4ea4d);
};
const $09e694cdaae84ff1$export$c16cf8a32075f588 = ()=>{
    $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$7f7b606f70e669e6);
    (0, $EKr1h.issueViewOnPageLoad).mark($f0ab548eaf57140f$export$7f7b606f70e669e6);
};
const $09e694cdaae84ff1$export$4d5d547fdbe28097 = ()=>{
    $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$b292c195104c50d3);
    (0, $EKr1h.issueViewLoad).mark($f0ab548eaf57140f$export$b292c195104c50d3);
};
const $09e694cdaae84ff1$export$8bc8bca4478fe6d7 = (markTime)=>{
    (0, $EKr1h.issueViewOnPageLoad).mark($f0ab548eaf57140f$export$4d1080224e02ef0b, markTime);
};
const $09e694cdaae84ff1$export$a45a77102d75517f = ()=>{
    $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$434b58ebadf14df2);
    (0, $EKr1h.issueViewLoad).mark($f0ab548eaf57140f$export$434b58ebadf14df2);
};
const $09e694cdaae84ff1$var$getSharedCustomData = ()=>({
        ...$09e694cdaae84ff1$var$state.getIssueScaleabilityReporter()(),
        ...(0, $Rsnea.getBackendBlockingTime)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issueViewLoad: (0, $EKr1h.issueViewLoad)
        }),
        isBentoRecentIssue: $09e694cdaae84ff1$var$state.getIsRecentIssue(),
        bentoRecentIssuesCount: $09e694cdaae84ff1$var$state.getRecentIssuesCount(),
        correlationId: $09e694cdaae84ff1$var$state.getCorrelationId(),
        initialLoadFullPageBundleLoadCount: $09e694cdaae84ff1$var$state.getIsInitial() ? (0, $6RCeq.default).getEntriesByType('resource').filter((x)=>x.name.includes('async-issue-app--full-page')).length : 0,
        ...(0, $4R6GH.fg)('jiv-20201-issue-view-server-time-perf-metric') ? {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            serverTime: (0, $6RCeq.default).getEntriesByType('resource').find(({ name: name })=>name.includes((0, $eDXka.IssueViewFetchOperations).INITIAL_AGG))?.serverTiming.find(({ name: name })=>name === 'atl-edge')?.duration
        } : {}
    });
const $09e694cdaae84ff1$export$e57956c4b76a36f = ({ lastTransitionTime: // TODO JIV-14563 Fixup or remove embeddedIssueTTI in BM3 metrics due to broken lastTransitionStartTime
// @ts-expect-error - this has never been wired up correctly, I only just discovered it by adding types for the data that is actually passed through.
lastTransitionTime })=>{
    const isFullIssue = $09e694cdaae84ff1$var$state.getIsFullIssue();
    $09e694cdaae84ff1$var$state.setInteractiveEnd((0, $6RCeq.default).now());
    if ($09e694cdaae84ff1$var$state) {
        const startTime = lastTransitionTime || $09e694cdaae84ff1$var$state.getStartTime();
        if ($09e694cdaae84ff1$var$state.getIsFullIssue()) (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
        const embeddedCustomData = !isFullIssue ? {
            embeddedIssueFMP: Math.floor($09e694cdaae84ff1$var$state.getFMP()),
            embeddedIssueTTI: Math.floor($09e694cdaae84ff1$var$state.getInteractiveEnd() - startTime),
            analyticsSource: $09e694cdaae84ff1$var$state.getAnalyticsSource(),
            featureFlags: Object.fromEntries((0, $7Ws94.allFeatureFlagsAccessed))
        } : {};
        const perfConfig = {
            stopTime: $09e694cdaae84ff1$var$state.getInteractiveEnd(),
            customData: {
                ...$09e694cdaae84ff1$var$getSharedCustomData(),
                ...embeddedCustomData
            }
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $eyWK5.addUFOCustomData)(perfConfig.customData);
        const ufoMetricKey = isFullIssue ? 'issue-view' : 'issue-embed';
        (0, $lAOer.addApdexToAll)({
            key: ufoMetricKey,
            startTime: isFullIssue ? undefined : (0, $EKr1h.embeddedIssueViewLoad).getData()?.start ?? undefined,
            stopTime: perfConfig.stopTime
        });
        if (isFullIssue) {
            (0, $307qF.addBM3TimingsToUFO)((0, $EKr1h.issueViewLoad).getData()?.marks, (0, $EKr1h.issueViewLoad).getData()?.config.timings);
            (0, $iAWa3.afterPaintEmit)(()=>{
                // @ts-expect-error payload type mismatch with optional values
                (0, $EKr1h.issueViewLoad).stop(perfConfig);
            }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $EKr1h.issueViewLoad));
        } else // @ts-expect-error payload type mismatch with optional values
        (0, $EKr1h.issueViewLoad).stop(perfConfig);
        (0, $6y2lk.markUimTtiIssueViewLoaded)();
        if (!isFullIssue) // See markStartIssue for more information.
        {
            if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
        }
    }
};
const $09e694cdaae84ff1$var$getBrowserNavigationMetrics = ()=>{
    const entries = (0, $6RCeq.default).getEntriesByType('navigation');
    if (entries.length === 0 || !(entries[0] instanceof PerformanceNavigationTiming)) return null;
    const navigation = entries[0];
    return {
        connectEnd: Math.round(navigation.connectEnd),
        connectStart: Math.round(navigation.connectStart),
        domComplete: Math.round(navigation.domComplete),
        domContentLoadedEventEnd: Math.round(navigation.domContentLoadedEventEnd),
        domContentLoadedEventStart: Math.round(navigation.domContentLoadedEventStart),
        domInteractive: Math.round(navigation.domInteractive),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        fetchStart: Math.round(navigation.fetchStart),
        loadEventStart: Math.round(navigation.loadEventStart),
        requestStart: Math.round(navigation.requestStart),
        responseEnd: Math.round(navigation.responseEnd),
        responseStart: Math.round(navigation.responseStart),
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        redirectCount: navigation.redirectCount,
        type: navigation.type
    };
};
const $09e694cdaae84ff1$export$c30d9392d27ab5a8 = ()=>{
    const isFullIssue = $09e694cdaae84ff1$var$state.getIsFullIssue();
    if (!isFullIssue) return;
    if ($09e694cdaae84ff1$var$state) {
        try {
            new PerformanceObserver((entryList)=>{
                entryList.getEntries().forEach((entry)=>$09e694cdaae84ff1$export$8bc8bca4478fe6d7(entry.startTime));
            }).observe({
                type: 'largest-contentful-paint',
                buffered: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
        // do nothing
        }
        const customData = {
            ...$09e694cdaae84ff1$var$getSharedCustomData(),
            browserNavigationMetrics: $09e694cdaae84ff1$var$getBrowserNavigationMetrics()
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $EKr1h.issueViewOnPageLoad).stop(customData);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $eyWK5.addUFOCustomData)(customData);
    }
};
const $09e694cdaae84ff1$export$71cdf78946f275c = (isFullPage = false)=>{
    (0, $EKr1h.issueViewLoad).start();
    if (!isFullPage) {
        (0, $EKr1h.embeddedIssueViewLoad).start({
            startTime: (0, $6RCeq.default).now()
        });
        /**
		 * All SPA full page loads already start the event delay through the
		 * usePageLoadedSubscriber hook in @atlassian/jira-event-delay-controller.
		 * The embedded views need to start this critical section explicitly here because
		 * there is no equivalent hook that is generically applicable to all experiences.
		 *
		 * The only events that currently leverage the delay mechanism are the automatic
		 * exposure events, so we can avoid the overhead of starting this critical section
		 * if it won't be necessary.
		 */ if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.startLowPriorityEventDelay)();
    }
    if (isFullPage) (0, $EKr1h.issueViewOnPageLoad).start({
        startTime: 0
    });
    (0, $6y2lk.startUimTti)();
};
const $09e694cdaae84ff1$export$7f5545008a1e5a18 = ({ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime })=>{
    const ssrMark = $09e694cdaae84ff1$var$getSsrMark();
    const previewTime = (0, $6RCeq.default).now();
    const startTime = $09e694cdaae84ff1$var$state.getStartTime();
    let fmp = 0;
    if ($09e694cdaae84ff1$var$state.getIsFullIssue()) {
        if (isInitialRender) // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
        fmp = ssrMark;
        else fmp = previewTime - (lastTransitionStartTime || startTime);
    } else fmp = previewTime - startTime;
    (0, $EKr1h.issueViewLoad).mark($f0ab548eaf57140f$export$62c04f0e896827e3);
    (0, $EKr1h.issueViewOnPageLoad).mark($f0ab548eaf57140f$export$62c04f0e896827e3);
    $09e694cdaae84ff1$var$state.setFMP(fmp);
    $09e694cdaae84ff1$var$state.setPreviewEnd(previewTime);
    $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$62c04f0e896827e3);
};
const $09e694cdaae84ff1$export$eedeaa0a5b3bd3d1 = (isInitialRender)=>{
    if ($09e694cdaae84ff1$var$state) $09e694cdaae84ff1$var$state.setIsLoadedWithPage(isInitialRender);
};
const $09e694cdaae84ff1$export$db2ef91f6ace96c7 = ()=>$09e694cdaae84ff1$var$state && $09e694cdaae84ff1$var$state.getIsFullIssue();

});
parcelRegister("307qF", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $60b371e0a217cca9$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $60b371e0a217cca9$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $60b371e0a217cca9$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");
function $60b371e0a217cca9$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $60b371e0a217cca9$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $aatTc.default));
    const interactionId = (0, $32M8E.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $lAOer.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $60b371e0a217cca9$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $60b371e0a217cca9$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $32M8E.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $lAOer.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $60b371e0a217cca9$export$f02972da195a43bb(marks, timingsConfig);
        (0, $lAOer.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

const $f0ab548eaf57140f$export$625e4e4c6eb56930 = 'ISSUE_FRAGMENT_READY_MARK';
const $f0ab548eaf57140f$export$10082883a7f4ea4d = 'ISSUE_START_RENDERING_MARK';
const $f0ab548eaf57140f$export$62c04f0e896827e3 = 'ISSUE_PREVIEW_RENDERED';
const $f0ab548eaf57140f$export$5db08809a3f311ed = 'ISSUE_FETCHED_MARK';
const $f0ab548eaf57140f$export$c21b33196a19ec61 = 'ISSUE_START_FETCHING_DATA';
const $f0ab548eaf57140f$export$e64e32643802b552 = 'ISSUE_READY_FOR_DATA';
const $f0ab548eaf57140f$export$e52cc35f872875f7 = 'ISSUE_DATA_AVAILABLE';
const $f0ab548eaf57140f$export$91b5cb94c32a9b = 'ISSUE_CACHED_CONTENT_LOADED';
const $f0ab548eaf57140f$export$205779a1d31dbc62 = 'ssr.issue.rendered';
const $f0ab548eaf57140f$export$bfb91b09e6b87d3c = 'ISSUE_START_GIRA_FETCH';
const $f0ab548eaf57140f$export$beb8599162403c36 = 'ISSUE_FINISH_GIRA_FETCH';
const $f0ab548eaf57140f$export$3a9e4a905dec520d = 'ISSUE_MOUNTED';
const $f0ab548eaf57140f$export$7f7b606f70e669e6 = 'ISSUE_RENDERED';
const $f0ab548eaf57140f$export$b292c195104c50d3 = 'ISSUE_LEGACY_INTERACTIVE';
const $f0ab548eaf57140f$export$434b58ebadf14df2 = 'ISSUE_SPA_MARKED_READY_END_OF_CRITICAL_PATH';
const $f0ab548eaf57140f$export$4d1080224e02ef0b = 'LCP_CANDIDATE';
const $f0ab548eaf57140f$export$a98a3196940af8fa = 'issueViewCriticalData-agg-suspense';
const $f0ab548eaf57140f$export$7b35970640b1e1c0 = 'issueViewCriticalData-gira-suspense';
const $f0ab548eaf57140f$export$1ea0ab50283b82a8 = 'issueViewCriticalData-redux';

parcelRegister("1XsIp", function(module, exports) {

$parcel$export(module.exports, "clearFetchIssueNetworkTimes", () => $80f3a44fca71778e$export$8d777cefeb6b914e);
$parcel$export(module.exports, "getFetchIssueNetworkTimes", () => $80f3a44fca71778e$export$48cecd0d00931806);

var $7OOGM = parcelRequire("7OOGM");

var $6RCeq = parcelRequire("6RCeq");

var $60SGJ = parcelRequire("60SGJ");
const $80f3a44fca71778e$var$fetchIssueNetworkMarks = [
    (0, $60SGJ.fetchUploadPerf),
    (0, $60SGJ.fetchCommentsPerf),
    (0, $60SGJ.fetchIssuePropertiesPerf),
    (0, $60SGJ.fetchIssueLinkPerf),
    (0, $60SGJ.fetchViewContextPerf),
    (0, $60SGJ.fetchSubtaskTypesPerf),
    (0, $60SGJ.fetchFieldDataPerf),
    (0, $60SGJ.fetchUserAuthPerf)
];
// Data remains the same once called once (for the same issue), so we cache it
// here for future requests for this data due to the calculation wiping the
//  performance marks required to calculate.  It does however need to be reset
// in cases like subtask click throughs when we load a new issue.
let $80f3a44fca71778e$var$fetchIssueNetworkTimes;
const $80f3a44fca71778e$var$calculateFetchIssueNetworkTimes = ()=>{
    const issueNetworkTimes = $80f3a44fca71778e$var$fetchIssueNetworkMarks.reduce((obj, perf)=>{
        const beginMarkName = `BEGIN_${perf.prefix}_${perf.key}`;
        const endMarkName = `END_${perf.prefix}_${perf.key}`;
        const networkTime = (0, $7OOGM.timeBetweenMarks)(beginMarkName, endMarkName);
        if (networkTime != null && networkTime > 0) {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            const aggregated = {
                ...obj,
                [`${perf.key}_NETWORK`]: networkTime
            };
            // This is vital to clear mark after use.  Or next call will failed to add the mark of same name.
            if ((0, $6RCeq.default).clearMarks) {
                (0, $6RCeq.default).clearMarks(beginMarkName);
                (0, $6RCeq.default).clearMarks(endMarkName);
            }
            return aggregated;
        }
        return obj;
    }, {});
    return issueNetworkTimes;
};
const $80f3a44fca71778e$export$8d777cefeb6b914e = ()=>{
    $80f3a44fca71778e$var$fetchIssueNetworkMarks.forEach((perf)=>{
        const beginMarkName = `BEGIN_${perf.prefix}_${perf.key}`;
        const endMarkName = `END_${perf.prefix}_${perf.key}`;
        if ((0, $6RCeq.default).clearMarks) {
            (0, $6RCeq.default).clearMarks(beginMarkName);
            (0, $6RCeq.default).clearMarks(endMarkName);
        }
    });
    $80f3a44fca71778e$var$fetchIssueNetworkTimes = null;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.ISSUE_DATA_AVAILABLE = null;
};
const $80f3a44fca71778e$export$48cecd0d00931806 = ()=>{
    if (!$80f3a44fca71778e$var$fetchIssueNetworkTimes) $80f3a44fca71778e$var$fetchIssueNetworkTimes = $80f3a44fca71778e$var$calculateFetchIssueNetworkTimes();
    return $80f3a44fca71778e$var$fetchIssueNetworkTimes;
};

});
parcelRegister("7OOGM", function(module, exports) {

$parcel$export(module.exports, "timeBetweenMarks", () => $9a82ffbeaa8b7a7f$export$9c25bf1893ba64c);

var $x9xyg = parcelRequire("x9xyg");
const $9a82ffbeaa8b7a7f$export$9c25bf1893ba64c = (startMarkName, endMarkName)=>{
    const startMark = (0, $x9xyg.getMark)(startMarkName);
    const endMark = (0, $x9xyg.getMark)(endMarkName);
    if (!startMark || !endMark || startMark.startTime > endMark.startTime) return null;
    return endMark.startTime - startMark.startTime;
};

});

parcelRegister("60SGJ", function(module, exports) {

$parcel$export(module.exports, "fetchFieldDataPerf", () => $9e43cd7de2afe373$export$b97d963a8496fa2f);
$parcel$export(module.exports, "fetchCommentsPerf", () => $9e43cd7de2afe373$export$179836a99669cbe7);
$parcel$export(module.exports, "fetchIssueLinkPerf", () => $9e43cd7de2afe373$export$8d0984a0f9f31117);
$parcel$export(module.exports, "fetchSubtaskTypesPerf", () => $9e43cd7de2afe373$export$c1324bd586e9a53a);
$parcel$export(module.exports, "fetchUploadPerf", () => $9e43cd7de2afe373$export$72fcc6cb1cdc70e0);
$parcel$export(module.exports, "fetchUserAuthPerf", () => $9e43cd7de2afe373$export$4052b1eae3373c3b);
$parcel$export(module.exports, "fetchViewContextPerf", () => $9e43cd7de2afe373$export$b4e2588a18d8d980);
$parcel$export(module.exports, "fetchIssuePropertiesPerf", () => $9e43cd7de2afe373$export$2ee73dd298bdfe8a);
const $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX = 'ISSUE_DETAILS';
const $9e43cd7de2afe373$var$FETCH_FIELD_DATA_REQUEST = 'FETCH_FIELD_DATA';
const $9e43cd7de2afe373$var$FETCH_INITIAL_COMMENTS_REQUEST = 'FETCH_INITIAL_COMMENTS';
const $9e43cd7de2afe373$var$FETCH_ISSUE_LINK_TYPES_REQUEST = 'FETCH_ISSUE_LINK_TYPES';
const $9e43cd7de2afe373$var$FETCH_SUBTASK_TYPES_REQUEST = 'FETCH_SUBTASK_TYPES';
const $9e43cd7de2afe373$var$FETCH_UPLOAD_CONTEXT_REQUEST = 'FETCH_LOAD_CONTEXT';
const $9e43cd7de2afe373$var$FETCH_USER_AUTH_REQUEST = 'FETCH_USER_AUTH';
const $9e43cd7de2afe373$var$FETCH_VIEW_CONTEXT_REQUEST = 'FETCH_VIEW_CONTEXT';
const $9e43cd7de2afe373$var$FETCH_ISSUE_PROPERTIES_REQUEST = 'FETCH_ISSUE_PROPERTIES';
const $9e43cd7de2afe373$export$b97d963a8496fa2f = {
    key: $9e43cd7de2afe373$var$FETCH_FIELD_DATA_REQUEST,
    prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $9e43cd7de2afe373$export$179836a99669cbe7 = {
    key: $9e43cd7de2afe373$var$FETCH_INITIAL_COMMENTS_REQUEST,
    prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $9e43cd7de2afe373$export$8d0984a0f9f31117 = {
    key: $9e43cd7de2afe373$var$FETCH_ISSUE_LINK_TYPES_REQUEST,
    prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $9e43cd7de2afe373$export$c1324bd586e9a53a = {
    key: $9e43cd7de2afe373$var$FETCH_SUBTASK_TYPES_REQUEST,
    prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $9e43cd7de2afe373$export$72fcc6cb1cdc70e0 = {
    key: $9e43cd7de2afe373$var$FETCH_UPLOAD_CONTEXT_REQUEST,
    prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $9e43cd7de2afe373$export$4052b1eae3373c3b = {
    key: $9e43cd7de2afe373$var$FETCH_USER_AUTH_REQUEST,
    prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $9e43cd7de2afe373$export$b4e2588a18d8d980 = {
    key: $9e43cd7de2afe373$var$FETCH_VIEW_CONTEXT_REQUEST,
    prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $9e43cd7de2afe373$export$2ee73dd298bdfe8a = {
    key: $9e43cd7de2afe373$var$FETCH_ISSUE_PROPERTIES_REQUEST,
    prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};

});


parcelRegister("EKr1h", function(module, exports) {

$parcel$export(module.exports, "issueViewLoad", () => $4f120a802ce83bc9$export$49371c2cc4aaa4f6);
$parcel$export(module.exports, "issueViewOnPageLoad", () => $4f120a802ce83bc9$export$2f6837d06b669285);
$parcel$export(module.exports, "embeddedIssueViewLoad", () => $4f120a802ce83bc9$export$9d773f01a8da623e);
$parcel$export(module.exports, "epicDropdownOpenInteraction", () => $4f120a802ce83bc9$export$8d33579ffe76aa5b);
$parcel$export(module.exports, "epicModalOpenInteraction", () => $4f120a802ce83bc9$export$8f0deabe791d5bb9);

var $2nKjG = parcelRequire("2nKjG");

const $4f120a802ce83bc9$export$49371c2cc4aaa4f6 = (0, $2nKjG.metrics).custom({
    key: 'issue-view-load',
    virtual: true,
    timings: [
        {
            key: 'legacy-tti-2021',
            startMark: 'metrics_init',
            endMark: $f0ab548eaf57140f$export$b292c195104c50d3
        },
        {
            key: 'timeBlockedOnBackend',
            startMark: $f0ab548eaf57140f$export$e64e32643802b552,
            endMark: $f0ab548eaf57140f$export$e52cc35f872875f7
        }
    ]
});
const $4f120a802ce83bc9$export$2f6837d06b669285 = (0, $2nKjG.metrics).custom({
    key: 'issue-view-on-page-load',
    timings: [
        {
            key: 'issue-mounted',
            endMark: $f0ab548eaf57140f$export$3a9e4a905dec520d
        },
        {
            key: 'latest-lcp',
            endMark: $f0ab548eaf57140f$export$4d1080224e02ef0b
        }
    ]
});
const $4f120a802ce83bc9$export$9d773f01a8da623e = (0, $2nKjG.metrics).custom({
    key: 'embedded-issue-view-load',
    until: $4f120a802ce83bc9$export$49371c2cc4aaa4f6,
    include: [
        $4f120a802ce83bc9$export$49371c2cc4aaa4f6
    ]
});
const $4f120a802ce83bc9$export$1e32b6c8e1e31a3d = (0, $2nKjG.metrics).pageLoad({
    key: 'service-management.queues.issue'
});
const $4f120a802ce83bc9$export$4be279014c4d8d39 = (0, $2nKjG.metrics).pageLoad({
    key: 'service-management.reports.issue'
});
const $4f120a802ce83bc9$export$8d33579ffe76aa5b = (0, $2nKjG.metrics).interaction({
    key: 'issue-epic-dropdown-menu-open'
});
const $4f120a802ce83bc9$export$8f0deabe791d5bb9 = (0, $2nKjG.metrics).interaction({
    key: 'issue-epic-modal-open'
});

});

parcelRegister("72N4j", function(module, exports) {

$parcel$export(module.exports, "serverTimingSelector", () => $2bce567eae8a73a3$export$a0b21c7e17057a47);

var $dGvGJ = parcelRequire("dGvGJ");

var $bcoYn = parcelRequire("bcoYn");
const $2bce567eae8a73a3$export$8ef68fa2b28a6d0f = (state)=>state.timing;
const $2bce567eae8a73a3$export$a0b21c7e17057a47 = (0, $dGvGJ.createSelector)($2bce567eae8a73a3$export$8ef68fa2b28a6d0f, (0, $bcoYn.isLoadingSelector), (timing, isLoading)=>isLoading ? undefined : timing.server);

});
parcelRegister("bcoYn", function(module, exports) {

$parcel$export(module.exports, "entitiesSelector", () => $468fb8d2be99a4f5$export$ccebe5cc5854d0fa);
$parcel$export(module.exports, "projectSelector", () => $468fb8d2be99a4f5$export$852a6c34ff1a2e77);
$parcel$export(module.exports, "uiSelector", () => $468fb8d2be99a4f5$export$185c0864c82372e3);
$parcel$export(module.exports, "entitiesIssueSelector", () => $468fb8d2be99a4f5$export$fa3ac1f794979805);
$parcel$export(module.exports, "entitiesRefreshedOnSelector", () => $468fb8d2be99a4f5$export$c4ebdc93969b82cc);
$parcel$export(module.exports, "flagsSelector", () => $468fb8d2be99a4f5$export$40cfdc5e96db7759);
$parcel$export(module.exports, "projectIdSelector", () => $468fb8d2be99a4f5$export$4c9d6034f65d22f4);
$parcel$export(module.exports, "projectIdsSelector", () => $468fb8d2be99a4f5$export$9edb3f63d1bd8546);
$parcel$export(module.exports, "projectKeySelector", () => $468fb8d2be99a4f5$export$404de5ac601b84bc);
$parcel$export(module.exports, "projectTypeSelector", () => $468fb8d2be99a4f5$export$69316f88206ca90b);
$parcel$export(module.exports, "isSimplifiedProjectSelector", () => $468fb8d2be99a4f5$export$d94d544d4b2e1310);
$parcel$export(module.exports, "loggedInUserDetailsSelector", () => $468fb8d2be99a4f5$export$b5a68452fc64275d);
$parcel$export(module.exports, "loggedInUserAvatarUrlSelector", () => $468fb8d2be99a4f5$export$e0efa9c12379be7a);
$parcel$export(module.exports, "loggedInUserDisplayNameSelector", () => $468fb8d2be99a4f5$export$4f56a07246719eb0);
$parcel$export(module.exports, "parentIssueEntitySelector", () => $468fb8d2be99a4f5$export$e10c57d263d23c49);
$parcel$export(module.exports, "loggedInUserTimeZoneSelector", () => $468fb8d2be99a4f5$export$ac6f9fd801c94fff);
$parcel$export(module.exports, "idSelector", () => $468fb8d2be99a4f5$export$66c501bed2fcd648);
$parcel$export(module.exports, "isClassicProjectSelector", () => $468fb8d2be99a4f5$export$45347d9f8a67561b);
$parcel$export(module.exports, "isLoadingSelector", () => $468fb8d2be99a4f5$export$c077f23183070903);
$parcel$export(module.exports, "doNotUseIsLoadingPromiseSelector", () => $468fb8d2be99a4f5$export$2ca9575c7da6bf18);
$parcel$export(module.exports, "isPreviewSelector", () => $468fb8d2be99a4f5$export$b33a1a8958a8d805);
$parcel$export(module.exports, "isCompletedLoadingSelector", () => $468fb8d2be99a4f5$export$9b99fb9e23fc133);
$parcel$export(module.exports, "loadingStageSelector", () => $468fb8d2be99a4f5$export$18bc980d36bf93d);
$parcel$export(module.exports, "isDeleteIssueModalOpenSelector", () => $468fb8d2be99a4f5$export$7cfd3e0dd7059b87);
$parcel$export(module.exports, "isDeletingIssueSelector", () => $468fb8d2be99a4f5$export$d414d8eddcb409e4);
$parcel$export(module.exports, "didIssueDeleteFailSelector", () => $468fb8d2be99a4f5$export$834732624d2c73e1);
$parcel$export(module.exports, "errorSelector", () => $468fb8d2be99a4f5$export$47aec13333381be0);
$parcel$export(module.exports, "errorMessageSelector", () => $468fb8d2be99a4f5$export$9b1097e17c0e6dc2);
$parcel$export(module.exports, "getUserByIdSelector", () => $468fb8d2be99a4f5$export$801a2f2bd4059665);
$parcel$export(module.exports, "parentLevelIssuesSelector", () => $468fb8d2be99a4f5$export$aa8980c49aba4478);
$parcel$export(module.exports, "baseAriSelector", () => $468fb8d2be99a4f5$export$fa12ae06e35ebd67);
$parcel$export(module.exports, "issueAriSelector", () => $468fb8d2be99a4f5$export$a2cdbba2136e72d3);
$parcel$export(module.exports, "epicLinkFieldKeySelector", () => $468fb8d2be99a4f5$export$27abc48b8d528300);
$parcel$export(module.exports, "isEpicSelector", () => $468fb8d2be99a4f5$export$6e8ebe94ad8bb62b);
$parcel$export(module.exports, "isEpicIssueTypeSelector", () => $468fb8d2be99a4f5$export$460d8048474fa8a2);
$parcel$export(module.exports, "getIssueStatusCategoryIdSelector", () => $468fb8d2be99a4f5$export$6395cbfb900cdf4e);
$parcel$export(module.exports, "isServiceDeskSelector", () => $468fb8d2be99a4f5$export$43d733e4b7e8c7d0);

var $dGvGJ = parcelRequire("dGvGJ");

var $2vSU6 = parcelRequire("2vSU6");


var $fOGZN = parcelRequire("fOGZN");

var $g5X3G = parcelRequire("g5X3G");

var $a1ky2 = parcelRequire("a1ky2");

var $7Ow8a = parcelRequire("7Ow8a");
const $468fb8d2be99a4f5$export$ccebe5cc5854d0fa = (state)=>state.entities;
const $468fb8d2be99a4f5$export$852a6c34ff1a2e77 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>entities ? entities.project : null);
const $468fb8d2be99a4f5$export$185c0864c82372e3 = (state)=>state.ui;
const $468fb8d2be99a4f5$export$27493ac3d8611290 = (state)=>state.agile;
const $468fb8d2be99a4f5$export$fa3ac1f794979805 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>entities.issue);
const $468fb8d2be99a4f5$export$c4ebdc93969b82cc = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>entities.refreshedOn);
const $468fb8d2be99a4f5$export$40cfdc5e96db7759 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.flags);
const $468fb8d2be99a4f5$export$4c9d6034f65d22f4 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$852a6c34ff1a2e77, (project)=>project && project.projectId ? project.projectId : null);
const $468fb8d2be99a4f5$export$9edb3f63d1bd8546 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$852a6c34ff1a2e77, (project)=>project && project.projectId ? [
        project.projectId
    ] : []);
const $468fb8d2be99a4f5$export$404de5ac601b84bc = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$852a6c34ff1a2e77, (project)=>project ? project.projectKey : null);
const $468fb8d2be99a4f5$export$69316f88206ca90b = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$852a6c34ff1a2e77, (project)=>project && project.projectType ? project.projectType : null);
const $468fb8d2be99a4f5$export$d94d544d4b2e1310 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$852a6c34ff1a2e77, (project)=>!!project && project.isSimplified);
const $468fb8d2be99a4f5$export$b5a68452fc64275d = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (0, $a1ky2.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>loggedInAccountId ? entities.users[loggedInAccountId] : null);
const $468fb8d2be99a4f5$export$e0efa9c12379be7a = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (0, $a1ky2.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>{
    const loggedInUser = loggedInAccountId ? entities.users[loggedInAccountId] : null;
    return loggedInUser ? loggedInUser.avatarUrl : null;
});
const $468fb8d2be99a4f5$export$4f56a07246719eb0 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (0, $a1ky2.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>{
    const loggedInUser = loggedInAccountId ? entities.users[loggedInAccountId] : null;
    return loggedInUser ? loggedInUser.displayName : null;
});
const $468fb8d2be99a4f5$export$e10c57d263d23c49 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>entities.parentIssue);
const $468fb8d2be99a4f5$export$ac6f9fd801c94fff = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$b5a68452fc64275d, (loggedInUser)=>loggedInUser ? loggedInUser.timeZone : undefined);
const $468fb8d2be99a4f5$export$66c501bed2fcd648 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$fa3ac1f794979805, (issue)=>issue && (0, $g5X3G.toIssueId)(issue.id));
const $468fb8d2be99a4f5$export$45347d9f8a67561b = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$d94d544d4b2e1310, (isSimplified)=>!isSimplified);
const $468fb8d2be99a4f5$export$c077f23183070903 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $fdfab07e3d100124$export$26d55645375ca9a));
const $468fb8d2be99a4f5$export$2ca9575c7da6bf18 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.doNotUseIsLoadingPromise);
const $468fb8d2be99a4f5$export$b33a1a8958a8d805 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $fdfab07e3d100124$export$1b56cc494043d9bf));
const $468fb8d2be99a4f5$export$9b99fb9e23fc133 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $fdfab07e3d100124$export$1660a2d7c2fff354));
const $468fb8d2be99a4f5$export$18bc980d36bf93d = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.loadingStage);
const $468fb8d2be99a4f5$export$7cfd3e0dd7059b87 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>!!(ui.issueDeletion && ui.issueDeletion.isDeleteIssueModalOpen));
const $468fb8d2be99a4f5$export$d414d8eddcb409e4 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.issueDeletion ? ui.issueDeletion.isDeletingIssue : false);
const $468fb8d2be99a4f5$export$834732624d2c73e1 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.issueDeletion ? ui.issueDeletion.didIssueDeleteFail : false);
const $468fb8d2be99a4f5$export$47aec13333381be0 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.error);
const $468fb8d2be99a4f5$export$9b1097e17c0e6dc2 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.errorMessage);
const $468fb8d2be99a4f5$export$801a2f2bd4059665 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>(userId)=>userId ? entities.users[userId] : undefined);
const $468fb8d2be99a4f5$export$aa8980c49aba4478 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>entities.parentLevelIssues);
const $468fb8d2be99a4f5$export$a60a6c96db10acc4 = ()=>'jira';
const $468fb8d2be99a4f5$export$57c6957997fb7f1d = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$69316f88206ca90b, (0, $2vSU6.projectTypeToCanonicalId));
const $468fb8d2be99a4f5$export$fa12ae06e35ebd67 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$a60a6c96db10acc4, (0, $a1ky2.cloudIdSelector), (resourceOwner, cloudId)=>cloudId ? `ari:cloud:${resourceOwner}:${cloudId}` : null);
const $468fb8d2be99a4f5$export$a2cdbba2136e72d3 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$fa12ae06e35ebd67, $468fb8d2be99a4f5$export$66c501bed2fcd648, (baseAri, issueId)=>{
    if (!baseAri || !issueId) return null;
    return `${baseAri}:issue/${issueId}`;
});
const $468fb8d2be99a4f5$export$27abc48b8d528300 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$27493ac3d8611290, (agile)=>agile && agile.epic && agile.epic.key || null);
const $468fb8d2be99a4f5$export$d062a59cf4fc9cec = (fields)=>({}).hasOwnProperty.call(fields, (0, $fOGZN.EPIC_ISSUES));
const $468fb8d2be99a4f5$export$6e8ebe94ad8bb62b = (0, $dGvGJ.createSelector)((0, $7Ow8a.fieldsSelector), (fields)=>$468fb8d2be99a4f5$export$d062a59cf4fc9cec(fields));
const $468fb8d2be99a4f5$export$88630f3045704997 = (fields)=>{
    if (({}).hasOwnProperty.call(fields, 'hierarchy-level-same-level')) return fields['hierarchy-level-same-level'].value.name === 'Epic';
    return false;
};
const $468fb8d2be99a4f5$export$460d8048474fa8a2 = (0, $dGvGJ.createSelector)((0, $7Ow8a.fieldsSelector), (fields)=>$468fb8d2be99a4f5$export$88630f3045704997(fields));
const $468fb8d2be99a4f5$export$697a560dc772eca6 = (fields)=>{
    if (({}).hasOwnProperty.call(fields, 'status')) return fields.status.value?.statusCategory?.id;
};
const $468fb8d2be99a4f5$export$6395cbfb900cdf4e = (0, $dGvGJ.createSelector)((0, $7Ow8a.fieldsSelector), (fields)=>$468fb8d2be99a4f5$export$697a560dc772eca6(fields));
const $468fb8d2be99a4f5$export$57e1ff0824f418cd = (0, $dGvGJ.createSelector)((0, $7Ow8a.fieldsSelector), (fields)=>$468fb8d2be99a4f5$export$7bead7bb2ab962ba(fields));
const $468fb8d2be99a4f5$export$7bead7bb2ab962ba = (fields)=>{
    if (({}).hasOwnProperty.call(fields, 'summary')) return fields.summary.value;
};
const $468fb8d2be99a4f5$export$43d733e4b7e8c7d0 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$69316f88206ca90b, (projectType)=>projectType === (0, $2vSU6.SERVICE_DESK_PROJECT));

});
const $fdfab07e3d100124$export$26d55645375ca9a = 'LOADING';
const $fdfab07e3d100124$export$1b56cc494043d9bf = 'PREVIEW';
const $fdfab07e3d100124$export$1660a2d7c2fff354 = 'COMPLETE';

parcelRegister("fOGZN", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $1df76d38eb6e3f90$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $1df76d38eb6e3f90$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $1df76d38eb6e3f90$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $1df76d38eb6e3f90$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $1df76d38eb6e3f90$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $1df76d38eb6e3f90$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $1df76d38eb6e3f90$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $1df76d38eb6e3f90$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $1df76d38eb6e3f90$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $1df76d38eb6e3f90$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $1df76d38eb6e3f90$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $1df76d38eb6e3f90$export$79b91d4669dcadcb);
$parcel$export(module.exports, "EPIC", () => $1df76d38eb6e3f90$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $1df76d38eb6e3f90$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $1df76d38eb6e3f90$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $1df76d38eb6e3f90$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $1df76d38eb6e3f90$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $1df76d38eb6e3f90$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $1df76d38eb6e3f90$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $1df76d38eb6e3f90$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SUMMARY", () => $1df76d38eb6e3f90$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $1df76d38eb6e3f90$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $1df76d38eb6e3f90$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $1df76d38eb6e3f90$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $1df76d38eb6e3f90$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $1df76d38eb6e3f90$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $1df76d38eb6e3f90$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $1df76d38eb6e3f90$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $1df76d38eb6e3f90$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $1df76d38eb6e3f90$export$aba22e09a66f6826);
$parcel$export(module.exports, "SELECT_CUSTOM_FIELD_TYPE", () => $1df76d38eb6e3f90$export$826d657005bbe54c);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $1df76d38eb6e3f90$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $1df76d38eb6e3f90$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $1df76d38eb6e3f90$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $1df76d38eb6e3f90$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $1df76d38eb6e3f90$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $1df76d38eb6e3f90$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $1df76d38eb6e3f90$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $1df76d38eb6e3f90$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $1df76d38eb6e3f90$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $1df76d38eb6e3f90$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $1df76d38eb6e3f90$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $1df76d38eb6e3f90$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $1df76d38eb6e3f90$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $1df76d38eb6e3f90$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $1df76d38eb6e3f90$export$902f6c5cc939598a);

var $65mz3 = parcelRequire("65mz3");

var $2vSU6 = parcelRequire("2vSU6");

var $5fc53 = parcelRequire("5fc53");
const $1df76d38eb6e3f90$export$ebb48b08205007c5 = 'issuetype';
const $1df76d38eb6e3f90$export$a464614f8f5fe986 = 'summary';
const $1df76d38eb6e3f90$export$a311a3c9b207604e = 'parent';
const $1df76d38eb6e3f90$export$2a4f270075a033de = 'parent-issue';
const $1df76d38eb6e3f90$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $1df76d38eb6e3f90$export$289917d9a7031e1d = 'watches';
const $1df76d38eb6e3f90$export$81614f6dc3be5b00 = 'votes';
const $1df76d38eb6e3f90$export$72a5630aa398d6b4 = 'security';
const $1df76d38eb6e3f90$export$caf1ff54fbdf44bf = 'issuerestriction';
const $1df76d38eb6e3f90$export$f8f7545d2bb78afb = 'assignee';
const $1df76d38eb6e3f90$export$6d7021166edc895c = 'reporter';
const $1df76d38eb6e3f90$export$cf7e173386d30cdd = 'duedate';
const $1df76d38eb6e3f90$export$bb34f3538ba26c7e = 'priority';
const $1df76d38eb6e3f90$export$79b91d4669dcadcb = 'labels';
const $1df76d38eb6e3f90$export$cbedbfe2cd0caec7 = 'components';
const $1df76d38eb6e3f90$export$950d47e775e208ee = 'devSummary';
const $1df76d38eb6e3f90$export$f91d2bb4cc99fa5e = 'releases';
const $1df76d38eb6e3f90$export$a316570a0dbfd2b0 = 'sprint';
const $1df76d38eb6e3f90$export$405b6d72f2d243a9 = 'storyPointsField';
const $1df76d38eb6e3f90$export$3cb4a99a332e4186 = 'epic';
const $1df76d38eb6e3f90$export$d7e18f5730074533 = 'fixVersions';
const $1df76d38eb6e3f90$export$c435f0000304e508 = 'versions';
const $1df76d38eb6e3f90$export$ee99ef6ee562a446 = 'timetracking';
const $1df76d38eb6e3f90$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $1df76d38eb6e3f90$export$e50006273435e7d4 = 'status';
const $1df76d38eb6e3f90$export$f1a6ce22cbb7eb32 = 'resolution';
const $1df76d38eb6e3f90$export$ff39ebd4bb12b718 = 'created';
const $1df76d38eb6e3f90$export$cd8e68094cb5c3cb = 'updated';
const $1df76d38eb6e3f90$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $1df76d38eb6e3f90$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $1df76d38eb6e3f90$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $1df76d38eb6e3f90$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $1df76d38eb6e3f90$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $1df76d38eb6e3f90$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $1df76d38eb6e3f90$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $1df76d38eb6e3f90$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $1df76d38eb6e3f90$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $1df76d38eb6e3f90$export$913055729e1380b2 = 'summary';
const $1df76d38eb6e3f90$export$d44826c816b5619b = 'description';
const $1df76d38eb6e3f90$export$a29989082612d0d9 = 'comment';
const $1df76d38eb6e3f90$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $1df76d38eb6e3f90$export$3b3d0889022c85b3 = 'children-issues';
const $1df76d38eb6e3f90$export$be46596bc6608f3b = 'environment';
const $1df76d38eb6e3f90$export$f528fadbfdb3c25e = 'subtasks';
const $1df76d38eb6e3f90$export$f10e53e8928b61bd = 'dataclassification';
const $1df76d38eb6e3f90$export$e0dfb65d1047c53c = (0, $5fc53.PARENT_CF_TYPE);
const $1df76d38eb6e3f90$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $1df76d38eb6e3f90$export$826d657005bbe54c = (0, $5fc53.SELECT_CF_TYPE);
const $1df76d38eb6e3f90$export$cdbd1eb3b05729e0 = 'flagActions';
const $1df76d38eb6e3f90$export$c161a774ec2e7e56 = 'cardCoverActions';
const $1df76d38eb6e3f90$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$1df76d38eb6e3f90$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$1df76d38eb6e3f90$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$1df76d38eb6e3f90$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $5fc53.TEAM_CF_TYPE)]: (0, $5fc53.TEAM_CF_TYPE),
        [(0, $5fc53.PARENT_CF_TYPE)]: (0, $5fc53.PARENT_CF_TYPE),
        [(0, $5fc53.BASELINE_START_CF_TYPE)]: (0, $5fc53.BASELINE_START_CF_TYPE),
        [(0, $5fc53.BASELINE_END_CF_TYPE)]: (0, $5fc53.BASELINE_END_CF_TYPE),
        [(0, $5fc53.COLOR_CF_TYPE)]: (0, $5fc53.COLOR_CF_TYPE),
        [(0, $5fc53.EPIC_COLOR_TYPE)]: (0, $5fc53.EPIC_COLOR_TYPE),
        [(0, $5fc53.EPIC_NAME_TYPE)]: (0, $5fc53.EPIC_NAME_TYPE)
    };
    return fields;
};
const $1df76d38eb6e3f90$export$87934b3672715c91 = [
    (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $1df76d38eb6e3f90$var$serviceDeskCustomFields = [
    (0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $5fc53.ORGANIZATIONS_CF_TYPE),
    (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE),
    (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE),
    (0, $5fc53.APPROVALS_CF_TYPE),
    (0, $5fc53.APPROVERS_LIST_CF_TYPE),
    (0, $5fc53.REQUEST_TYPE_CF_TYPE),
    (0, $5fc53.CMDB_OBJECT_CF_TYPE),
    (0, $5fc53.RESPONDERS_CF_TYPE),
    (0, $5fc53.MAJOR_INCIDENT_CF_TYPE),
    (0, $5fc53.ENTITLEMENT_CF_TYPE),
    (0, $5fc53.SENTIMENT_CF_TYPE),
    (0, $5fc53.ORGANIZATION_CF_TYPE)
];
const $1df76d38eb6e3f90$export$efd443bccc4c01ed = ()=>[
        (0, $5fc53.LABELS_CF_TYPE),
        (0, $5fc53.TEXT_CF_TYPE),
        (0, $5fc53.MULTI_USER_CF_TYPE),
        (0, $5fc53.PARTICIPANTS_CF_TYPE),
        (0, $5fc53.URL_CF_TYPE),
        (0, $5fc53.NUMBER_CF_TYPE),
        (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $5fc53.SELECT_CF_TYPE),
        (0, $5fc53.MULTI_SELECT_CF_TYPE),
        (0, $5fc53.VERSION_CF_TYPE),
        (0, $5fc53.TEXT_AREA_CF_TYPE),
        (0, $5fc53.MULTI_VERSION_CF_TYPE),
        (0, $5fc53.DATE_CF_TYPE),
        (0, $5fc53.GROUP_CF_TYPE),
        (0, $5fc53.MULTI_GROUP_CF_TYPE),
        (0, $5fc53.USER_CF_TYPE),
        (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
        (0, $5fc53.RADIO_BUTTONS_CF_TYPE),
        (0, $5fc53.DATETIME_CF_TYPE),
        (0, $5fc53.ASSETS_CF_TYPE),
        (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
        (0, $5fc53.PEOPLE_CF_TYPE),
        (0, $5fc53.CASCADING_SELECT_CF_TYPE),
        (0, $5fc53.PROJECT_PICKER_CF_TYPE),
        (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
        (0, $5fc53.READ_ONLY_CF_TYPE),
        (0, $5fc53.EPIC_STATUS_TYPE),
        (0, $5fc53.MESSAGE_VIEW_CF_TYPE),
        (0, $5fc53.MESSAGE_EDIT_CF_TYPE),
        (0, $5fc53.CATEGORY_TYPE),
        (0, $5fc53.GOALS_CF_TYPE),
        ...$1df76d38eb6e3f90$export$87934b3672715c91,
        ...$1df76d38eb6e3f90$var$serviceDeskCustomFields
    ];
const $1df76d38eb6e3f90$export$a18b3a656ee9c709 = {
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $2vSU6.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $1df76d38eb6e3f90$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $1df76d38eb6e3f90$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $65mz3.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $65mz3.default).SOFTWARE_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $65mz3.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0,
            $1df76d38eb6e3f90$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $65mz3.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $65mz3.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $65mz3.default).MOBILE_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $65mz3.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $65mz3.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (config.isSimplified) return $1df76d38eb6e3f90$export$aebf676dfa727a1c();
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
        case 0, $2vSU6.CORE_PROJECT:
            return $1df76d38eb6e3f90$export$381ce08838c53afa();
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $1df76d38eb6e3f90$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
    }
    return $1df76d38eb6e3f90$export$27e0678365e5dcff();
};

});
parcelRegister("65mz3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7178ba5d31d0f054$export$2e2bcd8739ae039);
const $7178ba5d31d0f054$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $7178ba5d31d0f054$export$2e2bcd8739ae039 = $7178ba5d31d0f054$var$keys;

});

parcelRegister("5fc53", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $81f079589240b9b7$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $81f079589240b9b7$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $81f079589240b9b7$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $81f079589240b9b7$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $81f079589240b9b7$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $81f079589240b9b7$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $81f079589240b9b7$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $81f079589240b9b7$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $81f079589240b9b7$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $81f079589240b9b7$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $81f079589240b9b7$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $81f079589240b9b7$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $81f079589240b9b7$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $81f079589240b9b7$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $81f079589240b9b7$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $81f079589240b9b7$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $81f079589240b9b7$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $81f079589240b9b7$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $81f079589240b9b7$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $81f079589240b9b7$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $81f079589240b9b7$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $81f079589240b9b7$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $81f079589240b9b7$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $81f079589240b9b7$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $81f079589240b9b7$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $81f079589240b9b7$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $81f079589240b9b7$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $81f079589240b9b7$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $81f079589240b9b7$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $81f079589240b9b7$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $81f079589240b9b7$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $81f079589240b9b7$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $81f079589240b9b7$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $81f079589240b9b7$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $81f079589240b9b7$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $81f079589240b9b7$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $81f079589240b9b7$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $81f079589240b9b7$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $81f079589240b9b7$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $81f079589240b9b7$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $81f079589240b9b7$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $81f079589240b9b7$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $81f079589240b9b7$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $81f079589240b9b7$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $81f079589240b9b7$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $81f079589240b9b7$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $81f079589240b9b7$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $81f079589240b9b7$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $81f079589240b9b7$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $81f079589240b9b7$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $81f079589240b9b7$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $81f079589240b9b7$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $81f079589240b9b7$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $81f079589240b9b7$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $81f079589240b9b7$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $81f079589240b9b7$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $81f079589240b9b7$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $81f079589240b9b7$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $81f079589240b9b7$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $81f079589240b9b7$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $81f079589240b9b7$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $81f079589240b9b7$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $81f079589240b9b7$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $81f079589240b9b7$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $81f079589240b9b7$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $81f079589240b9b7$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $81f079589240b9b7$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $81f079589240b9b7$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "JCS_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$7fe9e7bac5a59952);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $81f079589240b9b7$export$798d2f5814884447);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $81f079589240b9b7$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $81f079589240b9b7$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $81f079589240b9b7$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $81f079589240b9b7$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $81f079589240b9b7$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $81f079589240b9b7$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $81f079589240b9b7$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $81f079589240b9b7$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $81f079589240b9b7$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $81f079589240b9b7$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $81f079589240b9b7$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $81f079589240b9b7$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $81f079589240b9b7$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $81f079589240b9b7$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $81f079589240b9b7$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $81f079589240b9b7$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $81f079589240b9b7$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $81f079589240b9b7$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $81f079589240b9b7$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $81f079589240b9b7$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $81f079589240b9b7$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $81f079589240b9b7$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $81f079589240b9b7$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $81f079589240b9b7$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $81f079589240b9b7$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $81f079589240b9b7$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $81f079589240b9b7$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $81f079589240b9b7$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $81f079589240b9b7$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $81f079589240b9b7$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $81f079589240b9b7$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $81f079589240b9b7$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $81f079589240b9b7$export$34317c2d84a93553);
$parcel$export(module.exports, "ORGANIZATION_CF_TYPE", () => $81f079589240b9b7$export$c1e26582406f77ec);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $81f079589240b9b7$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $81f079589240b9b7$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $81f079589240b9b7$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $81f079589240b9b7$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $81f079589240b9b7$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $81f079589240b9b7$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $81f079589240b9b7$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $81f079589240b9b7$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $81f079589240b9b7$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $81f079589240b9b7$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $81f079589240b9b7$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $81f079589240b9b7$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $81f079589240b9b7$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $81f079589240b9b7$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $81f079589240b9b7$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $81f079589240b9b7$export$7b79405842547ccb);
$parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", () => $81f079589240b9b7$export$96201d0ae03ca323);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $81f079589240b9b7$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $81f079589240b9b7$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $81f079589240b9b7$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $81f079589240b9b7$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $81f079589240b9b7$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $81f079589240b9b7$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $81f079589240b9b7$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $81f079589240b9b7$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $81f079589240b9b7$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $81f079589240b9b7$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $81f079589240b9b7$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $81f079589240b9b7$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $81f079589240b9b7$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $81f079589240b9b7$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $81f079589240b9b7$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $81f079589240b9b7$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $81f079589240b9b7$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $81f079589240b9b7$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $81f079589240b9b7$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $81f079589240b9b7$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $81f079589240b9b7$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $81f079589240b9b7$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $81f079589240b9b7$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $81f079589240b9b7$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $81f079589240b9b7$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $81f079589240b9b7$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $81f079589240b9b7$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $81f079589240b9b7$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $81f079589240b9b7$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $81f079589240b9b7$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $81f079589240b9b7$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $81f079589240b9b7$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $81f079589240b9b7$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $81f079589240b9b7$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $81f079589240b9b7$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $81f079589240b9b7$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $81f079589240b9b7$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $81f079589240b9b7$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $81f079589240b9b7$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $81f079589240b9b7$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $81f079589240b9b7$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $81f079589240b9b7$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $81f079589240b9b7$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $81f079589240b9b7$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $81f079589240b9b7$export$b5358afda8ff335e);
$parcel$export(module.exports, "JOURNEY_PANEL_TYPE", () => $81f079589240b9b7$export$d2a475ff30e5bf97);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $81f079589240b9b7$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $81f079589240b9b7$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $81f079589240b9b7$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $81f079589240b9b7$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $81f079589240b9b7$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $81f079589240b9b7$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $81f079589240b9b7$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $81f079589240b9b7$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $81f079589240b9b7$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $81f079589240b9b7$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $81f079589240b9b7$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $81f079589240b9b7$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $81f079589240b9b7$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $81f079589240b9b7$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $81f079589240b9b7$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $81f079589240b9b7$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $81f079589240b9b7$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $81f079589240b9b7$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $81f079589240b9b7$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $81f079589240b9b7$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $81f079589240b9b7$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $81f079589240b9b7$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $81f079589240b9b7$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $81f079589240b9b7$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $81f079589240b9b7$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $81f079589240b9b7$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $81f079589240b9b7$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $81f079589240b9b7$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $81f079589240b9b7$export$3c3e26aadbfa2c32);

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");
const $81f079589240b9b7$export$b144116dae474c88 = 'issue-link-search';
const $81f079589240b9b7$export$bc917bc699b25f75 = 'number';
const $81f079589240b9b7$export$5f26ca419fdffbe7 = 'string';
const $81f079589240b9b7$export$ce9bfd823c7e1a6d = 'datetime';
const $81f079589240b9b7$export$346b72b1f7cd6d5a = 'date';
const $81f079589240b9b7$export$b20fbcacd7942c2a = 'option2';
const $81f079589240b9b7$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $81f079589240b9b7$export$a2e8554bffc61ece = 'any';
const $81f079589240b9b7$export$f25cd4907cbb25b9 = 'array';
const $81f079589240b9b7$export$5600354b43577e17 = 'user';
const $81f079589240b9b7$export$5dbc9917f72d0d2a = 'group';
const $81f079589240b9b7$export$253649f07fb55948 = 'object';
const $81f079589240b9b7$export$eb39592ba5247ee7 = 'group-list';
const $81f079589240b9b7$export$f48a9be226105736 = 'array-string';
const $81f079589240b9b7$export$42e2e93fc721df5d = 'version';
const $81f079589240b9b7$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$7773375e72c953ed = 'approval-panel';
const $81f079589240b9b7$export$80ad0037098f3919 = 'project';
const $81f079589240b9b7$export$82db8a26de491dd2 = 'array';
const $81f079589240b9b7$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $81f079589240b9b7$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $81f079589240b9b7$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $81f079589240b9b7$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $81f079589240b9b7$export$c979d9c548c05133 = 'JiraBooleanField';
const $81f079589240b9b7$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $81f079589240b9b7$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $81f079589240b9b7$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $81f079589240b9b7$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $81f079589240b9b7$export$b0deb225eed90fbd = 'JiraCMDBField';
const $81f079589240b9b7$export$add3775cfea8fde3 = 'JiraColorField';
const $81f079589240b9b7$export$9631d4098abab3eb = 'JiraComponentsField';
const $81f079589240b9b7$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $81f079589240b9b7$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $81f079589240b9b7$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $81f079589240b9b7$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $81f079589240b9b7$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $81f079589240b9b7$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $81f079589240b9b7$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $81f079589240b9b7$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $81f079589240b9b7$export$6d8da4497234455 = 'JiraEpicLinkField';
const $81f079589240b9b7$export$9bcfac568e4fa59c = 'JiraFlagField';
const $81f079589240b9b7$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $81f079589240b9b7$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $81f079589240b9b7$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $81f079589240b9b7$export$810709f0c5c2e9db = 'JiraLabelsField';
const $81f079589240b9b7$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $81f079589240b9b7$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $81f079589240b9b7$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $81f079589240b9b7$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $81f079589240b9b7$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $81f079589240b9b7$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $81f079589240b9b7$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $81f079589240b9b7$export$31aea7548807c6b5 = 'JiraPeopleField';
const $81f079589240b9b7$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $81f079589240b9b7$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $81f079589240b9b7$export$12f54499c6252188 = 'JiraProjectField';
const $81f079589240b9b7$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $81f079589240b9b7$export$c69486dd643dfb69 = 'JiraReporterField';
const $81f079589240b9b7$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $81f079589240b9b7$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $81f079589240b9b7$export$37f4daaa7b409554 = 'JiraRichTextField';
const $81f079589240b9b7$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $81f079589240b9b7$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $81f079589240b9b7$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $81f079589240b9b7$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $81f079589240b9b7$export$e40f819979b3881d = 'JiraStatusField';
const $81f079589240b9b7$export$6c243704a22baffe = 'JiraTeamField';
const $81f079589240b9b7$export$6c32429bac235203 = 'JiraTeamViewField';
const $81f079589240b9b7$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $81f079589240b9b7$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $81f079589240b9b7$export$37ccd11f08a93ccb = 'JiraUrlField';
const $81f079589240b9b7$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $81f079589240b9b7$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $81f079589240b9b7$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $81f079589240b9b7$export$aa815aaa741ae18 = 'JiraWatchesField';
const $81f079589240b9b7$export$e805f89b15d2abf4 = 'JiraAssetField';
const $81f079589240b9b7$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $81f079589240b9b7$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $81f079589240b9b7$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $81f079589240b9b7$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $81f079589240b9b7$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $81f079589240b9b7$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $81f079589240b9b7$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $81f079589240b9b7$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $81f079589240b9b7$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $81f079589240b9b7$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $81f079589240b9b7$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $81f079589240b9b7$export$c48132adab502d6b = 'JiraForgeUsersField';
const $81f079589240b9b7$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $81f079589240b9b7$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $81f079589240b9b7$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $81f079589240b9b7$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $81f079589240b9b7$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $81f079589240b9b7$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $81f079589240b9b7$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $81f079589240b9b7$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $81f079589240b9b7$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $81f079589240b9b7$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $81f079589240b9b7$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $81f079589240b9b7$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $81f079589240b9b7$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $81f079589240b9b7$export$bfcb1a91094f113a = 'JiraGoalsField';
const $81f079589240b9b7$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $81f079589240b9b7$export$7fe9e7bac5a59952 = 'JiraCustomerServiceOrganizationField';
const $81f079589240b9b7$export$798d2f5814884447 = 'forgeCustomField';
const $81f079589240b9b7$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $81f079589240b9b7$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $81f079589240b9b7$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $81f079589240b9b7$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $81f079589240b9b7$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $81f079589240b9b7$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $81f079589240b9b7$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $81f079589240b9b7$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $81f079589240b9b7$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $81f079589240b9b7$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $81f079589240b9b7$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $81f079589240b9b7$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $81f079589240b9b7$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $81f079589240b9b7$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $81f079589240b9b7$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $81f079589240b9b7$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $81f079589240b9b7$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $81f079589240b9b7$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $81f079589240b9b7$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $81f079589240b9b7$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $81f079589240b9b7$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $81f079589240b9b7$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $81f079589240b9b7$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $81f079589240b9b7$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $81f079589240b9b7$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $81f079589240b9b7$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $81f079589240b9b7$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $81f079589240b9b7$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $81f079589240b9b7$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $81f079589240b9b7$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $81f079589240b9b7$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $81f079589240b9b7$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $81f079589240b9b7$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $81f079589240b9b7$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $81f079589240b9b7$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $81f079589240b9b7$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $81f079589240b9b7$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
const $81f079589240b9b7$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $81f079589240b9b7$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $81f079589240b9b7$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $81f079589240b9b7$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $81f079589240b9b7$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $81f079589240b9b7$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $81f079589240b9b7$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $81f079589240b9b7$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $81f079589240b9b7$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $81f079589240b9b7$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $81f079589240b9b7$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $81f079589240b9b7$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $81f079589240b9b7$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $81f079589240b9b7$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $81f079589240b9b7$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $81f079589240b9b7$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $81f079589240b9b7$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $81f079589240b9b7$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $81f079589240b9b7$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $81f079589240b9b7$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $81f079589240b9b7$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $81f079589240b9b7$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $81f079589240b9b7$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $81f079589240b9b7$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $81f079589240b9b7$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $81f079589240b9b7$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $81f079589240b9b7$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $81f079589240b9b7$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $81f079589240b9b7$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $81f079589240b9b7$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $81f079589240b9b7$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $81f079589240b9b7$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $81f079589240b9b7$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $81f079589240b9b7$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $81f079589240b9b7$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $81f079589240b9b7$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $81f079589240b9b7$export$fba8634fd401ba8b = 'assignee';
const $81f079589240b9b7$export$a91aea2438afcce8 = 'reporter';
const $81f079589240b9b7$export$b159f8b8f27aae4c = 'duedate';
const $81f079589240b9b7$export$34740f8d07d23ac0 = 'priority';
const $81f079589240b9b7$export$43b6e33ec70f2272 = 'labels';
const $81f079589240b9b7$export$ff39ebd4bb12b718 = 'created';
const $81f079589240b9b7$export$cd8e68094cb5c3cb = 'updated';
const $81f079589240b9b7$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $81f079589240b9b7$export$37abf56f13f61ec5 = 'components';
const $81f079589240b9b7$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $81f079589240b9b7$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $81f079589240b9b7$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $81f079589240b9b7$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $81f079589240b9b7$export$791007408faf42f4 = 'servicedesk-incident-management';
const $81f079589240b9b7$export$827a1c600bac12a3 = 'devSummary';
const $81f079589240b9b7$export$e9ba671d077969f8 = 'releases';
const $81f079589240b9b7$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $81f079589240b9b7$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $81f079589240b9b7$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $81f079589240b9b7$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $81f079589240b9b7$export$a5c9f63aadcb220 = 'fixVersions';
const $81f079589240b9b7$export$94009605902e4fe5 = 'versions';
const $81f079589240b9b7$export$5e7324042f1d6b31 = 'description';
const $81f079589240b9b7$export$113281d03e6830ef = 'environment';
const $81f079589240b9b7$export$5ff798870a3dffbf = 'watches';
const $81f079589240b9b7$export$907219511d14ba3d = 'summary';
const $81f079589240b9b7$export$d09aa6a4f3538063 = 'proforma-forms';
const $81f079589240b9b7$export$3aca8c91b58a42e2 = 'resolution';
const $81f079589240b9b7$export$ccb5ffefbf8b987c = 'timetracking';
const $81f079589240b9b7$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $81f079589240b9b7$export$358267065be1e = 'status';
const $81f079589240b9b7$export$dcaa788c7ada56de = 'statusCategory';
const $81f079589240b9b7$export$ebb48b08205007c5 = 'issuetype';
const $81f079589240b9b7$export$5e91047fe9955d0e = 'issuekey';
const $81f079589240b9b7$export$3b3d0889022c85b3 = 'children-issues';
const $81f079589240b9b7$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $81f079589240b9b7$export$8fe3d5be8cb17459 = 'epic-issues';
const $81f079589240b9b7$export$335851d83a79891 = 'hierarchy-level-below';
const $81f079589240b9b7$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $81f079589240b9b7$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $81f079589240b9b7$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $81f079589240b9b7$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $81f079589240b9b7$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $81f079589240b9b7$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $81f079589240b9b7$export$7b3d247435a784fa = 'SLA_PANEL';
const $81f079589240b9b7$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $81f079589240b9b7$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $81f079589240b9b7$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $81f079589240b9b7$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $81f079589240b9b7$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $81f079589240b9b7$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $81f079589240b9b7$export$d2a475ff30e5bf97 = 'JOURNEY_PANEL';
const $81f079589240b9b7$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $81f079589240b9b7$export$22f61ccc2730431f = 'similar-issues';
const $81f079589240b9b7$export$8bbb446f57294715 = 'subtasks';
const $81f079589240b9b7$export$34fcd7cb291a1e4d = 'votes';
const $81f079589240b9b7$export$5e93f2a57cc4ca3a = 'parent';
const $81f079589240b9b7$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$91a9dba2d38d9a6f = 'project';
const $81f079589240b9b7$export$df36fc05622c402 = 'worklog';
const $81f079589240b9b7$export$ede0a4c20124ec85 = 'timespent';
const $81f079589240b9b7$export$3eeb79d48fb5f667 = 'dataclassification';
const $81f079589240b9b7$export$45e72c9a63ab61ab = 'SENTIMENT';
const $81f079589240b9b7$export$99ad62164189f781 = 'ecosystemGlance';
const $81f079589240b9b7$export$7719ef6e9283671 = 'forgeGlance';
const $81f079589240b9b7$export$bfebea5ce2e1887a = 'ecosystemContext';
const $81f079589240b9b7$export$be8e68fb1aed253e = 'forgeContext';
const $81f079589240b9b7$export$84e5674890d55030 = 'issuerestriction';
const $81f079589240b9b7$export$326a5522a485e43d = 'security';
const $81f079589240b9b7$export$c9f3f01e2c535302 = 'securitylevel';
const $81f079589240b9b7$export$35e5652f764785bd = 'creator';
const $81f079589240b9b7$export$66519f3bbff1796a = 'team';
const $81f079589240b9b7$export$a4ee0bca77cc8463 = 'estimate';
const $81f079589240b9b7$export$fed53408e89e0497 = 'dueDate';
const $81f079589240b9b7$export$d53c26f9ce31f56b = 'targetStart';
const $81f079589240b9b7$export$48f82d653f85e459 = 'targetEnd';
const $81f079589240b9b7$export$ea5a888f39f722c7 = 'startDate';
const $81f079589240b9b7$export$f245bbec12cc0e40 = 'color';
const $81f079589240b9b7$export$aed630b4b7114a59 = 'attachment';
const $81f079589240b9b7$export$b50c1a8fef07104 = 'issuelinks';
const $81f079589240b9b7$export$ea3d72f4bb7738ba = 'timeestimate';
const $81f079589240b9b7$export$a4cab0124760d860 = 'comment';
const $81f079589240b9b7$export$734929aef118d7e2 = 'worklog';
const $81f079589240b9b7$export$ffbacacb07c1d46d = 'parent';
const $81f079589240b9b7$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $81f079589240b9b7$export$278c072e2f9176ab = 'aggregatetimespent';
const $81f079589240b9b7$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $81f079589240b9b7$export$fbc5ebe2e580bf8b = 'progress';
const $81f079589240b9b7$export$aa3b37e271efd578 = 'aggregateprogress';
const $81f079589240b9b7$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $81f079589240b9b7$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $81f079589240b9b7$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $81f079589240b9b7$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $81f079589240b9b7$export$34740f8d07d23ac0,
        REPORTER_TYPE: $81f079589240b9b7$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $81f079589240b9b7$export$5e7324042f1d6b31,
        LABELS_TYPE: $81f079589240b9b7$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $81f079589240b9b7$export$37abf56f13f61ec5,
        SPRINT_TYPE: $81f079589240b9b7$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $81f079589240b9b7$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $81f079589240b9b7$export$269d70c1b1c9fb80,
        FIX_VERSIONS_TYPE: $81f079589240b9b7$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $81f079589240b9b7$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $81f079589240b9b7$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $81f079589240b9b7$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $81f079589240b9b7$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $81f079589240b9b7$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $81f079589240b9b7$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $81f079589240b9b7$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $81f079589240b9b7$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $81f079589240b9b7$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $81f079589240b9b7$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $81f079589240b9b7$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $81f079589240b9b7$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $81f079589240b9b7$export$c7ae0622b0bd5d56,
        ASSETS_CF_TYPE: $81f079589240b9b7$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $81f079589240b9b7$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $81f079589240b9b7$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $81f079589240b9b7$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $81f079589240b9b7$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $81f079589240b9b7$export$e9ba671d077969f8,
        BASELINE_START_CF_TYPE: $81f079589240b9b7$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $81f079589240b9b7$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $81f079589240b9b7$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $81f079589240b9b7$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $81f079589240b9b7$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $81f079589240b9b7$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $81f079589240b9b7$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $81f079589240b9b7$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $81f079589240b9b7$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $81f079589240b9b7$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $81f079589240b9b7$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $81f079589240b9b7$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $81f079589240b9b7$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $81f079589240b9b7$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $81f079589240b9b7$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $81f079589240b9b7$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $81f079589240b9b7$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $81f079589240b9b7$export$39866626496bbfc8,
        VERSION_CF_TYPE: $81f079589240b9b7$export$24382b4e8c58336b,
        DATE_CF_TYPE: $81f079589240b9b7$export$ff745f432984005d,
        GROUP_CF_TYPE: $81f079589240b9b7$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $81f079589240b9b7$export$b600addfa3355c57,
        USER_CF_TYPE: $81f079589240b9b7$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $81f079589240b9b7$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $81f079589240b9b7$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $81f079589240b9b7$export$65524be5675e57e6,
        TEAM_CF_TYPE: $81f079589240b9b7$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $81f079589240b9b7$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $81f079589240b9b7$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $81f079589240b9b7$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $81f079589240b9b7$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $81f079589240b9b7$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $81f079589240b9b7$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $81f079589240b9b7$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $81f079589240b9b7$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $81f079589240b9b7$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $81f079589240b9b7$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $81f079589240b9b7$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $81f079589240b9b7$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $81f079589240b9b7$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $81f079589240b9b7$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $81f079589240b9b7$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $81f079589240b9b7$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $81f079589240b9b7$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $81f079589240b9b7$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $81f079589240b9b7$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $81f079589240b9b7$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $81f079589240b9b7$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $81f079589240b9b7$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $81f079589240b9b7$export$2bbb7f69c97ea279,
        PARENT_TYPE: $81f079589240b9b7$export$5e93f2a57cc4ca3a,
        FORGE_CONTEXT_TYPE: $81f079589240b9b7$export$be8e68fb1aed253e,
        SENTIMENT_CF_TYPE: $81f079589240b9b7$export$c23cfbdf83daa90d
    };
    if ((0, $4R6GH.fg)('jsm-sentiment-analysis')) Object.assign(types, {
        SENTIMENT_TYPE: $81f079589240b9b7$export$45e72c9a63ab61ab
    });
    if ((0, $4R6GH.fg)('jsm-journey-builder-in-issue-view')) Object.assign(types, {
        JOURNEY_PANEL_TYPE: $81f079589240b9b7$export$d2a475ff30e5bf97
    });
    return types;
};
const $81f079589240b9b7$export$3c3e26aadbfa2c32 = (0, $8QpSo.default)($81f079589240b9b7$var$getLayoutFieldTypesNonMemoized);

});


parcelRegister("a1ky2", function(module, exports) {

$parcel$export(module.exports, "contextSelector", () => $df15ab6efcbffe76$export$c420c9f40402ab6d);
$parcel$export(module.exports, "accountIdloggedInUserSelector", () => $df15ab6efcbffe76$export$cb29341089829e17);
$parcel$export(module.exports, "orgIdSelector", () => $df15ab6efcbffe76$export$24984a39db14d8);
$parcel$export(module.exports, "baseUrlSelector", () => $df15ab6efcbffe76$export$1ca9a92a5f28e233);
$parcel$export(module.exports, "loginRedirectUrlSelector", () => $df15ab6efcbffe76$export$767583fcce1653ec);
$parcel$export(module.exports, "issueKeySelector", () => $df15ab6efcbffe76$export$d22bc6271070f453);
$parcel$export(module.exports, "issueIdSelector", () => $df15ab6efcbffe76$export$31efbca30077ec1e);
$parcel$export(module.exports, "projectKeySelector", () => $df15ab6efcbffe76$export$404de5ac601b84bc);
$parcel$export(module.exports, "analyticsSourceSelector", () => $df15ab6efcbffe76$export$85a9d212d56669b4);
$parcel$export(module.exports, "cloudIdSelector", () => $df15ab6efcbffe76$export$b5a643cfff945455);
$parcel$export(module.exports, "issueAriSelector", () => $df15ab6efcbffe76$export$a2cdbba2136e72d3);
$parcel$export(module.exports, "commentAriSelector", () => $df15ab6efcbffe76$export$b600fd41c88f35c8);
$parcel$export(module.exports, "isAnonymousSelector", () => $df15ab6efcbffe76$export$a165ec261432d0b8);
$parcel$export(module.exports, "localeSelector", () => $df15ab6efcbffe76$export$f7b7935883444b11);
$parcel$export(module.exports, "issueActionsSelector", () => $df15ab6efcbffe76$export$b62cb5286b153905);
$parcel$export(module.exports, "applicationKeySelector", () => $df15ab6efcbffe76$export$6c7d07328f197de7);
$parcel$export(module.exports, "isMobileSelector", () => $df15ab6efcbffe76$export$4cbb8c74e98876a5);
$parcel$export(module.exports, "isBitbucketSelector", () => $df15ab6efcbffe76$export$245e5ba54167b84a);
$parcel$export(module.exports, "isServiceDeskSelector", () => $df15ab6efcbffe76$export$43d733e4b7e8c7d0);
$parcel$export(module.exports, "isEcosystemEnabledSelector", () => $df15ab6efcbffe76$export$9bffc1987c753bd9);
$parcel$export(module.exports, "rapidViewIdSelector", () => $df15ab6efcbffe76$export$718e830000b27a0e);
$parcel$export(module.exports, "boardTypeSelector", () => $df15ab6efcbffe76$export$5af08fd769c0f0);
$parcel$export(module.exports, "boardIdSelector", () => $df15ab6efcbffe76$export$955e7dbf76b61f80);
$parcel$export(module.exports, "siteAdminStatusSelector", () => $df15ab6efcbffe76$export$93badd2a066af8bd);
$parcel$export(module.exports, "appPermissionsSelector", () => $df15ab6efcbffe76$export$5b71e1eb43056b6c);
$parcel$export(module.exports, "isModalSelector", () => $df15ab6efcbffe76$export$5fa593caa6a15917);
$parcel$export(module.exports, "shouldRenderHeaderSelector", () => $df15ab6efcbffe76$export$631793d49dec78de);
$parcel$export(module.exports, "viewModeSelector", () => $df15ab6efcbffe76$export$1f11fe78e4f22d45);
$parcel$export(module.exports, "appEditionsSelector", () => $df15ab6efcbffe76$export$28ca74e18c8f4529);
$parcel$export(module.exports, "tenantHasActiveServiceDeskLicenseSelector", () => $df15ab6efcbffe76$export$96c87532aec3474a);
$parcel$export(module.exports, "tenantHasActiveProductDiscoveryLicenseSelector", () => $df15ab6efcbffe76$export$f049ad7141428191);
$parcel$export(module.exports, "hasActivatedConfluenceWithinFourteenDaysSelector", () => $df15ab6efcbffe76$export$2b8e6729c89e24f5);
$parcel$export(module.exports, "hasActivatedConfluenceWithinSixtythreeDaysSelector", () => $df15ab6efcbffe76$export$a7671b4425572dc1);
$parcel$export(module.exports, "hasActivatedConfluenceWithinThirtyDaysSelector", () => $df15ab6efcbffe76$export$2321d15582b8ce8a);

var $dGvGJ = parcelRequire("dGvGJ");

var $70Rr2 = parcelRequire("70Rr2");
var $lb7qa = parcelRequire("lb7qa");
var $eZDAP = parcelRequire("eZDAP");
var $it1wb = parcelRequire("it1wb");
var $pyK8a = parcelRequire("pyK8a");


var $4Pf62 = parcelRequire("4Pf62");

var $k3PbQ = parcelRequire("k3PbQ");

var $fOGZN = parcelRequire("fOGZN");

var $g5X3G = parcelRequire("g5X3G");

var $ef5Xn = parcelRequire("ef5Xn");

var $dXq4S = parcelRequire("dXq4S");
const $df15ab6efcbffe76$export$c420c9f40402ab6d = (state)=>state.context;
const $df15ab6efcbffe76$export$cb29341089829e17 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.atlassianAccountId);
const $df15ab6efcbffe76$export$24984a39db14d8 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context?.orgId || null);
const $df15ab6efcbffe76$export$1ca9a92a5f28e233 = (_)=>'';
const $df15ab6efcbffe76$export$767583fcce1653ec = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.loginRedirectUrl);
const $df15ab6efcbffe76$export$d22bc6271070f453 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>(0, $g5X3G.toIssueKey)(context.issueKey));
const $df15ab6efcbffe76$export$31efbca30077ec1e = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.issueId);
const $df15ab6efcbffe76$export$404de5ac601b84bc = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$d22bc6271070f453, (issueKey)=>(0, $k3PbQ.extractProjectKey)(issueKey));
const $df15ab6efcbffe76$export$85a9d212d56669b4 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.analyticsSource !== undefined ? context.analyticsSource : undefined);
const $df15ab6efcbffe76$export$b5a643cfff945455 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.cloudId || (0, $g5X3G.toCloudId)(''));
const $df15ab6efcbffe76$export$a2cdbba2136e72d3 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$b5a643cfff945455, $df15ab6efcbffe76$export$31efbca30077ec1e, (cloudId, issueId)=>(0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ?? ''
    }));
const $df15ab6efcbffe76$export$b600fd41c88f35c8 = (commentId)=>(0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$b5a643cfff945455, $df15ab6efcbffe76$export$31efbca30077ec1e, (cloudId, issueId)=>`ari:cloud:jira:${cloudId}:issue-comment/${issueId ?? ''}/${commentId}`);
const $df15ab6efcbffe76$export$2335b963a9875096 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.activationId || (0, $g5X3G.toActivationId)(''));
const $df15ab6efcbffe76$export$a165ec261432d0b8 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.isAnonymous);
const $df15ab6efcbffe76$export$f7b7935883444b11 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.locale);
const $df15ab6efcbffe76$export$b62cb5286b153905 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.issueActions || []);
const $df15ab6efcbffe76$export$6c7d07328f197de7 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.applicationKey);
const $df15ab6efcbffe76$export$4cbb8c74e98876a5 = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$df15ab6efcbffe76$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $fcf97b7a09088940$export$ce88447986394f2d));
const $df15ab6efcbffe76$export$6fbe1dbaf5b67cc5 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $fOGZN.simpleSoftwareBoardConfiguration)().applicationKey || applicationKey === (0, $fOGZN.standardRoadmapConfiguration)().applicationKey);
const $df15ab6efcbffe76$export$7479ef2453efd3b4 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $fOGZN.softwareConfiguration)().applicationKey);
const $df15ab6efcbffe76$export$245e5ba54167b84a = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$df15ab6efcbffe76$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $fcf97b7a09088940$export$7552fe2669628499));
const $df15ab6efcbffe76$export$43d733e4b7e8c7d0 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $fOGZN.serviceDeskConfiguration)().applicationKey);
const $df15ab6efcbffe76$export$9bffc1987c753bd9 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>!!context.ecosystemEnabled);
const $df15ab6efcbffe76$export$718e830000b27a0e = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.rapidViewId);
const $df15ab6efcbffe76$export$8065de5fbcf23af5 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.estimationStatistic || null);
const $df15ab6efcbffe76$export$5af08fd769c0f0 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.boardType);
const $df15ab6efcbffe76$export$955e7dbf76b61f80 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.boardId);
const $df15ab6efcbffe76$export$93badd2a066af8bd = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.siteAdminStatus);
const $df15ab6efcbffe76$export$b468116a08f9183e = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.productCrossSellConfig);
const $df15ab6efcbffe76$export$f29192b357e6beca = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.licensedProducts);
const $df15ab6efcbffe76$export$5b71e1eb43056b6c = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.appPermissions);
const $df15ab6efcbffe76$export$5fa593caa6a15917 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.isModal);
const $df15ab6efcbffe76$export$631793d49dec78de = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$5fa593caa6a15917, $df15ab6efcbffe76$export$4cbb8c74e98876a5, (isModal, isMobile)=>!isModal && !isMobile);
const $df15ab6efcbffe76$export$1f11fe78e4f22d45 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.viewMode);
const $df15ab6efcbffe76$export$28ca74e18c8f4529 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.appEditions);
const $df15ab6efcbffe76$export$beea798086c18f0a = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.licenseStates);
const $df15ab6efcbffe76$export$40487a15195e570e = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.serviceDesk === (0, $ef5Xn.LICENSE_STATE_ACTIVE));
const $df15ab6efcbffe76$export$96c87532aec3474a = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$f29192b357e6beca, $df15ab6efcbffe76$export$40487a15195e570e, (licensedProducts, isServiceDeskLicenseActive)=>licensedProducts && licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SERVICEDESK] && isServiceDeskLicenseActive);
const $df15ab6efcbffe76$export$2fa17c0746682b0b = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.productDiscovery === (0, $ef5Xn.LICENSE_STATE_ACTIVE));
const $df15ab6efcbffe76$export$f049ad7141428191 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$f29192b357e6beca, $df15ab6efcbffe76$export$2fa17c0746682b0b, (licensedProducts, isProductDiscoveryLicenseActive)=>Boolean(licensedProducts && licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_PRODUCT_DISCOVERY] && isProductDiscoveryLicenseActive));
const $df15ab6efcbffe76$export$747a61878b414bda = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.confluenceActivationDate);
const $df15ab6efcbffe76$export$2b8e6729c89e24f5 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$747a61878b414bda, (confluenceActivationDate)=>{
    try {
        if (!confluenceActivationDate) return false;
        const today = (0, $70Rr2.default)(new Date());
        const fourteenDaysAgo = (0, $it1wb.default)((0, $pyK8a.default)(today, 14));
        const dateToCheck = (0, $eZDAP.default)(confluenceActivationDate);
        return (0, $lb7qa.default)(dateToCheck, {
            start: fourteenDaysAgo,
            end: today
        });
    } catch (error) {
        return false;
    }
});
const $df15ab6efcbffe76$export$a7671b4425572dc1 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$747a61878b414bda, (confluenceActivationDate)=>{
    if (!confluenceActivationDate) return false;
    const today = (0, $70Rr2.default)(new Date());
    const sixtythreeDaysAgo = (0, $it1wb.default)((0, $pyK8a.default)(today, 63));
    const dateToCheck = (0, $eZDAP.default)(confluenceActivationDate);
    return (0, $lb7qa.default)(dateToCheck, {
        start: sixtythreeDaysAgo,
        end: today
    });
});
const $df15ab6efcbffe76$export$2321d15582b8ce8a = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$747a61878b414bda, (confluenceActivationDate)=>{
    try {
        if (!confluenceActivationDate) return false;
        const today = (0, $70Rr2.default)(new Date());
        const thirtyDaysAgo = (0, $it1wb.default)((0, $pyK8a.default)(today, 31)); // 31 days to account for the 30 day trial
        const dateToCheck = (0, $eZDAP.default)(confluenceActivationDate);
        return (0, $lb7qa.default)(dateToCheck, {
            start: thirtyDaysAgo,
            end: today
        });
    } catch (error) {
        return false;
    }
}); // GALILEO-404 END

});
parcelRegister("dXq4S", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $5c4418bd595ae8cf$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $5c4418bd595ae8cf$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $5c4418bd595ae8cf$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $5c4418bd595ae8cf$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $5c4418bd595ae8cf$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
        const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
    const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});


parcelRegister("7Ow8a", function(module, exports) {

$parcel$export(module.exports, "fieldsSelector", () => $04968168b83fddb5$export$e1512647ca813bfa);
$parcel$export(module.exports, "fieldByCustomTypeSelector", () => $04968168b83fddb5$export$72dfc619a02c972c);
$parcel$export(module.exports, "customFieldIdSelector", () => $04968168b83fddb5$export$8ad8506b941e30dc);
$parcel$export(module.exports, "fieldSelector", () => $04968168b83fddb5$export$4ee5e7baedf94214);
$parcel$export(module.exports, "issueTypeIdSelector", () => $04968168b83fddb5$export$22410768c09b3a82);
$parcel$export(module.exports, "hasSubtasksSelector", () => $04968168b83fddb5$export$f363078714850fd9);
$parcel$export(module.exports, "hasSubtasksValuesSelector", () => $04968168b83fddb5$export$689f8f96c9d81e1b);
$parcel$export(module.exports, "hasPortfolioChildIssuesSelector", () => $04968168b83fddb5$export$724b8972771ff092);
$parcel$export(module.exports, "hasPortfolioChildIssueValuesSelector", () => $04968168b83fddb5$export$c6d2d4f8e243ac37);
$parcel$export(module.exports, "hasChildrenIssuesSelector", () => $04968168b83fddb5$export$29f34d4d7c528e9c);
$parcel$export(module.exports, "hasChildrenIssueValuesSelector", () => $04968168b83fddb5$export$9034aaa32d45814b);
$parcel$export(module.exports, "childIssuesLimitUrlSelector", () => $04968168b83fddb5$export$762e13908aaafb2d);
$parcel$export(module.exports, "availableFieldIdsSelector", () => $04968168b83fddb5$export$641248fa887fb9ea);
$parcel$export(module.exports, "fieldSchemaConfigurationSelector", () => $04968168b83fddb5$export$3c65874760e68948);
$parcel$export(module.exports, "isFieldEditableSelector", () => $04968168b83fddb5$export$76ece3d8c4244af2);
$parcel$export(module.exports, "fieldNameSelector", () => $04968168b83fddb5$export$2d1abc174b8a710e);
$parcel$export(module.exports, "fieldMetaKeySelector", () => $04968168b83fddb5$export$351970d5fcbd0b29);
$parcel$export(module.exports, "fieldARISelector", () => $04968168b83fddb5$export$f6363cecfaa3a9b0);
$parcel$export(module.exports, "fieldAutoCompleteUrlSelector", () => $04968168b83fddb5$export$d27105f13ab27906);
$parcel$export(module.exports, "fieldAllowedValuesSelector", () => $04968168b83fddb5$export$351dc1c32c2771ea);
$parcel$export(module.exports, "isFieldRequiredSelector", () => $04968168b83fddb5$export$4c5f76e28914074);
$parcel$export(module.exports, "fieldTypeSelector", () => $04968168b83fddb5$export$9e2f15437ff59992);
$parcel$export(module.exports, "fieldPersistedValueSelector", () => $04968168b83fddb5$export$ae4660b0b7ebeee9);
$parcel$export(module.exports, "fieldPendingValueSelector", () => $04968168b83fddb5$export$2ae929653dce6648);
$parcel$export(module.exports, "fieldEditingValueSelector", () => $04968168b83fddb5$export$487becf51bedcd03);
$parcel$export(module.exports, "fieldEditingAdfValueSelector", () => $04968168b83fddb5$export$31406f841bca5b75);
$parcel$export(module.exports, "fieldHtmlValueSelector", () => $04968168b83fddb5$export$e69c8171ecd8fde2);
$parcel$export(module.exports, "isFieldEditingSelector", () => $04968168b83fddb5$export$29e6b1cade110749);
$parcel$export(module.exports, "fieldEditSessionIdSelector", () => $04968168b83fddb5$export$c53ab145ef243c95);
$parcel$export(module.exports, "isFieldWaitingSelector", () => $04968168b83fddb5$export$30e972ebce44d9b8);
$parcel$export(module.exports, "fieldInvalidMessageSelector", () => $04968168b83fddb5$export$d323462f155519c3);
$parcel$export(module.exports, "fieldInvalidSelector", () => $04968168b83fddb5$export$e35f4d21d9739426);
$parcel$export(module.exports, "isRichTextFieldSelector", () => $04968168b83fddb5$export$120a4249e9b3c231);
$parcel$export(module.exports, "richTextFieldIdsSelector", () => $04968168b83fddb5$export$862745d3ab4003e5);
$parcel$export(module.exports, "isRichTextFieldEditingSelector", () => $04968168b83fddb5$export$df9b7004d8b93e46);
$parcel$export(module.exports, "isMultilineFieldSelector", () => $04968168b83fddb5$export$4d0b1fe809ae5e75);
$parcel$export(module.exports, "getEditingMultilineFieldIdsSelector", () => $04968168b83fddb5$export$2469330614f0dba9);

var $dGvGJ = parcelRequire("dGvGJ");

var $1sWm7 = parcelRequire("1sWm7");

var $dJl1T = parcelRequire("dJl1T");


var $69oHP = parcelRequire("69oHP");

var $fOGZN = parcelRequire("fOGZN");

var $5fc53 = parcelRequire("5fc53");


var $a1ky2 = parcelRequire("a1ky2");

var $aOGHX = parcelRequire("aOGHX");

var $3Uijm = parcelRequire("3Uijm");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $04968168b83fddb5$var$STABLE_EMPTY_ARRAY = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $04968168b83fddb5$var$STABLE_EMPTY_OBJECT = {};
const $04968168b83fddb5$export$e1512647ca813bfa = (state)=>state.fields || $04968168b83fddb5$var$STABLE_EMPTY_OBJECT;
const $04968168b83fddb5$var$getFieldByCustomType = (customType, fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(fields, (field)=>(field.schema && field.schema.custom) === customType);
const $04968168b83fddb5$export$46dde968006cd8d4 = (fieldId, fields)=>{
    let field = fields[fieldId];
    const customSystemFields = (0, $fOGZN.specialFields)();
    if (!field && Object.keys(customSystemFields).includes(fieldId)) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        const customType = customSystemFields[fieldId];
        // @ts-expect-error - TS2322 - Type 'Field | undefined' is not assignable to type 'Field'.
        field = $04968168b83fddb5$var$getFieldByCustomType(customType, fields);
    }
    return field;
};
const $04968168b83fddb5$export$cb67eba45dd11f50 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>!!fields[fieldId]);
const $04968168b83fddb5$export$309344981947f228 = (fieldsState, fieldName)=>Array.isArray(fieldsState[fieldName]?.value) ? fieldsState[fieldName].value.length > 0 : fieldsState[fieldName]?.value != null;
const $04968168b83fddb5$export$72dfc619a02c972c = (customType)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>$04968168b83fddb5$var$getFieldByCustomType(customType, fields));
const $04968168b83fddb5$export$8ad8506b941e30dc = (customFieldType)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$72dfc619a02c972c(customFieldType), (customField)=>{
        const idCandidates = customField ? customField.key.match(/customfield_(\d+)$/i) : null;
        return idCandidates ? +idCandidates[1] : null;
    });
const $04968168b83fddb5$export$4ee5e7baedf94214 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>$04968168b83fddb5$export$46dde968006cd8d4(fieldId, fields));
const $04968168b83fddb5$var$issueTypeFieldSelector = $04968168b83fddb5$export$4ee5e7baedf94214((0, $fOGZN.ISSUE_TYPE));
const $04968168b83fddb5$export$22410768c09b3a82 = (0, $dGvGJ.createSelector)($04968168b83fddb5$var$issueTypeFieldSelector, (issueType)=>(issueType && issueType.value && issueType.value.id) ?? null);
const $04968168b83fddb5$export$b8de62018cc85a18 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>$04968168b83fddb5$export$46dde968006cd8d4(fieldId, fields));
const $04968168b83fddb5$export$3c65f67962ca81cc = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $e9be48d6d2c01760$export$a5fc282ab2bf9b89)));
const $04968168b83fddb5$export$f363078714850fd9 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes('subtasks'));
const $04968168b83fddb5$export$689f8f96c9d81e1b = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>$04968168b83fddb5$export$309344981947f228(fields, 'subtasks'));
const $04968168b83fddb5$export$724b8972771ff092 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $fOGZN.PORTFOLIO_CHILD_ISSUES)));
const $04968168b83fddb5$export$c6d2d4f8e243ac37 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>$04968168b83fddb5$export$309344981947f228(fields, (0, $fOGZN.PORTFOLIO_CHILD_ISSUES)));
const $04968168b83fddb5$export$29f34d4d7c528e9c = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $fOGZN.CHILDREN_ISSUES)));
const $04968168b83fddb5$export$9034aaa32d45814b = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>$04968168b83fddb5$export$309344981947f228(fields, (0, $fOGZN.CHILDREN_ISSUES)));
const $04968168b83fddb5$export$762e13908aaafb2d = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>{
    const getChildIssueUrlSelector = (fieldId)=>fields?.[fieldId]?.issueLimitUrl || '';
    return getChildIssueUrlSelector;
});
const $04968168b83fddb5$export$9ee3b3f5d4ad4423 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>Object.keys(fields).map((fieldKey)=>$04968168b83fddb5$export$46dde968006cd8d4(fieldKey, fields)).filter(Boolean));
const $04968168b83fddb5$export$641248fa887fb9ea = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>Object.keys(fields));
const $04968168b83fddb5$export$e50b5889a6b86caf = (field)=>field ? field.editable : false;
const $04968168b83fddb5$export$3c65874760e68948 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.schema && field.schema.configuration && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        field.schema.configuration.reduce((config, { key: key, value: value })=>({
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...config,
                [key]: value
            }), {}));
const $04968168b83fddb5$export$76ece3d8c4244af2 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>$04968168b83fddb5$export$e50b5889a6b86caf(field));
const $04968168b83fddb5$export$2d1abc174b8a710e = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>{
        if (field && field.title) return field.title;
        (0, $dJl1T.default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
        return '';
    });
const $04968168b83fddb5$export$d20285fb6e3fb007 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$b8de62018cc85a18, (state, { fieldId: fieldId })=>fieldId, (field, fieldId)=>{
    if (field?.title) return field.title;
    (0, $dJl1T.default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
    return '';
});
const $04968168b83fddb5$export$351970d5fcbd0b29 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.key);
const $04968168b83fddb5$export$f6363cecfaa3a9b0 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.ari : undefined);
const $04968168b83fddb5$export$d27105f13ab27906 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.autoCompleteUrl);
const $04968168b83fddb5$export$351dc1c32c2771ea = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.allowedValues : $04968168b83fddb5$var$STABLE_EMPTY_ARRAY);
const $04968168b83fddb5$export$4c5f76e28914074 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.required : false);
const $04968168b83fddb5$export$9e2f15437ff59992 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $69oHP.getFieldType)(field));
const $04968168b83fddb5$export$ae4660b0b7ebeee9 = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.value);
const $04968168b83fddb5$export$bf3f8fd2c145740 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$b8de62018cc85a18, (field)=>field?.value);
const $04968168b83fddb5$export$2ae929653dce6648 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $3Uijm.default)(field));
const $04968168b83fddb5$export$487becf51bedcd03 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $aOGHX.default)(field));
const $04968168b83fddb5$export$31406f841bca5b75 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (field)=>field && (0, $aOGHX.getEditingAdfValue)(field));
const $04968168b83fddb5$export$e69c8171ecd8fde2 = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.renderedValue);
const $04968168b83fddb5$export$4e96991314eba25 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$b8de62018cc85a18, (field)=>field?.renderedValue);
const $04968168b83fddb5$export$18ec1d851ee244b3 = (field)=>field ? field.editingValue !== undefined : false;
const $04968168b83fddb5$export$29e6b1cade110749 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>$04968168b83fddb5$export$18ec1d851ee244b3(field));
const $04968168b83fddb5$export$c53ab145ef243c95 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>(field ? field.fieldEditSessionId : null) || '');
const $04968168b83fddb5$export$30e972ebce44d9b8 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.pendingValue !== undefined : false);
const $04968168b83fddb5$export$d323462f155519c3 = (fieldId, fallbackInvalidMessage)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && (field.isInvalid ? field.invalidMessage || fallbackInvalidMessage : null));
const $04968168b83fddb5$export$e35f4d21d9739426 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>Boolean(field && field.isInvalid));
const $04968168b83fddb5$export$448aaad27e620666 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.schema && field.schema.renderer);
const $04968168b83fddb5$export$94cc87cea4e06b09 = (fieldType)=>fieldType === (0, $5fc53.TEXT_AREA_CF_TYPE) || fieldType === (0, $fOGZN.ENVIRONMENT) || fieldType === (0, $fOGZN.DESCRIPTION);
const $04968168b83fddb5$export$120a4249e9b3c231 = (fieldId)=>(0, $dGvGJ.createSelector)((0, $a1ky2.isServiceDeskSelector), $04968168b83fddb5$export$9e2f15437ff59992(fieldId), $04968168b83fddb5$export$448aaad27e620666(fieldId), (isServiceDesk, fieldType, fieldRenderer)=>{
        const isDescription = fieldId === (0, $fOGZN.DESCRIPTION);
        const isMultilineRichTextField = $04968168b83fddb5$export$94cc87cea4e06b09(fieldType) && fieldRenderer === (0, $650578330a102f55$export$89b8c5d86c10a68c);
        return isDescription || isMultilineRichTextField;
    });
const $04968168b83fddb5$export$862745d3ab4003e5 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (state)=>state, (fields, state)=>Object.keys(fields).filter((fieldId)=>$04968168b83fddb5$export$120a4249e9b3c231(fieldId)(state)));
const $04968168b83fddb5$export$df9b7004d8b93e46 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$862745d3ab4003e5, (state)=>state, (richTextFieldIds, state)=>richTextFieldIds.some((fieldId)=>$04968168b83fddb5$export$29e6b1cade110749(fieldId)(state)));
const $04968168b83fddb5$export$4d0b1fe809ae5e75 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$9e2f15437ff59992(fieldId), (fieldType)=>$04968168b83fddb5$export$94cc87cea4e06b09(fieldType));
const $04968168b83fddb5$export$3263c202444b0e0 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (state)=>state, (fields, state)=>Object.keys(fields).filter((fieldId)=>$04968168b83fddb5$export$4d0b1fe809ae5e75(fieldId)(state)));
const $04968168b83fddb5$export$2469330614f0dba9 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$3263c202444b0e0, (state)=>state, (multilineFieldsIds, state)=>multilineFieldsIds.filter((fieldId)=>$04968168b83fddb5$export$29e6b1cade110749(fieldId)(state)));
const $04968168b83fddb5$export$a2fc0905011957cb = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214((0, $fOGZN.FIX_VERSIONS)), $04968168b83fddb5$export$4ee5e7baedf94214((0, $fOGZN.AFFECTS_VERSIONS)), (fixVersions, affectsVersions)=>{
    const ids = [];
    if (fixVersions) ids.push(fixVersions.key);
    if (affectsVersions) ids.push(affectsVersions.key);
    return ids;
});

});
const $650578330a102f55$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $650578330a102f55$export$a4a240cb4053b29f = 'jira-text-renderer';
const $650578330a102f55$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("69oHP", function(module, exports) {

$parcel$export(module.exports, "getFieldType", () => $53d3f894a8bd7ffe$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isRichTextSupported", () => $53d3f894a8bd7ffe$export$24d1b07fa0e9f9f1);


var $fOGZN = parcelRequire("fOGZN");

var $5fc53 = parcelRequire("5fc53");
const $53d3f894a8bd7ffe$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $fOGZN.specialFields)();
    return [
        ...(0, $fOGZN.customFieldsToDisplay)().filter((cf)=>!(0, $fOGZN.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $5fc53.FLAGGED_CF_TYPE)
    ];
};
const $53d3f894a8bd7ffe$export$f521834fc2bfcd81 = (custom)=>$53d3f894a8bd7ffe$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $53d3f894a8bd7ffe$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $53d3f894a8bd7ffe$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
const $53d3f894a8bd7ffe$export$24d1b07fa0e9f9f1 = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? fieldSchema.type === (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE) && fieldSchema.renderer === (0, $650578330a102f55$export$89b8c5d86c10a68c) || $53d3f894a8bd7ffe$export$b9089a6e41ed43aa(field) === (0, $5fc53.DESCRIPTION_TYPE) : false;
};

});

const $e9be48d6d2c01760$export$e18419056f3d184a = 'assignee';
const $e9be48d6d2c01760$export$45cafdfd629c3ca1 = 'reporter';
const $e9be48d6d2c01760$export$d5bc879e3b748593 = 'description';
const $e9be48d6d2c01760$export$a68dbc90211df1a8 = 'fixVersions';
const $e9be48d6d2c01760$export$93605f2a09aa8d26 = 'labels';
const $e9be48d6d2c01760$export$4420b7468f889692 = 'status';
const $e9be48d6d2c01760$export$e7cf1830fe735d1f = 'summary';
const $e9be48d6d2c01760$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $e9be48d6d2c01760$export$a5fc282ab2bf9b89 = 'issuelinks';
const $e9be48d6d2c01760$export$b52547457d714bc0 = 'epic-issues';
const $e9be48d6d2c01760$export$3cca6e37a5823d5a = 'children-issues';
const $e9be48d6d2c01760$export$98a935eb30de54ab = 'components';
const $e9be48d6d2c01760$export$f7a17147527dd688 = 'flag';

parcelRegister("aOGHX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf727673620c8917$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getEditingAdfValue", () => $bf727673620c8917$export$a799cf637c5b7727);

var $3Uijm = parcelRequire("3Uijm");
var /**
 * Returns the first available value for a given field.
 * editingValue => pendingValue => value
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$bf727673620c8917$export$2e2bcd8739ae039 = (field)=>typeof field.editingValue !== 'undefined' ? field.editingValue : (0, $3Uijm.default)(field);
const $bf727673620c8917$export$a799cf637c5b7727 = (field)=>field.editingValue || (0, $3Uijm.getPendingAdfValue)(field);

});
parcelRegister("3Uijm", function(module, exports) {

$parcel$export(module.exports, "default", () => $de9626bc322e3072$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getPendingAdfValue", () => $de9626bc322e3072$export$5012210a9f91b010);
var /**
 * Returns the first available value for a given field, excluding editingValue
 * pendingValue => value
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$de9626bc322e3072$export$2e2bcd8739ae039 = (field)=>typeof field.pendingValue !== 'undefined' ? field.pendingValue : field.value;
const $de9626bc322e3072$export$5012210a9f91b010 = (field)=>field.pendingValue || field.adfValue || field.value;

});





parcelRegister("iAWa3", function(module, exports) {

$parcel$export(module.exports, "afterPaintEmit", () => $8ad29d98765af503$export$dc4c3408669b8f4e);

var $x9xyg = parcelRequire("x9xyg");

const $8ad29d98765af503$export$dc4c3408669b8f4e = (emitMetrics, metric)=>{
    const stopTime = performance.now();
    setTimeout(()=>{
        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
        (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
        setTimeout(()=>{
            emitMetrics(stopTime);
        }, 500);
    });
};

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("6y2lk", function(module, exports) {

$parcel$export(module.exports, "startUimTti", () => $a642ea194b4a9d18$export$1422384676f6de7a);
$parcel$export(module.exports, "markUimTtiIssueViewLoaded", () => $a642ea194b4a9d18$export$5a9389b70d93def2);
$parcel$export(module.exports, "stopTTI", () => $a642ea194b4a9d18$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $a642ea194b4a9d18$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $a642ea194b4a9d18$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $a642ea194b4a9d18$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $a642ea194b4a9d18$export$d86f4868694f2aa7);

var $2nKjG = parcelRequire("2nKjG");
const $a642ea194b4a9d18$var$uimInIssueViewTTI = (0, $2nKjG.metrics).interaction({
    key: 'ui-modifications-in-issue-view',
    timings: [
        {
            key: 'issue-view-tti-delta',
            startMark: 'issue-view-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ]
});
const $a642ea194b4a9d18$export$1422384676f6de7a = ()=>{
    $a642ea194b4a9d18$var$uimInIssueViewTTI.start();
};
const $a642ea194b4a9d18$export$5a9389b70d93def2 = ()=>{
    $a642ea194b4a9d18$var$uimInIssueViewTTI.mark('issue-view-tti');
};
const $a642ea194b4a9d18$export$30ca4c461fab486c = (customData)=>{
    $a642ea194b4a9d18$var$uimInIssueViewTTI.stop({
        customData: customData
    });
};
const $a642ea194b4a9d18$export$27f2445288b528c = ()=>{
    $a642ea194b4a9d18$var$uimInIssueViewTTI.cancel();
};
const $a642ea194b4a9d18$export$7a2709fc1e33401a = ()=>{
    $a642ea194b4a9d18$var$uimInIssueViewTTI.mark('iframe-load');
};
const $a642ea194b4a9d18$export$cf3893335c93e33b = ()=>{
    $a642ea194b4a9d18$var$uimInIssueViewTTI.mark('fields-registered');
};
const $a642ea194b4a9d18$export$d86f4868694f2aa7 = ()=>{
    $a642ea194b4a9d18$var$uimInIssueViewTTI.mark('oninit-resolved');
};

});

parcelRegister("eDXka", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $9f0f96bc04f1e77a$export$b38f30d67f730bc4);
const $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $9f0f96bc04f1e77a$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("Rsnea", function(module, exports) {

$parcel$export(module.exports, "blockedOnBackendEntryLog", () => $09eba838967fcf46$export$dd1b3502b1e8ca97);
$parcel$export(module.exports, "getBackendBlockingTime", () => $09eba838967fcf46$export$8720c1f879c7ca46);

var $x9xyg = parcelRequire("x9xyg");


var $eR8VP = parcelRequire("eR8VP");

var $5HSWG = parcelRequire("5HSWG");
const $09eba838967fcf46$export$dd1b3502b1e8ca97 = (0, $eR8VP.createBlockedOnBackendEntryLog)();
function $09eba838967fcf46$var$measureBlockingEntry(measureName, backendBlockingStart, backendBlockingEnd) {
    (0, $x9xyg.setMark)(`${measureName}Start`, {
        startTime: backendBlockingStart
    });
    (0, $x9xyg.setMark)(`${measureName}End`, {
        startTime: backendBlockingEnd
    });
    (0, $x9xyg.setMeasure)(`${measureName}`, `${measureName}Start`, `${measureName}End`);
}
const $09eba838967fcf46$export$8720c1f879c7ca46 = (args)=>{
    const { blockingStart: blockingStartOrZero, totalBlockingDuration: totalBlockingDuration } = (0, $5HSWG.getSimplifiedBlockingTime)($09eba838967fcf46$export$dd1b3502b1e8ca97);
    const backendBlockingStart = Math.max(args.issueViewLoad.startTime, blockingStartOrZero);
    // Add the marks to the issueViewLoad BM3 event
    const backendBlockingEnd = backendBlockingStart + totalBlockingDuration;
    args.issueViewLoad.mark($f0ab548eaf57140f$export$e52cc35f872875f7, backendBlockingEnd);
    args.issueViewLoad.mark($f0ab548eaf57140f$export$e64e32643802b552, backendBlockingStart);
    $09eba838967fcf46$export$dd1b3502b1e8ca97.getBlockedOnBackendEntries().forEach(([blockingReason, { blockingStart: blockingStart, blockingEnd: blockingEnd }])=>$09eba838967fcf46$var$measureBlockingEntry(`issueView_blockedOnBackend_${blockingReason}`, blockingStart, blockingEnd));
    return {
        issueDataAvailable: backendBlockingEnd,
        issueReadyForData: backendBlockingStart
    };
};

});
parcelRegister("eR8VP", function(module, exports) {

$parcel$export(module.exports, "createBlockedOnBackendEntryLog", () => $03c2930a2b0da0b2$export$44ddca89673a78bc);
const $03c2930a2b0da0b2$export$44ddca89673a78bc = ()=>{
    const blockedOnBackendState = {
        timestamps: {}
    };
    // Internal use, use initialiseBlockedOnBackendStateForUpdatedKey externally
    const clearBlockedOnBackendState = ()=>{
        blockedOnBackendState.timestamps = {};
        blockedOnBackendState.currentKey = undefined;
    };
    // Internal use, use markStartBackendBlockingTimestamp or markEndBackendBlockingTimestamp
    const getOrCreateTimestampsEntryForKey = (blockingReasonKey)=>{
        let blockingDurationTimestamps = blockedOnBackendState.timestamps[blockingReasonKey];
        if (!blockingDurationTimestamps) {
            blockingDurationTimestamps = {};
            blockedOnBackendState.timestamps[blockingReasonKey] = blockingDurationTimestamps;
        }
        return blockingDurationTimestamps;
    };
    /**
	 * Initialise the store for a given key string.
	 * Only resets the state the first if the key string updates from its initial undefined OR if the key updates from the last time this was called
	 */ const initialiseBlockedOnBackendStateForUpdatedKey = (key)=>{
        if (key !== blockedOnBackendState.currentKey) {
            clearBlockedOnBackendState();
            blockedOnBackendState.currentKey = key;
        }
    };
    /**
	 * Fire this to mark the start of being blocked on backend for a given reason.
	 * @param blockingReasonKey An identifier for the reason for blocking. Until state is re-initialised, this reason cannot be used again to start a blocking span. Overlapping reasons will not be double counted
	 * @param timestamp optional, defaults to current time
	 */ const markStartBackendBlockingTimestamp = (blockingReasonKey, timestamp = performance.now())=>{
        const blockingDurationTimestamps = getOrCreateTimestampsEntryForKey(blockingReasonKey);
        if (!blockingDurationTimestamps.blockingStart) blockingDurationTimestamps.blockingStart = timestamp;
    };
    /**
	 * Fire this to mark the end of being blocked on backend for a given reason
	 * @param blockingReasonKey
	 * @param timestamp optional, defaults to current time
	 */ const markEndBackendBlockingTimestamp = (blockingReasonKey, timestamp = performance.now())=>{
        const blockingDurationTimestamps = getOrCreateTimestampsEntryForKey(blockingReasonKey);
        if (!blockingDurationTimestamps.blockingEnd) blockingDurationTimestamps.blockingEnd = timestamp;
    };
    /**
	 * Return a list of the entries gathered so far
	 * @param sorted whether the returned results should be sorted based on their start time. true by default
	 */ const getBlockedOnBackendEntries = ({ sorted: sorted = true } = {})=>{
        let entries = Object.entries(blockedOnBackendState.timestamps).filter((entry)=>{
            const [, blockingTimestamps] = entry;
            return blockingTimestamps.blockingStart != null && blockingTimestamps.blockingEnd != null && blockingTimestamps.blockingStart <= blockingTimestamps.blockingEnd;
        });
        if (sorted) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        entries = entries.sort(([, { blockingStart: start1 }], [, { blockingStart: start2 }])=>start1 - start2);
        return entries;
    };
    return {
        initialiseBlockedOnBackendStateForUpdatedKey: initialiseBlockedOnBackendStateForUpdatedKey,
        markStartBackendBlockingTimestamp: markStartBackendBlockingTimestamp,
        markEndBackendBlockingTimestamp: markEndBackendBlockingTimestamp,
        getBlockedOnBackendEntries: getBlockedOnBackendEntries
    };
};

});

parcelRegister("5HSWG", function(module, exports) {

$parcel$export(module.exports, "getSimplifiedBlockingTime", () => $f737b8377358abe8$export$580550d1d1ffca6c);

var $fV2OJ = parcelRequire("fV2OJ");
const $f737b8377358abe8$export$580550d1d1ffca6c = (entryLog)=>{
    const blockingTimestampEntries = entryLog.getBlockedOnBackendEntries({
        sorted: true
    });
    const blockingSpans = (0, $fV2OJ.mergeOverlappingBlockingEntries)(blockingTimestampEntries);
    const blockingStartTimes = blockingSpans.map(({ blockingStart: blockingStart })=>blockingStart ?? 0);
    const blockingDurations = blockingSpans.map(({ blockingEnd: blockingEnd, blockingStart: blockingStart })=>blockingEnd - blockingStart);
    const blockingStart = Math.min(...blockingStartTimes.length ? blockingStartTimes : [
        0
    ]);
    const totalBlockingDuration = blockingDurations.reduce((a, b)=>a + b, 0);
    return {
        blockingStart: blockingStart,
        totalBlockingDuration: totalBlockingDuration
    };
};

});
parcelRegister("fV2OJ", function(module, exports) {

$parcel$export(module.exports, "mergeOverlappingBlockingEntries", () => $a9340f8b2f19c6fe$export$e63ec487944afc72);
function $a9340f8b2f19c6fe$export$e63ec487944afc72(blockingTimestampEntriesSortedByStartTime) {
    return blockingTimestampEntriesSortedByStartTime.reduce((nonOverlappingSpans, [, { blockingStart: blockingStart, blockingEnd: blockingEnd }])=>{
        const lastSpan = nonOverlappingSpans[nonOverlappingSpans.length - 1];
        if (!lastSpan || blockingStart > lastSpan.blockingEnd) nonOverlappingSpans.push({
            blockingStart: blockingStart,
            blockingEnd: blockingEnd
        }); // add the span as-is to the known non-overlapping spans
        else if (lastSpan.blockingEnd < blockingEnd) lastSpan.blockingEnd = blockingEnd;
        return nonOverlappingSpans;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    []);
}

});



parcelRegister("1UioC", function(module, exports) {

$parcel$export(module.exports, "issueScaleabilityReporterFactory", () => $1f39c5825b4f5e5a$export$9f6c068bd6582299);


var $kuVxL = parcelRequire("kuVxL");

var $fOGZN = parcelRequire("fOGZN");

var $i84pu = parcelRequire("i84pu");

var $b5LNN = parcelRequire("b5LNN");

var $a1ky2 = parcelRequire("a1ky2");

var $7Ow8a = parcelRequire("7Ow8a");

var $bcoYn = parcelRequire("bcoYn");

var $gYUjk = parcelRequire("gYUjk");

var $lMzxr = parcelRequire("lMzxr");

var $jMY7o = parcelRequire("jMY7o");

var $hwyJi = parcelRequire("hwyJi");

var $lssfC = parcelRequire("lssfC");

var $d4MOh = parcelRequire("d4MOh");

var $9acDX = parcelRequire("9acDX");

var $ifezr = parcelRequire("ifezr");

var $3Ke60 = parcelRequire("3Ke60");

var $aN61o = parcelRequire("aN61o");

var $5fc53 = parcelRequire("5fc53");

var $dvijh = parcelRequire("dvijh");

var $fKtck = parcelRequire("fKtck");
const $1f39c5825b4f5e5a$var$getCascadingSelectFields = (state)=>Object.values((0, $7Ow8a.fieldsSelector)(state)).filter((fieldValues)=>fieldValues.schema.custom === (0, $5fc53.CASCADING_SELECT_CF_TYPE));
const $1f39c5825b4f5e5a$var$getAtlassianTeamFields = (state)=>Object.values((0, $7Ow8a.fieldsSelector)(state)).filter((fieldValues)=>fieldValues.schema.custom === (0, $5fc53.TEAMS_PLATFORM_CF_TYPE));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1f39c5825b4f5e5a$var$getCascadingSelectOptionChildrenCount = (cascadingSelectFieldValue)=>{
    if (cascadingSelectFieldValue.length === 0) return 0;
    return Object.values(cascadingSelectFieldValue).reduce((accumulatedCount, parentValue)=>accumulatedCount + (parentValue?.children?.length || 1), 0);
};
const $1f39c5825b4f5e5a$var$getCascadingSelectOptionsTotalCount = (state)=>{
    const cascadingSelectFields = $1f39c5825b4f5e5a$var$getCascadingSelectFields(state);
    if (cascadingSelectFields.length === 0) return 0;
    return cascadingSelectFields.reduce((accumulatedCount, cascadingSelectField)=>accumulatedCount + ($1f39c5825b4f5e5a$var$getCascadingSelectOptionChildrenCount(cascadingSelectField.allowedValues) || 1), 0);
};
const $1f39c5825b4f5e5a$export$ae327590f8230d00 = ({ projectKey: projectKey, ecosystem: ecosystem, forge: forge })=>{
    let open = 0;
    let closed = 0;
    if (projectKey !== undefined) {
        // The context groups store the state of open / closed inside local storage, so we need to get access to that
        // here. It's not held in redux which is why we look it up this way.
        const groupLocalStorageName = (0, $i84pu.getGroupLocalStorageName)(projectKey, 'context-group');
        try {
            // It's possible panels are uninstalled and not removed from localstorage, so we need to check they are installed
            // otherwise the analytics may be incorrectly advising how many panels are open
            const installedPanels = [
                ...ecosystem.map((item)=>`${groupLocalStorageName}-${(0, $b5LNN.generateContextPanelId)(item)}`),
                ...forge.map((item)=>`${groupLocalStorageName}-${item.id}`)
            ];
            open = Object.values((0, $i84pu.getGroupsLocalStorage)(installedPanels, (0, $135ded4f9a1460dc$export$e1184c3be46bd7cb))).filter(Boolean).length;
            // Panels may not exist in localStorage but may be installed, in which case they are closed as this is the default state
            closed = installedPanels.length - open;
        } catch  {
        // No action required
        }
    }
    return {
        open: open,
        closed: closed
    };
};
const $1f39c5825b4f5e5a$export$9f6c068bd6582299 = (store, issueContextActions)=>()=>{
        const state = store.getState();
        const { permalinkType: permalinkType } = (0, $fKtck.getPermalinkTypeAndId)() || {};
        const childIssues = (0, $7Ow8a.fieldSelector)((0, $5fc53.CHILDREN_ISSUES))(state);
        const proformaHarmonisation = (0, $7Ow8a.fieldSelector)((0, $5fc53.PROFORMA_FORMS))(state);
        const { open: contextPanelOpenCount, closed: contextPanelClosedCount } = $1f39c5825b4f5e5a$export$ae327590f8230d00({
            projectKey: state?.entities?.project?.projectKey,
            ecosystem: (0, $gYUjk.contextPanelEntitiesSelector)(state),
            forge: (0, $lMzxr.forgeContextPanelsSelector)(state)
        });
        const subtaskCount = (0, $7Ow8a.childIssuesLimitUrlSelector)(state)((0, $fOGZN.SUBTASKS)) && issueContextActions ? (0, $kuVxL.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : (0, $aN61o.subtaskEntitiesSelector)(state).length;
        const childIssuesCount = (0, $7Ow8a.childIssuesLimitUrlSelector)(state)((0, $5fc53.CHILDREN_ISSUES)) && issueContextActions ? (0, $kuVxL.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : childIssues?.value.length ?? 0;
        // If a portfolio issue is over the limit we cannot tell because
        // only the subtasks panel is displayed. Once the portfolio issue
        // type hierarchy level is a value > 1 then we can set this to ">100".
        let portfolioChildIssueCount;
        let actualSubtaskCount;
        let actualChildIssueCount;
        let actualEpicIssueCount;
        let epicIssueCount;
        const subtasks = (0, $7Ow8a.fieldSelector)((0, $fOGZN.SUBTASKS))(state);
        const epicIssues = (0, $7Ow8a.fieldSelector)((0, $fOGZN.EPIC_ISSUES))(state);
        const portfolioChildIssues = (0, $7Ow8a.fieldSelector)((0, $fOGZN.PORTFOLIO_CHILD_ISSUES))(state);
        const getChildIssuesLimitUrl = (0, $7Ow8a.childIssuesLimitUrlSelector)(state);
        const isEpicIssuesOverLimit = Boolean(getChildIssuesLimitUrl((0, $fOGZN.EPIC_ISSUES)));
        const isOverLimit = Boolean(getChildIssuesLimitUrl((0, $fOGZN.SUBTASKS))) || Boolean(getChildIssuesLimitUrl((0, $5fc53.CHILDREN_ISSUES))) || isEpicIssuesOverLimit;
        if (isOverLimit) {
            actualChildIssueCount = childIssues?.originalContentLength ?? 0;
            actualEpicIssueCount = epicIssues?.originalContentLength ?? 0;
            // If epic issue is over the limit, we exclude the subtasks field
            // from the store. So we need to grab the data from the epicIssues field.
            actualSubtaskCount = isEpicIssuesOverLimit ? epicIssues?.otherOriginalChildIssuesLength ?? 0 : subtasks?.originalContentLength ?? 0;
            epicIssueCount = isEpicIssuesOverLimit && issueContextActions ? (0, $kuVxL.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : epicIssues?.originalContentLength ?? 0;
            // If portfolio issue is over the limit, we exclude the portfolio-child-issues field
            // from the store. So we need to grab the data from the subtasks field.
            portfolioChildIssueCount = subtasks?.otherOriginalChildIssuesLength ?? 0;
        } else {
            actualChildIssueCount = childIssues?.value.length ?? 0;
            actualSubtaskCount = subtasks?.value.length ?? 0;
            actualEpicIssueCount = epicIssues?.value.length ?? 0;
            portfolioChildIssueCount = portfolioChildIssues?.value.length ?? 0;
            epicIssueCount = actualEpicIssueCount;
        }
        let iframeCount = null;
        // This is is to check if the document is undefined in SSR. See https://hello.atlassian.net/wiki/x/jnEv2w
        if (typeof document !== 'undefined') iframeCount = document?.querySelectorAll('iframe')?.length;
        // Properties added here show up in:
        // - jira.fe.custom.issue-view-on-page-load
        // - jira.fe.page-load.issue-view
        // - and jira.fe.custom.embedded-issue-view-load
        // Verify these in the BM3 tab of the Chrome Analytics extension.
        return {
            ecosystemGlances: (0, $gYUjk.glancesSelector)(state).length,
            ecosystemContentPanels: (0, $gYUjk.allContentPanelsSelector)(state).length,
            contextPanelOpenCount: contextPanelOpenCount,
            contextPanelClosedCount: contextPanelClosedCount,
            ecosystemActivityPanels: (0, $gYUjk.activityPanelsSelector)(state).length,
            iframeCount: iframeCount,
            hasIframe: Boolean(iframeCount),
            ecosystemCustomsFields: (0, $hwyJi.ecosystemCustomFieldIdsSelector)(state).length,
            childIssues: childIssuesCount,
            linkIssueCount: (0, $9acDX.combinedLinkedIssueCountSelector)(state),
            subtaskCount: subtaskCount,
            actualChildIssueCount: actualChildIssueCount,
            actualSubtaskCount: actualSubtaskCount,
            actualEpicIssueCount: actualEpicIssueCount,
            actualPortfolioChildIssueCount: portfolioChildIssueCount,
            epicIssueCount: epicIssueCount,
            portfolioChildIssueCount: portfolioChildIssueCount,
            issueId: (0, $a1ky2.issueIdSelector)(state),
            commentsTotalCount: (0, $d4MOh.totalCommentsSelector)(state),
            hasCommentPermalink: permalinkType === (0, $dvijh.COMMENTS),
            cascadingSelectCount: $1f39c5825b4f5e5a$var$getCascadingSelectFields(state).length,
            isAtlassianTeamFieldEnabled: $1f39c5825b4f5e5a$var$getAtlassianTeamFields(state).length > 0,
            cascadingSelectOptionsTotalCount: $1f39c5825b4f5e5a$var$getCascadingSelectOptionsTotalCount(state),
            proformaHarmonisationEnabled: proformaHarmonisation ? proformaHarmonisation.value.isHarmonisationEnabled : false,
            hasSubtasksTypes: (0, $3Ke60.isSubtaskTypesPresentSelector)(state),
            issueTypesCount: (0, $ifezr.issueTypesSelector)(state).length,
            issueTypeHierarchyLevel: !(0, $bcoYn.isSimplifiedProjectSelector)(state) ? (0, $lssfC.issueTypeHierarchyLevelSelector)(state) : (0, $jMY7o.hierarchyLevelSelector)(state)
        };
    };

});
const $135ded4f9a1460dc$export$dcd281f501ceae1a = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.pinned-fields';
const $135ded4f9a1460dc$export$e1184c3be46bd7cb = false;
const $135ded4f9a1460dc$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $135ded4f9a1460dc$export$988f0f6f6457039a = 'status-and-approval-spotlight';

parcelRegister("kuVxL", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimitExceededAnalyticsCount", () => $352d0cb4ab81075d$export$8cbe27041ec414b7);
const $352d0cb4ab81075d$export$1e3c128c36bad9a4 = 'CHILD_ISSUES_LIMIT_EXCEEDED';
const $352d0cb4ab81075d$export$8cbe27041ec414b7 = (childIssuesLimit)=>`>${childIssuesLimit}`;

});

parcelRegister("i84pu", function(module, exports) {

$parcel$export(module.exports, "getGroupLocalStorageName", () => $28741fb0cc9e4bb5$export$a3b190a19b138f2e);
$parcel$export(module.exports, "isGroupPanelOpen", () => $28741fb0cc9e4bb5$export$e79995f22545fd3e);
$parcel$export(module.exports, "getGroupsLocalStorage", () => $28741fb0cc9e4bb5$export$d0a5ccc42f3bcd33);
$parcel$export(module.exports, "useGroupLocalStorage", () => $28741fb0cc9e4bb5$export$4e1a840a45fb467c);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
// TODO : Add a prefix to identify each app and also make sure you update the same in test
const $28741fb0cc9e4bb5$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('');
const $28741fb0cc9e4bb5$export$a3b190a19b138f2e = (projectKey, id)=>`group.state.${projectKey}.${id}`;
const $28741fb0cc9e4bb5$export$a7e7b7df48874d2c = (keyName, defaultValue)=>{
    try {
        let item;
        if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) item = $28741fb0cc9e4bb5$var$localStorageProvider.get(keyName);
        else if (typeof window !== 'undefined') item = window.localStorage.getItem(keyName);
        if (item === 'true') return true;
        if (item === 'false') return false;
        throw Error('Invalid group state value');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        return defaultValue;
    }
};
const $28741fb0cc9e4bb5$export$e79995f22545fd3e = (projectKey, group, panelId, defaultValue)=>{
    const groupLocalStorageName = $28741fb0cc9e4bb5$export$a3b190a19b138f2e(projectKey, group);
    return $28741fb0cc9e4bb5$export$a7e7b7df48874d2c(`${groupLocalStorageName}-${panelId}`, defaultValue);
};
const $28741fb0cc9e4bb5$export$d0a5ccc42f3bcd33 = (keyNames, initialOpened)=>{
    const items = {};
    keyNames.forEach((key)=>{
        items[key] = $28741fb0cc9e4bb5$export$a7e7b7df48874d2c(key, initialOpened);
    });
    return items;
};
const $28741fb0cc9e4bb5$export$4e1a840a45fb467c = (projectKey, id, initialOpened)=>{
    const keyName = $28741fb0cc9e4bb5$export$a3b190a19b138f2e(projectKey, id);
    const [storedValue, setStoredValue] = (0, $5uXOq.useState)(()=>$28741fb0cc9e4bb5$export$a7e7b7df48874d2c(keyName, initialOpened));
    const setValue = (0, $5uXOq.useCallback)((value)=>{
        try {
            setStoredValue(value);
            if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) $28741fb0cc9e4bb5$var$localStorageProvider.set(keyName, String(value));
            else if (typeof window !== 'undefined') window.localStorage.setItem(keyName, String(value));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (_) {
        // Not decided what we do when we reach here.
        }
    }, [
        keyName
    ]);
    return [
        storedValue,
        setValue
    ];
};

});

parcelRegister("b5LNN", function(module, exports) {

$parcel$export(module.exports, "shouldHideNullUneditableField", () => $8e792d10938fd7f7$export$e7987ba89f8e2996);
$parcel$export(module.exports, "ecosystemGlancesToLayoutItem", () => $8e792d10938fd7f7$export$8dd9174e11169a13);
$parcel$export(module.exports, "ecosystemContextsToLayoutItem", () => $8e792d10938fd7f7$export$ff0381f8ed1f6cc7);
$parcel$export(module.exports, "useForgeGlancesAsLayoutItems", () => $8e792d10938fd7f7$export$969c8278a214a2d9);
$parcel$export(module.exports, "useForgeContextPanelsAsLayoutItems", () => $8e792d10938fd7f7$export$b4095ac407369aa0);
$parcel$export(module.exports, "addChangeboardingRefToFirstItem", () => $8e792d10938fd7f7$export$b7aff69af7ee8f70);
$parcel$export(module.exports, "getPinnedFieldItems", () => $8e792d10938fd7f7$export$7fc9f8048722ede9);
$parcel$export(module.exports, "generateContextPanelId", () => $8e792d10938fd7f7$export$c55ff2c236d30544);

var $1sWm7 = parcelRequire("1sWm7");

var $5cmSg = parcelRequire("5cmSg");

var $2gCtH = parcelRequire("2gCtH");

var $3fAi8 = parcelRequire("3fAi8");

var $41gqO = parcelRequire("41gqO");

var $awmXl = parcelRequire("awmXl");


var $cUUmI = parcelRequire("cUUmI");

var $fOGZN = parcelRequire("fOGZN");

var $2ewrm = parcelRequire("2ewrm");


var $vuOaC = parcelRequire("vuOaC");

var $5fc53 = parcelRequire("5fc53");

var $93Yeu = parcelRequire("93Yeu");

var $17Gip = parcelRequire("17Gip");
const $8e792d10938fd7f7$export$87af144309c7a3c5 = (canLogTime, isNativeJiraTimeTrackingEnabled)=>// Here we assume that if the time tracking field is an available field
    // but isNativeJiraTimeTrackingEnabled is false, a 3rd party time tracking app is installed.
    isNativeJiraTimeTrackingEnabled ? !canLogTime : false;
const $8e792d10938fd7f7$var$getFieldByCustomType = (customType, fieldsConfiguration)=>(0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(fieldsConfiguration, (field)=>(field.schema && field.schema.custom) === customType);
const $8e792d10938fd7f7$var$getFieldConfiguration = (fieldId, fields)=>{
    const field = fields[fieldId];
    const customSystemFields = (0, $fOGZN.specialFields)();
    const condition = !field && Object.prototype.hasOwnProperty.call(customSystemFields, fieldId);
    if (condition) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        const customType = customSystemFields[fieldId];
        return $8e792d10938fd7f7$var$getFieldByCustomType(customType, fields);
    }
    return field;
};
const $8e792d10938fd7f7$export$e7987ba89f8e2996 = (itemId, issueFieldsConfig, value, canLogTime, isNativeJiraTimeTrackingEnabled)=>{
    const fieldConfig = $8e792d10938fd7f7$var$getFieldConfiguration(itemId, issueFieldsConfig);
    const fieldType = (0, $vuOaC.getFieldType)(fieldConfig);
    if ((0, $vuOaC.getPanels)().includes(itemId)) return false;
    if (!fieldConfig || fieldType === undefined) return true;
    if ((0, $vuOaC.isEmpty)(value) && !fieldConfig.isEditable) {
        if (itemId === (0, $5fc53.ASSIGNEE_TYPE) || fieldType === (0, $5fc53.REQUEST_TYPE_CF_TYPE) || fieldType === (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE)) return false;
        // ARKEN-40: Forge custom fields with readonly and an empty value must still be shown as primary or secondary items
        if ((0, $cUUmI.isForgeField)(fieldConfig)) return false;
        if (itemId === (0, $5fc53.TIME_TRACKING_TYPE)) return $8e792d10938fd7f7$export$87af144309c7a3c5(canLogTime, isNativeJiraTimeTrackingEnabled);
        return true;
    }
    return false;
};
const $8e792d10938fd7f7$export$8dd9174e11169a13 = (ecosystemGlances)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = Object.keys(ecosystemGlances).reduce((acc, next)=>{
        const ecosystem = ecosystemGlances[next];
        const modules = Object.keys(ecosystem).map((moduleKey)=>ecosystem[moduleKey]);
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        return [
            ...acc,
            ...modules
        ];
    }, []);
    return result.map((connectGlance)=>({
            id: `${0, $5fc53.ECOSYSTEM_GLANCE_TYPE}__${connectGlance.appKey}__${connectGlance.moduleKey}`,
            type: (0, $5fc53.ECOSYSTEM_GLANCE_TYPE),
            payload: {
                ...connectGlance,
                glanceType: (0, $awmXl.CONNECT_ENTITY_TYPE)
            }
        }));
};
const $8e792d10938fd7f7$export$ff0381f8ed1f6cc7 = (ecosystemContextPanels)=>{
    const contextPanels = [];
    Object.values(ecosystemContextPanels).forEach((contextPanelObject)=>{
        contextPanels.push(Object.values(contextPanelObject)[0]);
    });
    return contextPanels.map((connectContextPanel)=>({
            id: `${0, $5fc53.ECOSYSTEM_CONTEXT_TYPE}__${connectContextPanel.appKey}__${connectContextPanel.moduleKey}`,
            type: (0, $5fc53.ECOSYSTEM_CONTEXT_TYPE),
            payload: {
                ...connectContextPanel,
                contextPanelType: (0, $awmXl.CONNECT_ENTITY_TYPE)
            }
        }));
};
const $8e792d10938fd7f7$var$ISSUE_TYPE = 'issuetype';
const $8e792d10938fd7f7$export$ea6c3ae2bd3a5510 = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const issueId = (0, $2gCtH.useIssueId)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const [permissions] = (0, $17Gip.useProjectPermissions)(projectKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    const [issueType] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: $8e792d10938fd7f7$var$ISSUE_TYPE
    });
    return {
        issueId: issueId || null,
        issueKey: issueKey,
        issueType: issueType && issueType.name,
        projectId: projectId,
        projectKey: projectKey,
        projectType: projectType || null,
        // Prop normalisation copied from original redux selector - Props names are exposed externally.
        canAddComments: permissions.canAddComments,
        canAdministerJira: permissions.canAdministerJira,
        canAdministerProjects: permissions.canAdministerProject,
        canAssignIssues: permissions.canAssignIssues,
        canBeAssignedToIssues: permissions.canBeAssignedToIssues,
        canCloneIssues: permissions.canCloneIssue,
        canCreateAttachments: permissions.canCreateAttachments,
        canCreateChildren: permissions.canCreateChildren,
        canCreateSubtasks: permissions.canCreateSubtask,
        canDeleteAllAttachments: permissions.canDeleteAllAttachments,
        canDeleteAllComments: permissions.canDeleteAllComments,
        canDeleteAllWorklogs: permissions.canDeleteAllWorklogs,
        canDeleteIssues: permissions.canDeleteIssue,
        canDeleteOwnAttachments: permissions.canDeleteOwnAttachments,
        canDeleteOwnComments: permissions.canDeleteOwnComments,
        canDeleteOwnWorklogs: permissions.canDeleteOwnWorklogs,
        canEditAllComments: permissions.canEditAllComments,
        canEditAllWorklogs: permissions.canEditAllWorklogs,
        canEditIssues: permissions.canEditIssues,
        canEditOwnComments: permissions.canEditOwnComments,
        canEditOwnWorklogs: permissions.canEditOwnWorklogs,
        canLinkIssues: permissions.canLinkIssues,
        canLogWork: permissions.canLogWork,
        canManageWatchers: permissions.canManageWatchers,
        canModifyReporters: permissions.canModifyReporter,
        canMoveIssues: permissions.canMoveIssue,
        canScheduleIssues: permissions.canScheduleIssues,
        canUseServiceManagementAgentFeatures: permissions.canUseServiceDeskAgentFeatures,
        canBrowseUsers: permissions.canBrowseUsers,
        canViewDevTools: permissions.canViewDevTools,
        canViewWatchers: permissions.canViewWatchers
    };
};
const $8e792d10938fd7f7$export$969c8278a214a2d9 = ()=>{
    const [forgeGlances] = (0, $2ewrm.useForgeGlances)();
    return forgeGlances.filter((extension)=>(0, $5cmSg.isExtensionVisible)(extension)).map((forgeGlance)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: icon } } = forgeGlance;
        return {
            id: id,
            type: (0, $5fc53.FORGE_GLANCE_TYPE),
            payload: {
                label: label,
                title: title,
                status: status,
                icon: icon,
                extension: forgeGlance,
                glanceType: (0, $f17db2727085e590$export$6f3804b3f188f650),
                moduleKey: id,
                appKey: id
            }
        };
    });
};
const $8e792d10938fd7f7$export$b4095ac407369aa0 = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const { ecosystemEnabled: ecosystemEnabled } = (0, $93Yeu.useProjectConfiguration)(projectKey);
    const [forgeContextPanels] = (0, $2ewrm.useForgeContextPanels)();
    if (!ecosystemEnabled) return [];
    return forgeContextPanels.filter((extension)=>(0, $5cmSg.isExtensionVisible)(extension)).map((contextPanels)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: url } } = contextPanels;
        return {
            id: id,
            type: (0, $41gqO.FORGE_CONTEXT_TYPE),
            payload: {
                type: (0, $41gqO.FORGE_CONTEXT_TYPE),
                label: label,
                name: title,
                status: status || null,
                icon: url ? {
                    url: url
                } : null,
                extension: contextPanels,
                contextPanelType: (0, $f17db2727085e590$export$6f3804b3f188f650),
                moduleKey: id,
                appKey: id,
                options: null
            }
        };
    });
};
const $8e792d10938fd7f7$export$b7aff69af7ee8f70 = (items)=>{
    let wrapperAdded = false;
    const allowedTypes = [
        (0, $41gqO.layoutContainerItemTypes).field,
        (0, $41gqO.layoutContainerItemTypes).panel
    ];
    const disallowedIds = [
        (0, $5fc53.ASSIGNEE_TYPE),
        (0, $5fc53.SLA_PANEL_TYPE)
    ];
    return items.map((item)=>{
        const typename = item.type !== undefined ? item.type : '';
        // @ts-expect-error - TS2345 - Argument of type 'any' is not assignable to parameter of type 'never'.
        if (!wrapperAdded && !disallowedIds.includes(item.id) && allowedTypes.includes(typename)) {
            wrapperAdded = true;
            // if it was added to csat field and csat field to be removed later in servicedesk template, this effectively won't work
            return {
                ...item,
                globalRef: (0, $acf4ef636a959927$export$95ff4d03075475e2)
            };
        }
        return item;
    });
};
const $8e792d10938fd7f7$export$7fc9f8048722ede9 = (dedupedItems, pinnedFields)=>pinnedFields.reduce((result, pinnedId)=>{
        const item = dedupedItems.find((dedupedItem)=>dedupedItem.type === (0, $41gqO.layoutContainerItemTypes).field && dedupedItem.fieldItemId === pinnedId || dedupedItem.type === (0, $41gqO.layoutContainerItemTypes).panel && dedupedItem.panelItemId === pinnedId);
        if (item !== undefined) result.push(item);
        return result;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, []);
const $8e792d10938fd7f7$export$c55ff2c236d30544 = ({ appKey: appKey, moduleKey: moduleKey })=>`${0, $5fc53.ECOSYSTEM_CONTEXT_TYPE}__${appKey}__${moduleKey}`;

});
parcelRegister("5cmSg", function(module, exports) {

$parcel$export(module.exports, "isExtensionVisible", () => $30771269db74e480$export$41e48b53c2cc2013);
$parcel$export(module.exports, "isExtensionHidden", () => $30771269db74e480$export$3f5b3e61d567ef3);
$parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", () => $30771269db74e480$export$5c38dfa9d1f96e61);
const $30771269db74e480$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
const $30771269db74e480$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
const $30771269db74e480$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
const $30771269db74e480$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';

});

parcelRegister("2gCtH", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $9e67f38435565e11$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $9e67f38435565e11$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $9e67f38435565e11$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $9e67f38435565e11$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $9e67f38435565e11$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $9e67f38435565e11$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $9e67f38435565e11$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $9e67f38435565e11$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $9e67f38435565e11$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $9e67f38435565e11$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $9e67f38435565e11$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $9e67f38435565e11$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $9e67f38435565e11$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $9e67f38435565e11$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $9e67f38435565e11$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $9e67f38435565e11$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $9e67f38435565e11$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $9e67f38435565e11$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $9e67f38435565e11$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $9e67f38435565e11$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $9e67f38435565e11$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiEnabledForIssue", () => $9e67f38435565e11$export$db5174c7538abe4b);
$parcel$export(module.exports, "useIsJiraIssue", () => $9e67f38435565e11$export$cf5fc815f761fb4b);

var $5uXOq = parcelRequire("5uXOq");


var $2vSU6 = parcelRequire("2vSU6");

var $4Pf62 = parcelRequire("4Pf62");

var $93Yeu = parcelRequire("93Yeu");

var $g5X3G = parcelRequire("g5X3G");

var $ef5Xn = parcelRequire("ef5Xn");

var $7trqb = parcelRequire("7trqb");

var $hqBSi = parcelRequire("hqBSi");

var $koiRX = parcelRequire("koiRX");
const $9e67f38435565e11$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $koiRX.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $9e67f38435565e11$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $koiRX.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $9e67f38435565e11$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $9e67f38435565e11$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $9e67f38435565e11$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $koiRX.useIssueContextStoreIsModal)();
    return isModal;
};
const $9e67f38435565e11$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $koiRX.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $9e67f38435565e11$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $koiRX.useIssueContextStoreIssueId)();
    return issueId;
};
const $9e67f38435565e11$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $koiRX.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $9e67f38435565e11$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $koiRX.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $9e67f38435565e11$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $koiRX.useIssueContextStoreIssueKey)();
    return (0, $g5X3G.toProjectKey)(issueKey.split('-')[0]);
};
const $9e67f38435565e11$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $koiRX.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $9e67f38435565e11$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $koiRX.useIssueContextStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        resetDetailView
    ]);
    return [
        undefined,
        actions
    ];
};
const $9e67f38435565e11$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $koiRX.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $9e67f38435565e11$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $koiRX.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $9e67f38435565e11$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $koiRX.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $9e67f38435565e11$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $koiRX.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $9e67f38435565e11$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $koiRX.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $9e67f38435565e11$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $koiRX.useIssueContextStoreViewMode)();
    return viewMode;
};
const $9e67f38435565e11$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $koiRX.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $9e67f38435565e11$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $koiRX.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $9e67f38435565e11$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $koiRX.useIssueContextStoreBoardId)();
    return boardId;
};
const $9e67f38435565e11$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $koiRX.useIssueContextStoreBoardType)();
    return boardType;
};
const $9e67f38435565e11$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $koiRX.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $9e67f38435565e11$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $koiRX.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $9e67f38435565e11$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $koiRX.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $9e67f38435565e11$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $koiRX.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $9e67f38435565e11$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $koiRX.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $9e67f38435565e11$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const licenseStates = (0, $7trqb.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $ef5Xn.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $9e67f38435565e11$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
    return analyticsSource === (0, $fcf97b7a09088940$export$b19f949fb9713614);
};
const $9e67f38435565e11$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
    return analyticsSource === (0, $fcf97b7a09088940$export$a5132300c5214280);
};
const $9e67f38435565e11$export$db5174c7538abe4b = ()=>{
    const [isAiEnabledForIssue] = (0, $koiRX.useIssueContextIsAiEnabledForIssue)();
    return isAiEnabledForIssue;
};
const $9e67f38435565e11$export$cf5fc815f761fb4b = ()=>{
    const issueKey = $9e67f38435565e11$export$22108eca27445997();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    return [
        (0, $2vSU6.SOFTWARE_PROJECT),
        (0, $2vSU6.CORE_PROJECT)
    ].some((type)=>type === projectType);
};

});
parcelRegister("93Yeu", function(module, exports) {

$parcel$export(module.exports, "useProjectKey", () => $5f0f9360597cdbd8$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectContextActions", () => $5f0f9360597cdbd8$export$bd73624ca941f105);
$parcel$export(module.exports, "useProjectType", () => $5f0f9360597cdbd8$export$6de29d851c914935);
$parcel$export(module.exports, "useProjectContext", () => $5f0f9360597cdbd8$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useApplication", () => $5f0f9360597cdbd8$export$aaf75bb403fe1fb5);
$parcel$export(module.exports, "useEdition", () => $5f0f9360597cdbd8$export$d56c02945cf5a9e5);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $5f0f9360597cdbd8$export$524ef4f6102ed540);
$parcel$export(module.exports, "useIsClassicProject", () => $5f0f9360597cdbd8$export$e2cf96f40a8867ce);
$parcel$export(module.exports, "useProjectId", () => $5f0f9360597cdbd8$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectStatus", () => $5f0f9360597cdbd8$export$30f16f2782a4113b);
$parcel$export(module.exports, "useProjectConfiguration", () => $5f0f9360597cdbd8$export$af19ad68b52fa1a6);
$parcel$export(module.exports, "useProjectIssueTypes", () => $5f0f9360597cdbd8$export$80bef597b440cf71);

var $5uXOq = parcelRequire("5uXOq");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $g5X3G = parcelRequire("g5X3G");

var $9OXo1 = parcelRequire("9OXo1");

var $buby4 = parcelRequire("buby4");

var $1daUm = parcelRequire("1daUm");
const $5f0f9360597cdbd8$export$f87be37f8e8be65 = (issueKey)=>(0, $g5X3G.toProjectKey)(issueKey.split('-')[0]);
const $5f0f9360597cdbd8$export$bd73624ca941f105 = ()=>{
    const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, $buby4.useProjectContextActionStore)();
    const actions = (0, $5uXOq.useMemo)(()=>({
            setProjectContext: setProjectContext,
            mergeProjectProperty: mergeProjectProperty
        }), [
        setProjectContext,
        mergeProjectProperty
    ]);
    return [
        null,
        actions
    ];
};
const $5f0f9360597cdbd8$export$6de29d851c914935 = (projectKey)=>{
    const [projectType] = (0, $buby4.useProjectContextProjectTypeStore)({
        projectKey: projectKey
    });
    return projectType;
};
const $5f0f9360597cdbd8$export$27e24febf0f5c3bc = (projectKey)=>{
    const [projectStyle] = (0, $buby4.useProjectContextJiraProjectStyleStore)({
        projectKey: projectKey
    });
    return projectStyle;
};
const $5f0f9360597cdbd8$export$8f31c2503e1efa93 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext;
};
const $5f0f9360597cdbd8$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
    const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
    if (projectType === undefined) {
        if (failSafely) return undefined;
        throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
    }
    return (0, $efvDm.getApplicationForProject)(projectType);
};
const $5f0f9360597cdbd8$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
    const { appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    const application = $5f0f9360597cdbd8$export$aaf75bb403fe1fb5(projectKey, failSafely);
    if (!application) return undefined;
    return (0, $ldyPw.getEdition)(application, appEditions);
};
const $5f0f9360597cdbd8$export$524ef4f6102ed540 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.isSimplified || false;
};
const $5f0f9360597cdbd8$export$e2cf96f40a8867ce = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return !projectContext?.isSimplified;
};
const $5f0f9360597cdbd8$export$16d1475ed6c26568 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectId;
};
const $5f0f9360597cdbd8$export$30f16f2782a4113b = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectStatus;
};
const $5f0f9360597cdbd8$export$af19ad68b52fa1a6 = (projectKey)=>{
    const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
    const isSimplified = $5f0f9360597cdbd8$export$524ef4f6102ed540(projectKey);
    return (0, $1daUm.getIssueConfiguration)({
        isSimplified: isSimplified,
        projectType: projectType
    });
};
const $5f0f9360597cdbd8$export$654dd2c557853fbe = (projectKey)=>{
    const [projectName] = (0, $buby4.useProjectContextProjectNameStore)({
        projectKey: projectKey
    });
    return projectName;
};
const $5f0f9360597cdbd8$export$80bef597b440cf71 = (projectKey)=>{
    const [issueTypes] = (0, $buby4.useProjectContextIssueTypesStore)({
        projectKey: projectKey
    });
    return issueTypes;
};

});
parcelRegister("buby4", function(module, exports) {

$parcel$export(module.exports, "useProjectContextActionStore", () => $42c27dedc1310bb2$export$9afb89c1fe103bbe);
$parcel$export(module.exports, "useProjectContextStore", () => $42c27dedc1310bb2$export$8b09478b33186ec);
$parcel$export(module.exports, "useProjectContextProjectTypeStore", () => $42c27dedc1310bb2$export$f2e1ed3b2b4707cb);
$parcel$export(module.exports, "useProjectContextJiraProjectStyleStore", () => $42c27dedc1310bb2$export$b291cf203d6481a4);
$parcel$export(module.exports, "useProjectContextProjectNameStore", () => $42c27dedc1310bb2$export$9469fde70658518);
$parcel$export(module.exports, "useProjectContextIssueTypesStore", () => $42c27dedc1310bb2$export$f73e9904779f6be5);

var $2vSU6 = parcelRequire("2vSU6");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $aDpiK = parcelRequire("aDpiK");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $42c27dedc1310bb2$var$initialState = {};
const $42c27dedc1310bb2$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'project-context',
    initialState: $42c27dedc1310bb2$var$initialState,
    actions: $aDpiK
});
const $42c27dedc1310bb2$export$9afb89c1fe103bbe = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: null
});
const $42c27dedc1310bb2$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
const $42c27dedc1310bb2$export$8b09478b33186ec = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectContext
});
const $42c27dedc1310bb2$var$getProjectType = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectType;
};
const $42c27dedc1310bb2$var$getJiraProjectStyle = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.isSimplified ? (0, $2vSU6.TEAM_MANAGED_PROJECT) : (0, $2vSU6.COMPANY_MANAGED_PROJECT);
};
const $42c27dedc1310bb2$export$f2e1ed3b2b4707cb = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectType
});
const $42c27dedc1310bb2$export$b291cf203d6481a4 = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getJiraProjectStyle
});
const $42c27dedc1310bb2$var$getProjectName = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectName;
};
const $42c27dedc1310bb2$export$9469fde70658518 = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectName
});
const $42c27dedc1310bb2$var$getIssueTypes = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.issueTypes;
};
const $42c27dedc1310bb2$export$f73e9904779f6be5 = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getIssueTypes
});

});
parcelRegister("aDpiK", function(module, exports) {

$parcel$export(module.exports, "setProjectContext", () => $ad16c28ce51d4ccf$export$d64151aab9ae5f09);
$parcel$export(module.exports, "mergeProjectProperty", () => $ad16c28ce51d4ccf$export$78f1c6052937615f);
const $ad16c28ce51d4ccf$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: projectContext
        });
    };
const $ad16c28ce51d4ccf$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentProjectContext = currentState[key];
        const newProjectContext = {
            ...currentProjectContext,
            ...projectContext
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: newProjectContext
        });
    };

});


parcelRegister("1daUm", function(module, exports) {

$parcel$export(module.exports, "getIssueConfiguration", () => $7afb7a15cd46bd62$export$902f6c5cc939598a);

var $65mz3 = parcelRequire("65mz3");

var $2vSU6 = parcelRequire("2vSU6");
const $7afb7a15cd46bd62$export$cdbd1eb3b05729e0 = 'flagActions';
const $7afb7a15cd46bd62$export$c161a774ec2e7e56 = 'cardCoverActions';
const $7afb7a15cd46bd62$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $7afb7a15cd46bd62$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $65mz3.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $65mz3.default).SOFTWARE_ISSUE,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $65mz3.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0,
            $7afb7a15cd46bd62$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $65mz3.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $65mz3.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $7afb7a15cd46bd62$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $65mz3.default).MOBILE_ISSUE,
        issueActions: []
    });
const $7afb7a15cd46bd62$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $65mz3.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (config.isSimplified) return $7afb7a15cd46bd62$export$aebf676dfa727a1c();
            return $7afb7a15cd46bd62$export$27e0678365e5dcff();
        case 0, $2vSU6.CORE_PROJECT:
            return $7afb7a15cd46bd62$export$381ce08838c53afa();
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $7afb7a15cd46bd62$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $7afb7a15cd46bd62$export$27e0678365e5dcff();
    }
    return $7afb7a15cd46bd62$export$27e0678365e5dcff();
};

});


parcelRegister("7trqb", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $5fcaa3f734e9c444$export$268651a63abe408a);

var $9OXo1 = parcelRequire("9OXo1");
const $5fcaa3f734e9c444$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("hqBSi", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $7564850c0894983d$export$54d534cc91e54850);

var $9OXo1 = parcelRequire("9OXo1");
const $7564850c0894983d$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("koiRX", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $35da250daae5206d$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $35da250daae5206d$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $35da250daae5206d$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $35da250daae5206d$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $35da250daae5206d$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $35da250daae5206d$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $35da250daae5206d$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $35da250daae5206d$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $35da250daae5206d$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $35da250daae5206d$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $35da250daae5206d$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $35da250daae5206d$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $35da250daae5206d$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $35da250daae5206d$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $35da250daae5206d$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $35da250daae5206d$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $35da250daae5206d$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $35da250daae5206d$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $35da250daae5206d$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $35da250daae5206d$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $35da250daae5206d$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $35da250daae5206d$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $35da250daae5206d$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiEnabledForIssue", () => $35da250daae5206d$export$455ae7fd9d68b157);
$parcel$export(module.exports, "IssueContextContainer", () => $35da250daae5206d$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $35da250daae5206d$export$965360ae27fcae98);

var $g5X3G = parcelRequire("g5X3G");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $fMAcJ = parcelRequire("fMAcJ");

var $iElCl = parcelRequire("iElCl");

var $edJtc = parcelRequire("edJtc");
const $35da250daae5206d$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $g5X3G.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $edJtc.getViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false,
    isAiEnabledForIssue: false
};
const $35da250daae5206d$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-context',
    initialState: $35da250daae5206d$export$d4c72bab9d6cc13a,
    actions: $fMAcJ.actions
});
const $35da250daae5206d$var$getIssueContext = (state)=>state;
const $35da250daae5206d$var$getIsModal = (state)=>state.isModal;
const $35da250daae5206d$var$getIssueKey = (state)=>state.issueKey;
const $35da250daae5206d$var$getIsArchived = (state)=>state.isArchived;
const $35da250daae5206d$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $35da250daae5206d$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $35da250daae5206d$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $35da250daae5206d$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $35da250daae5206d$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $35da250daae5206d$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $35da250daae5206d$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $35da250daae5206d$var$getIsLoading = (state)=>state.isLoading;
const $35da250daae5206d$var$getViewMode = (state)=>state.viewMode;
const $35da250daae5206d$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $35da250daae5206d$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $35da250daae5206d$var$getBoardId = (state)=>state.boardId;
const $35da250daae5206d$var$getBoardType = (state)=>state.boardType;
const $35da250daae5206d$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $35da250daae5206d$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $35da250daae5206d$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $35da250daae5206d$var$getRapidViewId = (state)=>state.rapidViewId;
const $35da250daae5206d$var$getViewScreenId = (state)=>state.viewScreenId;
const $35da250daae5206d$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $35da250daae5206d$var$getisAiEnabledForIssue = (state)=>Boolean(state.isAiEnabledForIssue);
const $35da250daae5206d$export$f6e0a3ee03299fbc = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueContext
});
const $35da250daae5206d$export$abdbea56d86b4aac = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: (0, $iElCl.getChildIssuesLimit)
});
const $35da250daae5206d$export$326ff2b963d51c5c = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: (0, $iElCl.getChildIssuesIssueLimitUrls)
});
const $35da250daae5206d$export$44bcaaabb74e402b = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueKey
});
const $35da250daae5206d$export$332dcee0cf9f4e45 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueId
});
const $35da250daae5206d$export$c940355b1fc6e1c4 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsArchived
});
const $35da250daae5206d$export$b9eebaa1da421997 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsClassifyEditEnabled
});
const $35da250daae5206d$export$daa47fd600e43a32 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsModal
});
const $35da250daae5206d$export$ba2e9546ab5ba6f = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getViewScreenId
});
const $35da250daae5206d$export$74d38d6c437efc1b = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getAnalyticsSource
});
const $35da250daae5206d$export$2092528ee170d9e7 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getRapidViewMap
});
const $35da250daae5206d$export$57898374e6239a5a = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getMaxTokenLength
});
const $35da250daae5206d$export$ff0264ec4c015dc1 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsLoadedWithPage
});
const $35da250daae5206d$export$6c8b81f6dca8c23d = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getEstimationStatistic
});
const $35da250daae5206d$export$fe7085456138f0fc = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsLoading
});
const $35da250daae5206d$export$c339e36468c12443 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getViewMode
});
const $35da250daae5206d$export$ef3bfa2642bb98cd = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getBackButtonUrl
});
const $35da250daae5206d$export$8accd063c74cd455 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueNavigatorData
});
const $35da250daae5206d$export$e7edffc2a20027e7 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getBoardId
});
const $35da250daae5206d$export$48aaa3a6bc2085d7 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getBoardType
});
const $35da250daae5206d$export$4a4b96bcf5166327 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsSpaEnabled
});
const $35da250daae5206d$export$bbd8ba0180545556 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getLoginRedirectUrl
});
const $35da250daae5206d$export$aaa89627762c7d00 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getOnIssueKeyChange
});
const $35da250daae5206d$export$796589b0ec52848a = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getRapidViewId
});
const $35da250daae5206d$export$7e70ee570119a0a7 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsAiOptInEnabled
});
const $35da250daae5206d$export$455ae7fd9d68b157 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getisAiEnabledForIssue
});
const $35da250daae5206d$export$93db6a8f3342dddf = (0, $gg7kZ.createContainer)($35da250daae5206d$export$6f57813fe9f31bf9);
const $35da250daae5206d$export$965360ae27fcae98 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("fMAcJ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $043cabfbcc6107f0$export$e324594224ef24da);

var $7l48d = parcelRequire("7l48d");

var $iElCl = parcelRequire("iElCl");

var $edJtc = parcelRequire("edJtc");
const $043cabfbcc6107f0$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || getState().viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || getState().viewMode
        });
    };
const $043cabfbcc6107f0$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $043cabfbcc6107f0$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $iElCl.getChildIssuesLimit)(getState());
const $043cabfbcc6107f0$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $043cabfbcc6107f0$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $043cabfbcc6107f0$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $043cabfbcc6107f0$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $043cabfbcc6107f0$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $043cabfbcc6107f0$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $043cabfbcc6107f0$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7l48d.localStorage).set((0, $7l48d.VIEW_MODE_STORAGE_KEY), 'MODAL');
        setState({
            viewMode: 'MODAL'
        });
    };
const $043cabfbcc6107f0$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7l48d.localStorage).set((0, $7l48d.VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
        setState({
            viewMode: 'SIDEBAR'
        });
    };
const $043cabfbcc6107f0$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $edJtc.getViewModeFromLocalStorage)()
        });
    };
const $043cabfbcc6107f0$export$e324594224ef24da = {
    setIssueContext: $043cabfbcc6107f0$export$784a03c4b74da53e,
    mergeIssueContext: $043cabfbcc6107f0$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $043cabfbcc6107f0$export$89b6937a83edcaa6,
    getMaxTokenLength: $043cabfbcc6107f0$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $043cabfbcc6107f0$export$2fe981b90be13483,
    getBackButtonUrl: $043cabfbcc6107f0$export$afce556782490aae,
    getIsSpaEnabled: $043cabfbcc6107f0$export$711dfa096bf81f2d,
    getIssueKey: $043cabfbcc6107f0$export$4a030f6192bebe03,
    getIsArchived: $043cabfbcc6107f0$export$b41341ac6c74ca6,
    setDetailViewAsModal: $043cabfbcc6107f0$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $043cabfbcc6107f0$export$b303af51de56a0e,
    resetDetailView: $043cabfbcc6107f0$export$75007d125f198b78
};

});
parcelRegister("7l48d", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $e736233a6ed098e3$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $e736233a6ed098e3$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $e736233a6ed098e3$export$a13f7f627010bccd);

var $bSSG7 = parcelRequire("bSSG7");
const $e736233a6ed098e3$export$25a759e49d5049db = 'issue.issue-context-service';
const $e736233a6ed098e3$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('jira_issue_view');
const $e736233a6ed098e3$export$a13f7f627010bccd = 'view-mode';

});

parcelRegister("iElCl", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $fde75c94a28741e3$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $fde75c94a28741e3$export$8f43520910e8128c);

var $dJl1T = parcelRequire("dJl1T");

var $7l48d = parcelRequire("7l48d");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData(`${(0, $7l48d.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $fde75c94a28741e3$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $fde75c94a28741e3$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});

parcelRegister("edJtc", function(module, exports) {

$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $75ce4ce78f606e67$export$cae7c4c591dcc261);

var $7l48d = parcelRequire("7l48d");
const $75ce4ce78f606e67$export$cae7c4c591dcc261 = ()=>{
    if (false) return 'DEFAULT';
    return (0, $7l48d.localStorage).get((0, $7l48d.VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';
};

});




parcelRegister("3fAi8", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $ddbc380ab4ee430c$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $ddbc380ab4ee430c$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $ddbc380ab4ee430c$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $ddbc380ab4ee430c$export$612d9bcb0c9d8976);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
        });
    };
const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $ddbc380ab4ee430c$var$actions = {
    setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
    getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
    setIssue: $ddbc380ab4ee430c$var$setIssue,
    mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
    setIssues: $ddbc380ab4ee430c$var$setIssues,
    mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
};
// this is a global store
const $ddbc380ab4ee430c$var$store = (0, $iXqE5.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $ddbc380ab4ee430c$var$actions
});
const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getAllFields
});
const $ddbc380ab4ee430c$export$ac289b84121829df = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, $51nlc.createSubscriber)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: null
});
const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("41gqO", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $b08b2795aecf222d$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $b08b2795aecf222d$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $b08b2795aecf222d$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $b08b2795aecf222d$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $b08b2795aecf222d$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $b08b2795aecf222d$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $b08b2795aecf222d$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $b08b2795aecf222d$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $b08b2795aecf222d$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $b08b2795aecf222d$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $b08b2795aecf222d$export$ad3536b13febb432);
const $b08b2795aecf222d$export$99ad62164189f781 = 'ecosystemGlance';
const $b08b2795aecf222d$export$7719ef6e9283671 = 'forgeGlance';
const $b08b2795aecf222d$export$bfebea5ce2e1887a = 'ecosystemContext';
const $b08b2795aecf222d$export$be8e68fb1aed253e = 'forgeContext';
const $b08b2795aecf222d$export$7bf561e6ab380ea1 = 'context';
const $b08b2795aecf222d$export$f42c11634d75863e = 'content';
const $b08b2795aecf222d$export$b38842736b6dbc1d = 'content-request';
const $b08b2795aecf222d$export$bc9fa2d93b5fabae = 'FIELD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$STATUS_TYPE = 'STATUS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$TAB_TYPE = 'TAB';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$PANEL_TYPE = 'PANEL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$FORGE_TYPE = 'FORGE';
const $b08b2795aecf222d$export$605c43f1b33ab69 = 'SUMMARY';
const $b08b2795aecf222d$export$e655b77b9efe622f = 'CustomItem';
const $b08b2795aecf222d$export$5cf403de05e9bea = 'FieldSectionItem';
const $b08b2795aecf222d$export$30f7f9a86f182492 = 'TabLayout';
const $b08b2795aecf222d$export$196e597ad9a97f7a = 'PanelSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $b08b2795aecf222d$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $b08b2795aecf222d$export$ad3536b13febb432 = (node)=>node.type === $b08b2795aecf222d$export$5507f31126c8b283.tab;

});

parcelRegister("awmXl", function(module, exports) {

$parcel$export(module.exports, "FORGE_ENTITY_TYPE", () => $c65c130bf8cdb044$export$6f3804b3f188f650);
$parcel$export(module.exports, "CONNECT_ENTITY_TYPE", () => $c65c130bf8cdb044$export$1b2059a011c9174d);
const $c65c130bf8cdb044$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';
const $c65c130bf8cdb044$export$1b2059a011c9174d = 'CONNECT_ENTITY_TYPE';
const $c65c130bf8cdb044$export$38f0fc1cf1f24cba = [
    $c65c130bf8cdb044$export$6f3804b3f188f650,
    $c65c130bf8cdb044$export$1b2059a011c9174d
];

});

/**
 * Opt into the new issue view modal key. To be cleaned up with issue.details.opt-back-in
 * This key is stored in the API and should not be renamed.
 * @see https://hello.atlassian.net/wiki/spaces/JIE/pages/920124493/How+to+re-set+new+Bento+Change+Boarding#Re-set-Opt-In-Back-Modal
 */ const $acf4ef636a959927$export$a3338d0a4845edfa = 'jira.details.opt-in-back.next-reminding-date';
const $acf4ef636a959927$export$26de4b42c139644c = 'jira.user.issue.should.show.welcome.message';
const $acf4ef636a959927$export$ece45f325779a5d5 = 'jira.user.issue.opt.in.back.modal.has.dismissed';
const $acf4ef636a959927$export$4603581e6066a63f = 'jira.user.issue.opt.in.back.banner.has.dismissed';
const $acf4ef636a959927$export$af60a7ae4202be66 = 'issue-details-changeboarding';
const $acf4ef636a959927$export$7b98e5a33c854454 = 30;
const $acf4ef636a959927$export$956fcd3a2e5c48a8 = 'SOFTWARE_ISSUE_STATUS';
const $acf4ef636a959927$export$ebb7dcd60318cfac = 'SERVICEDESK_ISSUE_STATUS';
const $acf4ef636a959927$export$a446d697df3d6b2c = 'SERVICEDESK_REQUEST_PANEL';
const $acf4ef636a959927$export$d3dadb39db0c423 = 'SERVICEDESK_CREATE_COMMENT_ACTIONS';
const $acf4ef636a959927$export$75867eab2abae162 = 'SERVICEDESK_PLACEHOLDER_CREATE_COMMENT_ACTIONS';
const $acf4ef636a959927$export$483d9bcbbd8280a6 = 'status-spotlight';
const $acf4ef636a959927$export$95f98990d7202b31 = 'SHOW_MORE';
const $acf4ef636a959927$export$95ff4d03075475e2 = 'PIN_FIELD';
const $acf4ef636a959927$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $acf4ef636a959927$export$6f48b612d5c03f4d = 'PERMALINK';
const $acf4ef636a959927$export$d84e7970e2d564af = 'BOARD_SIDEBAR';
const $acf4ef636a959927$export$fa5ad81958817beb = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.details-group';
const $acf4ef636a959927$export$1ba8bc5ff9e50d09 = 'QUICK_ADDS';
const $acf4ef636a959927$export$f9baa44349b5d6b8 = 'JSW_ACTIVITY_FEED_BUTTONS';
const $acf4ef636a959927$export$f49830a0e4ffb3f9 = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.sla-group';
const $acf4ef636a959927$export$efb12103a5e32a1e = 'PIN_FIELD_PLACEHOLDER_BANNER';
const $acf4ef636a959927$export$4288bce987c22af4 = 'PINNED_FIELDS_PANEL';
const $acf4ef636a959927$export$ddb80c23a62a41e = 'jira.user.issue.has.seen.quick-actions.change-boarding.message';

parcelRegister("cUUmI", function(module, exports) {

$parcel$export(module.exports, "isForgeField", () => $15b9f0b6efc77660$export$f4484ef180517e0e);
$parcel$export(module.exports, "getForgeFieldType", () => $15b9f0b6efc77660$export$3f8bcfe7fea0362a);

var $561FV = parcelRequire("561FV");

var $hGgHi = parcelRequire("hGgHi");

var $5fc53 = parcelRequire("5fc53");
const $15b9f0b6efc77660$export$f4484ef180517e0e = (field)=>field && (0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(field, 'schema.custom') && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(field.schema.custom) && field.schema.custom.includes('ari:cloud:ecosystem::extension');
const $15b9f0b6efc77660$export$3f8bcfe7fea0362a = (field)=>{
    if (!$15b9f0b6efc77660$export$f4484ef180517e0e(field)) return null;
    if (false) return field.schema.type;
    return 0, $5fc53.FORGE_CUSTOM_FIELD_TYPE;
};

});

parcelRegister("2ewrm", function(module, exports) {

$parcel$export(module.exports, "useForgeGlances", () => $27dec4fa64c988e8$export$dc79f3e7b8a6c3e1);
$parcel$export(module.exports, "useForgeContextPanels", () => $27dec4fa64c988e8$export$a1a589b738ca01b8);
$parcel$export(module.exports, "useForgeDataComplete", () => $27dec4fa64c988e8$export$db75d05b888b2963);
$parcel$export(module.exports, "useForgeCustomField", () => $27dec4fa64c988e8$export$2a006c08e9ab6fc3);
$parcel$export(module.exports, "useForgeActions", () => $27dec4fa64c988e8$export$4f3ebb446fd03f21);
$parcel$export(module.exports, "useForgeLoadingFailed", () => $27dec4fa64c988e8$export$25b2fc6a75c5447b);
$parcel$export(module.exports, "useForgeUimModules", () => $27dec4fa64c988e8$export$37d5ed3ba137e5df);
$parcel$export(module.exports, "useHasBlockedExtensions", () => $27dec4fa64c988e8$export$955dca49c49bfb60);
$parcel$export(module.exports, "useBlockedExtensions", () => $27dec4fa64c988e8$export$61349d0d8e89be3);
$parcel$export(module.exports, "useIsForgeDataEmpty", () => $27dec4fa64c988e8$export$57f2fa4b04feb8c2);

var $5uXOq = parcelRequire("5uXOq");

var $fr1K2 = parcelRequire("fr1K2");

var $f7nug = parcelRequire("f7nug");

var $dknBT = parcelRequire("dknBT");
const $27dec4fa64c988e8$export$dc79f3e7b8a6c3e1 = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    return [
        forge.issueGlance
    ];
};
const $27dec4fa64c988e8$export$a1a589b738ca01b8 = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    return [
        forge.issueContext
    ];
};
const $27dec4fa64c988e8$export$db75d05b888b2963 = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    return [
        forge.isForgeDataComplete
    ];
};
const $27dec4fa64c988e8$export$1a3a35919478733d = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    return [
        [
            ...forge.customField,
            ...forge.customFieldType
        ]
    ];
};
const $27dec4fa64c988e8$export$2a006c08e9ab6fc3 = (extensionId)=>{
    const [customFieldExtensions] = $27dec4fa64c988e8$export$1a3a35919478733d();
    return (0, $f7nug.useMemoizedStateObject)((0, $5uXOq.useMemo)(()=>customFieldExtensions.find((ext)=>ext.id === extensionId), [
        customFieldExtensions,
        extensionId
    ]));
};
const $27dec4fa64c988e8$export$4f3ebb446fd03f21 = ()=>{
    const [, actions] = (0, $dknBT.useForgeActionsStore)();
    return [
        undefined,
        actions
    ];
};
const $27dec4fa64c988e8$export$25b2fc6a75c5447b = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    return forge.isForgeLoadingFailed;
};
const $27dec4fa64c988e8$export$37d5ed3ba137e5df = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    return forge.uiModifications;
};
const $27dec4fa64c988e8$export$955dca49c49bfb60 = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!forge.blockedExtensions) return false;
        const toOmit = [
            'issueViewBackgroundScript',
            'uiModifications'
        ];
        return Object.values((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(forge.blockedExtensions, toOmit)).some((blockedExtensions)=>blockedExtensions.length > 0);
    }, [
        forge.blockedExtensions
    ]);
};
const $27dec4fa64c988e8$export$61349d0d8e89be3 = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    return forge.blockedExtensions;
};
const $27dec4fa64c988e8$export$57f2fa4b04feb8c2 = ()=>{
    const [forge] = (0, $dknBT.useForgeStore)();
    const isExtensionsEmpty = Object.keys(forge).every((key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        Array.isArray(forge[key]) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        forge[key].length === 0 : true);
    const isBlockedExtensionsEmpty = Object.keys(forge.blockedExtensions).every(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (key)=>forge.blockedExtensions[key].length === 0);
    return isExtensionsEmpty && isBlockedExtensionsEmpty;
};

});
parcelRegister("f7nug", function(module, exports) {

$parcel$export(module.exports, "useMemoizedStateObject", () => $8c9f7903bb5ef000$export$cc725e2aa41de44a);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");
const $8c9f7903bb5ef000$export$cc725e2aa41de44a = (data, equalityCheck = (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))))=>{
    const memoizedData = (0, $5uXOq.useRef)(data);
    return (0, $5uXOq.useMemo)(()=>{
        if (!equalityCheck(data, memoizedData.current)) {
            memoizedData.current = data;
            return data;
        }
        return memoizedData.current;
    }, [
        data,
        equalityCheck
    ]);
};

});

parcelRegister("dknBT", function(module, exports) {

$parcel$export(module.exports, "useForgeStore", () => $2746553070b63d5f$export$10f3118dc1498dfc);
$parcel$export(module.exports, "useForgeActionsStore", () => $2746553070b63d5f$export$7dd6be1114d73937);
$parcel$export(module.exports, "ForceStoreContainer", () => $2746553070b63d5f$export$540c057b33607be9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $e1HQk = parcelRequire("e1HQk");
const $2746553070b63d5f$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-view-layout-forge-apps-service',
    initialState: {
        issueGlance: [],
        issueContext: [],
        issueAction: [],
        issuePanel: [],
        issueActivity: [],
        customField: [],
        issueViewBackgroundScript: [],
        customFieldType: [],
        activeAction: null,
        uiModifications: [],
        isForgeLoadingFailed: false,
        isForgeDataComplete: false,
        blockedExtensions: {
            issueGlance: [],
            issueContext: [],
            issueAction: [],
            issuePanel: [],
            issueActivity: [],
            customField: [],
            issueViewBackgroundScript: [],
            customFieldType: [],
            uiModifications: []
        },
        // Not rate limited
        forgeRateLimitedUntil: 0,
        failedEventsCount: 0
    },
    actions: $e1HQk
});
const $2746553070b63d5f$export$10f3118dc1498dfc = (0, $3sQ5x.createHook)($2746553070b63d5f$export$6f57813fe9f31bf9);
const $2746553070b63d5f$export$7dd6be1114d73937 = (0, $3sQ5x.createHook)($2746553070b63d5f$export$6f57813fe9f31bf9, {
    selector: null
});
const $2746553070b63d5f$export$540c057b33607be9 = (0, $gg7kZ.createContainer)($2746553070b63d5f$export$6f57813fe9f31bf9);

});
parcelRegister("e1HQk", function(module, exports) {

$parcel$export(module.exports, "setForge", () => $02561657ceb6a564$export$8307a9da1b91b3b4);
$parcel$export(module.exports, "setForgeLoadingFailed", () => $02561657ceb6a564$export$7ff580b28fd472d0);
const $02561657ceb6a564$export$8307a9da1b91b3b4 = (forge)=>({ setState: setState })=>{
        setState(forge);
    };
const $02561657ceb6a564$export$7ff580b28fd472d0 = ()=>({ setState: setState })=>{
        setState({
            isForgeLoadingFailed: true
        });
    };

});



const $f17db2727085e590$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';

parcelRegister("vuOaC", function(module, exports) {

$parcel$export(module.exports, "getPanels", () => $61748c84e0a1e553$export$be078297eeb6e8a2);
$parcel$export(module.exports, "isEmpty", () => $61748c84e0a1e553$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "getAtlassianCustomFieldType", () => $61748c84e0a1e553$export$f521834fc2bfcd81);
$parcel$export(module.exports, "fieldTypeHandler", () => $61748c84e0a1e553$export$b2cc0ead6ce019e3);
$parcel$export(module.exports, "getFieldType", () => $61748c84e0a1e553$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "addGlobalRefToLayoutContainerTemplateItems", () => $61748c84e0a1e553$export$fa197d31f946730e);
$parcel$export(module.exports, "isUnsupportedItem", () => $61748c84e0a1e553$export$3d38168d24278ebb);

var $8LQ84 = parcelRequire("8LQ84");

var $hGgHi = parcelRequire("hGgHi");

var $1QOns = parcelRequire("1QOns");

var $8QpSo = parcelRequire("8QpSo");

var $b4PzF = parcelRequire("b4PzF");

var $4R6GH = parcelRequire("4R6GH");

var $41gqO = parcelRequire("41gqO");


var $cUUmI = parcelRequire("cUUmI");

var $fOGZN = parcelRequire("fOGZN");

var $cNJ33 = parcelRequire("cNJ33");

var $5fc53 = parcelRequire("5fc53");
const $61748c84e0a1e553$export$be078297eeb6e8a2 = ()=>[
        (0, $5fc53.ASSET_ONBOARDING_TYPE),
        (0, $5fc53.DEV_SUMMARY_TYPE),
        (0, $5fc53.KNOWLEDGE_BASE_TYPE),
        ...(0, $4R6GH.fg)('jsm-journey-builder-in-issue-view') ? [
            (0, $5fc53.JOURNEY_PANEL_TYPE)
        ] : [],
        (0, $5fc53.SENTIMENT_TYPE),
        (0, $5fc53.SLA_PANEL_TYPE),
        (0, $5fc53.LINKED_ALERTS_TYPE),
        ...(0, $b4PzF.isFedRamp)() ? [] : [
            (0, $5fc53.CHAT_CHANNEL_TYPE)
        ],
        ...(0, $b4PzF.isFedRamp)() ? [] : [
            (0, $5fc53.MSTEAMS_CHANNEL_TYPE)
        ],
        ...(0, $b4PzF.isFedRamp)() ? [] : [
            (0, $5fc53.ZOOM_MEETING_TYPE)
        ],
        (0, $5fc53.MANAGE_STAKEHOLDERS_TYPE)
    ];
const $61748c84e0a1e553$export$dd1bc94b04021eeb = (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) || (0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(value) && value.length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($1QOns)))(value) && Object.keys(value).length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($1QOns)))(value) && value.type === 'doc' && value.content && Object.keys(value.content).length === 0;
const $61748c84e0a1e553$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $fOGZN.specialFields)();
    return [
        ...(0, $fOGZN.customFieldsToDisplay)().filter((cf)=>!(0, $fOGZN.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $5fc53.FLAGGED_CF_TYPE)
    ];
};
const $61748c84e0a1e553$export$f521834fc2bfcd81 = (custom)=>$61748c84e0a1e553$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $61748c84e0a1e553$export$b2cc0ead6ce019e3 = (fieldConfig, layoutItem)=>{
    const id = (0, $cNJ33.getLayoutItemId)(layoutItem);
    const { type: type } = layoutItem;
    if (type === (0, $41gqO.layoutContainerItemTypes).tab || type === (0, $5fc53.ECOSYSTEM_GLANCE_TYPE) || type === (0, $5fc53.FORGE_GLANCE_TYPE) || type === (0, $5fc53.ECOSYSTEM_CONTEXT_TYPE) || type === (0, $41gqO.FORGE_CONTEXT_TYPE)) return {
        type: type,
        id: id
    };
    if ($61748c84e0a1e553$export$be078297eeb6e8a2().includes(id)) return {
        id: id,
        type: id
    };
    const forgeCustomField = (0, $cUUmI.getForgeFieldType)(fieldConfig);
    if (forgeCustomField !== null) return {
        type: forgeCustomField,
        id: id
    };
    const fieldSchema = fieldConfig?.schema || {};
    const systemType = fieldSchema.system !== null ? fieldSchema.system : '';
    return {
        type: $61748c84e0a1e553$export$f521834fc2bfcd81(fieldSchema.custom) || systemType || fieldSchema.type,
        id: id
    };
};
const $61748c84e0a1e553$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $61748c84e0a1e553$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
/**
 * We can't directly identify `Affected services`, `Change risk` or `Impact`, but we can
 * minimise the number of extra targets by wrapping only 'select' type fields since the above
 * all fit that criteria. `Description` fortunately has a custom type to identify it
 */ const $61748c84e0a1e553$var$fieldsWithGlobalTargets = [
    (0, $5fc53.DESCRIPTION_TYPE),
    (0, $5fc53.SELECT_CF_TYPE),
    (0, $5fc53.SERVICE_ENTITY_CF_TYPE)
];
const $61748c84e0a1e553$export$fa197d31f946730e = (// Use generic to constrain return type, e.g., passing ContextPanelItem should not return LayoutContainerTemplateItem
items, issueFieldsConfig)=>{
    if (!items || !issueFieldsConfig) return [];
    return items.map((item)=>{
        const { type: type, id: id } = $61748c84e0a1e553$export$b2cc0ead6ce019e3(issueFieldsConfig[(0, $cNJ33.getLayoutItemId)(item)], item);
        if ($61748c84e0a1e553$var$fieldsWithGlobalTargets.includes(type)) return {
            ...item,
            globalRef: `${0, $135ded4f9a1460dc$export$2028cf1423b28cf8}${id}`
        };
        return item;
    });
};
// This typing exists to ensure that we include fields here when adding new ones.
const $61748c84e0a1e553$var$getBaseSupportedItems = (0, $8QpSo.default)(()=>{
    return {
        // @ts-expect-error - TS2322 - Type '{ ecosystemGlance: boolean; forgeGlance: boolean; "com.pyxis.greenhopper.jira:gh-epic-status": true; "com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect": true; assignee: true; ... 75 more ...; "com.pyxis.greenhopper.jira:gh-epic-label": true; }' is not assignable to type 'CheckFieldTypeDefinitions<CheckedLegacyFieldTypeDefinitions<boolean>, IgnoredFieldChecks<boolean>>'.
        [(0, $5fc53.ECOSYSTEM_GLANCE_TYPE)]: true,
        [(0, $5fc53.FORGE_GLANCE_TYPE)]: true,
        [(0, $41gqO.FORGE_CONTEXT_TYPE)]: true,
        [(0, $5fc53.ECOSYSTEM_CONTEXT_TYPE)]: true,
        [(0, $5fc53.EPIC_STATUS_TYPE)]: true,
        [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: true,
        [(0, $5fc53.ASSIGNEE_TYPE)]: true,
        [(0, $5fc53.REPORTER_TYPE)]: true,
        [(0, $5fc53.DESCRIPTION_TYPE)]: true,
        [(0, $5fc53.ENVIRONMENT_TYPE)]: true,
        [(0, $5fc53.DUE_DATE_TYPE)]: true,
        [(0, $5fc53.PRIORITY_TYPE)]: true,
        [(0, $5fc53.LABELS_TYPE)]: true,
        [(0, $5fc53.COMPONENTS_TYPE)]: true,
        [(0, $5fc53.SPRINT_TYPE)]: true,
        [(0, $5fc53.STORY_POINTS_TYPE)]: true,
        [(0, $5fc53.EPIC_TYPE)]: true,
        [(0, $5fc53.FIX_VERSIONS_TYPE)]: true,
        [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: true,
        [(0, $5fc53.TIME_TRACKING_TYPE)]: true,
        [(0, $5fc53.TIME_ESTIMATE_TYPE)]: true,
        [(0, $5fc53.LABELS_CF_TYPE)]: true,
        [(0, $5fc53.TEXT_CF_TYPE)]: true,
        [(0, $5fc53.MULTI_USER_CF_TYPE)]: true,
        [(0, $5fc53.PARTICIPANTS_CF_TYPE)]: true,
        [(0, $5fc53.URL_CF_TYPE)]: true,
        [(0, $5fc53.NUMBER_CF_TYPE)]: true,
        [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: true,
        [(0, $5fc53.SELECT_CF_TYPE)]: true,
        [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: true,
        [(0, $5fc53.VERSION_CF_TYPE)]: true,
        [(0, $5fc53.TEXT_AREA_CF_TYPE)]: true,
        [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: true,
        [(0, $5fc53.DATE_CF_TYPE)]: true,
        [(0, $5fc53.GROUP_CF_TYPE)]: true,
        [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: true,
        [(0, $5fc53.USER_CF_TYPE)]: true,
        [(0, $5fc53.PEOPLE_CF_TYPE)]: true,
        [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: true,
        [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: true,
        [(0, $5fc53.DATETIME_CF_TYPE)]: true,
        [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: true,
        [(0, $5fc53.TEAM_CF_TYPE)]: true,
        [(0, $5fc53.PARENT_CF_TYPE)]: true,
        [(0, $5fc53.PARENT_FIELD_TYPE)]: true,
        [(0, $5fc53.BASELINE_START_CF_TYPE)]: true,
        [(0, $5fc53.BASELINE_END_CF_TYPE)]: true,
        [(0, $5fc53.COLOR_CF_TYPE)]: true,
        [(0, $5fc53.REQUEST_TYPE_CF_TYPE)]: true,
        [(0, $5fc53.APPROVALS_CF_TYPE)]: true,
        [(0, $5fc53.REQUEST_LANGUAGE_CF_TYPE)]: true,
        [(0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE)]: true,
        [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: true,
        [(0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)]: true,
        [(0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)]: true,
        [(0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)]: true,
        [(0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)]: true,
        [(0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE)]: true,
        [(0, $5fc53.ASSETS_CF_TYPE)]: true,
        [(0, $5fc53.SERVICE_ENTITY_CF_TYPE)]: true,
        [(0, $5fc53.APPROVERS_LIST_CF_TYPE)]: true,
        [(0, $5fc53.CMDB_OBJECT_CF_TYPE)]: true,
        [(0, $5fc53.REQUEST_FEEDBACK_CF_TYPE)]: true,
        [(0, $5fc53.ISSUE_FIELD_USER_CF_TYPE)]: true,
        [(0, $5fc53.ISSUE_FIELD_GROUPS_CF_TYPE)]: true,
        [(0, $5fc53.ISSUE_FIELD_STRINGS_CF_TYPE)]: true,
        [(0, $5fc53.READ_ONLY_CF_TYPE)]: true,
        [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: true,
        [(0, $5fc53.FORGE_CUSTOM_FIELD_TYPE)]: true,
        [(0, $5fc53.KNOWLEDGE_BASE_TYPE)]: true,
        [(0, $5fc53.JOURNEY_PANEL_TYPE)]: !false && (0, $4R6GH.fg)('jsm-journey-builder-in-issue-view'),
        [(0, $5fc53.SLA_PANEL_TYPE)]: true,
        [(0, $5fc53.SENTIMENT_TYPE)]: true,
        [(0, $5fc53.DEV_SUMMARY_TYPE)]: true,
        [(0, $5fc53.RELEASES_TYPE)]: true,
        [(0, $5fc53.ASSET_ONBOARDING_TYPE)]: true,
        [(0, $5fc53.LINKED_ALERTS_TYPE)]: true,
        [(0, $5fc53.CHAT_CHANNEL_TYPE)]: !false && !(0, $b4PzF.isFedRamp)(),
        [(0, $5fc53.MSTEAMS_CHANNEL_TYPE)]: !false && !(0, $b4PzF.isFedRamp)(),
        [(0, $5fc53.ZOOM_MEETING_TYPE)]: !false && !(0, $b4PzF.isFedRamp)(),
        [(0, $5fc53.MANAGE_STAKEHOLDERS_TYPE)]: !false,
        [(0, $5fc53.RESPONDERS_CF_TYPE)]: true,
        [(0, $5fc53.MAJOR_INCIDENT_CF_TYPE)]: true,
        [(0, $5fc53.MESSAGE_EDIT_CF_TYPE)]: true,
        [(0, $5fc53.MESSAGE_VIEW_CF_TYPE)]: true,
        [(0, $5fc53.EPIC_NAME_TYPE)]: true,
        [(0, $5fc53.CATEGORY_TYPE)]: true,
        [(0, $5fc53.ENTITLEMENT_CF_TYPE)]: true,
        [(0, $5fc53.SENTIMENT_CF_TYPE)]: true,
        [(0, $5fc53.GOALS_CF_TYPE)]: true,
        [(0, $5fc53.ORGANIZATION_CF_TYPE)]: true
    };
});
const $61748c84e0a1e553$export$3d38168d24278ebb = (type)=>!$61748c84e0a1e553$var$getBaseSupportedItems()[type];

});
parcelRegister("cNJ33", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemId", () => $0c6b6ff40aad7732$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $0c6b6ff40aad7732$export$355607dae809ec65);

var $41gqO = parcelRequire("41gqO");
const $0c6b6ff40aad7732$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $41gqO.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $41gqO.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $41gqO.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $0c6b6ff40aad7732$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($0c6b6ff40aad7732$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $41gqO.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $0c6b6ff40aad7732$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});


parcelRegister("17Gip", function(module, exports) {

$parcel$export(module.exports, "useProjectPermissions", () => $0b32a3d32d712870$export$c6c6b35628cf47a8);
$parcel$export(module.exports, "useCanAdministerProject", () => $0b32a3d32d712870$export$f39ed5a161efa614);
$parcel$export(module.exports, "useCanAdministerJira", () => $0b32a3d32d712870$export$ec12ddafd19b95ac);
$parcel$export(module.exports, "useCanConfigureIssue", () => $0b32a3d32d712870$export$e7267b8a084eadb3);
$parcel$export(module.exports, "useCanUseServiceDeskAgentFeatures", () => $0b32a3d32d712870$export$756d7c97077a2f76);
$parcel$export(module.exports, "useCanDownloadAttachments", () => $0b32a3d32d712870$export$d47dad3a7e3265ea);
$parcel$export(module.exports, "useProjectPermissionsActions", () => $0b32a3d32d712870$export$86c656cdb87052cd);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $khL17 = parcelRequire("khL17");
const $0b32a3d32d712870$export$c6c6b35628cf47a8 = (projectKey)=>{
    const [permissions, { setProjectPermissions: setProjectPermissions }] = (0, $khL17.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const actions = (0, $5uXOq.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        permissions,
        actions
    ];
};
const $0b32a3d32d712870$export$f39ed5a161efa614 = (projectKey)=>{
    const [permissions] = (0, $khL17.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerProject;
};
const $0b32a3d32d712870$export$ec12ddafd19b95ac = (projectKey)=>{
    const [permissions] = (0, $khL17.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerJira;
};
const $0b32a3d32d712870$export$e7267b8a084eadb3 = (projectKey)=>{
    const canConfigureAdministerProject = $0b32a3d32d712870$export$f39ed5a161efa614(projectKey);
    const canAdministerJira = $0b32a3d32d712870$export$ec12ddafd19b95ac(projectKey);
    return canConfigureAdministerProject || canAdministerJira;
};
const $0b32a3d32d712870$export$756d7c97077a2f76 = (projectKey)=>{
    const [permissions] = (0, $khL17.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { appPermissions: appPermissions } = (0, $9OXo1.useTenantContext)();
    return permissions.canUseServiceDeskAgentFeatures && appPermissions?.hasServiceDeskAccess;
};
const $0b32a3d32d712870$export$d47dad3a7e3265ea = (projectKey)=>{
    const [permissions] = (0, $khL17.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canExportIssue;
};
const $0b32a3d32d712870$export$86c656cdb87052cd = ()=>{
    const [, { setProjectPermissions: setProjectPermissions }] = (0, $khL17.useProjectPermissionsStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("khL17", function(module, exports) {

$parcel$export(module.exports, "defaultPermissions", () => $472e428a487a401f$export$ccfee65526b322ca);
$parcel$export(module.exports, "useProjectPermissionsStore", () => $472e428a487a401f$export$4919fa09a3d81224);
$parcel$export(module.exports, "useProjectPermissionsStoreActions", () => $472e428a487a401f$export$e8436ef485b33bdb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $l5qXF = parcelRequire("l5qXF");
const $472e428a487a401f$export$ccfee65526b322ca = {
    canAddComments: false,
    canAdministerJira: false,
    canAdministerProject: false,
    canAssignIssues: false,
    canBeAssignedToIssues: false,
    canCloneIssue: false,
    canCreateAttachments: false,
    canCreateChildren: false,
    canCreateSubtask: false,
    canDeleteAllAttachments: false,
    canDeleteAllComments: false,
    canDeleteAllWorklogs: false,
    canDeleteIssue: false,
    canDeleteOwnAttachments: false,
    canDeleteOwnComments: false,
    canDeleteOwnWorklogs: false,
    canEditAllComments: false,
    canEditAllWorklogs: false,
    canEditIssues: false,
    canEditOwnComments: false,
    canEditOwnWorklogs: false,
    canLinkIssues: false,
    canLogWork: false,
    canManageWatchers: false,
    canMoveIssue: false,
    canModifyReporter: false,
    canScheduleIssues: false,
    canUseServiceDeskAgentFeatures: false,
    canBrowseUsers: false,
    canViewDevTools: false,
    canViewWatchers: false,
    canViewVoters: false,
    canCreateIssuesInClassicProjectEpic: false,
    canResolveIssues: false,
    canExportIssue: false,
    canArchiveIssue: false,
    canUnarchiveIssue: false
};
const $472e428a487a401f$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'project-permissions',
    initialState: {},
    actions: $l5qXF
});
const $472e428a487a401f$var$getProjectPermissionSelector = (state, { projectKey: projectKey })=>state[projectKey] || $472e428a487a401f$export$ccfee65526b322ca;
const $472e428a487a401f$export$4919fa09a3d81224 = (0, $3sQ5x.createHook)($472e428a487a401f$export$6f57813fe9f31bf9, {
    selector: $472e428a487a401f$var$getProjectPermissionSelector
});
const $472e428a487a401f$export$e8436ef485b33bdb = (0, $3sQ5x.createHook)($472e428a487a401f$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("l5qXF", function(module, exports) {

$parcel$export(module.exports, "setProjectPermissions", () => $f3418fe5fb58759f$export$53f5cc27627e5fe3);
const $f3418fe5fb58759f$export$53f5cc27627e5fe3 = (projectKey, permissions)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [projectKey]: permissions
        });
    };

});




parcelRegister("gYUjk", function(module, exports) {

$parcel$export(module.exports, "issueViewBackgroundScriptsSelector", () => $e729124ed69c9647$export$eef935056c1a5112);
$parcel$export(module.exports, "issueContentPanelsSelector", () => $e729124ed69c9647$export$80fcdb58a34c02a8);
$parcel$export(module.exports, "isIssueContentPanelCustomisedSelector", () => $e729124ed69c9647$export$7d77b0f1f3d84166);
$parcel$export(module.exports, "canInstallAddonsSelector", () => $e729124ed69c9647$export$779e1275bbd7ba59);
$parcel$export(module.exports, "isIssueCreatedAfterEcosystemOnSelector", () => $e729124ed69c9647$export$528e2c054f1a65f6);
$parcel$export(module.exports, "contextPanelEntitiesSelector", () => $e729124ed69c9647$export$830512515d42357);
$parcel$export(module.exports, "glancesSelector", () => $e729124ed69c9647$export$d73d3447fc053be);
$parcel$export(module.exports, "ecosystemGlancesSelector", () => $e729124ed69c9647$export$df7140249f849373);
$parcel$export(module.exports, "glancePanelSelector", () => $e729124ed69c9647$export$e8938da368c7c5c4);
$parcel$export(module.exports, "allContentPanelsSelector", () => $e729124ed69c9647$export$7bc028a03185fc96);
$parcel$export(module.exports, "ecosystemAllPanelsSelector", () => $e729124ed69c9647$export$47d3fa7df862ae6f);
$parcel$export(module.exports, "ecosystemAddedContentPanelsSelector", () => $e729124ed69c9647$export$a48c28ad36cb708e);
$parcel$export(module.exports, "selectedContentPanelSelector", () => $e729124ed69c9647$export$1a9c93efcb1ffec7);
$parcel$export(module.exports, "activityPanelsSelector", () => $e729124ed69c9647$export$dd6c9850f9e61a72);
$parcel$export(module.exports, "ecosystemActivityPanelsSelector", () => $e729124ed69c9647$export$9222e43f5478367f);

var $dGvGJ = parcelRequire("dGvGJ");

var $183uB = parcelRequire("183uB");

var $Z1q1o = parcelRequire("Z1q1o");

var $eOKTW = parcelRequire("eOKTW");

var $5cmSg = parcelRequire("5cmSg");

var $awmXl = parcelRequire("awmXl");

var $a2FgJ = parcelRequire("a2FgJ");

var $a1ky2 = parcelRequire("a1ky2");

var $bcoYn = parcelRequire("bcoYn");

var $hKi22 = parcelRequire("hKi22");


var $4L22Y = parcelRequire("4L22Y");

var $lMzxr = parcelRequire("lMzxr");
const $e729124ed69c9647$export$eef935056c1a5112 = (0, $dGvGJ.createSelector)((0, $4L22Y.forgeEntitiesSelector), (forge)=>(forge.backgroundScripts || []).filter((0, $5cmSg.isExtensionVisible)));
const $e729124ed69c9647$export$80fcdb58a34c02a8 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.issueContentPanels || []);
const $e729124ed69c9647$export$7d77b0f1f3d84166 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>!!entities.issueContentPanels && entities.issueContentPanels.includes((0, $ad485f85fe233a83$export$bdafa6b589be8b30)));
const $e729124ed69c9647$export$779e1275bbd7ba59 = (0, $dGvGJ.createSelector)((0, $hKi22.canAdministerJiraPermissionsSelector), (canAdministerJira)=>canAdministerJira);
const $e729124ed69c9647$export$528e2c054f1a65f6 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.ecosystem && !!entities.ecosystem.ecosystemOnDate && // @ts-expect-error - TS2345 - Argument of type 'AuthoredTimestamp | undefined' is not assignable to parameter of type 'string'.
    Date.parse(entities.createdDate) > entities.ecosystem.ecosystemOnDate);
const $e729124ed69c9647$var$extractSecondLevelDeepValuesFromObject = (obj)=>Object.keys(obj || {}).flatMap((key)=>Object.values(obj ? obj[key] : {}));
const $e729124ed69c9647$var$glanceEntitiesSelector = (0, $dGvGJ.createSelector)((0, $4L22Y.ecosystemEntitiesSelector), (ecosystem)=>$e729124ed69c9647$var$extractSecondLevelDeepValuesFromObject(ecosystem.glances || {}));
const $e729124ed69c9647$export$830512515d42357 = (0, $dGvGJ.createSelector)((0, $4L22Y.ecosystemEntitiesSelector), (ecosystem)=>$e729124ed69c9647$var$extractSecondLevelDeepValuesFromObject(ecosystem.contextPanels));
const $e729124ed69c9647$var$contentPanelsEntitiesSelector = (0, $dGvGJ.createSelector)((0, $4L22Y.ecosystemEntitiesSelector), (ecosystem)=>$e729124ed69c9647$var$extractSecondLevelDeepValuesFromObject(ecosystem.contentPanels));
const $e729124ed69c9647$var$activityPanelsEntitiesSelector = (0, $dGvGJ.createSelector)((0, $4L22Y.ecosystemEntitiesSelector), (ecosystem)=>$e729124ed69c9647$var$extractSecondLevelDeepValuesFromObject(ecosystem.activityPanels));
const $e729124ed69c9647$export$7fec16e3d5cd5f4e = (selector)=>(0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), selector, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (ecosystemEnabled, otherSelector)=>ecosystemEnabled && otherSelector || []);
const $e729124ed69c9647$export$d73d3447fc053be = $e729124ed69c9647$export$7fec16e3d5cd5f4e((0, $dGvGJ.createSelector)($e729124ed69c9647$var$glanceEntitiesSelector, (glanceEntities)=>glanceEntities.map((entity)=>({
            appKey: entity.appKey,
            moduleKey: entity.moduleKey,
            name: entity.name,
            icon: entity.icon && entity.icon.url && {
                url: entity.icon.url
            },
            label: entity.label,
            status: entity.status,
            type: entity.type,
            glanceType: (0, $awmXl.CONNECT_ENTITY_TYPE)
        }))));
const $e729124ed69c9647$export$df7140249f849373 = (0, $dGvGJ.createSelector)([
    (0, $lMzxr.forgeGlancesSelector),
    $e729124ed69c9647$export$d73d3447fc053be
], (forge, connect)=>[
        ...forge,
        ...connect
    ]);
const $e729124ed69c9647$export$e8938da368c7c5c4 = (appKey, moduleKey)=>(0, $dGvGJ.createSelector)((0, $4L22Y.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.glances && ecosystem.glances[appKey] && ecosystem.glances[appKey][moduleKey]);
const $e729124ed69c9647$export$7bc028a03185fc96 = $e729124ed69c9647$export$7fec16e3d5cd5f4e((0, $dGvGJ.createSelector)($e729124ed69c9647$var$contentPanelsEntitiesSelector, (contentPanelEntities)=>contentPanelEntities));
const $e729124ed69c9647$export$47d3fa7df862ae6f = (0, $dGvGJ.createSelector)([
    (0, $lMzxr.forgePanelsSelector),
    $e729124ed69c9647$export$7bc028a03185fc96
], (forge, connect)=>[
        ...forge,
        ...connect
    ]);
const $e729124ed69c9647$var$panelsComparator = (firstPanel, secondPanel)=>{
    // The sort order rule:
    // 1. Forge panels without quick add button (no dateAdded prop)
    // 2. Forge panels sorted by date added (oldest > newest)
    // 3. Connect panels, sorting criteria won't be changed
    if (firstPanel.type === (0, $awmXl.FORGE_ENTITY_TYPE)) {
        // @ts-expect-error - TS2339 - Property 'dateAdded' does not exist on type 'AddedPanel'.
        const firstValue = firstPanel.dateAdded || 1;
        if (secondPanel.type === (0, $awmXl.FORGE_ENTITY_TYPE)) {
            // @ts-expect-error - TS2339 - Property 'dateAdded' does not exist on type 'AddedPanel'.
            const secondValue = secondPanel.dateAdded || 1;
            return firstValue - secondValue;
        }
        return firstValue;
    }
    return Infinity;
};
const $e729124ed69c9647$var$sortPanels = (allPanelsToAddedPanels)=>allPanelsToAddedPanels// @ts-expect-error - TS2769 - No overload matches this call.
    .map((panel)=>[].concat(panel)).sort((firstPanel, secondPanel)=>$e729124ed69c9647$var$panelsComparator(firstPanel[0], secondPanel[0]));
const $e729124ed69c9647$export$b2c15e41218fc96 = (firstActivity, secondActivity)=>{
    // The sort order rule:
    // 1. Forge activity ordered alphabetically.
    // 2. Connect panels, sorting criteria won't be changed
    if (firstActivity.type === (0, $awmXl.FORGE_ENTITY_TYPE)) {
        const firstValue = firstActivity.name.toLowerCase();
        if (secondActivity.type === (0, $awmXl.FORGE_ENTITY_TYPE)) {
            const secondValue = secondActivity.name.toLowerCase();
            if (firstValue < secondValue) return -Infinity;
            if (firstValue > secondValue) return Infinity;
            return 0;
        }
        return Infinity;
    }
    return Infinity;
};
const $e729124ed69c9647$export$a48c28ad36cb708e = $e729124ed69c9647$export$7fec16e3d5cd5f4e((0, $dGvGJ.createSelector)($e729124ed69c9647$export$80fcdb58a34c02a8, $e729124ed69c9647$export$47d3fa7df862ae6f, $e729124ed69c9647$export$7d77b0f1f3d84166, $e729124ed69c9647$export$528e2c054f1a65f6, (0, $a1ky2.analyticsSourceSelector), (selectedPanels, allPanels, customised, newIssue, analyticsSource)=>{
    const allPanelsToAddedPanels = allPanels.map((panel)=>{
        // Forge-defined panels
        if (panel.type === (0, $awmXl.FORGE_ENTITY_TYPE)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const forgePanel = panel;
            // For a transition period we always render panels without a quick add button
            if (!forgePanel.iconUrl) return forgePanel;
            const prefix = `${forgePanel.appKey}/${forgePanel.moduleKey}-`;
            const filteredSelectedPanels = selectedPanels.filter((sPanel)=>(0, $eOKTW.isKeyMatchPrefix)(sPanel, prefix)).map((sPanel)=>{
                const panelProperties = (0, $a2FgJ.parseForgeIssuePanel)(sPanel);
                if (panelProperties == null) (0, $Z1q1o.fireOperationalFailedEvent)(analyticsSource, {
                    error: Error(`Panel key doesn't match regexp: ${sPanel}`)
                });
                return panelProperties && {
                    ...forgePanel,
                    dateAdded: panelProperties.added,
                    panelInstanceId: panelProperties.id
                };
            }).filter(Boolean);
            return filteredSelectedPanels.length > 0 && filteredSelectedPanels;
        }
        // Connect-defined panels
        if (!customised && !newIssue) return panel;
        const isSelected = selectedPanels.includes(`${panel.appKey}_${panel.moduleKey}`) || // BENTO-2491 SelectedPanels could be saved using keys without tailing digits
        selectedPanels.includes(`${panel.appKey}_${(0, $a2FgJ.removeTimestamp)(panel.moduleKey, 10)}`) || panel.showByDefault;
        return isSelected && panel;
    });
    const addedPanels = (0, (/*@__PURE__*/$parcel$interopDefault($183uB)))($e729124ed69c9647$var$sortPanels(allPanelsToAddedPanels.filter(Boolean)));
    return addedPanels;
}));
const $e729124ed69c9647$export$9f3aeb87662f360b = (appKey, moduleKey)=>(0, $dGvGJ.createSelector)((0, $4L22Y.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.contentPanels && ecosystem.contentPanels[appKey] && ecosystem.contentPanels[appKey][moduleKey]);
const $e729124ed69c9647$export$1a9c93efcb1ffec7 = (appKey, moduleKey)=>(0, $dGvGJ.createSelector)((0, $4L22Y.ecosystemEntitiesSelector), (ecosystem)=>Boolean(ecosystem && ecosystem.selectedContentPanel && (ecosystem.selectedContentPanel === `${appKey}_${moduleKey}` || ecosystem.selectedContentPanel === `${appKey}_${(0, $a2FgJ.removeTimestamp)(moduleKey, 10)}`)));
const $e729124ed69c9647$export$dd6c9850f9e61a72 = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), $e729124ed69c9647$var$activityPanelsEntitiesSelector, (isEcosystemEnabled, activityPanelEntities)=>isEcosystemEnabled ? activityPanelEntities.map((entity)=>({
            name: entity.name,
            appKey: entity.appKey,
            moduleKey: entity.moduleKey,
            options: entity.options,
            type: (0, $awmXl.CONNECT_ENTITY_TYPE)
        })) : []);
const $e729124ed69c9647$export$9222e43f5478367f = (0, $dGvGJ.createSelector)([
    (0, $lMzxr.forgeIssueActivitySelector),
    $e729124ed69c9647$export$dd6c9850f9e61a72
], (forge, connect)=>[
        ...forge,
        ...connect
    ].sort($e729124ed69c9647$export$b2c15e41218fc96));

});
parcelRegister("Z1q1o", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $0436e469f25e247b$export$add44f896fb31ba3);
$parcel$export(module.exports, "fireUiActionClickedEvent", () => $0436e469f25e247b$export$a645c87ca2607d94);
$parcel$export(module.exports, "fireTrackActionSucceedEvent", () => $0436e469f25e247b$export$435f030e21a120be);
$parcel$export(module.exports, "fireOperationalActionFailedEvent", () => $0436e469f25e247b$export$828a66ad00e9a886);
$parcel$export(module.exports, "fireTrackSavedEvent", () => $0436e469f25e247b$export$1dbf5d2537a38bd8);
$parcel$export(module.exports, "fireOperationalSaveFailedEvent", () => $0436e469f25e247b$export$cda76554fa8eee1d);
$parcel$export(module.exports, "fireUiRemoveClickedEvent", () => $0436e469f25e247b$export$2e4d409fc887e7e);
$parcel$export(module.exports, "fireTrackRemovedEvent", () => $0436e469f25e247b$export$daf10221407e1b30);
$parcel$export(module.exports, "fireOperationalRemoveFailedEvent", () => $0436e469f25e247b$export$d12e864ea545eb36);
$parcel$export(module.exports, "fireUiTriggerSelectedEvent", () => $0436e469f25e247b$export$4d7a3fdb2dd15cbb);
$parcel$export(module.exports, "fireUiCollapseExpandClickedEvent", () => $0436e469f25e247b$export$c157193e598947ac);
$parcel$export(module.exports, "fireTrackUpdateSucceedEvent", () => $0436e469f25e247b$export$98e4a25792520246);
$parcel$export(module.exports, "fireOperationalUpdateFailedEvent", () => $0436e469f25e247b$export$9ee09996d253231a);

var $k2DRb = parcelRequire("k2DRb");

var $8uOa6 = parcelRequire("8uOa6");

var $9BrHy = parcelRequire("9BrHy");

var $8kVg1 = parcelRequire("8kVg1");

var $hBuqR = parcelRequire("hBuqR");

var $4R6GH = parcelRequire("4R6GH");
const $0436e469f25e247b$var$moduleEventId = (0, $9BrHy.getEventIdOld)({
    module: (0, $k2DRb.ISSUE_PANEL_MODULE),
    moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION)
});
const $0436e469f25e247b$var$triggerEventId = (0, $9BrHy.getEventIdOld)({
    module: (0, $k2DRb.ISSUE_PANEL_MODULE),
    moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
});
const $0436e469f25e247b$export$add44f896fb31ba3 = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).FAILED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.ISSUE_PANEL_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION)
        }) : $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$a645c87ca2607d94 = (source, attributes)=>(0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).ACTION_CLICKED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.ISSUE_PANEL_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION)
        }) : $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$435f030e21a120be = (source, attributes)=>(0, $8uOa6.fireTrackEvent)((0, $hBuqR.TRACK_ACTIONS).ACTION_SUCCEED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.ISSUE_PANEL_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION)
        }) : $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$828a66ad00e9a886 = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).ACTION_FAILED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.ISSUE_PANEL_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION)
        }) : $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$1dbf5d2537a38bd8 = (source, attributes)=>(0, $8uOa6.fireTrackEvent)((0, $hBuqR.TRACK_ACTIONS).SAVED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.ISSUE_PANEL_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION)
        }) : $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$cda76554fa8eee1d = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).SAVE_FAILED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.ISSUE_PANEL_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION)
        }) : $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$2e4d409fc887e7e = (source, attributes)=>(0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).REMOVE_CLICKED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.ISSUE_PANEL_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION)
        }) : $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$daf10221407e1b30 = (source, attributes)=>(0, $8uOa6.fireTrackEvent)((0, $hBuqR.TRACK_ACTIONS).REMOVED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.ISSUE_PANEL_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION)
        }) : $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$d12e864ea545eb36 = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).REMOVE_FAILED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.ISSUE_PANEL_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION)
        }) : $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$4d7a3fdb2dd15cbb = (extensionId, source, attributes)=>{
    (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).start({
        startTime: performance.now()
    });
    return (0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).SELECTED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.ISSUE_PANEL_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
        }) : $0436e469f25e247b$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};
const $0436e469f25e247b$export$c157193e598947ac = (source, attributes)=>(0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).COLLAPSE_EXPAND_CLICKED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.ISSUE_PANEL_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION)
        }) : $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$98e4a25792520246 = (source, attributes)=>(0, $8uOa6.fireTrackEvent)((0, $hBuqR.TRACK_ACTIONS).UPDATE_SUCCEED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.ISSUE_PANEL_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION)
        }) : $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $0436e469f25e247b$export$9ee09996d253231a = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).UPDATE_FAILED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.ISSUE_PANEL_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION)
        }) : $0436e469f25e247b$var$moduleEventId,
        source: source,
        attributes: attributes
    });

});
parcelRegister("9BrHy", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $10bc2a9e37d5a5bb$export$5639f6a927500d9);
$parcel$export(module.exports, "getEventIdOld", () => $10bc2a9e37d5a5bb$export$b2919e256f1e5dfc);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $10bc2a9e37d5a5bb$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getBrowserMetricsEventIdOld", () => $10bc2a9e37d5a5bb$export$66db5d4145894f38);
$parcel$export(module.exports, "getEventActionName", () => $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1);

var $k2DRb = parcelRequire("k2DRb");

var $6yg2S = parcelRequire("6yg2S");

var $hBuqR = parcelRequire("hBuqR");
const $10bc2a9e37d5a5bb$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $10bc2a9e37d5a5bb$var$prepareModuleMode = (entryPoint)=>`${$10bc2a9e37d5a5bb$var$capitalizeFirstLetter(entryPoint)}`;
const $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $10bc2a9e37d5a5bb$var$prepareModuleName = (moduleName)=>(0, $k2DRb.SUPPORTED_MODULES).includes(moduleName) ? $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $10bc2a9e37d5a5bb$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${eventNamePostfix}`);
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $10bc2a9e37d5a5bb$export$b2919e256f1e5dfc = ({ module: module, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $10bc2a9e37d5a5bb$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}-${forgeUiType}`);
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $10bc2a9e37d5a5bb$export$66db5d4145894f38 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hBuqR.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});


parcelRegister("eOKTW", function(module, exports) {

$parcel$export(module.exports, "toForgeKey", () => $2db6ad1a44c67382$export$fef910e3c6a21573);
$parcel$export(module.exports, "toForgeKeyWithDate", () => $2db6ad1a44c67382$export$4a8bc976ef8470fb);
$parcel$export(module.exports, "toForgeKeyFromExtensionId", () => $2db6ad1a44c67382$export$72368b9e5ac31f04);
$parcel$export(module.exports, "toConnectKey", () => $2db6ad1a44c67382$export$f1cde82a5f64810e);
$parcel$export(module.exports, "toEcosystemKeys", () => $2db6ad1a44c67382$export$c9483bbc66b4fb20);
$parcel$export(module.exports, "isForgeExtension", () => $2db6ad1a44c67382$export$b0ed77f2dd403096);
$parcel$export(module.exports, "isKeyMatchPrefix", () => $2db6ad1a44c67382$export$75f2b72396a13fc0);

var $k2DRb = parcelRequire("k2DRb");
const $2db6ad1a44c67382$export$fef910e3c6a21573 = (appKey, moduleKey)=>`${appKey}/${moduleKey}`;
const $2db6ad1a44c67382$export$4a8bc976ef8470fb = (appKey, moduleKey, panelInstanceId, dateAdded)=>`${appKey}/${moduleKey}-${panelInstanceId}-${dateAdded}`;
const $2db6ad1a44c67382$export$72368b9e5ac31f04 = (extensionId, panelInstanceId, dateAdded)=>panelInstanceId != null ? `${extensionId}-${panelInstanceId}-${dateAdded}` : `${extensionId}-${0, $k2DRb.NONE_PANEL_INSTANCE_ID}-${dateAdded}`;
const $2db6ad1a44c67382$export$f1cde82a5f64810e = (appKey, moduleKey)=>`${appKey}_${moduleKey}`;
const $2db6ad1a44c67382$export$c9483bbc66b4fb20 = (extensionId)=>{
    const [prefix, appId, envId, ...rest] = extensionId.split('/');
    const appKey = [
        prefix,
        appId,
        envId
    ].join('/');
    const moduleKey = rest.join('/');
    return {
        appKey: appKey,
        moduleKey: moduleKey
    };
};
const $2db6ad1a44c67382$export$b0ed77f2dd403096 = (appKey)=>appKey.startsWith((0, $k2DRb.FORGE_FIELD_TYPE_PREFIX));
const $2db6ad1a44c67382$export$75f2b72396a13fc0 = (key, prefix)=>key.startsWith(prefix) && /^\w+-\d+$/.test(key.slice(prefix.length));

});

parcelRegister("a2FgJ", function(module, exports) {

$parcel$export(module.exports, "removeTimestamp", () => $b16ff4531ea7aeeb$export$8144a1156e1fc1b3);
$parcel$export(module.exports, "parseForgeIssuePanel", () => $b16ff4531ea7aeeb$export$a21b4e384e411f26);
// when input is like 'my-issue-content-panel-5794110541888792068', output is 'my-issue-content-panel'
const $b16ff4531ea7aeeb$export$8144a1156e1fc1b3 = (str, minDigitsLen = 0)=>{
    const indexOfHyphen = str.lastIndexOf('-');
    const tail = str.substr(indexOfHyphen + 1);
    if (/^\d+$/.test(tail) && tail.length >= minDigitsLen) return str.substr(0, indexOfHyphen);
    return str;
};
const $b16ff4531ea7aeeb$export$a21b4e384e411f26 = (panelKey)=>{
    const match = panelKey.match(/^(.*)-(\w+)-(\d+)$/);
    if (match == null) return null;
    const [, extensionId, id, timestamp] = match;
    const added = Number(timestamp);
    return {
        extensionId: extensionId,
        id: id,
        added: added
    };
};

});

parcelRegister("hKi22", function(module, exports) {

$parcel$export(module.exports, "permissionsSelector", () => $73bbd0df9e2a988a$export$7a13e26fbaa74911);
$parcel$export(module.exports, "canBeAssignedToIssuesPermissionsSelector", () => $73bbd0df9e2a988a$export$6da6e9cc5af6cc92);
$parcel$export(module.exports, "canAdministerProjectPermissionsSelector", () => $73bbd0df9e2a988a$export$106fd3c30fc8b230);
$parcel$export(module.exports, "canAdministerJiraPermissionsSelector", () => $73bbd0df9e2a988a$export$adf4ccad5657586d);
$parcel$export(module.exports, "canModifyReporterPermissionsSelector", () => $73bbd0df9e2a988a$export$85a3c8518f632ff1);
$parcel$export(module.exports, "canAssignIssuesPermissionsSelector", () => $73bbd0df9e2a988a$export$f58a91878385514);
$parcel$export(module.exports, "canCreateChildrenPermissionsSelector", () => $73bbd0df9e2a988a$export$183d12154c212e2b);
$parcel$export(module.exports, "canExportIssueSelector", () => $73bbd0df9e2a988a$export$a409252beda5dd99);
$parcel$export(module.exports, "watchersPermissionsSelector", () => $73bbd0df9e2a988a$export$b3bd1cf4683807d8);
$parcel$export(module.exports, "canViewDevToolsPermissionsSelector", () => $73bbd0df9e2a988a$export$dfc7b576e23ac861);
$parcel$export(module.exports, "canUseServiceDeskAgentFeaturesSelector", () => $73bbd0df9e2a988a$export$1b79be16305d8111);

var $dGvGJ = parcelRequire("dGvGJ");

var $dPSWJ = parcelRequire("dPSWJ");

var $2vSU6 = parcelRequire("2vSU6");

var $a1ky2 = parcelRequire("a1ky2");

var $bcoYn = parcelRequire("bcoYn");
const $73bbd0df9e2a988a$var$internalPermissionsSelector = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.permissions || {});
const $73bbd0df9e2a988a$var$jsdPermissionsSetThatNeedApplicationRoleAndAgentPerm = new Set([
    // In the BE this is not technically a veto'd permission, however it simplifies the FE code to pretend that it is.
    'canUseServiceDeskAgentFeatures',
    // Normal veto'd permissions as per ServiceDeskCollaboratorPermissionOverrideStrategy in BE
    'canEditIssues',
    'canTransitionIssues',
    'canScheduleIssues',
    'canMoveIssue',
    'canAssignIssues',
    'canBeAssignedToIssues',
    'canDeleteIssue',
    'canManageWatchers',
    'canEditAllComments',
    'canDeleteAllComments',
    'canDeleteAllAttachments',
    'canLogWork',
    'canEditOwnWorklogs',
    'canEditAllWorklogs',
    'canDeleteOwnWorklogs',
    'canDeleteAllWorklogs',
    // These should be vetoed, but aren't requested by JFE yet
    'canResolveIssues',
    'canViewReadonlyWorkflow',
    'canCloseIssues',
    'canModifyReporter',
    'canSetIssueSecurity',
    'canArchiveIssue',
    'canUnarchiveIssue'
]);
const $73bbd0df9e2a988a$export$7a13e26fbaa74911 = (0, $dGvGJ.createSelector)((0, $a1ky2.appPermissionsSelector), (0, $bcoYn.projectTypeSelector), $73bbd0df9e2a988a$var$internalPermissionsSelector, (0, $a1ky2.tenantHasActiveServiceDeskLicenseSelector), (applicationPermissions, projectType, permissions, tenantHasActiveServiceDeskLicense)=>{
    if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && tenantHasActiveServiceDeskLicense) {
        const { canUseServiceDeskAgentFeatures: canUseServiceDeskAgentFeatures } = permissions;
        const hasJsdAppRole = applicationPermissions.hasServiceDeskAccess;
        return (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(permissions, (hasPermission, key)=>$73bbd0df9e2a988a$var$jsdPermissionsSetThatNeedApplicationRoleAndAgentPerm.has(key) ? hasPermission && hasJsdAppRole && canUseServiceDeskAgentFeatures : hasPermission);
    }
    return permissions;
});
const $73bbd0df9e2a988a$export$6da6e9cc5af6cc92 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>!!permissions.canBeAssignedToIssues);
const $73bbd0df9e2a988a$export$106fd3c30fc8b230 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>!!permissions.canAdministerProject);
const $73bbd0df9e2a988a$export$adf4ccad5657586d = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>!!permissions.canAdministerJira);
const $73bbd0df9e2a988a$var$canViewWatchersPermissionsSelector = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canViewWatchers);
const $73bbd0df9e2a988a$var$canManageWatchersPermissionsSelector = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canManageWatchers);
const $73bbd0df9e2a988a$export$85a3c8518f632ff1 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canModifyReporter);
const $73bbd0df9e2a988a$export$f58a91878385514 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canAssignIssues);
const $73bbd0df9e2a988a$export$183d12154c212e2b = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>!!permissions.canCreateChildren);
const $73bbd0df9e2a988a$export$a409252beda5dd99 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canExportIssue);
const $73bbd0df9e2a988a$export$b3bd1cf4683807d8 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$var$canViewWatchersPermissionsSelector, $73bbd0df9e2a988a$var$canManageWatchersPermissionsSelector, (canViewWatchers, canManageWatchers)=>({
        canViewWatchers: canViewWatchers,
        canManageWatchers: canManageWatchers
    }));
const $73bbd0df9e2a988a$export$ca6b7f39a3de4ff9 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canBrowseUsers);
const $73bbd0df9e2a988a$export$dfc7b576e23ac861 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canViewDevTools);
const $73bbd0df9e2a988a$export$1b79be16305d8111 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canUseServiceDeskAgentFeatures);

});
parcelRegister("dPSWJ", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $a12aa8fd8ab9a7da$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $bxDef(iteratee, 3);
    $hDnyx(object, function(value, key, object) {
        $1m3dq(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $a12aa8fd8ab9a7da$var$mapValues;

});


const $ad485f85fe233a83$export$bdafa6b589be8b30 = 'issue.content.panel.customised.flag';

parcelRegister("4L22Y", function(module, exports) {

$parcel$export(module.exports, "ecosystemEntitiesSelector", () => $6d9cf82623af37b7$export$8db07a5bb000e56f);
$parcel$export(module.exports, "forgeEntitiesSelector", () => $6d9cf82623af37b7$export$92b32d478f0e29fb);

var $dGvGJ = parcelRequire("dGvGJ");

var $bcoYn = parcelRequire("bcoYn");

var $7G3DM = parcelRequire("7G3DM");
const $6d9cf82623af37b7$export$8db07a5bb000e56f = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.ecosystem || {});
const $6d9cf82623af37b7$export$92b32d478f0e29fb = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.forge || (0, $7G3DM.initialState));

});
parcelRegister("7G3DM", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $73241870ac7c200f$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $73241870ac7c200f$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $aJ8eZ = parcelRequire("aJ8eZ");

var $jXy0Q = parcelRequire("jXy0Q");

var $akbnA = parcelRequire("akbnA");
const $73241870ac7c200f$export$d4c72bab9d6cc13a = {
    actions: [],
    glances: [],
    issueContexts: [],
    panels: [],
    activities: [],
    customFields: [],
    customFieldTypes: [],
    backgroundScripts: [],
    activeAction: null,
    panelsKeys: {
        newPanels: [],
        collapsedPanels: []
    },
    uiModifications: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$73241870ac7c200f$export$2e2bcd8739ae039 = (state = $73241870ac7c200f$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $aJ8eZ.FETCH_FORGE_SUCCESS:
            return {
                ...state,
                actions: action.payload.issueAction,
                glances: action.payload.issueGlance,
                issueContexts: action.payload.issueContext,
                panels: action.payload.issuePanel,
                activities: action.payload.issueActivity,
                customFields: action.payload.customField,
                customFieldTypes: action.payload.customFieldType,
                backgroundScripts: action.payload.issueViewBackgroundScript,
                panelsKeys: (0, $4R6GH.fg)('preserve_new_panels_upon_issue_refreshes') ? {
                    ...state.panelsKeys
                } : {
                    ...state.panelsKeys,
                    newPanels: []
                },
                uiModifications: action.payload.uiModifications
            };
        case 0, $aJ8eZ.FORGE_ISSUE_ACTION_EXEC:
            return {
                ...state,
                activeAction: {
                    action: action.payload,
                    isLoading: true
                }
            };
        case 0, $aJ8eZ.FORGE_ISSUE_ACTION_RENDERED:
            return {
                ...state,
                // @ts-expect-error - TS2322 - Type '{ isLoading: false; action?: Action | undefined; }' is not assignable to type 'ActiveAction'.
                activeAction: {
                    ...state.activeAction,
                    isLoading: false
                }
            };
        case 0, $aJ8eZ.FORGE_ISSUE_ACTION_CLOSE:
            return {
                ...state,
                activeAction: null
            };
        case 0, $aJ8eZ.FORGE_ISSUE_PANEL_ADDED:
            return {
                ...state,
                panelsKeys: {
                    ...state.panelsKeys,
                    newPanels: [
                        ...state.panelsKeys.newPanels,
                        action.payload
                    ]
                }
            };
        case 0, $aJ8eZ.FORGE_NEW_ISSUE_PANEL_UNTRACK:
            {
                const removedPanelKey = action.payload;
                const { panelsKeys: panelsKeys } = state;
                return {
                    ...state,
                    panelsKeys: {
                        ...panelsKeys,
                        newPanels: panelsKeys.newPanels.filter((panelKey)=>panelKey !== removedPanelKey)
                    }
                };
            }
        case 0, $aJ8eZ.FORGE_ISSUE_PANEL_REMOVED:
            {
                const removedPanelKey = action.payload;
                return {
                    ...state,
                    panelsKeys: {
                        newPanels: state.panelsKeys.newPanels.filter((panelKey)=>panelKey !== removedPanelKey),
                        collapsedPanels: state.panelsKeys.collapsedPanels.filter((panelKey)=>panelKey !== removedPanelKey)
                    }
                };
            }
        case 0, $aJ8eZ.FORGE_ISSUE_PANEL_UPDATED:
            {
                const { panelKey: panelKey, collapsed: collapsed } = action.payload;
                const updatedCollapsedPanels = collapsed ? Array.from(new Set([
                    ...state.panelsKeys.collapsedPanels,
                    panelKey
                ])) : state.panelsKeys.collapsedPanels.filter((key)=>key !== panelKey);
                return {
                    ...state,
                    panelsKeys: {
                        ...state.panelsKeys,
                        collapsedPanels: updatedCollapsedPanels
                    }
                };
            }
        case 0, $akbnA.FETCH_ISSUE_SUCCESS:
        case 0, $akbnA.REFRESH_ISSUE_SUCCESS:
        case 0, $jXy0Q.FETCH_ISSUE_REMOTE_DATA_SUCCESS:
            {
                const collapsedPanels = action.payload.forgeIssueProperties?.collapsedPanels || [];
                return {
                    ...state,
                    panelsKeys: {
                        ...state.panelsKeys,
                        collapsedPanels: Array.from(new Set([
                            ...state.panelsKeys.collapsedPanels,
                            ...collapsedPanels
                        ]))
                    }
                };
            }
        default:
            return state;
    }
};

});
parcelRegister("aJ8eZ", function(module, exports) {

$parcel$export(module.exports, "FETCH_FORGE_SUCCESS", () => $e621a0f6e2386727$export$b40fce05e753d390);
$parcel$export(module.exports, "fetchForgeSuccess", () => $e621a0f6e2386727$export$1b05a0184822bc74);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_EXEC", () => $e621a0f6e2386727$export$8c062df60fb76839);
$parcel$export(module.exports, "forgeIssueActionExec", () => $e621a0f6e2386727$export$3a189763780c504b);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_RENDERED", () => $e621a0f6e2386727$export$dd307b8c5e0de67d);
$parcel$export(module.exports, "forgeIssueActionRendered", () => $e621a0f6e2386727$export$2484a0b7a9a14f92);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_CLOSE", () => $e621a0f6e2386727$export$d91b51ae909f8e95);
$parcel$export(module.exports, "forgeIssueActionClose", () => $e621a0f6e2386727$export$335a03a463c5945a);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_ADDED", () => $e621a0f6e2386727$export$7d7831d10e022e0);
$parcel$export(module.exports, "forgeIssuePanelAdded", () => $e621a0f6e2386727$export$f24c609edeac582f);
$parcel$export(module.exports, "FORGE_NEW_ISSUE_PANEL_UNTRACK", () => $e621a0f6e2386727$export$d36cecbf4e320d4a);
$parcel$export(module.exports, "forgeNewIssuePanelUntrack", () => $e621a0f6e2386727$export$b93b979485d242c8);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_REMOVED", () => $e621a0f6e2386727$export$798e467d6a4cb5c);
$parcel$export(module.exports, "forgeIssuePanelRemoved", () => $e621a0f6e2386727$export$b584e6f1797702be);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_UPDATE_REQUEST", () => $e621a0f6e2386727$export$bb2e005bc0498829);
$parcel$export(module.exports, "forgeIssuePanelUpdateRequest", () => $e621a0f6e2386727$export$c67c4f64ec92ba7f);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_UPDATED", () => $e621a0f6e2386727$export$2ce5fe154022894b);
$parcel$export(module.exports, "forgeIssuePanelUpdated", () => $e621a0f6e2386727$export$e2eebb5b364492ce);
const $e621a0f6e2386727$export$b40fce05e753d390 = 'FETCH_FORGE_SUCCESS';
const $e621a0f6e2386727$export$1b05a0184822bc74 = (payload)=>({
        type: $e621a0f6e2386727$export$b40fce05e753d390,
        payload: payload
    });
const $e621a0f6e2386727$export$8c062df60fb76839 = 'FORGE_ISSUE_ACTION_EXEC';
const $e621a0f6e2386727$export$3a189763780c504b = (action)=>({
        type: $e621a0f6e2386727$export$8c062df60fb76839,
        payload: action
    });
const $e621a0f6e2386727$export$dd307b8c5e0de67d = 'FORGE_ISSUE_ACTION_RENDERED';
const $e621a0f6e2386727$export$2484a0b7a9a14f92 = ()=>({
        type: $e621a0f6e2386727$export$dd307b8c5e0de67d
    });
const $e621a0f6e2386727$export$d91b51ae909f8e95 = 'FORGE_ISSUE_ACTION_CLOSE';
const $e621a0f6e2386727$export$335a03a463c5945a = ()=>({
        type: $e621a0f6e2386727$export$d91b51ae909f8e95
    });
const $e621a0f6e2386727$export$7d7831d10e022e0 = 'FORGE_ISSUE_PANEL_ADDED';
const $e621a0f6e2386727$export$f24c609edeac582f = (issuePanelKey)=>({
        type: $e621a0f6e2386727$export$7d7831d10e022e0,
        payload: issuePanelKey
    });
const $e621a0f6e2386727$export$d36cecbf4e320d4a = 'FORGE_NEW_ISSUE_PANEL_UNTRACK';
const $e621a0f6e2386727$export$b93b979485d242c8 = (issuePanelKey)=>({
        type: $e621a0f6e2386727$export$d36cecbf4e320d4a,
        payload: issuePanelKey
    });
const $e621a0f6e2386727$export$798e467d6a4cb5c = 'FORGE_ISSUE_PANEL_REMOVED';
const $e621a0f6e2386727$export$b584e6f1797702be = (issuePanelKey)=>({
        type: $e621a0f6e2386727$export$798e467d6a4cb5c,
        payload: issuePanelKey
    });
const $e621a0f6e2386727$export$bb2e005bc0498829 = 'FORGE_ISSUE_PANEL_UPDATE_REQUEST';
const $e621a0f6e2386727$export$c67c4f64ec92ba7f = (payload)=>({
        type: $e621a0f6e2386727$export$bb2e005bc0498829,
        payload: payload
    });
const $e621a0f6e2386727$export$2ce5fe154022894b = 'FORGE_ISSUE_PANEL_UPDATED';
const $e621a0f6e2386727$export$e2eebb5b364492ce = (payload)=>({
        type: $e621a0f6e2386727$export$2ce5fe154022894b,
        payload: payload
    });

});

parcelRegister("jXy0Q", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_REQUEST", () => $6d3151fa7c469cff$export$d8a6e69b46d6d184);
$parcel$export(module.exports, "fetchIssueRemoteDataRequest", () => $6d3151fa7c469cff$export$222125e4e0f166e4);
$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_REQUEST_LOADING_COMPLETE", () => $6d3151fa7c469cff$export$c511d3093cea9ec6);
$parcel$export(module.exports, "fetchIssueRemoteDataRequestLoadingComplete", () => $6d3151fa7c469cff$export$86a90761307d7be0);
$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_SUCCESS", () => $6d3151fa7c469cff$export$2cdd723fc40cdd47);
$parcel$export(module.exports, "fetchIssueRemoteDataSuccess", () => $6d3151fa7c469cff$export$615a2d29b149df95);
$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_FAILURE", () => $6d3151fa7c469cff$export$396f0d977db541d9);
$parcel$export(module.exports, "fetchIssueRemoteDataFailure", () => $6d3151fa7c469cff$export$f7fd18472eaf2b77);
$parcel$export(module.exports, "FETCH_ALL_ISSUE_WHITEBOARDS_SUCCESS", () => $6d3151fa7c469cff$export$7067db2dbaa9931);
$parcel$export(module.exports, "fetchAllIssueWhiteboardsSuccess", () => $6d3151fa7c469cff$export$56e06a2cdd56648f);
const $6d3151fa7c469cff$export$d8a6e69b46d6d184 = 'FETCH_ISSUE_REMOTE_DATA_REQUEST';
const $6d3151fa7c469cff$export$222125e4e0f166e4 = (issueKey)=>({
        type: $6d3151fa7c469cff$export$d8a6e69b46d6d184,
        payload: issueKey
    });
const $6d3151fa7c469cff$export$c511d3093cea9ec6 = 'FETCH_ISSUE_REMOTE_DATA_REQUEST_LOADING_COMPLETE';
const $6d3151fa7c469cff$export$86a90761307d7be0 = ()=>({
        type: $6d3151fa7c469cff$export$c511d3093cea9ec6
    });
const $6d3151fa7c469cff$export$2cdd723fc40cdd47 = 'FETCH_ISSUE_REMOTE_DATA_SUCCESS';
const $6d3151fa7c469cff$export$615a2d29b149df95 = (entities)=>({
        type: $6d3151fa7c469cff$export$2cdd723fc40cdd47,
        payload: entities
    });
const $6d3151fa7c469cff$export$396f0d977db541d9 = 'FETCH_ISSUE_REMOTE_DATA_FAILURE';
const $6d3151fa7c469cff$export$f7fd18472eaf2b77 = ()=>({
        type: $6d3151fa7c469cff$export$396f0d977db541d9
    });
const $6d3151fa7c469cff$export$7067db2dbaa9931 = 'FETCH_ISSUE_WHITEBOARDS_SUCCESS';
const $6d3151fa7c469cff$export$56e06a2cdd56648f = (whiteboardData)=>({
        type: $6d3151fa7c469cff$export$7067db2dbaa9931,
        payload: whiteboardData
    });

});

parcelRegister("akbnA", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REQUEST", () => $96f907481cd25e73$export$afc8565512ebbf99);
$parcel$export(module.exports, "fetchIssueRequest", () => $96f907481cd25e73$export$ff7cd1a46115d8ca);
$parcel$export(module.exports, "FETCH_ISSUE_SUCCESS", () => $96f907481cd25e73$export$c32d0e1f370b7914);
$parcel$export(module.exports, "fetchIssueSuccess", () => $96f907481cd25e73$export$1e39a30e3f37e9d1);
$parcel$export(module.exports, "FETCH_ISSUE_FAILURE", () => $96f907481cd25e73$export$700ca24f76d5bbe6);
$parcel$export(module.exports, "fetchIssueFailure", () => $96f907481cd25e73$export$625e6e61fad65793);
$parcel$export(module.exports, "REFRESH_ISSUE_REQUEST", () => $96f907481cd25e73$export$b48f53bf5b842d57);
$parcel$export(module.exports, "refreshIssueRequest", () => $96f907481cd25e73$export$ccd0db94940d9159);
$parcel$export(module.exports, "CANCEL_REFRESH_ISSUE_REQUEST", () => $96f907481cd25e73$export$6b6ca6acd76420d1);
$parcel$export(module.exports, "cancelRefreshIssueRequest", () => $96f907481cd25e73$export$a7629a657f902cbc);
$parcel$export(module.exports, "REFRESH_ISSUE_SUCCESS", () => $96f907481cd25e73$export$de11c913f06a7952);
$parcel$export(module.exports, "refreshIssueSuccess", () => $96f907481cd25e73$export$cbd1c08fb706639c);
$parcel$export(module.exports, "FETCH_FORGE_REQUEST", () => $96f907481cd25e73$export$36b76b7384d868f3);
$parcel$export(module.exports, "fetchForgeRequest", () => $96f907481cd25e73$export$6ce2430992033a55);
const $96f907481cd25e73$export$afc8565512ebbf99 = 'FETCH_ISSUE_REQUEST';
const $96f907481cd25e73$export$ff7cd1a46115d8ca = ()=>({
        type: $96f907481cd25e73$export$afc8565512ebbf99
    });
const $96f907481cd25e73$export$c32d0e1f370b7914 = 'FETCH_ISSUE_SUCCESS';
const $96f907481cd25e73$export$1e39a30e3f37e9d1 = (entities)=>({
        type: $96f907481cd25e73$export$c32d0e1f370b7914,
        payload: entities
    });
const $96f907481cd25e73$export$700ca24f76d5bbe6 = 'FETCH_ISSUE_FAILURE';
const $96f907481cd25e73$export$625e6e61fad65793 = (failureDescription)=>({
        type: $96f907481cd25e73$export$700ca24f76d5bbe6,
        payload: failureDescription
    });
const $96f907481cd25e73$export$b48f53bf5b842d57 = 'REFRESH_ISSUE_REQUEST';
const $96f907481cd25e73$export$ccd0db94940d9159 = (payload, meta)=>({
        type: $96f907481cd25e73$export$b48f53bf5b842d57,
        payload: payload,
        meta: meta
    });
const $96f907481cd25e73$export$6b6ca6acd76420d1 = 'CANCEL_REFRESH_ISSUE_REQUEST';
const $96f907481cd25e73$export$a7629a657f902cbc = ()=>({
        type: $96f907481cd25e73$export$6b6ca6acd76420d1
    });
const $96f907481cd25e73$export$de11c913f06a7952 = 'REFRESH_ISSUE_SUCCESS';
const $96f907481cd25e73$export$cbd1c08fb706639c = (entities)=>({
        type: $96f907481cd25e73$export$de11c913f06a7952,
        payload: entities
    });
const $96f907481cd25e73$export$36b76b7384d868f3 = 'FETCH_FORGE_REQUEST';
const $96f907481cd25e73$export$6ce2430992033a55 = ()=>({
        type: $96f907481cd25e73$export$36b76b7384d868f3
    });

});



parcelRegister("lMzxr", function(module, exports) {

$parcel$export(module.exports, "forgeContextPanelsSelector", () => $98da256956b02977$export$94c701814d50fed3);
$parcel$export(module.exports, "forgeGlancesSelector", () => $98da256956b02977$export$92747468cb57714e);
$parcel$export(module.exports, "forgeUiModificationsSelector", () => $98da256956b02977$export$325ea69d1eb5eda0);
$parcel$export(module.exports, "forgeIssueActionsSelector", () => $98da256956b02977$export$9bcd40b01af57823);
$parcel$export(module.exports, "forgePanelsSelector", () => $98da256956b02977$export$ca115d43abfd7206);
$parcel$export(module.exports, "forgeUserCanSaveIssuePanelSelector", () => $98da256956b02977$export$ae25fce59e44b253);
$parcel$export(module.exports, "forgeJustAddedPanelSelector", () => $98da256956b02977$export$9c375a0b9a6e5017);
$parcel$export(module.exports, "forgeActiveIssueActionSelector", () => $98da256956b02977$export$ccad5f28efcec42d);
$parcel$export(module.exports, "forgeIssueDataSelector", () => $98da256956b02977$export$d3cd515b7639ce61);
$parcel$export(module.exports, "forgeIssueActivitySelector", () => $98da256956b02977$export$18ce84b90b4920eb);
$parcel$export(module.exports, "isForgePanelNewToIssueSelector", () => $98da256956b02977$export$97dadedc102bebdf);
$parcel$export(module.exports, "getForgeIssuePanel", () => $98da256956b02977$export$b01f1fc9eba6d8cd);
$parcel$export(module.exports, "forgeIsCollapsedPanelSelector", () => $98da256956b02977$export$3d7856e5c65d2291);

var $dGvGJ = parcelRequire("dGvGJ");

var $hGgHi = parcelRequire("hGgHi");

var $eOKTW = parcelRequire("eOKTW");

var $5cmSg = parcelRequire("5cmSg");

var $41gqO = parcelRequire("41gqO");

var $awmXl = parcelRequire("awmXl");

var $a2FgJ = parcelRequire("a2FgJ");

var $g5X3G = parcelRequire("g5X3G");

var $a1ky2 = parcelRequire("a1ky2");

var $7Ow8a = parcelRequire("7Ow8a");

var $bcoYn = parcelRequire("bcoYn");

var $hKi22 = parcelRequire("hKi22");

var $lssfC = parcelRequire("lssfC");

var $4L22Y = parcelRequire("4L22Y");
const $98da256956b02977$var$filterExtensions = (list)=>{
    return list.filter((0, $5cmSg.isExtensionVisible));
};
const $98da256956b02977$var$sortIssuePanels = (first, second)=>{
    if (first.name === second.name) return 0;
    return first.name > second.name ? 1 : -1;
};
const $98da256956b02977$export$b302c9df74ede99a = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (0, $a1ky2.issueIdSelector), (0, $a1ky2.issueKeySelector), (0, $lssfC.issueTypeNameSelector), (0, $bcoYn.projectIdSelector), (0, $a1ky2.projectKeySelector), (0, $bcoYn.projectTypeSelector), (permissions, issueId, issueKey, issueType, projectId, projectKey, projectType)=>({
        issueId: issueId || null,
        issueKey: issueKey,
        issueType: issueType,
        projectId: projectId,
        projectKey: projectKey,
        projectType: projectType || null,
        // Instead of dumping permissions as is we'd like to normalize prop names a bit
        // as they are exposed externally and have to look respectable
        canAddComments: permissions.canAddComments,
        canAdministerJira: permissions.canAdministerJira,
        canAdministerProjects: permissions.canAdministerProject,
        canArchiveIssue: permissions.canArchiveIssue,
        canAssignIssues: permissions.canAssignIssues,
        canBeAssignedToIssues: permissions.canBeAssignedToIssues,
        canCloneIssues: permissions.canCloneIssue,
        canCreateAttachments: permissions.canCreateAttachments,
        canCreateChildren: permissions.canCreateChildren,
        canCreateSubtasks: permissions.canCreateSubtask,
        canDeleteAllAttachments: permissions.canDeleteAllAttachments,
        canDeleteAllComments: permissions.canDeleteAllComments,
        canDeleteAllWorklogs: permissions.canDeleteAllWorklogs,
        canDeleteIssues: permissions.canDeleteIssue,
        canDeleteOwnAttachments: permissions.canDeleteOwnAttachments,
        canDeleteOwnComments: permissions.canDeleteOwnComments,
        canDeleteOwnWorklogs: permissions.canDeleteOwnWorklogs,
        canEditAllComments: permissions.canEditAllComments,
        canEditAllWorklogs: permissions.canEditAllWorklogs,
        canEditIssues: permissions.canEditIssues,
        canEditOwnComments: permissions.canEditOwnComments,
        canEditOwnWorklogs: permissions.canEditOwnWorklogs,
        canLinkIssues: permissions.canLinkIssues,
        canLogWork: permissions.canLogWork,
        canManageWatchers: permissions.canManageWatchers,
        canModifyReporters: permissions.canModifyReporter,
        canMoveIssues: permissions.canMoveIssue,
        canScheduleIssues: permissions.canScheduleIssues,
        canUnarchiveIssue: permissions.canUnarchiveIssue,
        canUseServiceManagementAgentFeatures: permissions.canUseServiceDeskAgentFeatures,
        canBrowseUsers: permissions.canBrowseUsers,
        canViewDevTools: permissions.canViewDevTools,
        canViewWatchers: permissions.canViewWatchers,
        canExportIssue: permissions.canExportIssue
    }));
const $98da256956b02977$export$94c701814d50fed3 = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.issueContexts)) return [];
    return forge.issueContexts.filter((extension)=>(0, $5cmSg.isExtensionVisible)(extension)).map((contextPanels)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: url } } = contextPanels;
        return {
            id: id,
            type: (0, $41gqO.FORGE_CONTEXT_TYPE),
            payload: {
                type: (0, $41gqO.FORGE_CONTEXT_TYPE),
                label: label,
                name: title,
                status: status || null,
                icon: url ? {
                    url: url
                } : null,
                contextPanelType: (0, $awmXl.FORGE_ENTITY_TYPE),
                moduleKey: id,
                appKey: id,
                options: null
            }
        };
    });
});
const $98da256956b02977$export$92747468cb57714e = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.glances)) return [];
    return $98da256956b02977$var$filterExtensions(forge.glances).map((extension)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: icon } } = extension;
        return {
            title: title,
            label: label,
            status: status,
            icon: icon,
            extension: extension,
            glanceType: (0, $awmXl.FORGE_ENTITY_TYPE),
            // Legacy props, too much refactoring needed in order to get rid of them
            moduleKey: id,
            appKey: id
        };
    });
});
const $98da256956b02977$export$325ea69d1eb5eda0 = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.uiModifications)) return [];
    return forge.uiModifications;
});
const $98da256956b02977$export$9bcd40b01af57823 = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.actions)) return [];
    return $98da256956b02977$var$filterExtensions(forge.actions).map((extension)=>{
        const { id: id, properties: { title: title } } = extension;
        return {
            id: id,
            title: title,
            extension: extension,
            type: (0, $awmXl.FORGE_ENTITY_TYPE)
        };
    });
});
const $98da256956b02977$export$ca115d43abfd7206 = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.panels)) return [];
    return $98da256956b02977$var$filterExtensions(forge.panels).filter((extension)=>extension.properties.icon != null).map((extension)=>{
        const { id: id, properties: { title: title, icon: icon, allowMultiple: allowMultiple } } = extension;
        const { appKey: appKey, moduleKey: moduleKey } = (0, $eOKTW.toEcosystemKeys)(id);
        return {
            name: title,
            tooltip: title,
            iconUrl: icon,
            extension: extension,
            allowMultiple: !!allowMultiple,
            showByDefault: false,
            type: (0, $awmXl.FORGE_ENTITY_TYPE),
            moduleKey: moduleKey,
            appKey: appKey
        };
    }).sort($98da256956b02977$var$sortIssuePanels);
});
const $98da256956b02977$export$ae25fce59e44b253 = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), $98da256956b02977$export$b302c9df74ede99a, (isEcosystemEnabled, issueViewStaticContext)=>isEcosystemEnabled && issueViewStaticContext.canEditIssues);
const $98da256956b02977$export$9c375a0b9a6e5017 = (panelKey)=>(0, $dGvGJ.createSelector)((0, $4L22Y.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.selectedContentPanel === panelKey);
const $98da256956b02977$export$38dd8c9ba1d48d98 = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.customFields)) return [];
    return $98da256956b02977$var$filterExtensions(forge.customFields);
});
const $98da256956b02977$export$9cef69a20109a92c = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.customFieldTypes)) return [];
    return $98da256956b02977$var$filterExtensions(forge.customFieldTypes);
});
const $98da256956b02977$export$2f1d736b0e7e1293 = (0, $dGvGJ.createSelector)($98da256956b02977$export$38dd8c9ba1d48d98, (fields)=>fields.length > 0);
const $98da256956b02977$export$252a589d17b14921 = (0, $dGvGJ.createSelector)($98da256956b02977$export$9cef69a20109a92c, (fieldsTypes)=>fieldsTypes.length > 0);
const $98da256956b02977$export$89b67d7e4e300f7d = (0, $dGvGJ.createSelector)($98da256956b02977$export$2f1d736b0e7e1293, $98da256956b02977$export$252a589d17b14921, (hasCustomFields, hasCustomFieldTypes)=>hasCustomFields || hasCustomFieldTypes);
const $98da256956b02977$export$e824cf91ff446be9 = (0, $dGvGJ.createSelector)($98da256956b02977$export$38dd8c9ba1d48d98, $98da256956b02977$export$9cef69a20109a92c, (customFields, customFieldTypes)=>[
        ...customFields,
        ...customFieldTypes
    ]);
const $98da256956b02977$export$ccad5f28efcec42d = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled) return null;
    return forge.activeAction || null;
});
const $98da256956b02977$export$e04b25b621339356 = (0, $dGvGJ.createSelector)((0, $7Ow8a.fieldsSelector), (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>fields[fieldId]?.schema.custom || '');
const $98da256956b02977$export$fbab82209930cdab = (0, $dGvGJ.createSelector)($98da256956b02977$export$e824cf91ff446be9, $98da256956b02977$export$e04b25b621339356, (forgeFields, extensionId)=>{
    const extension = forgeFields.find((field)=>field.id === extensionId);
    return extension || null;
});
const $98da256956b02977$export$7640f867620fe598 = (0, $dGvGJ.createSelector)($98da256956b02977$export$fbab82209930cdab, (extension)=>{
    if (!extension) return false;
    const hasRenderingFunction = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(extension.properties.function);
    const hasFormatterDefined = 'formatter' in extension.properties && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(extension.properties.formatter);
    return !hasRenderingFunction && hasFormatterDefined;
});
const $98da256956b02977$export$d3cd515b7639ce61 = (0, $dGvGJ.createSelector)((0, $a1ky2.issueKeySelector), (0, $a1ky2.issueIdSelector), (0, $lssfC.issueTypeIdSelector), (0, $lssfC.issueTypeNameSelector), (0, $a1ky2.projectKeySelector), (0, $bcoYn.projectIdSelector), (0, $bcoYn.projectTypeSelector), (issueKey, issueId, issueTypeId, issueType, projectKey, projectId, projectType)=>({
        issue: {
            key: issueKey,
            id: issueId,
            type: issueType,
            typeId: issueTypeId
        },
        project: {
            id: projectId !== null ? (0, $g5X3G.toProjectId)(projectId.toString()) : projectId,
            key: projectKey,
            type: projectType
        }
    }));
const $98da256956b02977$export$18ce84b90b4920eb = (0, $dGvGJ.createSelector)((0, $a1ky2.isEcosystemEnabledSelector), (0, $4L22Y.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.actions)) return [];
    return $98da256956b02977$var$filterExtensions(forge.activities).map((extension)=>{
        const { id: id, properties: { title: title } } = extension;
        const { appKey: appKey, moduleKey: moduleKey } = (0, $eOKTW.toEcosystemKeys)(id);
        return {
            name: title,
            extension: extension,
            type: (0, $awmXl.FORGE_ENTITY_TYPE),
            moduleKey: moduleKey,
            appKey: appKey
        };
    });
});
const $98da256956b02977$export$97dadedc102bebdf = (0, $dGvGJ.createSelector)((0, $4L22Y.forgeEntitiesSelector), (_, issuePanelKey)=>issuePanelKey, (forge, issuePanelKey)=>forge.panelsKeys.newPanels.includes(issuePanelKey));
const $98da256956b02977$export$b01f1fc9eba6d8cd = (forgePanelKey)=>(0, $dGvGJ.createSelector)($98da256956b02977$export$ca115d43abfd7206, (panels)=>{
        const { extensionId: extensionId } = (0, $a2FgJ.parseForgeIssuePanel)(forgePanelKey) || {};
        return panels.find((panel)=>extensionId === panel.extension.id);
    });
const $98da256956b02977$export$3d7856e5c65d2291 = (0, $dGvGJ.createSelector)((0, $4L22Y.forgeEntitiesSelector), (_, issuePanelKey)=>issuePanelKey, (forge, issuePanelKey)=>forge.panelsKeys.collapsedPanels.includes(issuePanelKey));

});
parcelRegister("lssfC", function(module, exports) {

$parcel$export(module.exports, "createFullIssueUrl", () => $470f41730d0b2b6c$export$f107e3172d0c8a79);
$parcel$export(module.exports, "issueTypeSelector", () => $470f41730d0b2b6c$export$c5a236f192993436);
$parcel$export(module.exports, "issueUrlSelector", () => $470f41730d0b2b6c$export$7855e152de23b9ca);
$parcel$export(module.exports, "fullIssueUrlSelector", () => $470f41730d0b2b6c$export$14eeb219bfe6649b);
$parcel$export(module.exports, "issueTypeNameSelector", () => $470f41730d0b2b6c$export$477df8db13e4dac3);
$parcel$export(module.exports, "issueTypeHierarchyLevelSelector", () => $470f41730d0b2b6c$export$2bcfec06e5c80ef6);
$parcel$export(module.exports, "issueTypeIdSelector", () => $470f41730d0b2b6c$export$22410768c09b3a82);
$parcel$export(module.exports, "issueTypeIconUrlSelector", () => $470f41730d0b2b6c$export$4cf7e4622f7b8aee);
$parcel$export(module.exports, "isIssueTypeFieldEditableSelector", () => $470f41730d0b2b6c$export$580b385a93b77724);
$parcel$export(module.exports, "getParentIssuesSelector", () => $470f41730d0b2b6c$export$1e6d1c8ba22c2162);

var $dGvGJ = parcelRequire("dGvGJ");

var $fOGZN = parcelRequire("fOGZN");

var $a1ky2 = parcelRequire("a1ky2");

var $7Ow8a = parcelRequire("7Ow8a");

var $bcoYn = parcelRequire("bcoYn");
// @ts-expect-error - TS2304 - Cannot find name 'BaseUrl'. | TS7006 - Parameter 'issueKey' implicitly has an 'any' type.
const $470f41730d0b2b6c$var$createRelativeIssueUrl = (baseUrl, issueKey)=>`${baseUrl ? baseUrl.replace(/\/?$/, '/') : '/'}browse/${issueKey}`;
const $470f41730d0b2b6c$export$f107e3172d0c8a79 = (baseUrl, issueKey)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    `${window.location.protocol}//${window.location.host}${$470f41730d0b2b6c$var$createRelativeIssueUrl(baseUrl, issueKey)}`;
const $470f41730d0b2b6c$var$issueTypeFieldSelector = (0, $7Ow8a.fieldSelector)((0, $fOGZN.ISSUE_TYPE));
const $470f41730d0b2b6c$var$subtaskIssueFieldSelector = (0, $7Ow8a.fieldSelector)((0, $fOGZN.SUBTASK_PARENT));
const $470f41730d0b2b6c$var$portfolioParentFieldSelector = (0, $7Ow8a.fieldSelector)((0, $fOGZN.PARENT));
const $470f41730d0b2b6c$export$c5a236f192993436 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$issueTypeFieldSelector, (issueType)=>issueType && issueType.value);
const $470f41730d0b2b6c$export$7855e152de23b9ca = (0, $dGvGJ.createSelector)((0, $a1ky2.baseUrlSelector), (0, $a1ky2.issueKeySelector), $470f41730d0b2b6c$var$createRelativeIssueUrl);
const $470f41730d0b2b6c$export$14eeb219bfe6649b = (0, $dGvGJ.createSelector)((0, $a1ky2.baseUrlSelector), (0, $a1ky2.issueKeySelector), $470f41730d0b2b6c$export$f107e3172d0c8a79);
const $470f41730d0b2b6c$export$477df8db13e4dac3 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$export$c5a236f192993436, (issueType)=>issueType && issueType.name);
const $470f41730d0b2b6c$export$2bcfec06e5c80ef6 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$export$c5a236f192993436, (issueType)=>{
    if (!issueType) return null;
    return issueType && issueType.hierarchyLevel;
});
const $470f41730d0b2b6c$export$22410768c09b3a82 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$export$c5a236f192993436, (issueType)=>issueType && issueType.id);
const $470f41730d0b2b6c$export$4cf7e4622f7b8aee = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$export$c5a236f192993436, (issueType)=>issueType && issueType.iconUrl);
const $470f41730d0b2b6c$export$580b385a93b77724 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$issueTypeFieldSelector, (issueType)=>issueType && Boolean(issueType.editable));
const $470f41730d0b2b6c$var$transformParentIssue = (issue, baseUrl)=>issue ? {
        summary: issue.summary,
        key: issue.key,
        url: $470f41730d0b2b6c$var$createRelativeIssueUrl(baseUrl, issue.key),
        issueTypeName: issue.issueTypeName || '',
        issueTypeIconUrl: issue.issueTypeIconUrl || ''
    } : null;
// @ts-expect-error - TS7006 - Parameter 'issue' implicitly has an 'any' type.
const $470f41730d0b2b6c$var$transformSubtaskParentIssue = (issue, baseUrl)=>issue ? {
        summary: issue.fields.summary,
        key: issue.key,
        url: $470f41730d0b2b6c$var$createRelativeIssueUrl(baseUrl, issue.key),
        issueTypeName: issue.issueTypeName || '',
        issueTypeIconUrl: issue.issueTypeIconUrl || ''
    } : null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $470f41730d0b2b6c$var$transformPortfolioParentIssue = (value, baseUrl)=>value && value.data ? {
        summary: value.data.summary,
        key: value.data.key,
        url: $470f41730d0b2b6c$var$createRelativeIssueUrl(baseUrl, value.data.key),
        issueTypeName: value.data.issueTypeName || '',
        issueTypeIconUrl: value.data.issueTypeIconUrl || ''
    } : null;
const $470f41730d0b2b6c$export$77f9f02e63a0906f = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$portfolioParentFieldSelector, (0, $a1ky2.baseUrlSelector), (portfolioParentIssue, baseUrl)=>$470f41730d0b2b6c$var$transformPortfolioParentIssue(portfolioParentIssue && portfolioParentIssue.value, baseUrl));
const $470f41730d0b2b6c$var$subtaskIssueParentSelector = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$subtaskIssueFieldSelector, (0, $a1ky2.baseUrlSelector), (subtaskIssue, baseUrl)=>$470f41730d0b2b6c$var$transformSubtaskParentIssue(subtaskIssue && subtaskIssue.value, baseUrl));
const $470f41730d0b2b6c$var$parentIssueSelector = (0, $dGvGJ.createSelector)((0, $bcoYn.parentIssueEntitySelector), (0, $a1ky2.baseUrlSelector), (parentIssue, baseUrl)=>$470f41730d0b2b6c$var$transformParentIssue(parentIssue, baseUrl));
const $470f41730d0b2b6c$export$dfeb83ef40558422 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$parentIssueSelector, $470f41730d0b2b6c$var$subtaskIssueParentSelector, $470f41730d0b2b6c$export$77f9f02e63a0906f, (parentIssue, subtaskIssue, portfolioParentIssue)=>parentIssue || subtaskIssue || portfolioParentIssue);
const $470f41730d0b2b6c$export$1e6d1c8ba22c2162 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$parentIssueSelector, (parentIssue)=>[
        parentIssue
    ].filter(Boolean));

});



parcelRegister("jMY7o", function(module, exports) {

$parcel$export(module.exports, "supportedChildIssueTypesEntitiesSelector", () => $67134f469e001b64$export$1e8043fccfcba3b9);
$parcel$export(module.exports, "supportsChildCreationSelector", () => $67134f469e001b64$export$1af32b549149f3d9);
$parcel$export(module.exports, "parentLevelIssueTypeIdsSelector", () => $67134f469e001b64$export$be50776e2ae27cf6);
$parcel$export(module.exports, "parentLevelIssueTypeNamesSelector", () => $67134f469e001b64$export$57b3549670d3627b);
$parcel$export(module.exports, "sameLevelIssueTypesIdsSelector", () => $67134f469e001b64$export$a81bfe971074142b);
$parcel$export(module.exports, "hierarchyLevelSelector", () => $67134f469e001b64$export$4f7eb1d272a8015);
$parcel$export(module.exports, "isIssueBaseLevel", () => $67134f469e001b64$export$d9c73da87a448c4);
$parcel$export(module.exports, "canLinkToParentSelector", () => $67134f469e001b64$export$5530450eb840ecb2);

var $dGvGJ = parcelRequire("dGvGJ");

var $g4tDr = parcelRequire("g4tDr");

var $5fc53 = parcelRequire("5fc53");

var $7Ow8a = parcelRequire("7Ow8a");

var $bcoYn = parcelRequire("bcoYn");

var $hKi22 = parcelRequire("hKi22");

var $6UM3P = parcelRequire("6UM3P");
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $67134f469e001b64$var$childLevelValueSelector = (0, $7Ow8a.fieldPersistedValueSelector)((0, $5fc53.HIERARCHY_LEVEL_BELOW)) || null;
const $67134f469e001b64$var$isChildLevelSubtaskLevelSelector = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$67134f469e001b64$var$childLevelValueSelector, (childLevelFieldValue)=>{
    if (!childLevelFieldValue) return false;
    return (0, $g4tDr.isSubtaskHierarchyLevel)(childLevelFieldValue.level);
});
const $67134f469e001b64$export$7a45e255c239753 = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$67134f469e001b64$var$childLevelValueSelector, (childLevelValue)=>childLevelValue && childLevelValue.issueTypes || []);
const $67134f469e001b64$export$1e8043fccfcba3b9 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), $67134f469e001b64$export$7a45e255c239753, (entities, supportedIssueTypes)=>{
    const allIssueTypes = entities.issueTypes;
    const supportedIssueTypeIds = supportedIssueTypes.map((issueType)=>issueType.id);
    return allIssueTypes.filter(// @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
    (issueType)=>supportedIssueTypeIds.indexOf(issueType.id) !== -1);
});
const $67134f469e001b64$export$1af32b549149f3d9 = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), $67134f469e001b64$export$7a45e255c239753, $67134f469e001b64$var$isChildLevelSubtaskLevelSelector, (0, $bcoYn.isSimplifiedProjectSelector), (permissions, supportedChildIssueTypes, isChildLevelSubtask, isSimplifiedProject)=>permissions.canCreateChildren && !!supportedChildIssueTypes.length && (isSimplifiedProject ? true : !isChildLevelSubtask));
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $67134f469e001b64$var$parentLevelValueSelector = (0, $7Ow8a.fieldPersistedValueSelector)((0, $5fc53.HIERARCHY_LEVEL_ABOVE)) || null;
const $67134f469e001b64$export$55a6507420d37093 = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$67134f469e001b64$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && (parentLevelValue.name || null));
const $67134f469e001b64$export$be50776e2ae27cf6 = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$67134f469e001b64$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && parentLevelValue.issueTypeIds.map(String) || []);
const $67134f469e001b64$export$57b3549670d3627b = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$67134f469e001b64$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && parentLevelValue.issueTypes.map((type)=>type.name).filter((name)=>name) || []);
const $67134f469e001b64$export$121e4a84c99db916 = (0, $dGvGJ.createSelector)($67134f469e001b64$export$be50776e2ae27cf6, (parentLevelValue)=>parentLevelValue.length > 0);
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $67134f469e001b64$var$sameLevelValueSelector = (0, $7Ow8a.fieldPersistedValueSelector)((0, $5fc53.HIERARCHY_LEVEL_SAME_LEVEL)) || null;
const $67134f469e001b64$export$26996c7f0f08c0d8 = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$67134f469e001b64$var$sameLevelValueSelector, (sameLevelFieldValue)=>{
    if (!sameLevelFieldValue) return false;
    return (0, $g4tDr.isSubtaskHierarchyLevel)(sameLevelFieldValue.level);
});
const $67134f469e001b64$export$a81bfe971074142b = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$67134f469e001b64$var$sameLevelValueSelector, (sameLevelFieldValue)=>sameLevelFieldValue ? sameLevelFieldValue.issueTypeIds.map(String) : []);
const $67134f469e001b64$export$4f7eb1d272a8015 = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$67134f469e001b64$var$sameLevelValueSelector, (sameLevelFieldValue)=>sameLevelFieldValue ? (0, $g4tDr.toHierarchyLevel)(sameLevelFieldValue.level) : null);
const $67134f469e001b64$export$d9c73da87a448c4 = (0, $dGvGJ.createSelector)($67134f469e001b64$export$4f7eb1d272a8015, (level)=>{
    if (level == null) // Some product types (JSM, Core, ...) do not support hierarchies at all and will not return this field.
    // For these, all issues are considered to be "Base" level.
    return true;
    return (0, $g4tDr.isBaseHierarchyLevel)(level);
});
const $67134f469e001b64$export$5530450eb840ecb2 = (0, $dGvGJ.createSelector)($67134f469e001b64$export$55a6507420d37093, (0, $6UM3P.canEditIssuesSelector), $67134f469e001b64$export$121e4a84c99db916, (parentLevelName, shouldShowAddParent, hasParentIssueTypeId)=>Boolean(parentLevelName) && shouldShowAddParent && hasParentIssueTypeId);

});
parcelRegister("g4tDr", function(module, exports) {

$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", () => $03dd5f7faa501890$export$2294cfc7730248df);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", () => $03dd5f7faa501890$export$961a1d6da881600c);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", () => $03dd5f7faa501890$export$e11dea67b88ee556);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", () => $03dd5f7faa501890$export$9ad20e435294162a);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", () => $03dd5f7faa501890$export$a454b3474c5ee5f5);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", () => $03dd5f7faa501890$export$b69c1b48ce8f83de);
$parcel$export(module.exports, "BASE_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$ba7c785763a2a58f);
$parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$e09d07f2dcff2603);
$parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$1165245f61159842);
$parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$8a96a83b3f957e58);
$parcel$export(module.exports, "toHierarchyLevel", () => $03dd5f7faa501890$export$c0c893ca5ccae9dd);
$parcel$export(module.exports, "isBaseHierarchyLevel", () => $03dd5f7faa501890$export$bcf91a9d8c5b0f58);
$parcel$export(module.exports, "isEpicHierarchyLevel", () => $03dd5f7faa501890$export$e415cf60723c7aae);
$parcel$export(module.exports, "isSubtaskHierarchyLevel", () => $03dd5f7faa501890$export$41f00a40e2ebd6e8);
$parcel$export(module.exports, "getHierarchyLevelType", () => $03dd5f7faa501890$export$556b686fea6fb229);
$parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", () => $03dd5f7faa501890$export$638ac52227e67c8);
const $03dd5f7faa501890$export$2294cfc7730248df = 4;
const $03dd5f7faa501890$export$961a1d6da881600c = 3;
const $03dd5f7faa501890$export$e11dea67b88ee556 = 2;
const $03dd5f7faa501890$export$9ad20e435294162a = 1;
const $03dd5f7faa501890$export$a454b3474c5ee5f5 = 0;
const $03dd5f7faa501890$export$b69c1b48ce8f83de = -1;
const $03dd5f7faa501890$export$ba7c785763a2a58f = 'BASE';
const $03dd5f7faa501890$export$e09d07f2dcff2603 = 'CHILD';
const $03dd5f7faa501890$export$1165245f61159842 = 'PARENT';
const $03dd5f7faa501890$export$8a96a83b3f957e58 = 'EPIC';
const $03dd5f7faa501890$export$c0c893ca5ccae9dd = (level)=>level;
const $03dd5f7faa501890$export$bcf91a9d8c5b0f58 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return true;
    return numericLevel === $03dd5f7faa501890$export$a454b3474c5ee5f5;
};
const $03dd5f7faa501890$export$e415cf60723c7aae = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $03dd5f7faa501890$export$9ad20e435294162a;
};
const $03dd5f7faa501890$export$41f00a40e2ebd6e8 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $03dd5f7faa501890$export$b69c1b48ce8f83de;
};
const $03dd5f7faa501890$export$556b686fea6fb229 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) > 0) return $03dd5f7faa501890$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
    return $03dd5f7faa501890$export$ba7c785763a2a58f;
};
const $03dd5f7faa501890$export$638ac52227e67c8 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) === 1) return $03dd5f7faa501890$export$8a96a83b3f957e58;
    if (Number(hierarchyLevel) > 1) return $03dd5f7faa501890$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
    return $03dd5f7faa501890$export$ba7c785763a2a58f;
};

});

parcelRegister("6UM3P", function(module, exports) {

$parcel$export(module.exports, "canEditIssuesSelector", () => $ab04ad11f2d2260b$export$cdd6892c8add3e54);
$parcel$export(module.exports, "canLinkIssuesSelector", () => $ab04ad11f2d2260b$export$50487d0d29271836);

var $dGvGJ = parcelRequire("dGvGJ");

var $hKi22 = parcelRequire("hKi22");
const $ab04ad11f2d2260b$export$a7a483ca0afc4ab3 = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (permissions)=>permissions.canCloneIssue);
const $ab04ad11f2d2260b$export$c1f4ef01259b4eb = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (permissions)=>permissions.canDeleteIssue);
const $ab04ad11f2d2260b$export$2f9dd165cbf0c5ea = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (permissions)=>permissions.canMoveIssue);
const $ab04ad11f2d2260b$export$cdd6892c8add3e54 = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (permissions)=>permissions.canEditIssues);
const $ab04ad11f2d2260b$export$f48030c6644c0c4d = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (permissions)=>permissions.canAdministerJira || permissions.canAdministerProject);
const $ab04ad11f2d2260b$export$4e8dac873f71d13e = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (permissions)=>permissions.canAssignIssues);
const $ab04ad11f2d2260b$export$50487d0d29271836 = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (permissions)=>permissions.canLinkIssues);

});


parcelRegister("hwyJi", function(module, exports) {

$parcel$export(module.exports, "ecosystemCustomFieldIdsSelector", () => $7ea8e744bda72f86$export$c16e6010c2ccc7b2);

var $dGvGJ = parcelRequire("dGvGJ");

var $69oHP = parcelRequire("69oHP");

var $fOGZN = parcelRequire("fOGZN");

var $7Ow8a = parcelRequire("7Ow8a");
const $7ea8e744bda72f86$export$1caf4359a6680b64 = (0, $dGvGJ.createSelector)((0, $7Ow8a.fieldsSelector), (fields)=>Object.keys(fields).filter((id)=>{
        const type = (0, $69oHP.getFieldType)(fields[id]);
        return type && (0, $fOGZN.customFieldsToDisplay)().includes(type);
    }));
const $7ea8e744bda72f86$export$c16e6010c2ccc7b2 = (0, $dGvGJ.createSelector)((0, $7Ow8a.fieldsSelector), (fields)=>Object.keys(fields).filter((id)=>{
        const type = (0, $69oHP.getFieldType)(fields[id]);
        return type && (0, $fOGZN.ecosystemCustomFields).includes(type);
    }));

});

parcelRegister("d4MOh", function(module, exports) {

$parcel$export(module.exports, "entitiesCommentsSelector", () => $1d69b1e69b91ee0e$export$2bcb958351592bb9);
$parcel$export(module.exports, "totalCommentsSelector", () => $1d69b1e69b91ee0e$export$3873a5701cda7746);
$parcel$export(module.exports, "startIndexCommentsSelector", () => $1d69b1e69b91ee0e$export$10621129a0e171e5);
$parcel$export(module.exports, "loadedCommentsSelector", () => $1d69b1e69b91ee0e$export$c3802eebab78988b);
$parcel$export(module.exports, "commentsPageInfoSelector", () => $1d69b1e69b91ee0e$export$bf7222a172daf33c);
$parcel$export(module.exports, "isLoadingMoreCommentsSelector", () => $1d69b1e69b91ee0e$export$5d4ebbdab84a3a1);
$parcel$export(module.exports, "hasScrolledPermalinkCommentSelector", () => $1d69b1e69b91ee0e$export$3190c124f9d4af8a);
$parcel$export(module.exports, "loadingMoreChildCommentsSelector", () => $1d69b1e69b91ee0e$export$59d9db30c7503d0f);
$parcel$export(module.exports, "loadingStageSelector", () => $1d69b1e69b91ee0e$export$18bc980d36bf93d);
$parcel$export(module.exports, "commentAuthorSelector", () => $1d69b1e69b91ee0e$export$6f6ac03c75ab3545);
$parcel$export(module.exports, "commentUpdateAuthorSelector", () => $1d69b1e69b91ee0e$export$7190d6fab16715b8);
$parcel$export(module.exports, "commentEditingBodySelector", () => $1d69b1e69b91ee0e$export$3e2634438f2a9b1a);
$parcel$export(module.exports, "commentEditingVisibilitySelector", () => $1d69b1e69b91ee0e$export$3c2f8c0a34054ef7);
$parcel$export(module.exports, "commentEditingOrViewBodyAdfSelector", () => $1d69b1e69b91ee0e$export$b0e0bc0c48cf00e6);
$parcel$export(module.exports, "commentOutsiderCommentSelector", () => $1d69b1e69b91ee0e$export$e7022c391905c53f);
$parcel$export(module.exports, "commentBodyHtmlSelector", () => $1d69b1e69b91ee0e$export$b9c6e85825c49cba);
$parcel$export(module.exports, "commentIsDeletedSelector", () => $1d69b1e69b91ee0e$export$e6360edf7c25f03d);
$parcel$export(module.exports, "commentRepliesSelector", () => $1d69b1e69b91ee0e$export$9fdd1ba68d7464f1);
$parcel$export(module.exports, "childCommentsPageInfoSelector", () => $1d69b1e69b91ee0e$export$f8de4e824ff1662d);
$parcel$export(module.exports, "commentCreatedDateSelector", () => $1d69b1e69b91ee0e$export$b580f3d971b4e6fb);
$parcel$export(module.exports, "commentUpdatedDateSelector", () => $1d69b1e69b91ee0e$export$8b9935e49715b2d6);
$parcel$export(module.exports, "commentEditedSelector", () => $1d69b1e69b91ee0e$export$eff4fd551b2f55a1);
$parcel$export(module.exports, "pendingCommentSelector", () => $1d69b1e69b91ee0e$export$d63578bef1057cae);
$parcel$export(module.exports, "commentIsOptimisticSelector", () => $1d69b1e69b91ee0e$export$be047268481f07d8);
$parcel$export(module.exports, "commentSaveFailedSelector", () => $1d69b1e69b91ee0e$export$72075ae8ef4d6f6a);
$parcel$export(module.exports, "commentHasDeleteModalSelector", () => $1d69b1e69b91ee0e$export$c756ab72f25508bb);
$parcel$export(module.exports, "commentVisibilitySelector", () => $1d69b1e69b91ee0e$export$2cf9d22f626e5db0);
$parcel$export(module.exports, "commentEditingOrViewVisibilitySelector", () => $1d69b1e69b91ee0e$export$82fbf902093fe491);
$parcel$export(module.exports, "commentEditingEventOccurredAtSelector", () => $1d69b1e69b91ee0e$export$d820e1c3ac105e35);
$parcel$export(module.exports, "commentEventOccurredAtSelector", () => $1d69b1e69b91ee0e$export$9c8937d1bd8cf4a);
$parcel$export(module.exports, "commentJsdIncidentActivityViewHiddenSelector", () => $1d69b1e69b91ee0e$export$8c7be677b9a2cbf3);
$parcel$export(module.exports, "commentEditSessionContainsAttachmentsUsageSelector", () => $1d69b1e69b91ee0e$export$2a2670a8fb40391d);
$parcel$export(module.exports, "isInternalCommentSelector", () => $1d69b1e69b91ee0e$export$b99aa78c1374f9fe);
$parcel$export(module.exports, "isEditingInternalCommentSelector", () => $1d69b1e69b91ee0e$export$54205c8c886a2b43);
$parcel$export(module.exports, "canAddCommentsSelector", () => $1d69b1e69b91ee0e$export$a34c155854eb296b);
$parcel$export(module.exports, "canDeleteCommentSelector", () => $1d69b1e69b91ee0e$export$8cc876bb72dc09b7);
$parcel$export(module.exports, "canEditCommentSelector", () => $1d69b1e69b91ee0e$export$eb110f3a00a8432);
$parcel$export(module.exports, "visibleCommentIdsSelector", () => $1d69b1e69b91ee0e$export$3b3d01d442cb684a);
$parcel$export(module.exports, "isThreadedCommentsEnabledSelector", () => $1d69b1e69b91ee0e$export$f81b9f2c3f00b89b);
$parcel$export(module.exports, "sortedVisibleCommentIdsSelector", () => $1d69b1e69b91ee0e$export$81c523e14f04df2d);
$parcel$export(module.exports, "getPersistedLatestCommentTimeSelector", () => $1d69b1e69b91ee0e$export$219697701c39ce2b);
$parcel$export(module.exports, "getCommentsViewedEventTriggeredSelector", () => $1d69b1e69b91ee0e$export$434434d0e137800b);
$parcel$export(module.exports, "getFullScreenLayoutSelector", () => $1d69b1e69b91ee0e$export$a150279c255f50ac);
$parcel$export(module.exports, "getUnreadCommentCountSelector", () => $1d69b1e69b91ee0e$export$567463de4ddebb27);
$parcel$export(module.exports, "getTopMostUnreadCommentIdSelector", () => $1d69b1e69b91ee0e$export$1332aaf4376530cf);
$parcel$export(module.exports, "getCommentScrollStatusForRealTimeUpdates", () => $1d69b1e69b91ee0e$export$f852f38f61c8471);
$parcel$export(module.exports, "isEditingCommentSelector", () => $1d69b1e69b91ee0e$export$6eba3f548a7f384e);
$parcel$export(module.exports, "commentSessionIdSelector", () => $1d69b1e69b91ee0e$export$239be48dfe5d80ba);
$parcel$export(module.exports, "getEditingCommentIdsSelector", () => $1d69b1e69b91ee0e$export$3a00787e516c672c);
$parcel$export(module.exports, "commentIdsSelector", () => $1d69b1e69b91ee0e$export$4c04cd370caea884);
$parcel$export(module.exports, "isEditingAnyCommentSelector", () => $1d69b1e69b91ee0e$export$2e24e984817b4c7b);
$parcel$export(module.exports, "isAddCommentEditorExpandedSelector", () => $1d69b1e69b91ee0e$export$5373a6bfd674797c);
$parcel$export(module.exports, "addCommentEditorForceFocusSelector", () => $1d69b1e69b91ee0e$export$37aee7d1ec9d42d3);
$parcel$export(module.exports, "isCommentEditorOpenSelector", () => $1d69b1e69b91ee0e$export$6df0ef2ac2b35c13);
$parcel$export(module.exports, "isCommentAttachmentInProgressSelector", () => $1d69b1e69b91ee0e$export$f140c5c89826efc6);
$parcel$export(module.exports, "isCommentVisibilityRestrictionSupportedSelector", () => $1d69b1e69b91ee0e$export$2ce513eb85289331);
$parcel$export(module.exports, "isReplyingToCommentSelector", () => $1d69b1e69b91ee0e$export$ab64c511f5921cdf);
$parcel$export(module.exports, "isCommentReplyEditorOpenSelector", () => $1d69b1e69b91ee0e$export$d89d07d36d57d778);
$parcel$export(module.exports, "replyContentSelector", () => $1d69b1e69b91ee0e$export$bb44f1aa6771eeb6);
$parcel$export(module.exports, "replyingToAuthorSelector", () => $1d69b1e69b91ee0e$export$6fe69cb268473af1);
$parcel$export(module.exports, "commentParentIdSelector", () => $1d69b1e69b91ee0e$export$9f25935861e23f9b);
$parcel$export(module.exports, "hasPublicCommentsSelector", () => $1d69b1e69b91ee0e$export$f3cffcd4d32274f6);

var $dGvGJ = parcelRequire("dGvGJ");

var $dMEgP = parcelRequire("dMEgP");

var $g7reD = parcelRequire("g7reD");

var $8ikER = parcelRequire("8ikER");

var $2vSU6 = parcelRequire("2vSU6");


var $g2C8o = parcelRequire("g2C8o");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");


var $a1ky2 = parcelRequire("a1ky2");

var $bcoYn = parcelRequire("bcoYn");

var $hKi22 = parcelRequire("hKi22");

var $2QmDq = parcelRequire("2QmDq");

const $1d69b1e69b91ee0e$export$9832028921909a8f = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.pendingDeletedIds);
const $1d69b1e69b91ee0e$export$2bcb958351592bb9 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.comments);
const $1d69b1e69b91ee0e$export$3873a5701cda7746 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.totalComments);
const $1d69b1e69b91ee0e$export$10621129a0e171e5 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.commentsStartIndex);
const $1d69b1e69b91ee0e$export$c3802eebab78988b = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.loadedComments);
const $1d69b1e69b91ee0e$export$bf7222a172daf33c = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.commentsPageInfo);
const $1d69b1e69b91ee0e$export$5d4ebbdab84a3a1 = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.isLoadingMoreComments);
const $1d69b1e69b91ee0e$export$3190c124f9d4af8a = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.hasScrolledPermalinkComment);
const $1d69b1e69b91ee0e$export$cb15fb58f04e4339 = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.pendingSavedValues);
const $1d69b1e69b91ee0e$var$deleteModalCommentIdSelector = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.deleteModalCommentId);
const $1d69b1e69b91ee0e$export$59d9db30c7503d0f = (commentId)=>(0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments?.childButtonLoadingState?.[commentId] ?? null);
const $1d69b1e69b91ee0e$export$18bc980d36bf93d = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.loadingStage);
const $1d69b1e69b91ee0e$export$f82d111da9150583 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$2bcb958351592bb9, $1d69b1e69b91ee0e$export$cb15fb58f04e4339, (comments, optimisticComments)=>{
    if (!(0, $4R6GH.fg)('threaded_comments_old_checks')) return {
        ...comments,
        ...optimisticComments
    };
    const allComments = {
        ...comments
    };
    for(const key in optimisticComments)if (Object.prototype.hasOwnProperty.call(comments, key)) allComments[key] = {
        ...allComments[key],
        ...optimisticComments[key]
    };
    else allComments[key] = optimisticComments[key];
    return allComments;
});
const $1d69b1e69b91ee0e$var$commentSelector = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$f82d111da9150583, (comments)=>comments[commentId]);
const $1d69b1e69b91ee0e$var$persistedCommentSelector = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$2bcb958351592bb9, (comments)=>comments[commentId]);
// If the user is anonymous, then they are not considered comment author
const $1d69b1e69b91ee0e$var$isUserCommentAuthorSelector = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (0, $a1ky2.accountIdloggedInUserSelector), (comment, loggedInUserId)=>loggedInUserId !== null && loggedInUserId === (comment && comment.authorId));
const $1d69b1e69b91ee0e$var$authorSelector = (commentId, authorIdPropertyName)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (0, $bcoYn.getUserByIdSelector), (comment, userByIdSelector)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'OptimisticComment | PersistedComment'.
        comment && comment[authorIdPropertyName] ? userByIdSelector(comment[authorIdPropertyName]) : null);
const $1d69b1e69b91ee0e$var$uiAllCommentsSelector = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui && ui.comments || null);
const $1d69b1e69b91ee0e$var$uiAllCommentEditorsSelector = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiAllCommentsSelector, (uiComments)=>uiComments && uiComments.commentEditors || null);
const $1d69b1e69b91ee0e$var$uiCommentEditorSelector = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiAllCommentEditorsSelector, (uiCommentEditors)=>uiCommentEditors && uiCommentEditors[commentId] || null);
const $1d69b1e69b91ee0e$export$6f6ac03c75ab3545 = (commentId)=>$1d69b1e69b91ee0e$var$authorSelector(commentId, 'authorId');
const $1d69b1e69b91ee0e$export$7190d6fab16715b8 = (commentId)=>$1d69b1e69b91ee0e$var$authorSelector(commentId, 'updateAuthorId');
const $1d69b1e69b91ee0e$export$3e2634438f2a9b1a = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.editingValue || null);
const $1d69b1e69b91ee0e$export$3c2f8c0a34054ef7 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.visibility || null);
const $1d69b1e69b91ee0e$export$b0e0bc0c48cf00e6 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$3e2634438f2a9b1a(commentId), $1d69b1e69b91ee0e$var$commentSelector(commentId), (editingComment, comment)=>editingComment || comment && comment.bodyAdf || null);
const $1d69b1e69b91ee0e$export$e7022c391905c53f = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.jsdAuthorCanSeeRequest : null);
const $1d69b1e69b91ee0e$export$b9c6e85825c49cba = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.bodyHtml : null);
const $1d69b1e69b91ee0e$export$e6360edf7c25f03d = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.isDeleted : null);
const $1d69b1e69b91ee0e$export$9fdd1ba68d7464f1 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$persistedCommentSelector(commentId), $1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9832028921909a8f, (comment, allComments, deletedIds)=>{
        if (comment?.childCommentIds && comment.childCommentIds.size > 0) {
            const nonDeletedReplies = Array.from(comment.childCommentIds).filter((id)=>!deletedIds.includes(id) && allComments[id]);
            if (nonDeletedReplies.length > 0) return nonDeletedReplies.map($1d69b1e69b91ee0e$var$mapIdToCommentSortInfo(allComments)).sort($1d69b1e69b91ee0e$var$compareComments).map((sortedComment)=>sortedComment.id);
        }
        return null;
    });
const $1d69b1e69b91ee0e$export$f8de4e824ff1662d = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$persistedCommentSelector(commentId), (comment)=>comment?.childCommentsPageInfo ?? {});
const $1d69b1e69b91ee0e$export$b580f3d971b4e6fb = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.createdDate : null);
const $1d69b1e69b91ee0e$export$8b9935e49715b2d6 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.updatedDate : null);
const $1d69b1e69b91ee0e$export$eff4fd551b2f55a1 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.edited : null);
const $1d69b1e69b91ee0e$export$d63578bef1057cae = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$cb15fb58f04e4339, (pendingComments)=>pendingComments[commentId]);
const $1d69b1e69b91ee0e$export$be047268481f07d8 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$d63578bef1057cae(commentId), (pendingComment)=>!!pendingComment);
const $1d69b1e69b91ee0e$export$72075ae8ef4d6f6a = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$d63578bef1057cae(commentId), (pendingComment)=>!!(pendingComment && pendingComment.hasSaveFailed));
const $1d69b1e69b91ee0e$export$c756ab72f25508bb = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$deleteModalCommentIdSelector, (deleteModalCommentId)=>deleteModalCommentId === commentId);
const $1d69b1e69b91ee0e$export$2cf9d22f626e5db0 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>{
        return comment ? comment.visibility : (0, $g2C8o.COMMENT_VISIBILITY_PUBLIC);
    });
const $1d69b1e69b91ee0e$var$commentIsInternalSelector = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.isInternal : false);
const $1d69b1e69b91ee0e$export$82fbf902093fe491 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$3c2f8c0a34054ef7(commentId), $1d69b1e69b91ee0e$export$2cf9d22f626e5db0(commentId), (editingVisibility, visibility)=>editingVisibility || visibility);
const $1d69b1e69b91ee0e$export$d820e1c3ac105e35 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.eventOccurredAt || null);
const $1d69b1e69b91ee0e$export$9c8937d1bd8cf4a = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment && comment.eventOccurredAt ? comment.eventOccurredAt : null);
const $1d69b1e69b91ee0e$export$9b5c22d8443e21d6 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$d820e1c3ac105e35(commentId), $1d69b1e69b91ee0e$export$9c8937d1bd8cf4a(commentId), (editingEventOccurredAt, eventOccurredAt)=>editingEventOccurredAt || eventOccurredAt);
const $1d69b1e69b91ee0e$export$8c7be677b9a2cbf3 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment && typeof comment.jsdIncidentActivityViewHidden === 'boolean' ? comment.jsdIncidentActivityViewHidden : null);
const $1d69b1e69b91ee0e$export$2a2670a8fb40391d = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (comment)=>!!comment?.editSessionContainsAttachmentsUsage);
const $1d69b1e69b91ee0e$export$b99aa78c1374f9fe = (commentId)=>(0, $dGvGJ.createSelector)((0, $a1ky2.isServiceDeskSelector), $1d69b1e69b91ee0e$var$commentIsInternalSelector(commentId), (isServiceDeskComment, isInternal)=>isServiceDeskComment && isInternal);
const $1d69b1e69b91ee0e$export$54205c8c886a2b43 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (commentEditor)=>commentEditor?.isInternal ?? true);
const $1d69b1e69b91ee0e$export$a34c155854eb296b = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (permissions)=>permissions.canAddComments);
const $1d69b1e69b91ee0e$export$8cc876bb72dc09b7 = (commentId)=>(0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), $1d69b1e69b91ee0e$var$isUserCommentAuthorSelector(commentId), (permissions, isUserCommentAuthor)=>permissions.canDeleteAllComments || permissions.canDeleteOwnComments && isUserCommentAuthor);
const $1d69b1e69b91ee0e$export$eb110f3a00a8432 = (commentId)=>(0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), $1d69b1e69b91ee0e$var$isUserCommentAuthorSelector(commentId), (permissions, isUserCommentAuthor)=>permissions.canEditAllComments || permissions.canEditOwnComments && isUserCommentAuthor);
const $1d69b1e69b91ee0e$var$mapIdToCommentSortInfo = (comments)=>(id)=>{
        const comment = comments[id];
        return {
            id: id,
            createdDate: new Date(comment.createdDate),
            eventOccurredAt: comment.eventOccurredAt ? new Date(comment.eventOccurredAt) : null,
            size: comment?.childCommentIds?.size ?? 0
        };
    };
const $1d69b1e69b91ee0e$var$compareComments = (a, b)=>{
    if (a.eventOccurredAt && b.eventOccurredAt && (0, $g7reD.default)(a.eventOccurredAt, b.eventOccurredAt) === 0) return (0, $g7reD.default)(a.createdDate, b.createdDate);
    const dateForA = a.eventOccurredAt ? a.eventOccurredAt : a.createdDate;
    const dateForB = b.eventOccurredAt ? b.eventOccurredAt : b.createdDate;
    return (0, $g7reD.default)(dateForA, dateForB);
};
const $1d69b1e69b91ee0e$export$3b3d01d442cb684a = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9832028921909a8f, (comments, deletedIds)=>{
    // filter out any comments currently pending deletion
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>!deletedIds.includes(id));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map($1d69b1e69b91ee0e$var$mapIdToCommentSortInfo(comments)).sort($1d69b1e69b91ee0e$var$compareComments).map((comment)=>comment.id);
    return sortedIds;
});
const $1d69b1e69b91ee0e$var$compareCommentsInclSortOrderType = (sortOrderType)=>(a, b)=>{
        if (a.eventOccurredAt && b.eventOccurredAt && (0, $g7reD.default)(a.eventOccurredAt, b.eventOccurredAt) === 0) return sortOrderType === (0, $c97bf8752afb1bcb$export$e86669f498228fff) ? (0, $g7reD.default)(a.createdDate, b.createdDate) : (0, $8ikER.default)(a.createdDate, b.createdDate);
        const dateForA = a.eventOccurredAt ? a.eventOccurredAt : a.createdDate;
        const dateForB = b.eventOccurredAt ? b.eventOccurredAt : b.createdDate;
        return sortOrderType === (0, $c97bf8752afb1bcb$export$e86669f498228fff) ? (0, $g7reD.default)(dateForA, dateForB) : (0, $8ikER.default)(dateForA, dateForB);
    };
const $1d69b1e69b91ee0e$export$f81b9f2c3f00b89b = (0, $dGvGJ.createSelector)((0, $bcoYn.projectTypeSelector), $1d69b1e69b91ee0e$export$f82d111da9150583, (projectType, allComments)=>(projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT)) && allComments && Object.keys(allComments).length > 0 && (0, $6s1PB.expVal)('threaded_comments_ga', 'isEnabled', false));
const $1d69b1e69b91ee0e$export$81c523e14f04df2d = (0, $dGvGJ.createSelector)((0, $2QmDq.getSelectedActivitySortOrder), $1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9832028921909a8f, $1d69b1e69b91ee0e$export$f81b9f2c3f00b89b, (sortOrderType, comments, deletedIds, isThreadedCommentsEnabled)=>{
    // filter out any comments currently pending deletion and replies as well
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>(deletedIds.includes(id) && comments[id]?.isDeleted && isThreadedCommentsEnabled || !deletedIds.includes(id)) && (isThreadedCommentsEnabled ? !comments[id].parentId : true));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map($1d69b1e69b91ee0e$var$mapIdToCommentSortInfo(comments)).sort($1d69b1e69b91ee0e$var$compareCommentsInclSortOrderType(sortOrderType)).map((comment)=>{
        // Both should be cleaned up together.
        if ((0, $4R6GH.fg)('cleanup_unwanted_threaded_comments_flag_check') || isThreadedCommentsEnabled) return {
            id: comment.id,
            size: comment.size
        };
        return comment.id;
    });
    return sortedIds;
});
const $1d69b1e69b91ee0e$export$219697701c39ce2b = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.latestCommentViewInteractedTime);
const $1d69b1e69b91ee0e$export$434434d0e137800b = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.commentsViewedEventTriggered);
const $1d69b1e69b91ee0e$export$fc1a070fbadb4b5d = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.isRealTimeCommentUpdated);
const $1d69b1e69b91ee0e$export$a150279c255f50ac = (0, $dGvGJ.createSelector)((0, $2QmDq.getSelectedActivityLayout), (0, $a1ky2.analyticsSourceSelector), (0, $bcoYn.projectTypeSelector), (selectedActivityFeedLayout, analyticSource, projectType)=>{
    if ((projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT)) && analyticSource === (0, $fcf97b7a09088940$export$b19f949fb9713614)) return selectedActivityFeedLayout;
    return null;
});
const $1d69b1e69b91ee0e$export$c6165da2884619ed = (0, $dGvGJ.createSelector)((0, $a1ky2.accountIdloggedInUserSelector), $1d69b1e69b91ee0e$export$219697701c39ce2b, $1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9832028921909a8f, (currentUserId, latestCommentTime, allComments, deletedIds)=>{
    if (!latestCommentTime) return [];
    return Object.keys(allComments).filter((commentId)=>{
        const { createdDate: createdDate, authorId: authorId } = allComments[commentId];
        // Exclude comments from current user and deleted comments in unread count
        if (currentUserId === authorId || deletedIds.includes(commentId) || allComments[commentId]?.isDeleted) return false;
        // Check if the comment is more recent than the latest comment time
        return new Date(createdDate) > new Date(latestCommentTime);
    });
});
const $1d69b1e69b91ee0e$export$567463de4ddebb27 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$c6165da2884619ed, (unreadCommentIds)=>{
    return unreadCommentIds.length;
});
const $1d69b1e69b91ee0e$export$1332aaf4376530cf = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$81c523e14f04df2d, $1d69b1e69b91ee0e$export$c6165da2884619ed, (comments, visibleCommentIds, unreadCommentIds)=>{
    for (const comment of visibleCommentIds){
        const commentId = typeof comment === 'object' ? comment.id : comment;
        // Check if the parent comment itself is unread
        if (unreadCommentIds.includes(commentId)) return commentId;
        // Get child comment IDs for the current comment
        const childCommentIds = comments[commentId]?.childCommentIds;
        // If there are child comment IDs, check if any are unread
        if (childCommentIds instanceof Set) for (const childCommentId of childCommentIds){
            if (unreadCommentIds.includes(childCommentId)) return childCommentId;
        }
    }
    return null;
});
const $1d69b1e69b91ee0e$export$f852f38f61c8471 = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.commentScrollStatusForRealTimeUpdates);
const $1d69b1e69b91ee0e$export$6eba3f548a7f384e = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (commentEditor)=>!!commentEditor && commentEditor.isEditing);
const $1d69b1e69b91ee0e$export$239be48dfe5d80ba = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiAllCommentsSelector, (uiComments)=>uiComments && uiComments.commentSessionId || null);
const $1d69b1e69b91ee0e$export$3a00787e516c672c = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$3b3d01d442cb684a, (state)=>state, (visibleCommentIds, state)=>visibleCommentIds.filter((commentId)=>$1d69b1e69b91ee0e$export$6eba3f548a7f384e(commentId)(state)));
const $1d69b1e69b91ee0e$export$4c04cd370caea884 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$2bcb958351592bb9, (comments)=>comments ? Object.keys(comments).filter((key)=>typeof comments[key] === 'object') : []);
const $1d69b1e69b91ee0e$export$2e24e984817b4c7b = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$4c04cd370caea884, (state)=>state, (commentIds, state)=>commentIds.some((id)=>$1d69b1e69b91ee0e$export$6eba3f548a7f384e(id)(state)));
const $1d69b1e69b91ee0e$export$5373a6bfd674797c = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.addCommentEditorExpand || false);
const $1d69b1e69b91ee0e$export$37aee7d1ec9d42d3 = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.addCommentEditorForceFocus || 0);
const $1d69b1e69b91ee0e$export$6df0ef2ac2b35c13 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$5373a6bfd674797c, $1d69b1e69b91ee0e$var$uiAllCommentEditorsSelector, (isAddCommentEditorExpanded, commentEditors)=>isAddCommentEditorExpanded || (commentEditors ? (0, (/*@__PURE__*/$parcel$interopDefault($dMEgP)))(commentEditors).some((editor)=>editor.isEditing) : false));
const $1d69b1e69b91ee0e$export$f140c5c89826efc6 = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.isCommentAttachmentInProgress);
const $1d69b1e69b91ee0e$export$2ce513eb85289331 = (0, $dGvGJ.createSelector)((0, $bcoYn.isSimplifiedProjectSelector), (0, $bcoYn.projectTypeSelector), (isSimplified, projectType)=>!isSimplified && (projectType === (0, $2vSU6.CORE_PROJECT) || projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)));
const $1d69b1e69b91ee0e$var$replyingToCommentIdSelector = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.replyingToCommentId);
const $1d69b1e69b91ee0e$export$ab64c511f5921cdf = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$replyingToCommentIdSelector, (replyingToCommentId)=>replyingToCommentId === commentId);
const $1d69b1e69b91ee0e$export$d89d07d36d57d778 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$replyingToCommentIdSelector, (replyingToCommentId)=>!!replyingToCommentId);
const $1d69b1e69b91ee0e$export$bb44f1aa6771eeb6 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$3e2634438f2a9b1a(`${(0, $7a0695d910e98a34$export$56251dcfec1ad08d)}-${commentId}`), (editingComment)=>editingComment || undefined);
const $1d69b1e69b91ee0e$var$replyingToAuthorIdSelector = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.comments.replyingToAuthorId);
const $1d69b1e69b91ee0e$export$6fe69cb268473af1 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$replyingToAuthorIdSelector, (0, $bcoYn.getUserByIdSelector), (replyingToAuthorId, getUserById)=>getUserById(replyingToAuthorId));
const $1d69b1e69b91ee0e$export$9f25935861e23f9b = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment && comment.parentId);
const $1d69b1e69b91ee0e$export$8f158a3cc48edde6 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9f25935861e23f9b(commentId), (comments, parentId)=>parentId ? comments[parentId] : undefined);
const $1d69b1e69b91ee0e$export$f3cffcd4d32274f6 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$f82d111da9150583, (comments)=>Object.values(comments).some((comment)=>comment.isInternal === false));

});
// Activity sort order
const $c97bf8752afb1bcb$export$eda5fe8da1abb04c = 'NEWEST_FIRST';
const $c97bf8752afb1bcb$export$e86669f498228fff = 'OLDEST_FIRST';

parcelRegister("g2C8o", function(module, exports) {

$parcel$export(module.exports, "SAVE_COMMENT_LOADING", () => $a2ddc97999af5bc9$export$ea56f55e95ac48c4);
$parcel$export(module.exports, "SAVE_CHILD_COMMENT_LOADING_PREFIX", () => $a2ddc97999af5bc9$export$7feea57d9f7d329e);
$parcel$export(module.exports, "LOADING", () => $a2ddc97999af5bc9$export$26d55645375ca9a);
$parcel$export(module.exports, "COMPLETE", () => $a2ddc97999af5bc9$export$1660a2d7c2fff354);
$parcel$export(module.exports, "COMMENT_VISIBILITY_PUBLIC", () => $a2ddc97999af5bc9$export$5dd24cf16d0bbf18);
$parcel$export(module.exports, "ActionButton", () => $a2ddc97999af5bc9$export$cfc7921d29ef7b80);

const $a2ddc97999af5bc9$export$34e5759f24cbaeac = (value)=>value;
const $a2ddc97999af5bc9$export$ea56f55e95ac48c4 = 'SAVE_COMMENT_LOADING';
const $a2ddc97999af5bc9$export$7feea57d9f7d329e = 'SAVE_CHILD_COMMENT_LOADING_';
const $a2ddc97999af5bc9$export$26d55645375ca9a = 'LOADING';
const $a2ddc97999af5bc9$export$1660a2d7c2fff354 = 'COMPLETE';
const $a2ddc97999af5bc9$export$5dd24cf16d0bbf18 = {
    type: (0, $b276debff3ef22b6$export$a3863626f98a38c2),
    value: ''
};
const $a2ddc97999af5bc9$export$cfc7921d29ef7b80 = {
    PREVIOUS: 'PREVIOUS',
    NEXT: 'NEXT'
};

});
const $b276debff3ef22b6$export$537a061b2f9c8800 = 'group';
const $b276debff3ef22b6$export$28a8bb936dce2def = 'role';
const $b276debff3ef22b6$export$a3863626f98a38c2 = 'public';


parcelRegister("2QmDq", function(module, exports) {

$parcel$export(module.exports, "getSelectedActivityItem", () => $9baa1155ae0bb232$export$49b8848afae8c381);
$parcel$export(module.exports, "getSelectedActivitySortOrder", () => $9baa1155ae0bb232$export$7091381d8f3bc5cc);
$parcel$export(module.exports, "getActivityFeedInViewPort", () => $9baa1155ae0bb232$export$50e1cbd5557ceae1);
$parcel$export(module.exports, "getSelectedActivityLayout", () => $9baa1155ae0bb232$export$caebda0b6783fefb);

var $dGvGJ = parcelRequire("dGvGJ");

var $bcoYn = parcelRequire("bcoYn");
const $9baa1155ae0bb232$var$getUiActivityFeed = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.activityFeed);
const $9baa1155ae0bb232$export$49b8848afae8c381 = (0, $dGvGJ.createSelector)($9baa1155ae0bb232$var$getUiActivityFeed, (activityFeed)=>activityFeed.selectedActivityItem);
const $9baa1155ae0bb232$export$7091381d8f3bc5cc = (0, $dGvGJ.createSelector)($9baa1155ae0bb232$var$getUiActivityFeed, (activityFeed)=>activityFeed.selectedActivitySortOrder);
const $9baa1155ae0bb232$export$50e1cbd5557ceae1 = (0, $dGvGJ.createSelector)($9baa1155ae0bb232$var$getUiActivityFeed, (activityFeed)=>activityFeed.isActivityFeedInViewPort ?? true);
const $9baa1155ae0bb232$export$caebda0b6783fefb = (0, $dGvGJ.createSelector)($9baa1155ae0bb232$var$getUiActivityFeed, (activityFeed)=>activityFeed?.selectedActivityFeedLayout ?? null);

});

const $7a0695d910e98a34$export$c4134c813c47beb0 = 'NEW_OPTIMISTIC_COMMENT';
const $7a0695d910e98a34$export$56251dcfec1ad08d = 'NEW_OPTIMISTIC_COMMENT_REPLY';


parcelRegister("9acDX", function(module, exports) {

$parcel$export(module.exports, "isIssueLinksEnabledSelector", () => $2fb14f2dbdb6e11c$export$a8cf8910b8314c1a);
$parcel$export(module.exports, "remoteIssuesSelector", () => $2fb14f2dbdb6e11c$export$13978ee723866c4d);
$parcel$export(module.exports, "optimisticLinksDataSelector", () => $2fb14f2dbdb6e11c$export$819781ef7e99d6c7);
$parcel$export(module.exports, "hasCombinedIssueLinksSelector", () => $2fb14f2dbdb6e11c$export$8b1b2dfb6701d22c);
$parcel$export(module.exports, "combinedLinkedIssueCountSelector", () => $2fb14f2dbdb6e11c$export$7e10bfdc67ac9362);
$parcel$export(module.exports, "combinedLinksSelector", () => $2fb14f2dbdb6e11c$export$a101eb6fc884a8a0);
$parcel$export(module.exports, "issueLinkSelector", () => $2fb14f2dbdb6e11c$export$b82f4900195f5854);
$parcel$export(module.exports, "linkedIssueSelector", () => $2fb14f2dbdb6e11c$export$f5f26ceb5c86ee0);
$parcel$export(module.exports, "quickAddClickedCountSelector", () => $2fb14f2dbdb6e11c$export$d545d81c8e208408);
$parcel$export(module.exports, "isOpenedFromJsmSimilarIssuesSelector", () => $2fb14f2dbdb6e11c$export$3bf48255064c85d5);
$parcel$export(module.exports, "quickAddClickedIssueSelector", () => $2fb14f2dbdb6e11c$export$2c43c6abed5983de);
$parcel$export(module.exports, "shouldDisplayAddLinksSelector", () => $2fb14f2dbdb6e11c$export$5757979a0baa9c47);
$parcel$export(module.exports, "triggeredViaHotKeySelector", () => $2fb14f2dbdb6e11c$export$34364f7190cff8a8);
$parcel$export(module.exports, "shouldDisplayRelatedIssuePanelSelector", () => $2fb14f2dbdb6e11c$export$eea0e617974abf06);
$parcel$export(module.exports, "canCreateLinkedIssueSelector", () => $2fb14f2dbdb6e11c$export$99914e520087b170);

var $dGvGJ = parcelRequire("dGvGJ");

var $gccSB = parcelRequire("gccSB");

var $4f8Oj = parcelRequire("4f8Oj");

var $h6fst = parcelRequire("h6fst");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $bkUsp = parcelRequire("bkUsp");

var $bcoYn = parcelRequire("bcoYn");

var $1uvGd = parcelRequire("1uvGd");
/**
 * selectors for issue links
 *
 * issue links state looks like
 * issueLinks: {
 *  issueLinks: [
 *      link1,
 *      link2
 *  ],
 *  linkedIssueKeys: ['KEY-1', 'KEY-2'],
 *  linkedIssues: {
 *      'KEY-1': issue1,
 *      'KEY-2': issue2
 *  }
 * }
 */ const $2fb14f2dbdb6e11c$var$issueLinksRootSelector = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities && entities.issueLinks);
const $2fb14f2dbdb6e11c$export$a8cf8910b8314c1a = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (root)=>!!root);
const $2fb14f2dbdb6e11c$var$linksDataSelector = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.issueLinks);
const $2fb14f2dbdb6e11c$export$13978ee723866c4d = (state)=>state?.entities?.remoteIssueLinks?.remoteIssues || [];
const $2fb14f2dbdb6e11c$export$819781ef7e99d6c7 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linksDataSelector, (issueLinks)=>issueLinks && (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(issueLinks, (link)=>link.isOptimistic));
const $2fb14f2dbdb6e11c$var$linkedIssuesSelector = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.linkedIssues);
const $2fb14f2dbdb6e11c$export$701dc165268e44de = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks?.linkedIssueKeys || []);
const $2fb14f2dbdb6e11c$export$3c65f67962ca81cc = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linksDataSelector, (links)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(links));
const $2fb14f2dbdb6e11c$export$8b1b2dfb6701d22c = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linksDataSelector, $2fb14f2dbdb6e11c$export$13978ee723866c4d, (links, remoteLinks)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(links) || !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(remoteLinks));
const $2fb14f2dbdb6e11c$export$7e10bfdc67ac9362 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$export$701dc165268e44de, $2fb14f2dbdb6e11c$export$13978ee723866c4d, (links, remoteLinks)=>links.length + remoteLinks.length);
const $2fb14f2dbdb6e11c$export$f9c1778e36ca60f9 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linksDataSelector, $2fb14f2dbdb6e11c$var$linkedIssuesSelector, (0, $1uvGd.jpdDeliverLinkTypeIdSelector), (links, issues, jpdDeliverLinkTypeId)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(links)) return (0, (/*@__PURE__*/$parcel$interopDefault($h6fst)))(links).filter((link)=>!link.isDeleted && !!link.linkedIssueKey)// Filter out links with jpd delivery link typeId and direction === "OUTWARD" and they are displayed in separate Ideas section
    .filter($2fb14f2dbdb6e11c$var$removeOutwardImplementsIdeaLinks(jpdDeliverLinkTypeId, issues)).map((link)=>({
            ...link,
            linkedIssue: issues[link.linkedIssueKey]
        })) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((linksMap, link)=>Object.assign(linksMap, {
            [link.typeName]: [
                ...linksMap[link.typeName] || [],
                link
            ]
        }), {});
    return null;
});
function $2fb14f2dbdb6e11c$var$removeOutwardImplementsIdeaLinks(jpdDeliverLinkTypeId, issues) {
    return (link)=>{
        if (jpdDeliverLinkTypeId && (0, $4R6GH.fg)('jpd_idea_panel_in_issue_view')) {
            const isImplementsLink = link.typeId === jpdDeliverLinkTypeId;
            const isOutwardLink = link.direction === (0, $bkUsp.OUTWARD_LINK_DIRECTION);
            const isIdea = issues[link.linkedIssueKey]?.issueProjectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT);
            if (isIdea && isImplementsLink && isOutwardLink) return false;
        }
        return true;
    };
}
const $2fb14f2dbdb6e11c$export$a101eb6fc884a8a0 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$export$f9c1778e36ca60f9, $2fb14f2dbdb6e11c$export$13978ee723866c4d, (links, remoteIssues)=>{
    if (links == null && remoteIssues.length === 0) return null;
    const extractBasicIssueDetails = (remoteIssueLinkEntity)=>({
            id: remoteIssueLinkEntity.remoteIssueId,
            issueKey: remoteIssueLinkEntity.issueKey,
            issueLink: remoteIssueLinkEntity.issueLinkUrl,
            issueSummary: remoteIssueLinkEntity.summary,
            issueTypeIconUrl: remoteIssueLinkEntity.iconUrl
        });
    // FIXME: JIV-15410 - expected to return IssueLink[]
    return remoteIssues.reduce((combinedLinks, remoteIssue)=>{
        const { issueDetails: issueDetails, relationship: relationship, id: id, issueKey: issueKey, issueLinkUrl: issueLinkUrl, remoteIssueLinkError: remoteIssueLinkError, globalId: globalId, isSaved: isSaved, isLoading: isLoading, isOptimistic: isOptimistic, hasError: hasError, isDeleted: isDeleted } = remoteIssue;
        if (relationship != null && isDeleted !== true) return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...combinedLinks,
            [relationship]: [
                ...combinedLinks[relationship] || [],
                {
                    id: id.toString(),
                    direction: (0, $bkUsp.OUTWARD_LINK_DIRECTION),
                    typeName: relationship,
                    linkedIssueKey: issueKey,
                    linkedIssue: issueDetails || extractBasicIssueDetails(remoteIssue),
                    isRemote: true,
                    globalId: globalId,
                    remoteServerHostname: new URL(issueLinkUrl).hostname,
                    remoteIssueLinkError: remoteIssueLinkError,
                    isSaved: isSaved,
                    isLoading: isLoading,
                    isOptimistic: isOptimistic,
                    hasError: hasError
                }
            ]
        };
        return combinedLinks;
    }, {
        ...links
    });
});
const $2fb14f2dbdb6e11c$export$b82f4900195f5854 = (issueLinkId)=>(0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linksDataSelector, (links)=>links && links[issueLinkId] || null);
const $2fb14f2dbdb6e11c$export$f5f26ceb5c86ee0 = (issueKey)=>(0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linkedIssuesSelector, (linkedIssues)=>linkedIssues && linkedIssues[issueKey] || null);
const $2fb14f2dbdb6e11c$export$d545d81c8e208408 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.quickAddClicked);
const $2fb14f2dbdb6e11c$export$3bf48255064c85d5 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>!!issueLinks?.isOpenedFromJsmSimilarIssues);
const $2fb14f2dbdb6e11c$export$2c43c6abed5983de = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.quickAddClickedIssue);
const $2fb14f2dbdb6e11c$export$5757979a0baa9c47 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$export$d545d81c8e208408, (count)=>!!count);
const $2fb14f2dbdb6e11c$export$34364f7190cff8a8 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.triggeredViaHotKey);
const $2fb14f2dbdb6e11c$export$eea0e617974abf06 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.aiLinkedIssueSuggestion);
const $2fb14f2dbdb6e11c$export$99914e520087b170 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.canCreateLinkedIssue);

});
parcelRegister("h6fst", function(module, exports) {

var $7Q2q6 = parcelRequire("7Q2q6");

var $jHlUS = parcelRequire("jHlUS");

var $jtBGw = parcelRequire("jtBGw");

var $hTJwX = parcelRequire("hTJwX");

var $agVdz = parcelRequire("agVdz");

var $cY2dI = parcelRequire("cY2dI");

var $f1B3k = parcelRequire("f1B3k");

var $eUuIg = parcelRequire("eUuIg");

var $jx6Tp = parcelRequire("jx6Tp");

var $dMEgP = parcelRequire("dMEgP");
/** `Object#toString` result references. */ var $c72efce4841a6f93$var$mapTag = '[object Map]', $c72efce4841a6f93$var$setTag = '[object Set]';
/** Built-in value references. */ var $c72efce4841a6f93$var$symIterator = $7Q2q6 ? $7Q2q6.iterator : undefined;
/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function $c72efce4841a6f93$var$toArray(value) {
    if (!value) return [];
    if ($hTJwX(value)) return $agVdz(value) ? $jx6Tp(value) : $jHlUS(value);
    if ($c72efce4841a6f93$var$symIterator && value[$c72efce4841a6f93$var$symIterator]) return $cY2dI(value[$c72efce4841a6f93$var$symIterator]());
    var tag = $jtBGw(value), func = tag == $c72efce4841a6f93$var$mapTag ? $f1B3k : tag == $c72efce4841a6f93$var$setTag ? $eUuIg : $dMEgP;
    return func(value);
}
module.exports = $c72efce4841a6f93$var$toArray;

});
parcelRegister("agVdz", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $8LQ84 = parcelRequire("8LQ84");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $77a7c84c5ee0b808$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $77a7c84c5ee0b808$var$isString(value) {
    return typeof value == 'string' || !$8LQ84(value) && $fC1Kz(value) && $beQoo(value) == $77a7c84c5ee0b808$var$stringTag;
}
module.exports = $77a7c84c5ee0b808$var$isString;

});

parcelRegister("cY2dI", function(module, exports) {
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function $970ccf8c01557998$var$iteratorToArray(iterator) {
    var data, result = [];
    while(!(data = iterator.next()).done)result.push(data.value);
    return result;
}
module.exports = $970ccf8c01557998$var$iteratorToArray;

});


parcelRegister("bkUsp", function(module, exports) {

$parcel$export(module.exports, "INWARD_LINK_DIRECTION", () => $1e4a31a537751af2$export$b5e2b68b0fa7f1c8);
$parcel$export(module.exports, "OUTWARD_LINK_DIRECTION", () => $1e4a31a537751af2$export$5dec99d71ec794ba);
$parcel$export(module.exports, "BOTH_LINK_DIRECTION", () => $1e4a31a537751af2$export$6cdcf74878b11d34);
$parcel$export(module.exports, "IssueLinkDirectionTypes", () => $1e4a31a537751af2$export$4b7bcc27238c61b9);
const $1e4a31a537751af2$export$b5e2b68b0fa7f1c8 = 'INWARD';
const $1e4a31a537751af2$export$5dec99d71ec794ba = 'OUTWARD';
const $1e4a31a537751af2$export$6cdcf74878b11d34 = 'BOTH';
const $1e4a31a537751af2$export$4b7bcc27238c61b9 = {
    [$1e4a31a537751af2$export$b5e2b68b0fa7f1c8]: $1e4a31a537751af2$export$b5e2b68b0fa7f1c8,
    [$1e4a31a537751af2$export$5dec99d71ec794ba]: $1e4a31a537751af2$export$5dec99d71ec794ba,
    [$1e4a31a537751af2$export$6cdcf74878b11d34]: $1e4a31a537751af2$export$6cdcf74878b11d34
};

});

parcelRegister("1uvGd", function(module, exports) {

$parcel$export(module.exports, "jpdDeliverLinkTypeIdSelector", () => $20ab26563cc602b2$export$c25a0be5d19458d3);

var $dGvGJ = parcelRequire("dGvGJ");

var $bcoYn = parcelRequire("bcoYn");
const $20ab26563cc602b2$export$c25a0be5d19458d3 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.jpdDeliveryIssueLinkTypeId);

});


parcelRegister("ifezr", function(module, exports) {

$parcel$export(module.exports, "issueTypesSelector", () => $1b8b68c890f5544b$export$f5378064bf877b95);
$parcel$export(module.exports, "hasUnsupportedType", () => $1b8b68c890f5544b$export$1f59505fa2d77635);
$parcel$export(module.exports, "issueTypesForClassicProjectEpicSelector", () => $1b8b68c890f5544b$export$a0efcb09d3e23dc1);
$parcel$export(module.exports, "fetchIssueTypesStatusSelector", () => $1b8b68c890f5544b$export$bfbb65ccb13a16eb);

var $dGvGJ = parcelRequire("dGvGJ");

var $gccSB = parcelRequire("gccSB");

var $bcoYn = parcelRequire("bcoYn");

var $lssfC = parcelRequire("lssfC");
const $1b8b68c890f5544b$export$f5378064bf877b95 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.issueTypes);
// A collection of issue fields which are marked as `required`
// for the creation of an issue, but are considered as 'provided' since
// the data for these fields is supplied by JIRA.
const $1b8b68c890f5544b$var$providedRequiredFields = [
    'summary',
    'issuetype',
    'parent',
    'project'
];
const $1b8b68c890f5544b$var$isRequiredFieldProvided = (fieldName)=>$1b8b68c890f5544b$var$providedRequiredFields.find((providedFieldName)=>fieldName === providedFieldName);
// A field is considered 'unsupported' if not provided by JIRA,
// has no default value, and is a `required` field.
const $1b8b68c890f5544b$var$hasUnsupportedRequiredField = (fields)=>// @ts-expect-error - TS2769 - No overload matches this call.
    !!Object.keys(fields).find((fieldName)=>!$1b8b68c890f5544b$var$isRequiredFieldProvided(fieldName) && // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        !fields[fieldName].hasDefaultValue && // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        fields[fieldName].required);
const $1b8b68c890f5544b$export$1f59505fa2d77635 = (issueType)=>(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueType.fields) || $1b8b68c890f5544b$var$hasUnsupportedRequiredField(issueType.fields);
const $1b8b68c890f5544b$export$a0efcb09d3e23dc1 = (0, $dGvGJ.createSelector)($1b8b68c890f5544b$export$f5378064bf877b95, (0, $lssfC.issueTypeSelector), (0, $bcoYn.isEpicSelector), (issueTypes, currentIssueType, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isCurrentIssueAnEpic)=>{
    const epicIssueTypeId = isCurrentIssueAnEpic && currentIssueType && currentIssueType.id;
    return issueTypes.filter(// @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'number' and 'string | boolean | undefined' have no overlap.
    (issueType)=>!issueType.subtask && issueType.id !== epicIssueTypeId);
});
const $1b8b68c890f5544b$export$bfbb65ccb13a16eb = (0, $dGvGJ.createSelector)((0, $bcoYn.uiSelector), (ui)=>ui.fetchIssueTypesStatus);

});

parcelRegister("3Ke60", function(module, exports) {

$parcel$export(module.exports, "subtaskTypesSelector", () => $e14dab62dd4bafa5$export$86a4f97fc27a0c44);
$parcel$export(module.exports, "isSubtaskTypesPresentSelector", () => $e14dab62dd4bafa5$export$9a147dcac364dd81);
$parcel$export(module.exports, "hasUnsupportedTypeSelector", () => $e14dab62dd4bafa5$export$3fbfbdcf57f34c2);

var $dGvGJ = parcelRequire("dGvGJ");

var $ifezr = parcelRequire("ifezr");
const $e14dab62dd4bafa5$export$86a4f97fc27a0c44 = (0, $dGvGJ.createSelector)((0, $ifezr.issueTypesSelector), (issueTypes)=>issueTypes.filter((type)=>type.subtask));
const $e14dab62dd4bafa5$export$9a147dcac364dd81 = (0, $dGvGJ.createSelector)($e14dab62dd4bafa5$export$86a4f97fc27a0c44, (subtaskTypes)=>subtaskTypes.length >= 1);
const $e14dab62dd4bafa5$export$3fbfbdcf57f34c2 = (0, $dGvGJ.createSelector)($e14dab62dd4bafa5$export$86a4f97fc27a0c44, (subtaskTypes)=>!!subtaskTypes.find((0, $ifezr.hasUnsupportedType)));

});

parcelRegister("aN61o", function(module, exports) {

$parcel$export(module.exports, "isSubtaskSelector", () => $37d2c831d03fb4f0$export$15fea4741156936);
$parcel$export(module.exports, "subtaskEntitiesSelector", () => $37d2c831d03fb4f0$export$17e529874841c746);
$parcel$export(module.exports, "hasSubtasksSelector", () => $37d2c831d03fb4f0$export$f363078714850fd9);
$parcel$export(module.exports, "canCreateSubtaskSelector", () => $37d2c831d03fb4f0$export$151aaebeef1cfe63);

var $dGvGJ = parcelRequire("dGvGJ");


var $fOGZN = parcelRequire("fOGZN");

var $a1ky2 = parcelRequire("a1ky2");

var $7Ow8a = parcelRequire("7Ow8a");

var $bcoYn = parcelRequire("bcoYn");

var $hKi22 = parcelRequire("hKi22");

var $gnp10 = parcelRequire("gnp10");

var $jMY7o = parcelRequire("jMY7o");

var $lssfC = parcelRequire("lssfC");

var $fbv6S = parcelRequire("fbv6S");

var $3Ke60 = parcelRequire("3Ke60");
const $37d2c831d03fb4f0$export$15fea4741156936 = (0, $dGvGJ.createSelector)((0, $lssfC.issueTypeSelector), (issueType)=>!!(issueType && issueType.subtask));
const $37d2c831d03fb4f0$export$17e529874841c746 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.subtasks || []);
const $37d2c831d03fb4f0$export$f363078714850fd9 = (0, $dGvGJ.createSelector)($37d2c831d03fb4f0$export$17e529874841c746, (0, $7Ow8a.childIssuesLimitUrlSelector), (subtasks, getChildIssuesLimitUrl)=>subtasks.length > 0 || Boolean(getChildIssuesLimitUrl((0, $fOGZN.SUBTASKS))));
const $37d2c831d03fb4f0$export$899afcd59181acbb = (0, $dGvGJ.createSelector)((0, $bcoYn.isSimplifiedProjectSelector), (0, $jMY7o.isIssueBaseLevel), (0, $gnp10.hasChildrenIssuesSelector), $37d2c831d03fb4f0$export$f363078714850fd9, (isSimplifiedProject, issueBaseLevel, hasChildrenIssues, hasSubtasks)=>isSimplifiedProject ? issueBaseLevel && hasChildrenIssues : hasSubtasks);
const $37d2c831d03fb4f0$export$58b46fbc7ab224f6 = (0, $dGvGJ.createSelector)((0, $3Ke60.hasUnsupportedTypeSelector), (0, $fbv6S.projectHasSubtaskValidatorsSelector), (hasRequiredFields, hasSubtaskValidators)=>hasRequiredFields || hasSubtaskValidators);
const $37d2c831d03fb4f0$export$94f22e5d109e9b04 = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), ({ jiraSettings: jiraSettings })=>jiraSettings?.subtasksConfiguration?.enabled);
const $37d2c831d03fb4f0$export$151aaebeef1cfe63 = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), $37d2c831d03fb4f0$export$15fea4741156936, (0, $3Ke60.isSubtaskTypesPresentSelector), $37d2c831d03fb4f0$export$58b46fbc7ab224f6, (0, $a1ky2.isMobileSelector), (0, $a1ky2.isBitbucketSelector), (0, $a1ky2.isServiceDeskSelector), (0, $bcoYn.isSimplifiedProjectSelector), $37d2c831d03fb4f0$export$94f22e5d109e9b04, (0, $bcoYn.projectSelector), ({ canCreateSubtask: canCreateSubtask }, isSubtask, typesPresent, shouldUseFallbackDialog, isMobile, isBitbucket, isServicedesk, isSimplified, subtasksEnabled, project)=>{
    const shouldHideForMobileOrBitbucket = shouldUseFallbackDialog ? isMobile || isBitbucket : false;
    const isProjectActive = (project?.projectStatus ?? (0, $cd476f3ecebdab63$export$62113557945f790a)) === (0, $cd476f3ecebdab63$export$62113557945f790a);
    const shouldShowSubtask = isServicedesk ? !isSimplified : true;
    return !!(canCreateSubtask && !isSubtask && typesPresent && !shouldHideForMobileOrBitbucket && shouldShowSubtask && subtasksEnabled && isProjectActive);
});

});
const $cd476f3ecebdab63$export$62113557945f790a = 'PROJECT_ACTIVE';
const $cd476f3ecebdab63$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $cd476f3ecebdab63$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';

parcelRegister("gnp10", function(module, exports) {

$parcel$export(module.exports, "hasChildrenIssuesSelector", () => $29aeec2b4781c452$export$29f34d4d7c528e9c);

var $dGvGJ = parcelRequire("dGvGJ");

var $gccSB = parcelRequire("gccSB");

var $5fc53 = parcelRequire("5fc53");

var $7Ow8a = parcelRequire("7Ow8a");
const $29aeec2b4781c452$var$childrenIssueSelector = (0, $7Ow8a.fieldSelector)((0, $5fc53.CHILDREN_ISSUES));
const $29aeec2b4781c452$export$29f34d4d7c528e9c = (0, $dGvGJ.createSelector)($29aeec2b4781c452$var$childrenIssueSelector, (0, $7Ow8a.childIssuesLimitUrlSelector), (childrenIssues, getChildIssuesLimitUrl)=>childrenIssues ? !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(childrenIssues.value) || Boolean(getChildIssuesLimitUrl((0, $5fc53.CHILDREN_ISSUES))) : false);

});

parcelRegister("fbv6S", function(module, exports) {

$parcel$export(module.exports, "projectHasSubtaskValidatorsSelector", () => $cb6f2b5c3e56bbb6$export$ecfed315b19a7565);

var $dGvGJ = parcelRequire("dGvGJ");

const $cb6f2b5c3e56bbb6$var$hasSubtaskValidators = (hasValidators)=>hasValidators.status === (0, $5d539a63717f8747$export$4c02edeb1b5e410a) && hasValidators.value;
const $cb6f2b5c3e56bbb6$var$unknown = (hasValidators)=>hasValidators.status === (0, $5d539a63717f8747$export$26d55645375ca9a) || hasValidators.status === (0, $5d539a63717f8747$export$d71930f7f5807a72);
const $cb6f2b5c3e56bbb6$export$ecfed315b19a7565 = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.validators, (validators)=>{
    const val = validators.projectHasSubtaskValidators;
    return $cb6f2b5c3e56bbb6$var$hasSubtaskValidators(val) || $cb6f2b5c3e56bbb6$var$unknown(val);
});

});
const $5d539a63717f8747$export$26d55645375ca9a = 'LOADING';
const $5d539a63717f8747$export$d71930f7f5807a72 = 'FAILED';
const $5d539a63717f8747$export$4c02edeb1b5e410a = 'LOADED';



parcelRegister("dvijh", function(module, exports) {

$parcel$export(module.exports, "COMMENTS", () => $1403612d0fe1296c$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $1403612d0fe1296c$export$df36fc05622c402);
$parcel$export(module.exports, "PermalinkType", () => $1403612d0fe1296c$export$b18d061fc042df1a);
const $1403612d0fe1296c$export$4cab9dfa8fc858f4 = 'Comments';
const $1403612d0fe1296c$export$df36fc05622c402 = 'Worklog';
const $1403612d0fe1296c$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};

});

parcelRegister("fKtck", function(module, exports) {

$parcel$export(module.exports, "getPermalinkTypeAndId", () => $11ab2af1eff70e7f$export$f72cac1fa8a03e80);
$parcel$export(module.exports, "getPermalinkStatus", () => $11ab2af1eff70e7f$export$f79ae8c396759c89);
$parcel$export(module.exports, "getUrlPermalinkParameter", () => $11ab2af1eff70e7f$export$b66f3e03c722c21c);
$parcel$export(module.exports, "PermalinkType", () => (parcelRequire("dvijh")).PermalinkType);

var $8QpSo = parcelRequire("8QpSo");

var $ebyGx = parcelRequire("ebyGx");

var $gKZoD = parcelRequire("gKZoD");

var $dvijh = parcelRequire("dvijh");
const $11ab2af1eff70e7f$export$58d3deae755361f = (0, $8QpSo.default)((searchString)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parseUrl(searchString).query;
    if (params[(0, $dvijh.PermalinkType).COMMENTS]) return {
        permalinkType: (0, $dvijh.COMMENTS),
        permalinkId: params[(0, $dvijh.PermalinkType).COMMENTS]
    };
    if (params[(0, $dvijh.PermalinkType).WORKLOG]) return {
        permalinkType: (0, $dvijh.WORKLOG),
        permalinkId: params[(0, $dvijh.PermalinkType).WORKLOG]
    };
    return null;
});
const $11ab2af1eff70e7f$export$f72cac1fa8a03e80 = ()=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return $11ab2af1eff70e7f$export$58d3deae755361f(window.location.search);
};
const $11ab2af1eff70e7f$export$f79ae8c396759c89 = (targetPermalinkType)=>{
    const { permalinkId: permalinkId, permalinkType: permalinkType } = $11ab2af1eff70e7f$export$f72cac1fa8a03e80() || {};
    const hasPermalink = permalinkType === targetPermalinkType && permalinkId != null;
    return {
        hasPermalink: hasPermalink,
        permalinkId: hasPermalink ? permalinkId : ''
    };
};
const $11ab2af1eff70e7f$export$b66f3e03c722c21c = (id, permalinkType)=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const pathName = window.location.pathname;
    let urlQueryParam = `?${permalinkType}=${id}`;
    // in backlogs/modal view, next-gen board view, or jsd queues view
    if (/\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/.test(pathName) || /\/jira\/people\/.*\/boards\/.*/.test(pathName) || pathName === '/secure/RapidBoard.jspa' || pathName.startsWith('/jira/software/projects/') && pathName.split('/')[5] === 'boards' || pathName.startsWith('/jira/servicedesk/projects/') && pathName.split('/')[5] === 'queues') {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const url = new URL(window.location.href);
        // delete the opposite to avoid doubling up param in url
        url.searchParams.delete(permalinkType === (0, $dvijh.PermalinkType).WORKLOG ? (0, $dvijh.PermalinkType).COMMENTS : (0, $dvijh.PermalinkType).WORKLOG);
        url.searchParams.set(permalinkType, id);
        urlQueryParam = url.search;
    }
    return urlQueryParam;
};

});


parcelRegister("jf6us", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bdbb34cd5461e74$export$2e2bcd8739ae039);
class $6bdbb34cd5461e74$export$2e2bcd8739ae039 {
    constructor(state){
        this.hasLoadedEditor = false;
        this.startTime = Math.floor(performance.now()) // start time in origin relative  millis
        ;
        this.immutableState = state;
        this.isLoadedWithPage = state.isLoadedWithPage;
    }
    lazyMetricsProps() {
        return this.immutableState.lazyMetricsProps;
    }
    getDataProvider() {
        return this.immutableState.dataProvider;
    }
    getIsFullIssue() {
        return this.immutableState.analyticsSource === 'full-issue';
    }
    getIsLoadedWithPage() {
        return this.immutableState.isLoadedWithPage;
    }
    setIsLoadedWithPage(newValue) {
        this.isLoadedWithPage = newValue;
    }
    getIsSPA() {
        return this.immutableState.isSPA;
    }
    getIsRecentIssue() {
        return this.immutableState.isRecentIssue;
    }
    getRecentIssuesCount() {
        return this.immutableState.recentIssuesCount;
    }
    getAnalyticsSource() {
        return this.immutableState.analyticsSource;
    }
    getCorrelationId() {
        return this.immutableState.correlationId;
    }
    getIssueScaleabilityReporter() {
        return this.immutableState.issueScaleabilityReporter;
    }
    getStartTime() {
        return this.startTime;
    }
    setPreviewEnd(end) {
        this.previewEnd = end === null ? 0 : Math.floor(end);
    }
    getPreviewEnd() {
        return this.previewEnd;
    }
    setFMP(end) {
        this.fmp = end === null ? 0 : Math.floor(end);
    }
    getFMP() {
        return this.fmp;
    }
    setInteractiveEnd(millisSinceEpoch) {
        this.interactiveEnd = millisSinceEpoch;
    }
    getInteractiveEnd() {
        return this.interactiveEnd;
    }
    setTrueInteractiveEnd(millisSinceEpoch) {
        this.trueInteractiveEnd = Math.floor(millisSinceEpoch);
    }
    getTrueInteractiveEnd() {
        return Math.floor(this.trueInteractiveEnd);
    }
    getHasLoadedEditor() {
        return this.hasLoadedEditor;
    }
    getIsInitial() {
        return this.getIsFullIssue() && !this.getIsSPA();
    }
    getLocation() {
        const { route: route } = this.immutableState;
        const routeName = route?.name;
        return routeName || '';
    }
}

});

parcelRegister("fdHx2", function(module, exports) {

$parcel$export(module.exports, "metricsStateSelector", () => $e53f50d927a7fce5$export$8cfb2e5f509cb762);

var $dGvGJ = parcelRequire("dGvGJ");

var $fuw6O = parcelRequire("fuw6O");

var $a1ky2 = parcelRequire("a1ky2");
const $e53f50d927a7fce5$export$8cfb2e5f509cb762 = (0, $dGvGJ.createSelector)((0, $a1ky2.applicationKeySelector), (0, $a1ky2.viewModeSelector), (0, $a1ky2.issueIdSelector), (analyticsKey, viewMode, issueId)=>({
        analyticsKey: analyticsKey,
        viewMode: (0, $fuw6O.getSafeViewMode)(viewMode),
        issueId: issueId
    }));

});
parcelRegister("fuw6O", function(module, exports) {

$parcel$export(module.exports, "getSafeViewMode", () => $f501923c845d9095$export$abc152b4d639d329);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
// TODO : Add a prefix to identify each app and also make sure you update the same in test
const $f501923c845d9095$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('');
const $f501923c845d9095$var$getViewMode = ()=>{
    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) return $f501923c845d9095$var$localStorageProvider.get('gh.ghx-issue-fragment-view-mode') || 'default';
    if (typeof window !== 'undefined') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window?.localStorage?.getItem('gh.ghx-issue-fragment-view-mode') || 'default';
    return 'default';
};
const $f501923c845d9095$var$mapPredefinedViewMode = (predefinedViewMode)=>{
    switch(predefinedViewMode){
        case 'MODAL':
            return 'modal';
        case 'SIDEBAR':
            return 'sidebar';
        default:
            return null;
    }
};
const $f501923c845d9095$export$abc152b4d639d329 = (predefinedViewMode = null)=>$f501923c845d9095$var$mapPredefinedViewMode(predefinedViewMode) || $f501923c845d9095$var$getViewMode().replace(/"/g, '');

});



parcelRegister("a1E0h", function(module, exports) {

$parcel$export(module.exports, "default", () => $d74b2d5db613050c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jzjy1 = parcelRequire("jzjy1");

var $dJl1T = parcelRequire("dJl1T");

var $co1wz = parcelRequire("co1wz");

var $7eqRV = parcelRequire("7eqRV");

var $5gJcp = parcelRequire("5gJcp");

var $eVPAx = parcelRequire("eVPAx");

var $bngFq = parcelRequire("bngFq");

var $9noxX = parcelRequire("9noxX");

var $4wxhn = parcelRequire("4wxhn");

var $ebuBP = parcelRequire("ebuBP");

var $g5X3G = parcelRequire("g5X3G");

var $jQ7vZ = parcelRequire("jQ7vZ");

var $b7Svb = parcelRequire("b7Svb");

var $lVJAU = parcelRequire("lVJAU");
const $d74b2d5db613050c$var$isEcClientEnabled = ()=>{
    const experiences = (0, $co1wz.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-issue-view');
};

const $d74b2d5db613050c$export$8c70dcc4643464f8 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("7F3Js")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $d74b2d5db613050c$export$5aebed4b5cba826a = ({ backButtonUrl: backButtonUrl, issueNavigatorData: issueNavigatorData, issueKey: issueKey, onDispatchExternalActionRef: onDispatchExternalActionRef, onIssueDeleteSuccess: onIssueDeleteSuccess, analyticsSource: analyticsSource, ServiceDeskAnalyticsContext: ServiceDeskAnalyticsContext = (0, $9noxX.ServiceDeskAnalyticsContext) })=>{
    const routerActions = (0, $lVJAU.useRouterActions)();
    const [selectedIssueKey, setIssueKey] = (0, $jQ7vZ.useQueryParam)('selectedIssue');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let saveIssueMutationToCache;
    if ($d74b2d5db613050c$var$isEcClientEnabled()) // eslint-disable-next-line react-hooks/rules-of-hooks
    saveIssueMutationToCache = (0, $eVPAx.useEcClient)().saveIssueMutationToCache;
    const onIssueKeyChange = (data)=>{
        setIssueKey(data.toIssueKey);
        (0, $dJl1T.default).safeInfoWithoutCustomerData('jsm.issue.view.issue-key-change', 'Invalid issue key, redirecting to correct issue key');
        routerActions.push(`/browse/${data.toIssueKey}`);
    };
    const onChangeHandler = (event)=>{
        (0, $4wxhn.saveIssueMutationAnalyticsToCache)(event, createAnalyticsEvent, saveIssueMutationToCache);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebuBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ServiceDeskAnalyticsContext, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eqRV.IssueBoundary), {
        packageName: "servicedesk-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d74b2d5db613050c$export$8c70dcc4643464f8, {
        onClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        analyticsSource: analyticsSource,
        backButtonUrl: backButtonUrl,
        dispatchExternalActionRef: onDispatchExternalActionRef,
        shouldSetInitialFocus: true,
        isLoadedWithPage: true,
        issueKey: (0, $g5X3G.toIssueKey)(selectedIssueKey) || issueKey,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueKeyChange: onIssueKeyChange,
        issueMaxWidth: (0, $5gJcp.getIssueContainerMaxWidth)(),
        onChange: onChangeHandler,
        issueNavigatorData: issueNavigatorData
    }))));
};
const $d74b2d5db613050c$var$getAnalyticsSourceFromUrl = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    if (pathname.includes('reports')) return 'viewReportIssue';
    return 'viewQueueIssue';
};
const $d74b2d5db613050c$var$WrappedIssueView = (0, $jzjy1.AnalyticsSource)($d74b2d5db613050c$var$getAnalyticsSourceFromUrl(), (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))($d74b2d5db613050c$export$5aebed4b5cba826a);
const $d74b2d5db613050c$var$IssueViewContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d74b2d5db613050c$var$WrappedIssueView, props);
var $d74b2d5db613050c$export$2e2bcd8739ae039 = $d74b2d5db613050c$var$IssueViewContainer;

});
parcelRegister("7eqRV", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $e3c8771effba3477$export$fbf48ede0cf52b5a);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $lb0Dk = parcelRequire("lb0Dk");
const $e3c8771effba3477$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $e3c8771effba3477$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});
parcelRegister("gjEtj", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $c322f875acea1654$export$c3f500e812fb1bb3);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $i2Rm5 = parcelRequire("i2Rm5");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");
const $c322f875acea1654$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $5uXOq.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});
parcelRegister("gAeCk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5368db3a32c0eb20$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $x9xyg = parcelRequire("x9xyg");
const $5368db3a32c0eb20$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
    const renderRef = (0, $5uXOq.useRef)(false);
    if (!renderRef.current) {
        renderRef.current = true;
        (0, $x9xyg.setMark)(metricKey);
        onSet && onSet();
    }
    return null;
};
var $5368db3a32c0eb20$export$2e2bcd8739ae039 = $5368db3a32c0eb20$var$PerformanceMark;

});


parcelRegister("lb0Dk", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $bf9ca492e3d15685$export$49addbcdecb6e6ff);
/* IssueViewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $iMqhh = parcelRequire("iMqhh");

var $hCy6k = parcelRequire("hCy6k");

var $gERis = parcelRequire("gERis");
const $bf9ca492e3d15685$var$fullpageStyles = null;
const $bf9ca492e3d15685$var$modalStyles = null;
const $bf9ca492e3d15685$var$customSpacingStyles = null;
const $bf9ca492e3d15685$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $bf9ca492e3d15685$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $bf9ca492e3d15685$var$fullpageStyles : null,
        isModalView === true ? $bf9ca492e3d15685$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMqhh.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gERis))),
        className: (0, $bwpsq.default)([
            "_p12f1ypn _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};

});
parcelRegister("iMqhh", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $db79d17d45755de5$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $db79d17d45755de5$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $db79d17d45755de5$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $8kj45 = parcelRequire("8kj45");

var $doZTA = parcelRequire("doZTA");

var $hhMVP = parcelRequire("hhMVP");
const $db79d17d45755de5$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const { Provider: $db79d17d45755de5$var$Provider, Consumer: $db79d17d45755de5$var$Consumer } = $db79d17d45755de5$export$37eeac5cc5245b18;
const $db79d17d45755de5$export$55a90a8e865a39b5 = 700;
const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$db79d17d45755de5$export$55a90a8e865a39b5}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $db79d17d45755de5$var$useRouteKey() {
    const [routeState] = (0, $doZTA.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $db79d17d45755de5$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $db79d17d45755de5$var$useRouteKey();
    (0, $hhMVP.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $hhMVP.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4);
        (0, $hhMVP.setCachedIsCompactValue)(defaultState, key);
    }
    const [isCompact, setIsCompact] = (0, $5uXOq.useState)(defaultState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8kj45.ContainerQueryObserver), {
        query: $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY,
        onChange: (state)=>{
            (0, $hhMVP.setCachedIsCompactValue)(state, key);
            setIsCompact(state);
        },
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$Provider, {
        value: isCompact
    }, children));
};
const $db79d17d45755de5$export$20feb77b5b617e44 = $db79d17d45755de5$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db79d17d45755de5$var$StyledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
const $7093eea63dce9286$export$ee15e0cd1efafcb4 = false;

parcelRegister("8kj45", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $ed10e3c030ea0408$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $ed10e3c030ea0408$var$QueryContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
let $ed10e3c030ea0408$var$currentIdSeed = 0;
function $ed10e3c030ea0408$var$generateAttributeValue() {
    return `indicator-span-${$ed10e3c030ea0408$var$currentIdSeed++}`;
}
function $ed10e3c030ea0408$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $5uXOq.useState)(defaultState);
    const handleQueryStatusChange = (0, $5uXOq.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$QueryContext.Provider, {
        value: active
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $ed10e3c030ea0408$export$b66a67697973e01() {
    const currentState = (0, $5uXOq.useContext)($ed10e3c030ea0408$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $ed10e3c030ea0408$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $5uXOq.useMemo)(()=>$ed10e3c030ea0408$var$generateAttributeValue(), []);
    const spanRef = (0, $5uXOq.useRef)(null);
    const containerRef = (0, $5uXOq.useRef)(null);
    const currentState = $ed10e3c030ea0408$export$b66a67697973e01();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed10e3c030ea0408$var$ContainerToBeQueried = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hhMVP", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $cd61c7d28b4f2500$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $cd61c7d28b4f2500$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $cd61c7d28b4f2500$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $cd61c7d28b4f2500$var$cachedIsCompactValues = {};
let $cd61c7d28b4f2500$var$previousRouteKey;
function $cd61c7d28b4f2500$export$c47621d55d10906c(key) {
    return $cd61c7d28b4f2500$var$cachedIsCompactValues[key];
}
function $cd61c7d28b4f2500$export$568b2dd75c2027b4(isCompactValue, key) {
    $cd61c7d28b4f2500$var$cachedIsCompactValues[key] = isCompactValue;
}
function $cd61c7d28b4f2500$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $cd61c7d28b4f2500$var$previousRouteKey) {
        $cd61c7d28b4f2500$var$previousRouteKey = currentRouteKey;
        delete $cd61c7d28b4f2500$var$cachedIsCompactValues[$cd61c7d28b4f2500$var$previousRouteKey];
    }
}

});


parcelRegister("hCy6k", function(module, exports) {

$parcel$export(module.exports, "AppSkeletonImage", () => $a2cd0a6153845fd0$export$45b107c5dc7b51a5);
/* AppSkeletonImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8iquX = parcelRequire("8iquX");


var $koVbs = parcelRequire("koVbs");

var $d0Ozr = parcelRequire("d0Ozr");
const $a2cd0a6153845fd0$var$skeletonImageStyles = null;
const $a2cd0a6153845fd0$export$45b107c5dc7b51a5 = ({ src: src, className: className, containerStyles: containerStyles, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iquX.default), {
        name: "app-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2cd0a6153845fd0$var$SkeletonWrapper // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: src,
        "data-testid": testId,
        alt: `${formatMessage((0, $d0Ozr.default).loading)}...`,
        className: (0, $bwpsq.default)([
            "_1dqonqa1 _1h6d3acm _1e0c1ule _vchhusvi _1bsb1osq _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
            className
        ])
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a2cd0a6153845fd0$var$SkeletonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d0Ozr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6abc81adadf77f72$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6abc81adadf77f72$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loading: {
        "id": "skeletons.common.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("gERis", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.e425fdce.svg", import.meta.url).toString();

});



parcelRegister("5gJcp", function(module, exports) {

$parcel$export(module.exports, "HEADER_BREADCRUMBS_BEGIN_MARK_KEY", () => $0350c967e71738f5$export$eb0ef5297b0cdc23);
$parcel$export(module.exports, "HEADER_BREADCRUMBS_END_MARK_KEY", () => $0350c967e71738f5$export$9c0a7052eb43d49c);
$parcel$export(module.exports, "HEADER_ACTIONS_BEGIN_MARK_KEY", () => $0350c967e71738f5$export$ff64d9f93169b1f0);
$parcel$export(module.exports, "HEADER_ACTIONS_END_MARK_KEY", () => $0350c967e71738f5$export$e696e07345d019c7);
$parcel$export(module.exports, "ISSUE_NAME_BEGIN_MARK_KEY", () => $0350c967e71738f5$export$39f2c7a88d6952c7);
$parcel$export(module.exports, "ISSUE_NAME_END_MARK_KEY", () => $0350c967e71738f5$export$6b38db117e6a59c3);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_BEGIN_MARK_KEY", () => $0350c967e71738f5$export$e4ec603cd2ae64c3);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_END_MARK_KEY", () => $0350c967e71738f5$export$485e8138df2fade3);
$parcel$export(module.exports, "CONTENT_ITEMS_BEGIN_MARK_KEY", () => $0350c967e71738f5$export$37c39403f63dfe50);
$parcel$export(module.exports, "CONTENT_ITEMS_END_MARK_KEY", () => $0350c967e71738f5$export$bcac34901554ce05);
$parcel$export(module.exports, "ACTIVITY_FEED_BEGIN_MARK_KEY", () => $0350c967e71738f5$export$cfd354167a2170f3);
$parcel$export(module.exports, "ACTIVITY_FEED_END_MARK_KEY", () => $0350c967e71738f5$export$e20857c483438d46);
$parcel$export(module.exports, "FOOTNOTE_BEGIN_MARK_KEY", () => $0350c967e71738f5$export$2f7e8d259a68175d);
$parcel$export(module.exports, "FOOTNOTE_END_MARK_KEY", () => $0350c967e71738f5$export$8c4857e697bb9a6b);
$parcel$export(module.exports, "ISSUE_STATUS_BEGIN_MARK_KEY", () => $0350c967e71738f5$export$6669013ba0004c0);
$parcel$export(module.exports, "ISSUE_STATUS_END_MARK_KEY", () => $0350c967e71738f5$export$ff2ebe781d7bd44e);
$parcel$export(module.exports, "defaultRatioRightColumn", () => $0350c967e71738f5$export$7fec582ac43ca9da);
$parcel$export(module.exports, "activitySidePanelRatio", () => $0350c967e71738f5$export$6695481d80b63521);
$parcel$export(module.exports, "getIssueContainerMaxWidth", () => $0350c967e71738f5$export$c76181843186885);
$parcel$export(module.exports, "ACTIVITY_SIDE_PANEL_MIN_WIDTH", () => $0350c967e71738f5$export$dd2feff7666e1f68);
const $0350c967e71738f5$export$eb0ef5297b0cdc23 = 'HEADER_BREADCRUMBS_BEGIN_MARK';
const $0350c967e71738f5$export$9c0a7052eb43d49c = 'HEADER_BREADCRUMBS_END_MARK';
const $0350c967e71738f5$export$ff64d9f93169b1f0 = 'HEADER_ACTIONS_BEGIN_MARK';
const $0350c967e71738f5$export$e696e07345d019c7 = 'HEADER_ACTIONS_END_MARK';
const $0350c967e71738f5$export$39f2c7a88d6952c7 = 'ISSUE_NAME_BEGIN_MARK';
const $0350c967e71738f5$export$6b38db117e6a59c3 = 'ISSUE_NAME_END_MARK';
const $0350c967e71738f5$export$e4ec603cd2ae64c3 = 'QUICK_ADD_ITEMS_BEGIN_MARK';
const $0350c967e71738f5$export$485e8138df2fade3 = 'QUICK_ADD_ITEMS_END_MARK';
const $0350c967e71738f5$export$37c39403f63dfe50 = 'CONTENT_ITEMS_BEGIN_MARK';
const $0350c967e71738f5$export$bcac34901554ce05 = 'CONTENT_ITEMS_END_MARK';
const $0350c967e71738f5$export$cfd354167a2170f3 = 'ACTIVITY_FEED_BEGIN_MARK';
const $0350c967e71738f5$export$e20857c483438d46 = 'ACTIVITY_FEED_END_MARK';
const $0350c967e71738f5$export$2f7e8d259a68175d = 'FOOTNOTE_BEGIN_MARK';
const $0350c967e71738f5$export$8c4857e697bb9a6b = 'FOOTNOTE_END_MARK';
const $0350c967e71738f5$export$6669013ba0004c0 = 'ISSUE_STATUS_BEGIN_MARK';
const $0350c967e71738f5$export$ff2ebe781d7bd44e = 'ISSUE_STATUS_END_MARK';
const $0350c967e71738f5$export$7fec582ac43ca9da = 0.35;
const $0350c967e71738f5$export$6695481d80b63521 = 0.4;
const $0350c967e71738f5$export$c76181843186885 = ()=>1680;
const $0350c967e71738f5$export$dd2feff7666e1f68 = 380;

});

parcelRegister("eVPAx", function(module, exports) {

$parcel$export(module.exports, "useEcClient", () => $cc73f0417ca1290f$export$9da409beb25e67da);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $9OXo1 = parcelRequire("9OXo1");

var $6I26d = parcelRequire("6I26d");
const $cc73f0417ca1290f$export$9da409beb25e67da = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let tenantContext;
    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        tenantContext = (0, $9OXo1.useTenantContext)();
    } catch (e) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jsis-ec-client', `tenant context : ${e?.toString() || ''}`);
    }
    (0, $5uXOq.useEffect)(()=>{
        (0, $6I26d.EcClient).setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    }, [
        tenantContext
    ]);
    const saveIssueMutationToCache = (0, $5uXOq.useCallback)((issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $6I26d.default).saveIssueMutationToCache(issueMutation, key, analyticsFailureEventObj), []);
    const saveIssueMutationsToCache = (0, $5uXOq.useCallback)((issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $6I26d.default).saveIssueMutationsToCache(issueMutations, key, analyticsFailureEventObj), []);
    const searchAndReconcile = (0, $5uXOq.useCallback)((matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability)=>(0, $6I26d.default).searchAndReconcile(matchApiUrl, jqlMatchingKey, search, parseIssueData, capability), []);
    const getIssueMutationFromCache = (key)=>(0, $6I26d.default).getIssueMutationFromCache(key);
    return {
        saveIssueMutationToCache: saveIssueMutationToCache,
        saveIssueMutationsToCache: saveIssueMutationsToCache,
        searchAndReconcile: searchAndReconcile,
        getIssueMutationFromCache: getIssueMutationFromCache
    };
};

});
parcelRegister("6I26d", function(module, exports) {

$parcel$export(module.exports, "EcClient", () => $5fae311104e1f2c3$export$a736992aaac2307a);
$parcel$export(module.exports, "getEcClient", () => $5fae311104e1f2c3$export$c9342bd32f51406b);
$parcel$export(module.exports, "default", () => $5fae311104e1f2c3$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $co1wz = parcelRequire("co1wz");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");

var $fjcgS = parcelRequire("fjcgS");

var $eKonk = parcelRequire("eKonk");

var $cz9EJ = parcelRequire("cz9EJ");

var $iTj50 = parcelRequire("iTj50");

var $6timm = parcelRequire("6timm");
class $5fae311104e1f2c3$export$a736992aaac2307a {
    #issueCache;
    #config;
    constructor(){
        this.#issueCache = new (0, $iTj50.default)('issue-cache-v1');
        this.#config = {};
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, atlassianAccountId) {
        (0, $iTj50.default).setTenantDetails(activationID, cloudID, atlassianAccountId);
    }
    /**
	 * A method to fire analytics events for both success and failure
	 */ static fireAnalyticsEvents(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, isSaved, analyticsFailureEventObj = {}) {
        try {
            // let mutationAnalyticsObj: any = [];
            let trackingId = '-1';
            if (Array.isArray(issueMutations)) //   mutationAnalyticsObj = issueMutations.map((item: IssueMutation) => item.issueId);
            trackingId = String(new Date(issueMutations[0]?.lastModified).valueOf()) + (0, $iTj50.default).userID;
            else trackingId = String(new Date(issueMutations.lastModified).valueOf()) + (0, $iTj50.default).userID;
            const payload = {
                action: 'mutated',
                actionSubject: 'issue',
                source: key?.analyticsMetadata?.scenario || 'unknown',
                attributes: {
                    ...key.analyticsMetadata,
                    trackingId: // issueMutationDetails: mutationAnalyticsObj,
                    trackingId
                }
            };
            // Error condition
            if (!isSaved) {
                if (!analyticsFailureEventObj) // eslint-disable-next-line no-param-reassign
                analyticsFailureEventObj = {
                    error: true,
                    errorMsg: payload.source
                };
                payload.attributes = {
                    ...payload.attributes,
                    ...analyticsFailureEventObj
                };
            }
            if (Object.prototype.hasOwnProperty.call(key, 'analyticsEventObj')) (0, $8zOmE.fireTrackAnalytics)(// @ts-expect-error - Argument of type 'Object' is not assignable to parameter of type 'UIAnalyticsEvent'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            key.analyticsEventObj, `${payload.actionSubject} ${payload.action}`, payload.attributes);
            else // if there is no UI component that triggers the event then we manually fire the event
            (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
                client.getInstance().sendTrackEvent(payload);
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('jsis-ec-client', e);
        }
    }
    /**
	 * A method to save a single issue mutations in cache
	 */ async saveIssueMutationToCache(issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        if ((0, $co1wz.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $iTj50.default).setBackendCache(issueMutation);
            $5fae311104e1f2c3$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return isSaved;
        }
        return this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
            let isSaved = false;
            if (issueMutation.mutationType === (0, $cz9EJ.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
            else if (result || issueMutation.mutationType === (0, $cz9EJ.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
            else isSaved = await this.#issueCache.create(issueMutation.issueId);
            $5fae311104e1f2c3$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return new Promise((resolve)=>resolve(isSaved));
        });
    }
    /**
	 * A method to save multiple issue mutations in cache
	 */ async saveIssueMutationsToCache(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        const data = [];
        if ((0, $co1wz.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $iTj50.default).setBackendCache(issueMutations);
            $5fae311104e1f2c3$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            return [
                isSaved
            ];
        }
        issueMutations.forEach(async (issueMutation)=>{
            this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
                let isSaved = false;
                if (issueMutation.mutationType === (0, $cz9EJ.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
                else if (result || issueMutation.mutationType === (0, $cz9EJ.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
                else isSaved = await this.#issueCache.create(issueMutation.issueId);
                data.push(isSaved);
                $5fae311104e1f2c3$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            });
        });
        return new Promise((resolve)=>resolve(data));
    }
    /**
	 * A method to get issue mutations in saved in cache
	 */ getIssueMutationFromCache(key) {
        return this.#issueCache.get(key);
    }
    /**
	 * A method to remove the deleted issues from the search API
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async filterData(data) {
        const localStorageData = await this.getIssueMutationFromCache(null);
        const deletedData = new Set();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(localStorageData).forEach((element)=>{
            if (element.mutationType === (0, $cz9EJ.MutationSource).DELETE) deletedData.add(element.issueId);
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredData = [];
        let success = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(data).forEach((element)=>{
            if (!element.id || typeof element.id !== 'number') success = false;
            else if (!deletedData.has(element.id.toString())) filteredData.push(element);
        });
        return new Promise((// eslint-disable-next-line @typescript-eslint/no-explicit-any
        resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject)=>{
            if (success) resolve(filteredData);
            else reject(new Error());
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async constructMatchRequest() {
        const issueData = {
            issues: [],
            hydrationMode: 0
        };
        const data = await this.getIssueMutationFromCache(null);
        Object.values(data).forEach((issueMutation)=>{
            const element = {
                issueId: issueMutation.issueId,
                version: issueMutation.version
            };
            issueData.issues.push(element);
        });
        const options = {
            method: 'POST',
            headers: {
                content_type: 'application/json',
                // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
                'x-atlassian-capability': (0, $eKonk.getEnhancedCapabilityHeader)(this.#config.capability)
            },
            body: JSON.stringify(issueData)
        };
        return new Promise((resolve)=>resolve(options));
    }
    /**
	 * A method to get the relevant search data from the parsing function that the user has provided
	 */ static getIssueDataFromSearch(data, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData) {
        const result = parseIssueData(data);
        if (result == null) return [];
        return result;
    }
    /**
	 * A method to get the search data and reconcile it with the data present in cache
	 */ async searchAndReconcile(matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability) {
        // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
        this.#config.capability = capability;
        const matchRequest = await this.constructMatchRequest();
        if (matchRequest && matchRequest.body && matchRequest.body.issues && matchRequest.body.issues.length === 0) return search.then((data)=>new Promise((resolve)=>resolve({
                    reconciledIssues: $5fae311104e1f2c3$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData),
                    matchAPIResponse: {
                        response: {
                            resultsByIssueId: {}
                        },
                        issue: {
                            issuesResponse: {}
                        }
                    }
                })));
        const matchPromise = (0, $7f4tk.default)(matchApiUrl, matchRequest);
        return Promise.all([
            search,
            matchPromise
        ]).then(([data, response])=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const structuredData = $5fae311104e1f2c3$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData);
            return this.filterData(structuredData) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((filteredSearchData)=>{
                if (response == null || response.response == null || response.response.resultsByIssueId == null) throw new Error('Match response is invalid!');
                const matchedIssueIds = response.response.resultsByIssueId;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const filteredMatchedIssueIdsData = [];
                Object.entries(matchedIssueIds).forEach(([key, value])=>{
                    if (value === 'RESULT_MATCH') filteredMatchedIssueIdsData.push({
                        id: parseInt(key, 10)
                    });
                });
                return new Promise((resolve)=>{
                    resolve({
                        reconciledIssues: (0, $6timm.mergeResponseData)(filteredSearchData, filteredMatchedIssueIdsData),
                        matchAPIResponse: response
                    });
                });
            }).catch(()=>new Promise((resolve)=>resolve({
                        reconciledIssues: structuredData,
                        matchAPIResponse: response
                    })));
        });
    }
}
const $5fae311104e1f2c3$var$ecClient = new $5fae311104e1f2c3$export$a736992aaac2307a();
function $5fae311104e1f2c3$export$c9342bd32f51406b(tenantContext = {}) {
    $5fae311104e1f2c3$export$a736992aaac2307a.setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    return $5fae311104e1f2c3$var$ecClient;
}
var $5fae311104e1f2c3$export$2e2bcd8739ae039 = $5fae311104e1f2c3$var$ecClient;

});
parcelRegister("cz9EJ", function(module, exports) {

$parcel$export(module.exports, "MutationSource", () => $ae51bde1e2afd7bd$export$17f28c4c94a74282);
$parcel$export(module.exports, "CacheType", () => $ae51bde1e2afd7bd$export$ba193b555633db78);
const $ae51bde1e2afd7bd$export$17f28c4c94a74282 = {
    CREATE: 0,
    UPDATE: 1,
    DELETE: 2
};
const $ae51bde1e2afd7bd$export$ba193b555633db78 = {
    LOCAL: 'local',
    SESSION: 'session'
};

});

parcelRegister("iTj50", function(module, exports) {

$parcel$export(module.exports, "default", () => $54a03fc66154e7ea$export$2e2bcd8739ae039);
// Issue Cache API is an internal tool and this file should not be edited. Please contact Odin team for any modifications.

var $8Op28 = parcelRequire("8Op28");

var $dJl1T = parcelRequire("dJl1T");

var $co1wz = parcelRequire("co1wz");

var $7f4tk = parcelRequire("7f4tk");

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");

var $82QYR = parcelRequire("82QYR");

var $cz9EJ = parcelRequire("cz9EJ");

var $6timm = parcelRequire("6timm");
const $54a03fc66154e7ea$var$MAX_AGE_MIN = 5;
const $54a03fc66154e7ea$var$MAX_AGE = $54a03fc66154e7ea$var$MAX_AGE_MIN * 60000;
const $54a03fc66154e7ea$var$CACHE_SIZE = 100;
const $54a03fc66154e7ea$var$CACHE_KEY_PREFIX = '__storejs';
const $54a03fc66154e7ea$var$BE_CACHE_SAVE_ISSUE_MUTATION = '/gateway/api/jira-jql-service/api/v1/issue-mutation';
// TODO: JFP-2253 Owning team to add a prefix here for the local storage provider and update the same for the test
const $54a03fc66154e7ea$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('');
class $54a03fc66154e7ea$export$2e2bcd8739ae039 {
    #localCache;
    #sessionCache;
    constructor(namespace, maxAge = $54a03fc66154e7ea$var$MAX_AGE){
        this.maxAge = maxAge;
        this.namespace = namespace;
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#localCache = new (0, $8Op28.Cache)({
            size: $54a03fc66154e7ea$var$CACHE_SIZE,
            storageType: (0, $cz9EJ.CacheType).LOCAL,
            cacheKey: namespace
        });
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#sessionCache = new (0, $8Op28.Cache)({
            size: $54a03fc66154e7ea$var$CACHE_SIZE,
            storageType: (0, $cz9EJ.CacheType).SESSION,
            cacheKey: namespace
        });
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, userID) {
        if (activationID && activationID !== $54a03fc66154e7ea$export$2e2bcd8739ae039.activationID) $54a03fc66154e7ea$export$2e2bcd8739ae039.activationID = activationID;
        if (cloudID && cloudID !== $54a03fc66154e7ea$export$2e2bcd8739ae039.cloudID) $54a03fc66154e7ea$export$2e2bcd8739ae039.cloudID = cloudID;
        if (userID && userID !== $54a03fc66154e7ea$export$2e2bcd8739ae039.userID) $54a03fc66154e7ea$export$2e2bcd8739ae039.userID = userID;
    }
    /**
	 * A util method to decide whether an issue mutation in cache is stale or not
	 */ static isIssueMutationStale(issueMutation) {
        const lastModified = new Date(issueMutation.lastModified).getTime();
        return Date.now() - lastModified < $54a03fc66154e7ea$var$MAX_AGE;
    }
    /**
	 * A util method to generate partial key containing username for storing in cache
	 */ static generateKey() {
        let anonymousId = (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $54a03fc66154e7ea$var$localStorageProvider.get('ajs_anonymous_id') : window.localStorage.getItem('ajs_anonymous_id');
        anonymousId = anonymousId ? `.${anonymousId}` : '';
        anonymousId = anonymousId.replace(/["]+/g, '');
        // TODO : Replace this with something more generic
        return `jsis.ecCache.data${anonymousId}.newIssuesMutationList`;
    }
    /**
	 * A method to generate key containing username as well as namespace for storing in cache
	 */ generateReadKey() {
        return `${$54a03fc66154e7ea$var$CACHE_KEY_PREFIX}_${this.namespace}_${$54a03fc66154e7ea$export$2e2bcd8739ae039.generateKey()}`;
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds and returns corresponding issue mutations
	 * Returns all the issue mutations when provided with null argument in form of an array
	 * Cleans the cache before accessing issue mutations in order to avoid stale data
	 */ async get(key) {
        return this.cleanCache().then(()=>this.getWithoutClean(key));
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds to return selective issue mutations
	 * Returns all the issue mutations when provided with null argument
	 */ async getWithoutClean(key) {
        if (key == null) return new Promise((resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>data ? resolve(data) : resolve({}));
        });
        return new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>{
                if (!data) resolve({});
                else {
                    const iterableData = data;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const newData = {};
                    if (typeof key === 'string') newData[key] = iterableData[key];
                    else if (Array.isArray(key)) key.forEach((issueId)=>{
                        newData[issueId] = iterableData[issueId];
                    });
                    resolve(newData);
                }
            });
        });
    }
    /**
	 * A method to construct object to be stored in backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static constructBackendCacheObject(value) {
        if (value instanceof (0, $82QYR.default)) return {
            issueId: value.issueId,
            mutationType: value.mutationType,
            mutationTimestamp: value.lastModified
        };
        const result = [];
        value.forEach((data)=>{
            result.push($54a03fc66154e7ea$export$2e2bcd8739ae039.constructBackendCacheObject(data));
        });
        return result;
    }
    /**
	 * A method to save the issue mutations in the backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static setBackendCache(data) {
        try {
            let issueBody = $54a03fc66154e7ea$export$2e2bcd8739ae039.constructBackendCacheObject(data);
            let trackingId = '-1';
            if (data instanceof (0, $82QYR.default)) {
                trackingId = String(new Date(data.lastModified).valueOf()) + ($54a03fc66154e7ea$export$2e2bcd8739ae039.userID || '');
                issueBody = [
                    issueBody
                ];
            } else trackingId = String(new Date(data[0].lastModified).valueOf()) + ($54a03fc66154e7ea$export$2e2bcd8739ae039.userID || '');
            (0, $7f4tk.default)($54a03fc66154e7ea$var$BE_CACHE_SAVE_ISSUE_MUTATION, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'ATL-activationId': $54a03fc66154e7ea$export$2e2bcd8739ae039.activationID || '',
                    'atl-CloudId': $54a03fc66154e7ea$export$2e2bcd8739ae039.cloudID || '',
                    trackingId: trackingId
                },
                body: JSON.stringify({
                    issueMutations: issueBody
                })
            });
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('jsis-ec-client', `${e?.toString() || ''}mutationObj: ${data}`);
            return false;
        }
    }
    /**
	 * A method to save the issue mutations in the cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ async set(value) {
        return this.getWithoutClean().then(async (cacheData)=>{
            if (value instanceof (0, $82QYR.default)) {
                const storeValue = {
                    [value.issueId]: value
                };
                return new Promise((resolve)=>{
                    try {
                        this.#localCache.set(this.generateReadKey(), (0, $6timm.mergeData)(cacheData, storeValue));
                        resolve(true);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (e) {
                        resolve(false);
                    }
                });
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const storeData = {};
            value.forEach((data)=>{
                storeData[data.issueId] = data;
            });
            return new Promise((resolve)=>{
                try {
                    this.#localCache.set(this.generateReadKey(), (0, $6timm.mergeData)(cacheData, storeData));
                    resolve(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    resolve(false);
                }
            });
        });
    }
    /**
	 * A method to create a new issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be created in cache
	 */ async create(value) {
        return this.cleanCache().then(()=>{
            if (!Array.isArray(value)) return this.set(new (0, $82QYR.default)(value, (0, $cz9EJ.MutationSource).CREATE, '1', [], new Date().toISOString()));
            const storeData = value.map((data)=>new (0, $82QYR.default)(data, (0, $cz9EJ.MutationSource).CREATE, '1', [], new Date().toISOString()));
            return this.set(storeData);
        });
    }
    /**
	 * A method to update an already existing issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be updated in cache
	 */ async update(value) {
        if ((0, $co1wz.ff)('odin.enable.backend.cache.ec.client')) {
            if (typeof value === 'string') return this.set(new (0, $82QYR.default)(value, (0, $cz9EJ.MutationSource).UPDATE, '1', []));
            return this.set(value.map((issueId)=>new (0, $82QYR.default)(issueId, (0, $cz9EJ.MutationSource).UPDATE, '1', [])));
        }
        return this.getWithoutClean(value).then((data)=>{
            const valueToUpdate = [];
            Object.entries(data).forEach(([issueId, issueMutationObj])=>{
                if (issueMutationObj instanceof (0, $82QYR.default)) {
                    if ($54a03fc66154e7ea$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) valueToUpdate.push(new (0, $82QYR.default)(String(issueId), (0, $cz9EJ.MutationSource).UPDATE, issueMutationObj.version, issueMutationObj.matchStatus, new Date().toISOString()));
                    else valueToUpdate.push(new (0, $82QYR.default)(String(issueId), (0, $cz9EJ.MutationSource).CREATE, '1', issueMutationObj.matchStatus, new Date().toISOString()));
                } else valueToUpdate.push(new (0, $82QYR.default)(String(issueId), (0, $cz9EJ.MutationSource).UPDATE, // TODO: Incorporate the version and match status and change the update method signature
                '1', [], new Date().toISOString()));
            });
            return this.set(valueToUpdate);
        });
    }
    /**
	 * A method to delete an issue mutation in cache
	 */ async delete(key) {
        if (typeof key === 'string') return this.set(new (0, $82QYR.default)(key, (0, $cz9EJ.MutationSource).DELETE, '', [], new Date().toISOString()));
        const storeData = key.map((data)=>new (0, $82QYR.default)(data, (0, $cz9EJ.MutationSource).DELETE, '', [], new Date().toISOString()));
        return this.set(storeData);
    }
    /**
	 * A method to clear the cache
	 */ async clear() {
        return this.#localCache.clear();
    }
    /**
	 * A method that selectively deletes the stale cache entries
	 */ async cleanCache() {
        // We don't clean the backend cache
        if ((0, $co1wz.ff)('odin.enable.backend.cache.ec.client')) return Promise.resolve(true);
        return this.getWithoutClean(null).then((data)=>{
            const issuesToKeep = [];
            if (data && Object.keys(data).length !== 0 && Object.getPrototypeOf(data) === Object.prototype) Object.keys(data).forEach((issueId)=>{
                const issueMutationObj = data[issueId];
                if ($54a03fc66154e7ea$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) issuesToKeep.push(issueMutationObj);
            });
            return this.clear().then(()=>this.set(issuesToKeep));
        });
    }
    /**
	 * A method to check if an issue id is present in the cache
	 */ isPresent(issueId) {
        return this.get(issueId).then((data)=>!!data && !!Object.values(data)[0]);
    }
    /**
	 * A method to check if any mutation is present in the cache
	 */ isEmpty() {
        return this.get(null).then((data)=>Object.keys(data).length === 0);
    }
    /**
	 * A method to find the size of the local storage for any given key
	 */ static getLocalStorageSizeForGivenKey(key) {
        const value = (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $54a03fc66154e7ea$var$localStorageProvider.get(key) : window.localStorage.getItem(key);
        if (value != null) {
            const keySize = value.length;
            return keySize;
        }
        return 0;
    }
    /**
	 * A method to find the size of the local storage for any given key
	 * It returns size of all the keys when provided with no key
	 */ static getLocalStorageSize(key) {
        if (key != null) return $54a03fc66154e7ea$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(key);
        let totalSize = 0;
        if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) Object.keys($54a03fc66154e7ea$var$localStorageProvider).forEach((keys)=>{
            totalSize += $54a03fc66154e7ea$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(keys);
        });
        else Object.keys(localStorage).forEach((keys)=>{
            totalSize += $54a03fc66154e7ea$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(keys);
        });
        return totalSize;
    }
}

});
parcelRegister("8Op28", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $3e46065a4b1d2500$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $3e46065a4b1d2500$export$2e2bcd8739ae039);

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");

var $dJl1T = parcelRequire("dJl1T");


var $1NZBJ = parcelRequire("1NZBJ");
const $3e46065a4b1d2500$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $3e46065a4b1d2500$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $1NZBJ.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $3e46065a4b1d2500$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $3e46065a4b1d2500$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)) storage = (0, $bSSG7.createLocalStorageProvider)((0, $1NZBJ.CACHE_PREFIX));
        else storage = (0, $eNf8a.createSessionStorageProvider)((0, $1NZBJ.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $43a74598c9c16cf3$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $43a74598c9c16cf3$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $dJl1T.default).safeWarnWithoutCustomerData((0, $43a74598c9c16cf3$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $43a74598c9c16cf3$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $43a74598c9c16cf3$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $1NZBJ.default).scopes.current !== (0, $1NZBJ.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3e46065a4b1d2500$var$cacheMap = {};
const $3e46065a4b1d2500$var$getCache = async (props)=>{
    await (0, $1NZBJ.scopeGuard)().catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $3e46065a4b1d2500$var$cacheMap[cacheKey] = $3e46065a4b1d2500$var$cacheMap[cacheKey] || new $3e46065a4b1d2500$export$94affb487e701bf2(props);
    return $3e46065a4b1d2500$var$cacheMap[cacheKey];
};
const $3e46065a4b1d2500$export$710d301bf26d9700 = ()=>{
    Object.values($3e46065a4b1d2500$var$cacheMap).forEach((cache)=>cache.clear());
};
var $3e46065a4b1d2500$export$2e2bcd8739ae039 = $3e46065a4b1d2500$var$getCache;

});
const $43a74598c9c16cf3$export$7271276960377470 = 'common-cache';
const $43a74598c9c16cf3$export$a61768fefd33fcb1 = 'capacity exceeded';
const $43a74598c9c16cf3$export$6c4d37c7f376a1de = 'clear';
const $43a74598c9c16cf3$export$e271b26eefe41db8 = 'update';
const $43a74598c9c16cf3$export$4bd2facc4a3e6aa1 = 'delete';
const $43a74598c9c16cf3$export$26d12233004a7a60 = 'delete stale entry';
const $43a74598c9c16cf3$export$1bb358554aac31c1 = 'get';
const $43a74598c9c16cf3$export$61f74127e2b53cbe = 'hydrate';
const $43a74598c9c16cf3$export$5e8f180ef0142226 = 'set';
const $43a74598c9c16cf3$export$9eb68924983e00fb = 'get entries';
const $43a74598c9c16cf3$export$bf340b99118a1511 = 'memory';
const $43a74598c9c16cf3$export$2670cb7d5d4f7184 = 'local';
const $43a74598c9c16cf3$export$b796061ff0c82e1a = 'session';

parcelRegister("1NZBJ", function(module, exports) {

$parcel$export(module.exports, "CACHE_PREFIX", () => $e0fd77b45718946f$export$69ca515e4489d790);
$parcel$export(module.exports, "scopeGuard", () => $e0fd77b45718946f$export$653cd03438bb0386);
$parcel$export(module.exports, "default", () => $e0fd77b45718946f$export$2e2bcd8739ae039);

var $bSSG7 = parcelRequire("bSSG7");
let $e0fd77b45718946f$var$resolveCachePromise;
const $e0fd77b45718946f$var$cachePromise = new Promise((resolve)=>{
    $e0fd77b45718946f$var$resolveCachePromise = resolve;
});
const $e0fd77b45718946f$export$27be962d708928a = '__scope_key__';
const $e0fd77b45718946f$export$69ca515e4489d790 = 'cache_prefix';
const $e0fd77b45718946f$var$TIMEOUT = 10000;
const $e0fd77b45718946f$var$promiseWithMaxExecutionTime = (ms, promise)=>{
    let id;
    const timeout = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        id = setTimeout(()=>{
            const storage = (0, $bSSG7.createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
            storage.clearAll();
            reject(new Error(`Cache scope was not set within ${$e0fd77b45718946f$var$TIMEOUT}ms`));
        }, ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).then((result)=>{
        clearTimeout(id);
        return result;
    });
};
const $e0fd77b45718946f$export$653cd03438bb0386 = ()=>$e0fd77b45718946f$var$promiseWithMaxExecutionTime($e0fd77b45718946f$var$TIMEOUT, $e0fd77b45718946f$var$cachePromise);
const $e0fd77b45718946f$var$config = {
    devTools: false,
    scopes: {
        prev: null,
        current: null
    },
    set (scopeKey) {
        const storage = (0, $bSSG7.createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
        const scopeKeyInStorage = storage.get($e0fd77b45718946f$export$27be962d708928a);
        // init value
        if (this.scopes.prev === null && this.scopes.current === null) {
            if (scopeKeyInStorage) {
                // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
                this.scopes.prev = scopeKeyInStorage;
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.scopes.current = scopeKeyInStorage;
            }
        }
        // same account id
        if (this.scopes.current !== scopeKey) {
            // diffrent account id
            if (this.scopes.current !== null) // scope has changed during session
            storage.clearAll();
            // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
            this.scopes.prev = this.scopes.current;
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.scopes.current = scopeKey;
            storage.set($e0fd77b45718946f$export$27be962d708928a, scopeKey);
        }
        // @ts-expect-error - TS7005 - Variable 'resolveCachePromise' implicitly has an 'any' type.
        $e0fd77b45718946f$var$resolveCachePromise();
    },
    get () {
        return this.scopes.current;
    }
};
var $e0fd77b45718946f$export$2e2bcd8739ae039 = $e0fd77b45718946f$var$config;

});


parcelRegister("82QYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $07dcfaa1e79d8d31$export$2e2bcd8739ae039);
class $07dcfaa1e79d8d31$export$2e2bcd8739ae039 {
    constructor(issueId, mutationType, version = '1', matchStatus = [], // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lastModified){
        this.issueId = issueId;
        this.mutationType = mutationType;
        this.version = version;
        this.matchStatus = matchStatus;
        // create a new timeStamp whenever an object is initialized
        this.lastModified = new Date().toISOString();
    }
}

});

parcelRegister("6timm", function(module, exports) {

$parcel$export(module.exports, "mergeData", () => $9f26803814916d08$export$696bf4df45a0ddde);
$parcel$export(module.exports, "mergeResponseData", () => $9f26803814916d08$export$71923bad28063cb1);

var $j8DrX = parcelRequire("j8DrX");
function $9f26803814916d08$export$696bf4df45a0ddde(oldData, newData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    Object.keys(oldData).forEach((issueId)=>{
        result[issueId] = oldData[issueId];
    });
    Object.keys(newData).forEach((issueId)=>{
        result[issueId] = newData[issueId];
    });
    return result;
}
function $9f26803814916d08$export$71923bad28063cb1(searchData, matchData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mergedData = [];
    const issueData = new Map();
    if (matchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matchData.forEach((element)=>{
        issueData.set(element.id, element);
    });
    if (searchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchData.forEach((element)=>{
        // TODO: if issueVersion in Match is less than Search, we should not be overwriting that issueID.
        if (issueData.has(element.id)) {
            mergedData.push(issueData.get(element.id));
            issueData.delete(element.id);
        } else mergedData.push(element);
    });
    if (issueData.size) issueData.forEach((value)=>{
        mergedData.push(value);
    });
    return mergedData;
}
function $9f26803814916d08$export$eeaad9fa1f02ef4a(customKeys) {
    return {
        shard: (0, $j8DrX.default)('ajs-shard') || '',
        userId: (0, $j8DrX.default)('ajs-atlassian-account-id') || '',
        projectId: (0, $j8DrX.default)('ajs-project-key') || '',
        ...customKeys
    };
}

});




// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("9noxX", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $12b9024f66e7ef57$export$ac31f8f3368d6881);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $4DPZY = parcelRequire("4DPZY");

var $8H3A4 = parcelRequire("8H3A4");
const $12b9024f66e7ef57$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $5uXOq.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
$12b9024f66e7ef57$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $8H3A4.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $4DPZY.useContainerContext)
};

});
parcelRegister("4DPZY", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $a65e0c39573f7437$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $a65e0c39573f7437$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7xTO3 = parcelRequire("7xTO3");

var $ggg5j = parcelRequire("ggg5j");

var $2YP9W = parcelRequire("2YP9W");

var $6SkQo = parcelRequire("6SkQo");
const $a65e0c39573f7437$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource));
    const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
    const projectContext = $a65e0c39573f7437$var$useProjectContext();
    const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("6SkQo", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $84cf60e2c9c0e289$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $84cf60e2c9c0e289$export$d17fffd59c7b3c60);

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $bsuuc = parcelRequire("bsuuc");
const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
    if (projectType === 'customer_service' && (0, $4R6GH.fg)('jcs_project_type_m3')) return 0, $2vSU6.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'business':
            return 0, $2vSU6.CORE_PROJECT;
        case 'software':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $bsuuc.extractData)(projectNavInfo);
    const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $bsuuc.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("4wxhn", function(module, exports) {

$parcel$export(module.exports, "saveIssueMutationAnalyticsToCache", () => $47fa0c6a95e9c2da$export$75fba429fd9a065f);

var $co1wz = parcelRequire("co1wz");

var $FTaAj = parcelRequire("FTaAj");

var $82QYR = parcelRequire("82QYR");

var $cz9EJ = parcelRequire("cz9EJ");
const $47fa0c6a95e9c2da$var$isEcClientEnabled = ()=>{
    const experiences = (0, $co1wz.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-issue-view');
};
const $47fa0c6a95e9c2da$export$75fba429fd9a065f = (event, createAnalyticsEvent, /* saveIssueMutationToCache from useEcClient() */ saveIssueMutationToCache)=>{
    if ($47fa0c6a95e9c2da$var$isEcClientEnabled() && event?.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED) {
        const mutationFailedAnalyticsPayload = {
            errorMsg: 'FAILED_JSM_ISSUEVIEW',
            error: true
        };
        const analyticsEventObj = createAnalyticsEvent({});
        const analyticsDataKey = {
            analyticsEventObj: analyticsEventObj,
            analyticsMetadata: {
                scenario: 'jsm-issue-view',
                type: event.type
            }
        };
        saveIssueMutationToCache(new (0, $82QYR.default)(event?.issueId, (0, $cz9EJ.MutationSource).UPDATE), analyticsDataKey, mutationFailedAnalyticsPayload);
    }
};

});
parcelRegister("FTaAj", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $0a7f3a2a8450d0c8$export$8db21fc94823e1cc);
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $0a7f3a2a8450d0c8$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$export$8db21fc94823e1cc = {
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED]: $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED]: $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED]: $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED,
    [$0a7f3a2a8450d0c8$var$SUBTASK_ADDED]: $0a7f3a2a8450d0c8$var$SUBTASK_ADDED,
    [$0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED,
    [$0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});


parcelRegister("ebuBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c071e939b06924f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bjGZV = parcelRequire("bjGZV");
const $1c071e939b06924f$export$e809a659e11e6855 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bjGZV.FullPageIssueContainer), null, props.children);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1c071e939b06924f$export$2e2bcd8739ae039 = ({ ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1c071e939b06924f$export$e809a659e11e6855, rest);

});
parcelRegister("bjGZV", function(module, exports) {

$parcel$export(module.exports, "FullPageIssueContainer", () => $70e5c13e9d9b58f1$export$f4550b4a355415eb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $70e5c13e9d9b58f1$export$f4550b4a355415eb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("jQ7vZ", function(module, exports) {

$parcel$export(module.exports, "useQueryParam", () => $9fff0bf09ea99829$export$ae316f0eeb712a36);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $9xWGk = parcelRequire("9xWGk");

var $ebyGx = parcelRequire("ebyGx");

var $doZTA = parcelRequire("doZTA");
const $9fff0bf09ea99829$export$ae316f0eeb712a36 = (queryParam)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push }] = (0, $doZTA.useRouter)();
    const queryParamValue = query[queryParam];
    const setQueryParam = (0, $5uXOq.useCallback)((newValue)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
            ...query,
            [queryParam]: newValue
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value));
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(parsedSearch);
        push(pathname + (strSearch !== '' ? `?${strSearch}` : ''));
    }, [
        pathname,
        push,
        query,
        queryParam
    ]);
    return [
        queryParamValue,
        setQueryParam
    ];
};

});

parcelRegister("7F3Js", function(module, exports) {

let $593f41e45c567fb3$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $593f41e45c567fb3$var$load("kCvaU")
        ]);
    }),
    $593f41e45c567fb3$var$load("kWrFZ"),
    $593f41e45c567fb3$var$load("dsiAd"),
    $593f41e45c567fb3$var$load("kfXhT"),
    $593f41e45c567fb3$var$load("2Lfdl"),
    $593f41e45c567fb3$var$load("92sUi"),
    $593f41e45c567fb3$var$load("i5RRW"),
    $593f41e45c567fb3$var$load("eNmuD"),
    $593f41e45c567fb3$var$load("hPzOn"),
    $593f41e45c567fb3$var$load("h2MrD"),
    $593f41e45c567fb3$var$load("bYT2S"),
    $593f41e45c567fb3$var$load("cM9em"),
    $593f41e45c567fb3$var$load("fr9NE"),
    $593f41e45c567fb3$var$load("cggv6")
]).then(()=>parcelRequire('6qbjz'));

});
parcelRegister("avM1e", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});







//# sourceMappingURL=async-servicedesk-queues-issue-view.1d9f2577.js.map
